/* eslint-disable max-len */
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import tailwindColors from '@bbkShared/tailwind.colors';

const brightbackIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Brightback</title>
    <g fill="none" fillRule="evenodd">
      <path fill="#FF75B3" d="M15.114 16.524h-5.038l2.519-4.13z" />
      <path fill="#FF7575" d="M17.633 12.393h-5.038l2.519 4.131z" />
      <path fill="#C76ECC" d="M10.076 16.524H5.038l2.519-4.13z" />
      <path fill="#EB73D5" d="M12.595 12.393H7.557l2.519 4.131z" />
      <path fill="#745185" d="M5.038 16.524H0l2.519-4.13z" />
      <path fill="#9260AB" d="M7.557 12.393H2.519l2.519 4.131z" />
      <path fill="#745185" d="M7.557 12.393H2.519l2.519-4.13z" />
      <path fill="#FF9C75" d="M17.633 12.393h-5.038l2.519-4.13z" />
      <path fill="#FFB575" d="M15.114 8.262h-5.038l2.519 4.131z" />
      <path fill="#5E3799" d="M5.038 8.262H0l2.519-4.13z" />
      <path fill="#425AB8" d="M7.557 4.131H2.519l2.519 4.131z" />
      <path fill="#FFD175" d="M15.114 8.262h-5.038l2.519-4.13z" />
      <path fill="#FFF175" d="M17.633 4.131h-5.038l2.519 4.131z" />
      <path fill="#0E96B8" d="M7.557 4.131H2.519L5.038 0z" />
      <path fill="#A5ED4E" d="M17.633 4.131h-5.038L15.114 0z" />
      <path fill="#0CB07C" d="M10.076 0H5.038l2.519 4.131z" />
      <path fill="#27BA51" d="M12.595 4.131H7.557L10.076 0z" />
      <path fill="#6FD640" d="M15.114 0h-5.038l2.519 4.131z" />
    </g>
  </svg>
);
const icons = {
  // admin: (<svg width="18" height="20"><path d="M.915 3.855a.302.302 0 0 1 .2-.332C3.727 2.37 6.332 1.213 8.93.05c.12-.06.26-.06.379 0 2.613 1.17 5.227 2.33 7.84 3.48a.272.272 0 0 1 .2.295c0 1.78 0 3.563-.01 5.343a11.475 11.475 0 0 1-2.28 6.804c-1.42 1.914-3.236 3.282-5.537 3.974a1.263 1.263 0 0 1-.764 0 10.435 10.435 0 0 1-5.337-3.697A11.485 11.485 0 0 1 .93 9.05V6.743c0-.962 0-1.925-.014-2.887zm14.313 6.15h.27c0-.081.012-.151.012-.22V5a.23.23 0 0 0-.146-.262c-2.022-.888-4.042-1.782-6.062-2.683-.05-.021-.104-.035-.174-.061V9.854c0 .057 0 .112.014.17-.056 0-.111-.015-.17-.015H2.783c.285 3.115 2.611 7 6.36 8.121v-8.124h6.085z" fill="#FFF" opacity=".9" /></svg>),
  // help: (<svg width="20" height="20"><path d="M17.077 2.923C13.181-.974 6.82-.974 2.923 2.923c-3.897 3.896-3.897 10.258 0 14.154 3.896 3.897 10.258 3.897 14.154 0 3.897-3.896 3.897-10.258 0-14.154zm1.432 9.9l-3.201-1.075c.379-1.137.379-2.38 0-3.517l3.201-1.075a9.293 9.293 0 0 1 0 5.667zM1.49 7.178l3.202 1.075a5.579 5.579 0 0 0 0 3.517L1.49 12.845a9.293 9.293 0 0 1 0-5.667zm5.308 6.024a4.552 4.552 0 0 1 0-6.424 4.552 4.552 0 0 1 6.424 0 4.552 4.552 0 0 1 0 6.424c-1.79 1.77-4.655 1.77-6.424 0zm6.024-11.711l-1.075 3.201a5.579 5.579 0 0 0-3.517 0L7.155 1.491a9.293 9.293 0 0 1 5.667 0zM7.177 18.51l1.075-3.202c1.137.38 2.38.38 3.517 0l1.075 3.202a9.293 9.293 0 0 1-5.667 0z" fill="#FFF" opacity=".9" /></svg>),
  // signout: (<svg width="14" height="18"><path d="M13.736 10.47c0-.924-.748-1.672-1.67-1.67h-.494l-.002-3.938A4.87 4.87 0 0 0 6.705 0a4.872 4.872 0 0 0-4.863 4.866l.003 3.938H1.67C.748 8.806 0 9.554 0 10.476l.004 5.854c0 .922.748 1.67 1.67 1.67l10.396-.006a1.67 1.67 0 0 0 1.67-1.67l-.004-5.854zM3.638 8.804l-.002-3.938a3.075 3.075 0 0 1 3.068-3.074 3.079 3.079 0 0 1 3.074 3.07L9.78 8.8l-6.142.004z" fill="#000" opacity=".5" /></svg>),
  // switch: (<svg width="20" height="15"><path d="M6.853 6.173c-.779-1.366-1.496-2.155-2.55-2.155H0V1.953h4.304c1.665 0 2.799.925 3.683 2.155-.435.687-.802 1.406-1.134 2.065zm7.975 4.385V8.605l5.17 2.986-5.17 2.984v-1.952h-1.923c-1.665 0-2.8-.925-3.684-2.155.436-.687.802-1.406 1.135-2.065.778 1.366 1.496 2.155 2.55 2.155h1.922zm-1.922-6.54c-1.41 0-2.218 1.41-3.377 3.731-1.143 2.286-2.437 4.874-5.227 4.874H0v-2.065h4.302c1.41 0 2.219-1.41 3.378-3.731 1.143-2.286 2.437-4.874 5.226-4.874h1.922V0L20 2.986 14.828 5.97V4.018h-1.922z" fill="#000" opacity=".3" /></svg>),
  offers: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="m21.4 14.25-7.15 7.15q-.3.3-.675.45t-.75.15-.75-.15-.675-.45l-8.825-8.825a1.975 1.975 0 0 1-.575-1.4V4q0-.824.587-1.412A1.93 1.93 0 0 1 4 2h7.175q.4 0 .775.163.375.162.65.437l8.8 8.825q.3.3.438.675.137.375.137.75t-.138.738a1.9 1.9 0 0 1-.437.662M6.5 8q.624 0 1.063-.437Q8 7.125 8 6.5t-.437-1.062A1.45 1.45 0 0 0 6.5 5q-.625 0-1.062.438A1.45 1.45 0 0 0 5 6.5q0 .624.438 1.063Q5.874 8 6.5 8m6.5 9.5 3.5-3.5q.275-.275.438-.65a2 2 0 0 0 .162-.8q0-.85-.6-1.45t-1.45-.6q-.476 0-.937.275-.463.275-1.113.925-.75-.7-1.175-.95a1.7 1.7 0 0 0-.875-.25q-.85 0-1.45.6t-.6 1.45q0 .425.162.8.163.375.438.65z"
      />
    </svg>
  ),
  upArrow: (
    <svg
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 0.599999L12.5 6.6L11.1 8L6.5 3.4L1.9 8L0.5 6.6L6.5 0.599999Z"
        fill="#272833"
      />
    </svg>
  ),
  downArrow: (
    <svg
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 7.4L0.5 1.4L1.9 0L6.5 4.6L11.1 0L12.5 1.4L6.5 7.4Z"
        fill="#272833"
      />
    </svg>
  ),
  downArrowCircle: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m12 16 4-4-1.4-1.4-1.6 1.6V8h-2v4.2l-1.6-1.6L8 12zm0 6a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
        fill="#062531"
      />
    </svg>
  ),
  customersSnap: (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0ZM18 16V13C18 12.2667 17.7958 11.5625 17.3875 10.8875C16.9792 10.2125 16.4 9.63333 15.65 9.15C16.5 9.25 17.3 9.42083 18.05 9.6625C18.8 9.90417 19.5 10.2 20.15 10.55C20.75 10.8833 21.2083 11.2542 21.525 11.6625C21.8417 12.0708 22 12.5167 22 13V16H18ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM18 4C18 5.1 17.6083 6.04167 16.825 6.825C16.0417 7.60833 15.1 8 14 8C13.8167 8 13.5833 7.97917 13.3 7.9375C13.0167 7.89583 12.7833 7.85 12.6 7.8C13.05 7.26667 13.3958 6.675 13.6375 6.025C13.8792 5.375 14 4.7 14 4C14 3.3 13.8792 2.625 13.6375 1.975C13.3958 1.325 13.05 0.733333 12.6 0.2C12.8333 0.116667 13.0667 0.0625 13.3 0.0375C13.5333 0.0125 13.7667 0 14 0C15.1 0 16.0417 0.391667 16.825 1.175C17.6083 1.95833 18 2.9 18 4Z"
        fill="#21262C"
      />
    </svg>
  ),
  account: (
    <svg width="20" height="20">
      <path
        d="M12.942 14.586c-.882-.47-.411-1.353 0-1.764.53-.53 1.177-2.353 1.177-2.353 1.059-.471 1.177-1.235 1.294-1.765.47-1.53-.706-1.764-.706-1.764s.94-2.53.176-4.47c-1-2.53-5.059-3.472-5.765-1.118C4.295.292 5.294 6.938 5.294 6.938s-1.177.235-.706 1.765c.118.53.235 1.294 1.294 1.765 0 0 .648 1.823 1.177 2.352.411.412.882 1.294 0 1.765C5.294 15.526 0 15.762 0 19.88h20c.001-4.117-5.293-4.352-7.058-5.293z"
        fill="#000"
        opacity=".3"
      />
    </svg>
  ),
  airplane: (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path
        fill="#FFF"
        d="M12.58 6.73a.414.414 0 0 0-.597-.572l-7.44 6.33-3.93-1.52a.954.954 0 0 1-.11-1.734L16.815.096a.804.804 0 0 1 1.181.784l-1.43 14.916a.99.99 0 0 1-1.35.824l-4.783-1.852-3.003 2.813a.776.776 0 0 1-1.304-.572v-2.21l6.453-8.07z"
      />
    </svg>
  ),
  arrow: (
    <svg width="12" height="11">
      <path
        d="M7.58.362a1.263 1.263 0 0 0-1.77 0 1.263 1.263 0 0 0 0 1.77l1.931 1.93h-6.49C.554 4.063 0 4.618 0 5.315s.554 1.251 1.251 1.251H7.76L5.81 8.496a1.263 1.263 0 0 0 0 1.77c.25.25.572.358.876.358.304 0 .644-.125.876-.358l4.076-4.058a1.263 1.263 0 0 0 0-1.77L7.58.362z"
        fill="currentColor"
      />
    </svg>
  ),
  arrow14: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
    >
      <path
        d="M206.843238,14.4222388 C206.280253,13.8592537 205.341666,13.8592537 204.778681,14.4222388 C204.215696,14.985224 204.215696,15.9238106 204.778681,16.4867957 L207.031498,18.7396122 L199.460024,18.7396122 C198.646916,18.7396122 198,19.3865279 198,20.1996359 C198,21.0127439 198.646916,21.6596595 199.460024,21.6596595 L207.05173,21.6596595 L204.778681,23.9124761 C204.215696,24.4754612 204.215696,25.4140478 204.778681,25.9770329 C205.070352,26.2687039 205.445954,26.3941826 205.800364,26.3941826 C206.154774,26.3941826 206.551567,26.2483429 206.822047,25.9770329 L211.577761,21.2425934 C212.140746,20.6796082 212.140746,19.7410216 211.577761,19.1780365 L206.843238,14.4222388 Z"
        transform="rotate(-90 99.5 112.697)"
      />
    </svg>
  ),
  arrowLeft: (
    <svg width="26" height="26">
      <path
        d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zM11.157 7.422l-4.735 4.756a1.473 1.473 0 0 0 0 2.065l4.756 4.734c.27.271.667.417 1.022.417.354 0 .73-.125 1.021-.417a1.473 1.473 0 0 0 0-2.065l-2.273-2.252h7.592c.813 0 1.46-.647 1.46-1.46s-.647-1.46-1.46-1.46h-7.571l2.252-2.253a1.473 1.473 0 0 0 0-2.065 1.473 1.473 0 0 0-2.064 0z"
        fill="#FFF"
      />
    </svg>
  ),
  arrowRight: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="11"
      viewBox="0 0 18 11"
    >
      <path
        fill="#9013FE"
        d="M932.916915,15.1726624 L932.214738,15.8465316 C931.9408,16.1085945 931.9408,16.6035008 932.214738,16.8646521 L934.66379,19.2022032 L921.629137,19.2022032 C921.286733,19.2378135 920.998185,19.5601291 921.000009,19.9052919 L921.000009,20.8430473 C921.000009,21.2110246 921.334208,21.5461359 921.702186,21.5461359 L934.663673,21.5461359 C933.847353,22.325008 933.031034,23.104815 932.214621,23.8836871 C931.940683,24.14575 931.940683,24.6406563 932.214621,24.9018075 L932.916798,25.5683836 C933.174302,25.8131018 933.624445,25.8131018 933.881949,25.5683836 C935.288127,24.2279383 937.390146,22.2191403 938.794547,20.8787884 C939.068484,20.6167256 939.068484,20.1218192 938.794547,19.860668 L933.881949,15.1727091 C933.534051,14.9060881 933.235476,14.9818691 932.916798,15.1727091 L932.916915,15.1726624 Z"
        transform="translate(-921 -15)"
      />
    </svg>
  ),
  bbkMiniLogo: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#FF3300">
        <path d="M6.562 10.4712L19.1115 7.48322V0.979996H12.6082L6.562 10.4712Z" />
        <path d="M0.339996 10.366C0.339996 11.1394 0.427878 11.8952 0.621217 12.6158L6.562 10.4715L0.568488 8.3096C0.427878 8.9775 0.339996 9.66297 0.339996 10.366Z" />
        <path d="M2.55524 4.30182L6.56263 10.4711L8.40814 1.06779C6.07049 1.40174 4.01407 2.57935 2.55524 4.30182Z" />
        <path d="M6.562 10.4712L19.1115 13.4592V19.98H12.6082L6.562 10.4712Z" />
        <path d="M2.55524 16.6405L6.56263 10.4712L8.40814 19.8745C6.07049 19.5582 4.01407 18.363 2.55524 16.6405Z" />
      </g>
    </svg>
  ),
  bbkMiniLogoOld: (
    <svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1">
      <g
        id="Reasons-map"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="v3-01-TAB:-Reasons---default"
          transform="translate(-1130.000000, -828.000000)"
        >
          <g id="Group-13" transform="translate(1101.000000, 694.000000)">
            <g
              id="Dynamic-group-Copy"
              transform="translate(29.000000, 131.000000)"
            >
              <g id="logomark" transform="translate(0.000000, 3.000000)">
                <polygon
                  id="Fill-110-Copy-11"
                  fill="#FF75B3"
                  points="16.7930029 18.3603635 11.1953353 18.3603635 13.9941691 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-10"
                  fill="#FF7575"
                  points="19.5918367 13.7702624 13.9941691 13.7702624 16.7930029 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-14"
                  fill="#C76ECC"
                  points="11.1953353 18.3603635 5.59766764 18.3603635 8.39650146 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-13"
                  fill="#EB73D5"
                  points="13.9941691 13.7702624 8.39650146 13.7702624 11.1953353 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-16"
                  fill="#745185"
                  points="5.59766764 18.3603635 0 18.3603635 2.79883382 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-15"
                  fill="#9260AB"
                  points="8.39650146 13.7702624 2.79883382 13.7702624 5.59766764 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-17"
                  fill="#745185"
                  points="8.39650146 13.7702761 2.79883382 13.7702761 5.59766764 9.18017493"
                />
                <polygon
                  id="Fill-110-Copy-12"
                  fill="#FF9C75"
                  points="19.5918367 13.7702761 13.9941691 13.7702761 16.7930029 9.18017493"
                />
                <polygon
                  id="Fill-110-Copy-9"
                  fill="#FFB575"
                  points="16.7930029 9.18017493 11.1953353 9.18017493 13.9941691 13.7702487"
                />
                <polygon
                  id="Fill-110"
                  fill="#5E3799"
                  points="5.59766764 9.18018859 0 9.18018859 2.79883382 4.59008746"
                />
                <polygon
                  id="Fill-110-Copy"
                  fill="#425AB8"
                  points="8.39650146 4.59008746 2.79883382 4.59008746 5.59766764 9.18016126"
                />
                <polygon
                  id="Fill-110-Copy-8"
                  fill="#FFD175"
                  points="16.7930029 9.18018859 11.1953353 9.18018859 13.9941691 4.59008746"
                />
                <polygon
                  id="Fill-110-Copy-7"
                  fill="#FFF175"
                  points="19.5918367 4.59008746 13.9941691 4.59008746 16.7930029 9.18016126"
                />
                <polygon
                  id="Fill-110-Copy-2"
                  fill="#0E96B8"
                  points="8.39650146 4.59010113 2.79883382 4.59010113 5.59766764 0"
                />
                <polygon
                  id="Fill-110-Copy-6"
                  fill="#A5ED4E"
                  points="19.5918367 4.59010113 13.9941691 4.59010113 16.7930029 0"
                />
                <polygon
                  id="Fill-110-Copy-3"
                  fill="#0CB07C"
                  points="11.1953353 0 5.59766764 0 8.39650146 4.5900738"
                />
                <polygon
                  id="Fill-110-Copy-5"
                  fill="#27BA51"
                  points="13.9941691 4.59010113 8.39650146 4.59010113 11.1953353 0"
                />
                <polygon
                  id="Fill-110-Copy-4"
                  fill="#6FD640"
                  points="16.7930029 0 11.1953353 0 13.9941691 4.5900738"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  bbkGrayscale: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M19.912 15.224a.607.607 0 010 .629L17.55 19.76a.598.598 0 01-.511.289H1l2.729-4.513 2.729-4.512 2.729 4.513h5.458l-2.73-4.513 2.73-4.512H9.186l-2.728 4.512H1l2.729-4.512L6.458 2h10.58c.208 0 .402.11.51.289l2.364 3.908a.607.607 0 010 .63l-2.538 4.198 2.538 4.199z" />
    </svg>
  ),
  cbRetention: (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 143 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor">
        <path d="M9.25781 14.2174L27.9311 9.77136V0.0947266H18.2545L9.25781 14.2174Z" />
        <path d="M0 14.0609C0 15.2116 0.130766 16.3362 0.41845 17.4085L9.25819 14.2178L0.33999 11.001C0.130765 11.9948 0 13.0148 0 14.0609Z" />
        <path d="M3.29688 5.03775L9.25978 14.2175L12.0058 0.225586C8.52749 0.722494 5.46758 2.47475 3.29688 5.03775Z" />
        <path d="M9.25781 14.2178L27.9311 18.6638V28.3666H18.2545L9.25781 14.2178Z" />
        <path d="M3.29688 23.3975L9.25978 14.2178L12.0058 28.2097C8.52749 27.7389 5.46758 25.9605 3.29688 23.3975Z" />
      </g>
      <path
        d="M43.5514 21.2305V9.85537H45.8558V14.6736H45.7929C45.7929 13.0396 46.1421 11.8036 46.8404 10.9656C47.5386 10.1277 48.5651 9.70873 49.9198 9.70873H50.3388V12.2435H49.5427C48.5651 12.2435 47.804 12.5089 47.2593 13.0396C46.7286 13.5563 46.4633 14.3104 46.4633 15.302V21.2305H43.5514ZM57.2955 21.6285C56.3179 21.6285 55.459 21.4609 54.7188 21.1257C53.9926 20.7905 53.3851 20.3436 52.8963 19.785C52.4215 19.2124 52.0584 18.577 51.807 17.8787C51.5696 17.1804 51.4509 16.4682 51.4509 15.7419V15.3439C51.4509 14.5898 51.5696 13.8635 51.807 13.1653C52.0584 12.453 52.4215 11.8245 52.8963 11.2799C53.3851 10.7212 53.9856 10.2813 54.6979 9.96011C55.4101 9.62494 56.2341 9.45735 57.1698 9.45735C58.3988 9.45735 59.4253 9.72968 60.2493 10.2743C61.0872 10.805 61.7157 11.5103 62.1346 12.3902C62.5536 13.256 62.7631 14.1917 62.7631 15.1973V16.2447H52.6868V14.4641H60.9406L60.0398 15.3439C60.0398 14.6177 59.935 13.9962 59.7256 13.4795C59.5161 12.9627 59.1949 12.5647 58.7619 12.2854C58.3429 12.0061 57.8122 11.8664 57.1698 11.8664C56.5274 11.8664 55.9827 12.0131 55.5358 12.3064C55.0889 12.5996 54.7468 13.0256 54.5094 13.5842C54.2859 14.1289 54.1742 14.7853 54.1742 15.5534C54.1742 16.2656 54.2859 16.9011 54.5094 17.4597C54.7328 18.0044 55.075 18.4373 55.5358 18.7585C55.9967 19.0658 56.5833 19.2194 57.2955 19.2194C58.0078 19.2194 58.5873 19.0797 59.0343 18.8004C59.4812 18.5071 59.7675 18.151 59.8931 17.732H62.5746C62.407 18.5141 62.0858 19.1985 61.6109 19.785C61.1361 20.3716 60.5286 20.8255 59.7884 21.1467C59.0622 21.4679 58.2312 21.6285 57.2955 21.6285ZM70.1395 21.3771C69.092 21.3771 68.2262 21.2444 67.5418 20.9791C66.8715 20.6998 66.3687 20.2389 66.0335 19.5965C65.6984 18.9401 65.5308 18.0602 65.5308 16.957L65.5517 6.65023H68.275L68.2541 17.1455C68.2541 17.7041 68.4007 18.1371 68.694 18.4443C69.0013 18.7376 69.4342 18.8842 69.9928 18.8842H71.7735V21.3771H70.1395ZM63.7292 11.9921V9.85537H71.7735V11.9921H63.7292ZM79.2466 21.6285C78.269 21.6285 77.4101 21.4609 76.6699 21.1257C75.9437 20.7905 75.3361 20.3436 74.8473 19.785C74.3725 19.2124 74.0094 18.577 73.758 17.8787C73.5206 17.1804 73.4019 16.4682 73.4019 15.7419V15.3439C73.4019 14.5898 73.5206 13.8635 73.758 13.1653C74.0094 12.453 74.3725 11.8245 74.8473 11.2799C75.3361 10.7212 75.9367 10.2813 76.6489 9.96011C77.3612 9.62494 78.1852 9.45735 79.1209 9.45735C80.3498 9.45735 81.3763 9.72968 82.2003 10.2743C83.0383 10.805 83.6667 11.5103 84.0857 12.3902C84.5047 13.256 84.7141 14.1917 84.7141 15.1973V16.2447H74.6379V14.4641H82.8916L81.9908 15.3439C81.9908 14.6177 81.8861 13.9962 81.6766 13.4795C81.4671 12.9627 81.1459 12.5647 80.713 12.2854C80.294 12.0061 79.7633 11.8664 79.1209 11.8664C78.4784 11.8664 77.9338 12.0131 77.4869 12.3064C77.04 12.5996 76.6978 13.0256 76.4604 13.5842C76.2369 14.1289 76.1252 14.7853 76.1252 15.5534C76.1252 16.2656 76.2369 16.9011 76.4604 17.4597C76.6838 18.0044 77.026 18.4373 77.4869 18.7585C77.9477 19.0658 78.5343 19.2194 79.2466 19.2194C79.9588 19.2194 80.5384 19.0797 80.9853 18.8004C81.4322 18.5071 81.7185 18.151 81.8442 17.732H84.5256C84.358 18.5141 84.0368 19.1985 83.562 19.785C83.0871 20.3716 82.4796 20.8255 81.7394 21.1467C81.0132 21.4679 80.1823 21.6285 79.2466 21.6285ZM87.1466 21.2305V9.85537H89.451V14.7364H89.2415C89.2415 13.5772 89.3951 12.6136 89.7024 11.8455C90.0096 11.0634 90.4635 10.4768 91.064 10.0858C91.6785 9.69477 92.4397 9.49924 93.3474 9.49924H93.4731C94.8278 9.49924 95.8543 9.93917 96.5526 10.819C97.2509 11.6849 97.6 12.9837 97.6 14.7154V21.2305H94.6881V14.4641C94.6881 13.7658 94.4856 13.2002 94.0806 12.7672C93.6896 12.3343 93.1449 12.1178 92.4466 12.1178C91.7344 12.1178 91.1548 12.3413 90.7079 12.7882C90.275 13.2211 90.0585 13.8077 90.0585 14.5479V21.2305H87.1466ZM105.674 21.3771C104.627 21.3771 103.761 21.2444 103.077 20.9791C102.406 20.6998 101.904 20.2389 101.568 19.5965C101.233 18.9401 101.066 18.0602 101.066 16.957L101.087 6.65023H103.81L103.789 17.1455C103.789 17.7041 103.936 18.1371 104.229 18.4443C104.536 18.7376 104.969 18.8842 105.528 18.8842H107.308V21.3771H105.674ZM99.2641 11.9921V9.85537H107.308V11.9921H99.2641ZM110.297 21.2305V9.85537H113.209V21.2305H110.297ZM108.705 12.034V9.85537H113.209V12.034H108.705ZM111.365 8.49371C110.793 8.49371 110.367 8.34707 110.088 8.05379C109.822 7.74654 109.689 7.36947 109.689 6.92256C109.689 6.44773 109.822 6.06367 110.088 5.77039C110.367 5.47711 110.793 5.33047 111.365 5.33047C111.938 5.33047 112.357 5.47711 112.622 5.77039C112.888 6.06367 113.02 6.44773 113.02 6.92256C113.02 7.36947 112.888 7.74654 112.622 8.05379C112.357 8.34707 111.938 8.49371 111.365 8.49371ZM122.032 21.6285C121.027 21.6285 120.14 21.4679 119.372 21.1467C118.604 20.8255 117.954 20.3925 117.424 19.8479C116.893 19.2892 116.488 18.6608 116.209 17.9625C115.943 17.2642 115.811 16.538 115.811 15.7838V15.3439C115.811 14.5618 115.95 13.8216 116.23 13.1234C116.523 12.4111 116.935 11.7826 117.465 11.238C118.01 10.6793 118.667 10.2464 119.435 9.93917C120.203 9.61795 121.069 9.45735 122.032 9.45735C122.996 9.45735 123.862 9.61795 124.63 9.93917C125.398 10.2464 126.047 10.6793 126.578 11.238C127.123 11.7826 127.535 12.4111 127.814 13.1234C128.093 13.8216 128.233 14.5618 128.233 15.3439V15.7838C128.233 16.538 128.093 17.2642 127.814 17.9625C127.549 18.6608 127.151 19.2892 126.62 19.8479C126.089 20.3925 125.44 20.8255 124.672 21.1467C123.904 21.4679 123.024 21.6285 122.032 21.6285ZM122.032 19.1356C122.745 19.1356 123.345 18.982 123.834 18.6747C124.323 18.3535 124.693 17.9276 124.944 17.3969C125.196 16.8522 125.321 16.2377 125.321 15.5534C125.321 14.8551 125.189 14.2406 124.923 13.7099C124.672 13.1653 124.295 12.7393 123.792 12.4321C123.303 12.1108 122.717 11.9502 122.032 11.9502C121.348 11.9502 120.754 12.1108 120.252 12.4321C119.763 12.7393 119.386 13.1653 119.12 13.7099C118.855 14.2406 118.722 14.8551 118.722 15.5534C118.722 16.2377 118.848 16.8522 119.099 17.3969C119.365 17.9276 119.742 18.3535 120.231 18.6747C120.72 18.982 121.32 19.1356 122.032 19.1356ZM130.783 21.2305V9.85537H133.087V14.7364H132.878C132.878 13.5772 133.031 12.6136 133.338 11.8455C133.646 11.0634 134.1 10.4768 134.7 10.0858C135.315 9.69477 136.076 9.49924 136.984 9.49924H137.109C138.464 9.49924 139.49 9.93917 140.189 10.819C140.887 11.6849 141.236 12.9837 141.236 14.7154V21.2305H138.324V14.4641C138.324 13.7658 138.122 13.2002 137.717 12.7672C137.326 12.3343 136.781 12.1178 136.083 12.1178C135.371 12.1178 134.791 12.3413 134.344 12.7882C133.911 13.2211 133.695 13.8077 133.695 14.5479V21.2305H130.783Z"
        fill="#111827"
      />
    </svg>
  ),
  cbRetentionPulse: (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor">
        <path
          d="M42.593 64.4402L127.797 44.1535V0H83.6437L42.593 64.4402Z"
          fillOpacity="0.1"
        />
        <path
          d="M0.348816 63.7262C0.348816 68.9769 0.945487 74.1083 2.25816 79.0009L42.5929 64.4422L1.90015 49.7642C0.945483 54.2989 0.348816 58.9529 0.348816 63.7262Z"
          fillOpacity="0.1"
        />
        <path
          d="M15.389 22.5535L42.597 64.4396L55.1271 0.596054C39.2557 2.86339 25.2937 10.8588 15.389 22.5535Z"
          fillOpacity="0.1"
        />
        <path
          d="M42.593 64.4405L127.797 84.7272V129H83.6437L42.593 64.4405Z"
          fillOpacity="0.1"
        />
        <path
          d="M15.389 106.327L42.597 64.4405L55.1271 128.284C39.2557 126.136 25.2937 118.021 15.389 106.327Z"
          fillOpacity="0.1"
        />
        <path
          d="M42.5886 64.4432L106.866 49.139V15.83H73.557L42.5886 64.4432Z"
          fillOpacity="0.2"
        />
        <path
          d="M10.72 63.9045C10.72 67.8656 11.1701 71.7367 12.1604 75.4277L42.5886 64.4447L11.8903 53.3717C11.1701 56.7926 10.72 60.3036 10.72 63.9045Z"
          fillOpacity="0.2"
        />
        <path
          d="M22.0662 32.8441L42.5917 64.4427L52.0443 16.2797C40.071 17.9901 29.5382 24.0218 22.0662 32.8441Z"
          fillOpacity="0.2"
        />
        <path
          d="M42.5886 64.4434L106.866 79.7475V113.147H73.557L42.5886 64.4434Z"
          fillOpacity="0.2"
        />
        <path
          d="M22.0662 96.0419L42.5917 64.4434L52.0443 112.606C40.071 110.986 29.5382 104.864 22.0662 96.0419Z"
          fillOpacity="0.2"
        />
        <path d="M42.5907 64.4471L89.486 53.2815V28.98H65.1845L42.5907 64.4471Z" />
        <path d="M19.34 64.0541C19.34 66.944 19.6684 69.7683 20.3909 72.4611L42.5906 64.4482L20.1938 56.3696C19.6684 58.8654 19.34 61.4269 19.34 64.0541Z" />
        <path d="M27.6179 41.3931L42.5929 64.4467L49.4893 29.3081C40.7539 30.556 33.0693 34.9565 27.6179 41.3931Z" />
        <path d="M42.5907 64.4472L89.486 75.6128V99.98H65.1845L42.5907 64.4472Z" />
        <path d="M27.6179 87.5008L42.5929 64.4472L49.4893 99.5859C40.7539 98.4037 33.0693 93.9375 27.6179 87.5008Z" />
      </g>
    </svg>
  ),
  cbRetentionGrayscale: (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.0552 15.5939C19.3424 15.7788 18.7798 15.409 19.0552 15.5939C19.2991 15.748 19.3935 16.0638 19.2834 16.3257C19.185 16.5568 18.945 16.7032 18.6932 16.6916C18.4297 16.68 18.2015 16.5067 18.1307 16.2679C18.052 16.0214 18.1504 15.7557 18.3589 15.6054C18.5634 15.463 18.8506 15.4591 19.0591 15.5978L19.0552 15.5939ZM11.2109 21.194C11.3525 21.194 11.4862 21.194 11.6318 21.194C11.9072 21.1786 12.1904 21.1555 12.4658 21.1285C12.69 21.1016 12.0094 21.1786 12.4658 21.1285C12.7412 21.09 12.9772 21.3519 12.9103 21.6177C12.8788 21.741 12.7923 21.8488 12.6743 21.8873C12.5956 21.9258 12.5169 21.9258 12.4382 21.9335C12.3478 21.9451 12.2534 21.9528 12.1629 21.9605C11.4154 22.0221 10.668 22.0106 9.93232 21.9335C9.26356 21.8565 8.59476 21.7294 7.95351 21.5407C7.32408 21.3596 6.71828 21.117 6.13212 20.8204C5.54201 20.5239 4.9834 20.1657 4.45624 19.7805C3.85435 19.3299 3.2957 18.8254 2.80395 18.2707C2.30434 17.7238 1.85982 17.123 1.49003 16.4875C1.10843 15.8327 0.793733 15.151 0.557681 14.4462C0.313763 13.7144 0.148531 12.9633 0.0619826 12.2046C-0.0166613 11.4343 -0.024566 10.6524 0.0619826 9.87824C0.140667 9.11946 0.298035 8.36843 0.534088 7.63664C0.7701 6.92409 1.07697 6.23468 1.45462 5.58375C1.82836 4.9367 2.27288 4.32815 2.7725 3.76583C3.26033 3.21121 3.81499 2.70281 4.41297 2.25603C5.01485 1.80925 5.67183 1.41639 6.3524 1.09286C7.04871 0.761632 7.77651 0.5036 8.5279 0.322557C9.29502 0.137684 10.0779 0.0298409 10.8647 0.00673173C11.6515 -0.0202088 12.4461 0.0337133 13.225 0.168497C13.9804 0.303321 14.72 0.515134 15.4359 0.792445C16.1362 1.06975 16.8128 1.41639 17.4422 1.83236C18.0717 2.23679 18.6618 2.70668 19.1929 3.23049C19.4171 3.45 19.6256 3.67726 19.7633 3.96228C19.8813 4.2049 19.96 4.47068 19.9718 4.74412C20.0111 5.29874 19.8144 5.85336 19.4328 6.26933C18.9923 6.75079 18.3313 7.01269 17.6743 6.9626C17.3596 6.94336 17.0449 6.85476 16.7695 6.7007C16.6201 6.62367 16.4863 6.52353 16.3683 6.41185C16.2306 6.28473 16.1047 6.14995 15.967 6.0267C15.4163 5.526 14.7868 5.10233 14.1023 4.80191C13.3942 4.49379 12.6389 4.29351 11.8718 4.22418C11.085 4.15869 10.2903 4.21648 9.52317 4.40518C8.77573 4.58623 8.06761 4.89048 7.4264 5.30261C6.79696 5.707 6.2344 6.21157 5.77411 6.79313C5.30205 7.37857 4.92439 8.0372 4.67261 8.74205C4.41297 9.46227 4.27919 10.221 4.27919 10.9759C4.27919 11.7462 4.4051 12.5166 4.66475 13.2368C4.91258 13.93 5.27845 14.5925 5.74265 15.1779C6.20685 15.7557 6.76547 16.2641 7.3949 16.6723C8.03615 17.0883 8.74818 17.4041 9.49171 17.589C10.2549 17.7816 11.0535 17.847 11.8403 17.7816C12.6074 17.7161 13.3588 17.5235 14.063 17.2193C14.1417 17.1807 14.2085 17.1422 14.2872 17.1307C14.3502 17.1153 14.421 17.1191 14.4839 17.1384C14.6177 17.1769 14.72 17.2847 14.7593 17.408C14.7986 17.5389 14.7593 17.6776 14.6806 17.7778C14.6295 17.8355 14.5626 17.8701 14.4957 17.9048C14.417 17.9433 14.3265 17.9819 14.24 18.0127C13.5319 18.3092 12.7687 18.4941 11.9977 18.5711C11.2109 18.6482 10.4162 18.6019 9.64512 18.4479C9.74349 18.5634 9.84181 18.679 9.92836 18.8023C10.0189 18.9255 10.1054 19.0488 10.192 19.1797C10.1998 19.1989 10.2313 19.249 10.2313 19.249C10.2313 19.249 10.247 19.249 10.2706 19.249C10.31 19.2567 10.3493 19.2606 10.3887 19.2644C10.4673 19.276 10.546 19.2798 10.6247 19.2875C10.9551 19.3068 11.2817 19.3106 11.6082 19.2991C12.2494 19.2721 12.8867 19.172 13.5044 19.0025C14.1062 18.8408 14.6845 18.6097 15.2353 18.3208C15.7743 18.0397 16.2778 17.7046 16.742 17.3117C16.86 17.2193 16.9662 17.1191 17.0764 17.019C17.1747 16.9304 17.2613 16.8264 17.3832 16.7648C17.5917 16.6608 17.8553 16.6877 18.0402 16.8302C18.2251 16.9766 18.3156 17.2154 18.2566 17.4465C18.2251 17.5621 18.1622 17.6583 18.0756 17.7431C17.9694 17.8471 17.8593 17.9472 17.7491 18.0512C17.3046 18.4479 16.8168 18.8061 16.2935 19.1181C15.7703 19.4262 15.2156 19.6958 14.6413 19.9076C14.0433 20.1233 13.4296 20.2851 12.8041 20.3852C12.1589 20.4815 11.5059 20.52 10.8529 20.5008C10.904 20.6394 10.9512 20.7819 10.9945 20.9244C11.0142 20.9899 11.0338 21.0554 11.0495 21.117C11.0495 21.1401 11.0692 21.2017 11.0692 21.2017H11.199L11.2109 21.194ZM17.4777 19.1681C17.6586 19.0372 16.325 20.0155 17.4777 19.1681C17.5406 19.1296 17.6153 19.0988 17.6901 19.0911C17.8474 19.0796 17.9969 19.1566 18.0756 19.2837C18.1543 19.4185 18.1543 19.5918 18.0638 19.7151C18.0127 19.7921 17.9379 19.8306 17.8671 19.8845C17.7884 19.9423 17.7019 20.0001 17.6193 20.054C17.4619 20.1695 17.2928 20.2697 17.1275 20.3736C16.4509 20.7742 15.7349 21.1055 14.9914 21.3674C14.6216 21.4945 14.2439 21.5985 13.8584 21.6909C13.6853 21.7294 13.5161 21.7024 13.4021 21.5638C13.3037 21.4367 13.284 21.2634 13.3627 21.1247C13.3903 21.0593 13.4414 21.0092 13.5083 20.9707C13.587 20.9206 13.6735 20.909 13.7561 20.8936C13.9528 20.8436 14.1417 20.7896 14.3305 20.7319C14.7042 20.6163 15.0779 20.4854 15.432 20.3275C16.1558 20.0116 16.8404 19.6187 17.4698 19.1566L17.4777 19.1681ZM18.8349 17.9857C18.9923 17.8201 18.6932 18.1282 18.8349 17.9857C19.0158 17.7931 19.3463 17.8239 19.484 18.0473C19.539 18.1398 19.5548 18.2515 19.5233 18.3555C19.4958 18.4826 19.3895 18.5712 19.2991 18.6636C19.1968 18.7714 19.0867 18.8754 18.9765 18.9794C18.8742 19.0719 18.7483 19.1257 18.6106 19.1065C18.3667 19.068 18.2094 18.8292 18.2802 18.6058C18.3195 18.4749 18.4218 18.3978 18.5162 18.3092C18.6264 18.2052 18.7365 18.0935 18.8427 17.9857H18.8349ZM16.2778 15.6748C16.4352 15.513 15.8844 16.0792 16.2778 15.6748C16.4116 15.5361 16.6318 15.5092 16.7892 15.6093C16.9584 15.7095 17.0253 15.9174 16.9584 16.0946C16.919 16.1793 16.8522 16.2487 16.7814 16.3141C16.7145 16.3912 16.6397 16.4567 16.565 16.5298C16.4352 16.6454 16.3014 16.7609 16.1598 16.8765C16.0103 16.992 15.8569 17.1076 15.7034 17.2116C15.5461 17.3271 15.3297 17.3348 15.1763 17.2116C15.0425 17.096 14.9993 16.9111 15.0583 16.7494C15.0976 16.6723 15.1487 16.6145 15.2156 16.5683C15.2943 16.5106 15.3808 16.4528 15.4635 16.3912C15.7585 16.1755 16.03 15.929 16.2896 15.6709L16.2778 15.6748ZM11.2502 8.38767C11.3879 8.38767 11.5256 8.39537 11.6593 8.41848C12.1904 8.49551 12.694 8.74201 13.0834 9.11176C13.4768 9.4738 13.7443 9.95139 13.8545 10.4714C13.9646 11.0029 13.8938 11.5652 13.6696 12.0621C13.4532 12.5397 13.0873 12.9479 12.631 13.2175C12.1589 13.4987 11.5964 13.6296 11.0456 13.5873C10.5027 13.5488 9.98345 13.3369 9.55857 12.998C9.14551 12.6629 8.84259 12.2084 8.69313 11.7039C8.54363 11.1801 8.56331 10.6139 8.75213 10.1016C8.93701 9.61246 9.27534 9.17726 9.71203 8.87684C10.1605 8.56871 10.7034 8.39541 11.2463 8.39541L11.2502 8.38767Z" />
    </svg>
  ),
  cbRetention2023Grayscale: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.562 10.4712L19.1115 7.48322V0.979996H12.6082L6.562 10.4712Z" />
      <path d="M0.339996 10.366C0.339996 11.1394 0.427878 11.8952 0.621217 12.6158L6.562 10.4715L0.568488 8.3096C0.427878 8.9775 0.339996 9.66297 0.339996 10.366Z" />
      <path d="M2.55524 4.30182L6.56263 10.4711L8.40814 1.06779C6.07049 1.40174 4.01407 2.57935 2.55524 4.30182Z" />
      <path d="M6.562 10.4712L19.1115 13.4592V19.98H12.6082L6.562 10.4712Z" />
      <path d="M2.55524 16.6405L6.56263 10.4712L8.40814 19.8745C6.07049 19.5582 4.01407 18.363 2.55524 16.6405Z" />
    </svg>
  ),
  bbkMiniLogoTrans: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
    >
      <g fill="#FFF" fillRule="evenodd">
        <polygon
          points="18.472 20.196 12.315 20.196 15.394 15.147"
          opacity=".6"
        />
        <polygon
          points="21.551 15.147 15.394 15.147 18.472 20.196"
          opacity=".8"
        />
        <polygon
          points="12.315 20.196 6.157 20.196 9.236 15.147"
          opacity=".4"
        />
        <polygon
          points="15.394 15.147 9.236 15.147 12.315 20.196"
          opacity=".5"
        />
        <polygon points="6.157 20.196 0 20.196 3.079 15.147" opacity=".4" />
        <polygon points="9.236 15.147 3.079 15.147 6.157 20.196" opacity=".3" />
        <polygon points="9.236 15.147 3.079 15.147 6.157 10.098" opacity=".2" />
        <polygon
          points="21.551 15.147 15.394 15.147 18.472 10.098"
          opacity=".7"
        />
        <polygon
          points="18.472 10.098 12.315 10.098 15.394 15.147"
          opacity=".8"
        />
        <polygon points="6.157 10.098 0 10.098 3.079 5.049" opacity=".2" />
        <polygon points="9.236 5.049 3.079 5.049 6.157 10.098" opacity=".4" />
        <polygon
          points="18.472 10.098 12.315 10.098 15.394 5.049"
          opacity=".7"
        />
        <polygon
          points="21.551 5.049 15.394 5.049 18.472 10.098"
          opacity=".8"
        />
        <polygon points="9.236 5.049 3.079 5.049 6.157 0" opacity=".3" />
        <polygon points="21.551 5.049 15.394 5.049 18.472 0" opacity=".8" />
        <polygon points="12.315 0 6.157 0 9.236 5.049" opacity=".4" />
        <polygon points="15.394 5.049 9.236 5.049 12.315 0" opacity=".3" />
        <polygon points="18.472 0 12.315 0 15.394 5.049" opacity=".6" />
      </g>
    </svg>
  ),
  bold: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M13.8817028,10.9859419 C15.4957162,11.3613154 16.6284795,11.8173057 17.2802934,12.352236 C18.216631,13.1139038 18.6843591,14.098934 18.6843591,15.3107662 C18.6843591,16.5888762 18.1704322,17.6469344 17.1425569,18.4825548 C15.8803983,19.4936188 14.0455807,20 11.6395445,20 L3,20 L3,19.536464 C3.78600335,19.536464 4.3184184,19.4625652 4.59890047,19.3164553 C4.87854414,19.1703367 5.07419581,18.9797134 5.18757532,18.747107 C5.30094193,18.5128237 5.35636762,17.9350698 5.35636762,17.0171988 L5.35636762,5.98365685 C5.35636762,5.06413053 5.30094408,4.48551666 5.18757532,4.24704133 C5.07420656,4.008566 4.87602889,3.81960015 4.59219315,3.67685461 C4.307519,3.53493459 3.7776192,3.46439594 3.0000215,3.46439594 L3,3 L11.1489857,3 C13.0972258,3 14.4762036,3.17299082 15.2855965,3.52065574 C16.0967953,3.86748009 16.7358611,4.38559909 17.2036107,5.07421731 C17.6721987,5.76449086 17.9056435,6.49760957 17.9056435,7.27602419 C17.9056435,8.0939518 17.6092101,8.82285694 17.0155047,9.46278259 C16.4226378,10.1018483 15.3788111,10.6098849 13.8815523,10.9860967 L13.8817028,10.9859419 Z M9.31922014,11.6241693 L9.31922014,17.0783816 L9.305784,17.705688 C9.305784,18.1566478 9.42083174,18.4967433 9.65093153,18.7268345 C9.88102271,18.9560873 10.2219567,19.0711436 10.6729165,19.0711436 C11.3422081,19.0711436 11.9585937,18.9233461 12.5229115,18.6269126 C13.0855525,18.3304792 13.5188626,17.8988459 13.8194881,17.3345281 C14.1201136,16.7718871 14.2704479,16.1420654 14.2704479,15.4484382 C14.2704479,14.6540292 14.0865405,13.9419139 13.7195662,13.3120922 C13.3525984,12.6805937 12.8462172,12.238878 12.202121,11.9886433 C11.5588632,11.7375488 10.59819,11.6166235 9.31926314,11.6241908 L9.31922014,11.6241693 Z M9.31922014,10.6466848 C10.504954,10.6466848 11.3808182,10.5140024 11.946039,10.2461159 C12.5095184,9.97823156 12.9428284,9.60201968 13.2426156,9.11748028 C13.5440795,8.63294088 13.6935754,8.01487852 13.6935754,7.26245476 C13.6935754,6.51003101 13.5457778,5.89364547 13.2493444,5.41329815 C12.9512341,4.93295082 12.527985,4.56682143 11.9762649,4.31656529 C11.4245448,4.06547073 10.5385981,3.94454548 9.31848921,3.95211272 L9.31848921,10.6467493 L9.31922014,10.6466848 Z" />
    </svg>
  ),
  brightback: (
    <svg width="177" height="30" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M168.822 18.212l3.359 5.618h4.218l-5.07-8.501 4.984-5.615h-4.43l-5.044 5.688h-.049V2.541h-3.786v21.29h3.786v-3.376l1.987-2.243h.045zm-13.737 5.858c1.356 0 2.573-.236 3.648-.708 1.079-.468 1.942-1.08 2.593-1.836l-2.601-2.284a4.193 4.193 0 0 1-1.393 1.021c-.553.27-1.185.408-1.88.408-1.12 0-2.028-.363-2.733-1.091-.7-.721-1.05-1.666-1.05-2.822 0-.566.09-1.087.269-1.567.179-.48.431-.892.757-1.23.322-.334.72-.603 1.189-.794.472-.195.985-.29 1.539-.29 1.327 0 2.422.502 3.29 1.511l2.552-2.202c-.696-.88-1.58-1.547-2.65-2.011a8.294 8.294 0 0 0-3.347-.7c-1.441 0-2.724.305-3.856.92a6.525 6.525 0 0 0-2.634 2.577c-.63 1.115-.953 2.381-.953 3.815 0 1.42.318 2.687.94 3.794a6.552 6.552 0 0 0 2.594 2.577c1.1.607 2.341.912 3.726.912zm-16.445-3.387c-1.058 0-1.934-.358-2.601-1.075-.676-.713-1.014-1.645-1.014-2.78 0-1.186.35-2.138 1.042-2.867.688-.72 1.551-1.083 2.59-1.083 1.026 0 1.872.374 2.548 1.128.672.749 1.01 1.69 1.01 2.821 0 1.136-.346 2.068-1.03 2.781-.688.717-1.54 1.075-2.545 1.075zm3.416-10.969v1.592h-.053c-1.054-1.221-2.443-1.832-4.169-1.832-.928 0-1.808.183-2.63.554a6.432 6.432 0 0 0-2.121 1.506c-.587.64-1.047 1.417-1.385 2.333a8.38 8.38 0 0 0-.513 2.948c0 1.075.176 2.06.513 2.972.338.904.803 1.67 1.401 2.3a6.284 6.284 0 0 0 2.15 1.458c.834.35 1.73.525 2.703.525 1.804 0 3.213-.651 4.222-1.946h.061v1.706h3.604V9.714h-3.783zm-19.644 10.969c-1.055 0-1.938-.358-2.643-1.075-.716-.713-1.067-1.645-1.067-2.78 0-1.137.347-2.081 1.039-2.83.7-.75 1.588-1.12 2.67-1.12 1.035 0 1.898.362 2.582 1.083.688.729 1.034 1.681 1.034 2.866 0 1.136-.338 2.068-1.01 2.781-.671.717-1.543 1.075-2.605 1.075zm.806-11.209c-1.78 0-3.196.61-4.263 1.832h-.07V2.541h-3.79v21.29h3.616v-1.707h.073c1.026 1.295 2.467 1.946 4.32 1.946.969 0 1.868-.175 2.703-.525a6.307 6.307 0 0 0 2.146-1.458c.594-.63 1.062-1.396 1.4-2.3.342-.912.51-1.897.51-2.972 0-1.059-.168-2.04-.51-2.948-.338-.916-.798-1.693-1.384-2.333a6.39 6.39 0 0 0-2.121-1.506 6.35 6.35 0 0 0-2.63-.554zM109.656 24.07c.863 0 1.571-.077 2.117-.228a7.232 7.232 0 0 0 1.62-.663l-.969-3.021c-.643.333-1.233.496-1.775.496-.448 0-.765-.146-.96-.44-.192-.292-.286-.744-.286-1.367v-5.998h3.84V9.714h-3.84V4.686l-3.786.411v4.617h-1.665v3.135h1.665v6.519c0 1.547.358 2.711 1.083 3.51.72.793 1.706 1.192 2.956 1.192zM97.393 9.474c-.912 0-1.763.167-2.545.493-.786.33-1.47.814-2.044 1.457h-.053V2.541h-3.786v21.29h3.786v-7.154c0-1.246.29-2.19.871-2.834.587-.648 1.393-.965 2.431-.965.937 0 1.633.256 2.08.774.449.517.668 1.404.668 2.65v7.54h3.803v-8.497c0-1.05-.13-1.962-.387-2.732-.248-.765-.614-1.372-1.083-1.828a4.296 4.296 0 0 0-1.632-.993c-.611-.216-1.315-.318-2.11-.318zM79.035 20.145c-.408 0-.79-.057-1.153-.158a3.624 3.624 0 0 1-.985-.477 3.145 3.145 0 0 1-.773-.749 3.233 3.233 0 0 1-.501-1.005 4.33 4.33 0 0 1-.18-1.238c0-1.063.338-1.93 1.002-2.598.672-.668 1.535-1.005 2.59-1.005 1.013 0 1.864.333 2.544.989.68.66 1.026 1.523 1.026 2.59 0 1.058-.338 1.933-1.005 2.617-.668.692-1.527 1.034-2.565 1.034zm3.4-10.43v1.453h-.07a5.484 5.484 0 0 0-1.914-1.262 6.217 6.217 0 0 0-2.308-.432c-1.242 0-2.362.306-3.359.92-.998.607-1.775 1.462-2.337 2.553-.558 1.091-.839 2.32-.839 3.685 0 1.343.29 2.548.867 3.603a6.226 6.226 0 0 0 2.403 2.467c1.017.582 2.17.872 3.464.872 1.694 0 3.062-.55 4.109-1.653h.065v1.429c0 .903-.346 1.649-1.043 2.243-.696.594-1.677.892-2.947.892-.843 0-1.62-.118-2.346-.342-.724-.22-1.473-.55-2.243-.973l-.875 3.188c1.657.956 3.583 1.424 5.785 1.424 1.063 0 2.012-.118 2.846-.366.835-.244 1.531-.586 2.097-1.03a5.553 5.553 0 0 0 1.396-1.612 7.08 7.08 0 0 0 .79-2.08c.16-.758.24-1.58.24-2.488V9.714h-3.782zM65.586 23.83h3.782V9.714h-3.782V23.83zm1.889-16.106c.639 0 1.189-.229 1.653-.676.46-.452.692-.998.692-1.641 0-.627-.232-1.169-.692-1.62a2.289 2.289 0 0 0-1.653-.68c-.652 0-1.201.227-1.657.68-.46.451-.684.993-.684 1.62 0 .427.097.814.31 1.164.207.359.488.635.854.843.362.208.753.31 1.177.31zm-3.864 1.75c-.843 0-1.625.2-2.357.599-.733.403-1.368.973-1.91 1.718h-.036V9.714h-3.787V23.83h3.787v-6.55c0-1.084.317-1.967.948-2.651.635-.692 1.519-1.034 2.65-1.034.29 0 .628.016 1.002.044V9.486c-.057-.012-.159-.012-.297-.012zM45.466 20.26h-3.278v-5.28h3.314c1.177 0 2.08.236 2.687.712.62.477.929 1.128.929 1.959 0 .57-.155 1.054-.464 1.44-.31.396-.737.689-1.275.88-.545.192-1.18.29-1.913.29zM42.188 6.89h2.642c.77 0 1.41.102 1.918.301.51.204.876.48 1.104.83.223.347.333.77.333 1.255 0 .545-.146 1.005-.443 1.376a2.5 2.5 0 0 1-1.12.806c-.452.163-.96.244-1.527.244h-2.907V6.89zm7.044 6.058v-.06a4.677 4.677 0 0 0 1.779-1.161c.472-.505.806-1.039 1.002-1.609.199-.57.297-1.176.297-1.815 0-1.629-.57-2.867-1.718-3.726-1.145-.859-2.806-1.286-4.988-1.286h-7.41v20.54h8.497c1.103 0 2.08-.138 2.927-.423.851-.281 1.552-.68 2.093-1.185a5.005 5.005 0 0 0 1.226-1.796c.277-.688.415-1.445.415-2.271 0-1.344-.358-2.468-1.07-3.364-.717-.903-1.731-1.514-3.05-1.844z"
          fill="#FFF"
        />
        <path
          fill="#27BA51"
          d="M14.8 0l3.697 6.408h-7.398l1.848-3.204L14.8 0"
        />
        <path
          fill="#27BA51"
          d="M14.8 0l3.697 6.408h-7.398l1.848-3.204L14.8 0"
        />
        <path fill="#6FD640" d="M18.497 6.408L22.193 0H14.8l3.697 6.408" />
        <path fill="#6FD640" d="M18.497 6.408L22.193 0H14.8l3.697 6.408" />
        <path
          fill="#A5ED4E"
          d="M22.193 0l1.853 3.204 1.848 3.204h-7.397L22.193 0"
        />
        <path
          fill="#A5ED4E"
          d="M22.193 0l1.853 3.204 1.848 3.204h-7.397L22.193 0"
        />
        <path
          fill="#FFF175"
          d="M22.193 12.813l1.853-3.2 1.848-3.205h-7.397l1.848 3.205 1.848 3.2"
        />
        <path
          fill="#FFF175"
          d="M22.193 12.813l1.853-3.2 1.848-3.205h-7.397l1.848 3.205 1.848 3.2"
        />
        <path
          fill="#FFD175"
          d="M18.497 6.408l1.848 3.205 1.848 3.2H14.8l1.848-3.2 1.849-3.205"
        />
        <path
          fill="#FFD175"
          d="M18.497 6.408l1.848 3.205 1.848 3.2H14.8l1.848-3.2 1.849-3.205"
        />
        <path
          fill="#5E3799"
          d="M3.7 6.408l1.85 3.205 1.848 3.2H0l1.853-3.2L3.7 6.408"
        />
        <path
          fill="#5E3799"
          d="M3.7 6.408l1.85 3.205 1.848 3.2H0l1.853-3.2L3.7 6.408"
        />
        <path
          fill="#FF9C75"
          d="M22.193 12.813l1.853 3.204 1.848 3.204h-7.397l3.696-6.408"
        />
        <path
          fill="#FF9C75"
          d="M22.193 12.813l1.853 3.204 1.848 3.204h-7.397l3.696-6.408"
        />
        <path fill="#FFB575" d="M18.497 19.221l3.696-6.408H14.8l3.697 6.408" />
        <path fill="#FFB575" d="M18.497 19.221l3.696-6.408H14.8l3.697 6.408" />
        <path
          fill="#FF7575"
          d="M22.193 25.626l1.853-3.2 1.848-3.205h-7.397l1.848 3.204 1.848 3.2"
        />
        <path
          fill="#FF7575"
          d="M22.193 25.626l1.853-3.2 1.848-3.205h-7.397l1.848 3.204 1.848 3.2"
        />
        <path
          fill="#FF75B3"
          d="M18.497 19.221l1.848 3.204 1.848 3.2H14.8l1.848-3.2 1.849-3.204"
        />
        <path
          fill="#FF75B3"
          d="M18.497 19.221l1.848 3.204 1.848 3.2H14.8l1.848-3.2 1.849-3.204"
        />
        <path
          fill="#EB73D5"
          d="M14.8 25.626l1.848-3.2 1.849-3.205h-7.398l1.848 3.204 1.853 3.2"
        />
        <path
          fill="#EB73D5"
          d="M14.8 25.626l1.848-3.2 1.849-3.205h-7.398l1.848 3.204 1.853 3.2"
        />
        <path
          fill="#C76ECC"
          d="M11.099 19.221l1.848 3.204 1.849 3.2H7.398l3.7-6.404"
        />
        <path
          fill="#C76ECC"
          d="M11.099 19.221l1.848 3.204 1.849 3.2H7.398l3.7-6.404"
        />
        <path
          fill="#0CB07C"
          d="M11.099 6.408l1.848-3.204L14.8 0H7.398l1.848 3.204L11.1 6.408"
        />
        <path
          fill="#0CB07C"
          d="M11.099 6.408l1.848-3.204L14.8 0H7.398l1.848 3.204L11.1 6.408"
        />
        <path fill="#0E96B8" d="M7.398 0l1.848 3.204L11.1 6.408H3.7L7.398 0" />
        <path fill="#0E96B8" d="M7.398 0l1.848 3.204L11.1 6.408H3.7L7.398 0" />
        <path
          fill="#425AB8"
          d="M7.398 12.813l3.7-6.405H3.702l1.848 3.205 1.849 3.2"
        />
        <path
          fill="#425AB8"
          d="M7.398 12.813l3.7-6.405H3.702l1.848 3.205 1.849 3.2"
        />
        <path
          fill="#745185"
          d="M3.7 19.221l1.85 3.204 1.848 3.2H0l1.853-3.2L3.7 19.221"
        />
        <path
          fill="#745185"
          d="M3.7 19.221l1.85 3.204 1.848 3.2H0l1.853-3.2L3.7 19.221M7.398 12.813l1.848 3.204 1.853 3.204H3.7l3.697-6.408"
        />
        <path
          fill="#745185"
          d="M7.398 12.813l1.848 3.204 1.853 3.204H3.7l3.697-6.408"
        />
        <path
          fill="#9260AB"
          d="M7.398 25.626l3.7-6.405H3.702l1.848 3.204 1.849 3.2"
        />
        <path
          fill="#9260AB"
          d="M7.398 25.626l3.7-6.405H3.702l1.848 3.204 1.849 3.2"
        />
      </g>
    </svg>
  ),
  brightbackWordmarkSingleColor: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="783"
      height="132"
      viewBox="0 0 783 132"
    >
      <title>Brightback</title>
      <g fillRule="evenodd">
        <path d="M119.49,82.84 C120.236083,84.043771 120.236083,85.566229 119.49,86.77 L104.6,111.19 L104.6,111.19 C104.259481,111.74608 103.780555,112.204333 103.21,112.52 C102.650614,112.831547 102.020283,112.993435 101.38,112.990054 L0.32,112.990054 L17.51,84.79 L34.71,56.59 L51.91,84.79 L86.3,84.79 L69.1,56.59 L86.3,28.39 L51.91,28.39 L34.71,56.59 L0.32,56.59 L17.51,28.39 L34.71,0.189946442 L101.38,0.189946442 C102.020283,0.186564606 102.650614,0.348452829 103.21,0.66 C103.779629,0.981352448 104.258005,1.44252016 104.6,2 L104.6,2 L119.49,26.42 C119.858766,27.0217303 120.052676,27.7142661 120.05013,28.42 C120.055898,29.1261666 119.861744,29.8195733 119.49,30.42 L103.49,56.66 L119.49,82.84 Z" />
        <path
          fillRule="nonzero"
          d="M236.74 65.81C239.886667 69.77 241.46 74.71 241.46 80.63 241.500327 84.050134 240.87892 87.4457982 239.63 90.63 238.425961 93.6214068 236.579042 96.3115585 234.22 98.51 231.576556 100.902911 228.439082 102.685023 225.03 103.73 220.860104 105.033817 216.508389 105.66176 212.14 105.59L174.76 105.59 174.76 15.23 207.36 15.23C216.973333 15.23 224.306667 17.1133333 229.36 20.88 234.413333 24.6466667 236.926667 30.1133333 236.9 37.28 236.919667 40.0008008 236.480166 42.7054222 235.6 45.28 234.642043 47.922796 233.139601 50.3348806 231.19 52.36 229.008129 54.6456927 226.328772 56.3977118 223.36 57.48L223.36 57.73C229.12 59.17 233.58 61.8633333 236.74 65.81zM192.33 52.24L205.13 52.24C207.409232 52.273557 209.676758 51.9080454 211.83 51.16 213.774674 50.4639693 215.485833 49.2377544 216.77 47.62 218.12292 45.8950192 218.83038 43.7514166 218.77 41.56 219.027315 37.40845 216.406148 33.6214016 212.43 32.4 209.724428 31.4334161 206.861709 30.9823003 203.99 31.07L192.33 31.07 192.33 52.24zM215.16 88.61C217.360155 87.8848315 219.309104 86.5496976 220.78 84.76 222.174578 82.9350903 222.898463 80.685747 222.83 78.39 222.961393 75.0302379 221.441451 71.8185671 218.76 69.79 216.053333 67.6966667 212.11 66.65 206.93 66.65L192.33 66.65 192.33 89.88 206.74 89.88C209.598552 89.9399055 212.446288 89.5103776 215.16 88.61zM287.88 42.49L287.88 60.75C286.233333 60.63 284.763333 60.57 283.47 60.57 278.47 60.57 274.62 62.08 271.83 65.1 268.971387 68.3025803 267.469007 72.4906004 267.64 76.78L267.64 105.59 251 105.59 251 43.49 267.65 43.49 267.65 52.62 267.83 52.62C270.020368 49.5018072 272.888863 46.9205038 276.22 45.07 279.396514 43.32397 282.965272 42.4154337 286.59 42.43 287.020868 42.4203092 287.451892 42.4403568 287.88 42.49L287.88 42.49zM298.38 33.36C295.192926 31.5782907 293.230286 28.2011705 293.26 24.55 293.22251 21.8532431 294.309482 19.2626278 296.26 17.4 300.299593 13.4254053 306.780407 13.4254053 310.82 17.4 312.759774 19.283158 313.854415 21.8714826 313.854415 24.575 313.854415 27.2785174 312.759774 29.866842 310.82 31.75 308.908114 33.7009594 306.281361 34.7849019 303.55 34.75 301.733391 34.7572009 299.948075 34.2772032 298.38 33.36zM295.24 43.49L311.89 43.49 311.89 105.59 295.24 105.59 295.24 43.49zM386 43.49L386 98.49C386.049096 102.145009 385.713922 105.795057 385 109.38 384.335745 112.59933 383.160909 115.691713 381.52 118.54 379.954662 121.286374 377.869126 123.701384 375.38 125.65 372.619057 127.73493 369.486719 129.275646 366.15 130.19 362.077299 131.316453 357.865206 131.858537 353.64 131.8 343.946667 131.8 335.46 129.71 328.18 125.53L332.03 111.53C335.166346 113.290322 338.473301 114.727692 341.9 115.82 345.241879 116.833677 348.717863 117.336026 352.21 117.31 357.796667 117.31 362.13 116.006667 365.21 113.4 368.181108 110.9893 369.877618 107.345491 369.81 103.52L369.81 97.25 369.5 97.25C364.9 102.09 358.873333 104.513333 351.42 104.52 346.089331 104.603431 340.831463 103.275164 336.18 100.67 331.705788 98.1279136 328.044154 94.3691905 325.62 89.83 323.017721 84.9509596 321.702945 79.4887856 321.8 73.96 321.710257 68.3387278 322.975959 62.778554 325.49 57.75 330.197832 48.2502885 339.949016 42.3046343 350.55 42.47 354.026602 42.4523032 357.474744 43.0971328 360.71 44.37 363.875607 45.6018679 366.742541 47.4938394 369.12 49.92L369.43 49.92 369.43 43.53 386 43.49zM365.7 84.85C368.67086 81.7544207 370.261735 77.5878428 370.11 73.3 370.280344 69.0450223 368.646136 64.9159222 365.61 61.93 361.076276 57.2816345 354.153409 55.894359 348.17869 58.436934 342.20397 60.979509 338.403753 66.9300523 338.61 73.42 338.594533 75.2622684 338.857501 77.0963002 339.39 78.86 339.869845 80.4526284 340.613501 81.9534616 341.59 83.3 342.532694 84.5744851 343.677868 85.6858776 344.98 86.59 346.30651 87.5103018 347.771684 88.212505 349.32 88.67 350.966211 89.1532126 352.674381 89.3924238 354.39 89.38 358.629115 89.526676 362.734224 87.8824548 365.7 84.85zM444.45 43.83C450.256481 45.7328797 454.747918 50.3815176 456.45 56.25 457.634372 60.1372635 458.197969 64.1870606 458.12 68.25L458.12 105.64 441.42 105.64 441.42 72.49C441.42 66.9833333 440.42 63.0933333 438.42 60.82 436.42 58.5466667 433.366667 57.4066667 429.26 57.4 424.7 57.4 421.136667 58.8166667 418.57 61.65 416.003333 64.4833333 414.72 68.6366667 414.72 74.11L414.72 105.59 398.09 105.59 398.09 11.94 414.73 11.94 414.73 51 415 51C417.481199 48.2201888 420.55757 46.0359656 424 44.61 430.536868 42.0004581 437.773661 41.7249726 444.49 43.83L444.45 43.83zM476.09 101.4C472.93 97.9 471.346667 92.7566667 471.34 85.97L471.34 57.28 464 57.28 464 43.49 471.32 43.49 471.32 23.18 487.97 21.38 487.97 43.49 504.86 43.49 504.86 57.28 488 57.28 488 83.67C488 86.4033333 488.423333 88.4033333 489.27 89.67 490.225266 91.011233 491.819815 91.7457154 493.46 91.6 496.205611 91.5108217 498.890162 90.7668273 501.29 89.43L505.57 102.72C503.307334 103.95864 500.912199 104.938163 498.43 105.64 495.383435 106.377219 492.253634 106.713396 489.12 106.64 483.606667 106.646667 479.263333 104.9 476.09 101.4zM560.34 44.85C563.871542 46.4010657 567.044531 48.6650551 569.66 51.5 572.34601 54.4852286 574.421703 57.9673639 575.77 61.75 578.74393 70.1615438 578.74393 79.3384562 575.77 87.75 574.425631 91.5113655 572.322055 94.9560553 569.59 97.87 566.929184 100.651753 563.71285 102.84254 560.15 104.3 556.380169 105.853455 552.337204 106.635525 548.26 106.6 540.1 106.6 533.766667 103.743333 529.26 98.03L529 98.03 529 105.54 513.1 105.54 513.1 11.94 529.74 11.94 529.74 50.51 530 50.51C534.666667 45.1233333 540.92 42.43 548.76 42.43 552.747749 42.4082255 556.69471 43.2330655 560.34 44.85zM556.68 87C559.64 83.86 561.12 79.7833333 561.12 74.77 561.12 69.55 559.606667 65.3466667 556.58 62.16 553.653012 59.0127571 549.516602 57.2722603 545.22 57.38 540.77567 57.2474269 536.492468 59.0497282 533.48 62.32 530.377869 65.7089571 528.726586 70.1781911 528.88 74.77 528.703251 79.3167991 530.398413 83.7372318 533.57 87 536.630708 90.1208965 540.850133 91.8303976 545.22 91.72 549.541788 91.87217 553.718977 90.1517221 556.68 87L556.68 87zM648.28 43.49L648.28 105.59 632.45 105.59 632.45 98.08 632.14 98.08C627.713333 103.786667 621.523333 106.643333 613.57 106.65 609.489633 106.6847 605.443561 105.902686 601.67 104.35 598.108566 102.889906 594.892748 100.699471 592.23 97.92 589.497945 95.0060553 587.394369 91.5613655 586.05 87.8 583.088151 79.3863876 583.088151 70.2136124 586.05 61.8 587.397988 58.0150096 589.477477 54.5322048 592.17 51.55 597.561162 45.7361485 605.141294 42.4465887 613.07 42.4797479 620.65 42.4797479 626.756667 45.1733333 631.39 50.56L631.64 50.56 631.64 43.56 648.28 43.49zM627.79 87C630.81 83.86 632.32 79.7833333 632.32 74.77 632.470804 70.2164 630.883416 65.7760042 627.88 62.35 625.07634 59.0944804 620.965461 57.2609036 616.67 57.35 612.365231 57.245242 608.220761 58.9845366 605.28 62.13 602.233333 65.3233333 600.71 69.5266667 600.71 74.74 600.71 79.7466667 602.19 83.8233333 605.15 86.97 608.141873 89.9917318 612.217687 91.6918556 616.47 91.6918556 620.722313 91.6918556 624.798127 89.9917318 627.79 86.97L627.79 87zM672.54 102.64C667.740475 100.023478 663.786034 96.0933185 661.14 91.31 655.614102 80.8340402 655.614102 68.3059598 661.14 57.83 663.851557 53.0133133 667.883196 49.0718834 672.76 46.47 677.997634 43.7216018 683.846373 42.3454279 689.76 42.47 694.826998 42.4663759 699.839521 43.5151918 704.48 45.55 709.047158 47.4854868 713.061038 50.5268258 716.16 54.4L704.89 64C701.33722 59.6885705 696.005403 57.2419039 690.42 57.36 688.10185 57.3348696 685.801433 57.76641 683.65 58.63 681.674321 59.4154238 679.888178 60.611867 678.41 62.14 676.94116 63.6923854 675.807633 65.5305373 675.08 67.54 674.279779 69.751609 673.880196 72.0881547 673.9 74.44 673.9 79.5266667 675.443333 83.6666667 678.53 86.86 681.680523 90.068902 686.036003 91.8038347 690.53 91.64 693.391367 91.6818249 696.225221 91.0767679 698.82 89.87 701.139887 88.7934842 703.220777 87.2634179 704.94 85.37L716.36 95.43C713.234373 98.9565288 709.350528 101.729239 705 103.54 699.92001 105.678339 694.451003 106.737405 688.94 106.65 683.220032 106.740739 677.572731 105.359905 672.54 102.64z"
        />
        <polygon
          fillRule="nonzero"
          points="749.15 80.88 740.39 90.75 740.39 105.59 723.74 105.59 723.74 11.94 740.39 11.94 740.39 68.52 740.64 68.52 762.81 43.52 782.31 43.52 760.39 68.24 782.68 105.62 764.11 105.62 749.33 80.91"
        />
      </g>
    </svg>
  ),
  brightbackChargebeeLogo: (
    <svg
      width="174"
      height="52"
      viewBox="0 0 174 52"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          opacity="0.87"
          d="M122.878 43.9281C122.815 43.8828 122.745 43.8508 122.669 43.8339C122.594 43.817 122.516 43.8157 122.441 43.83C122.365 43.8443 122.293 43.8739 122.229 43.917C122.165 43.9601 122.111 44.0158 122.07 44.0807C121.846 44.3866 121.556 44.6376 121.221 44.8149C120.886 44.9921 120.515 45.0908 120.137 45.1036C119.938 45.1192 119.738 45.0886 119.552 45.0141C119.367 44.9396 119.202 44.8232 119.069 44.6741C119.069 44.6741 119.04 44.6289 119.023 44.6176C121.883 43.0295 121.849 41.6675 121.725 41.1646C121.641 40.8584 121.457 40.5892 121.202 40.4006C120.946 40.2119 120.635 40.1148 120.318 40.1247C118.684 40.1247 117.599 41.8936 117.599 43.5438C117.6 43.7481 117.615 43.952 117.645 44.1541C116.994 44.6719 116.21 44.9952 115.384 45.0866C115.196 45.1011 115.006 45.0731 114.83 45.0047C114.654 44.9362 114.496 44.829 114.367 44.691C114.289 44.5985 114.224 44.4959 114.175 44.3858C116.362 43.7755 117.192 42.4135 117.034 41.3285C117.001 41.0011 116.848 40.6975 116.605 40.4754C116.363 40.2534 116.046 40.1286 115.717 40.1247C114.192 40.1247 113.09 41.6788 112.92 43.2104C112.641 43.1877 112.372 43.0985 112.134 42.9504C112.168 42.7125 112.189 42.4729 112.197 42.2327C112.211 41.7918 112.114 41.3543 111.914 40.9611C111.799 40.7584 111.632 40.5898 111.431 40.4726C111.229 40.3554 111 40.2939 110.767 40.2942C110.635 40.294 110.506 40.3289 110.393 40.3955C110.28 40.4621 110.186 40.5579 110.123 40.6729C109.84 41.1759 110.032 42.1536 110.546 42.9334C110.643 43.0876 110.754 43.2316 110.88 43.363C110.597 44.2502 109.998 45.0584 109.247 45.0584C109.096 45.063 108.946 45.0373 108.805 44.983C108.664 44.9286 108.536 44.8467 108.427 44.7419C108.073 44.2804 107.875 43.7183 107.862 43.1369C109.998 40.5373 111.049 37.9885 110.456 36.7848C110.363 36.5889 110.215 36.424 110.031 36.3098C109.846 36.1956 109.633 36.1368 109.416 36.1405C107.941 36.1405 107.06 38.0054 106.715 41.8371C106.715 42.0688 106.681 42.357 106.681 42.6622C105.901 43.702 104.596 45.0584 103.431 45.0584C103.29 45.0692 103.148 45.0443 103.019 44.986C102.889 44.9278 102.777 44.838 102.691 44.7249C102.678 44.7029 102.663 44.6821 102.646 44.6628C102.646 44.6628 102.68 44.6628 102.691 44.6345C105.568 42.8317 105.517 41.4697 105.381 40.9837C105.293 40.712 105.116 40.4774 104.88 40.3168C104.644 40.1562 104.361 40.0787 104.076 40.0965C102.408 40.0965 101.278 41.9614 101.278 43.702C101.281 43.8551 101.292 44.008 101.312 44.1598C100.775 44.5271 100.351 44.8606 99.9275 45.1827C99.9897 44.708 100.086 44.0976 100.199 43.1991C100.227 43.0126 100.244 42.86 100.261 42.7865C100.351 42.1253 99.238 41.9897 99.1307 42.7243C99.0233 43.459 98.6729 45.0584 97.7461 45.0584C97.1809 45.0584 96.8984 44.4932 96.9605 43.5947C97.0397 42.2214 97.8082 41.1024 98.752 41.1024C98.8556 41.1114 98.9551 41.1474 99.0404 41.2069C99.1257 41.2664 99.1939 41.3473 99.238 41.4415C99.5376 41.9614 100.464 41.5149 100.261 40.9668C100.146 40.679 99.9387 40.4376 99.6718 40.2801C99.405 40.1226 99.0934 40.0581 98.7859 40.0965C96.5875 40.0965 95.8924 42.2666 95.802 43.702C95.7794 43.9294 95.7794 44.1585 95.802 44.3858C95.6844 44.5624 95.532 44.7131 95.3542 44.8287C95.1764 44.9443 94.9769 45.0225 94.7678 45.0584C94.4231 45.0584 94.2027 44.6797 94.327 43.8094C94.4513 42.9391 94.5474 42.2779 94.5926 41.8823C94.8639 40.0682 92.5186 40.1134 92.5186 40.1134C92.5186 40.1134 92.4903 39.0453 91.5917 39.0453C91.4663 39.0484 91.3429 39.0776 91.2294 39.131C91.1159 39.1844 91.0147 39.2608 90.9323 39.3554C90.8499 39.4501 90.7881 39.5608 90.7509 39.6806C90.7136 39.8004 90.7016 39.9266 90.7158 40.0512C90.7216 40.2346 90.772 40.4137 90.8626 40.5732C90.9532 40.7327 91.0813 40.8678 91.2357 40.9668C91.1227 41.9162 90.6706 45.0584 89.6477 45.0584C89.1899 45.0584 89.1617 44.5893 89.2069 44.2502C89.269 43.7924 89.3481 43.0013 89.3821 42.7978C89.4725 42.1423 88.3592 42.0066 88.2518 42.7413C88.1444 43.476 87.794 45.0753 86.8672 45.0753C86.3021 45.0753 86.0195 44.4028 86.0647 43.5777C86.1438 42.1875 86.9124 41.1194 87.8562 41.1194C87.9606 41.1253 88.0614 41.1602 88.1472 41.2201C88.233 41.2799 88.3005 41.3625 88.3422 41.4584C88.5965 41.9727 89.5516 41.611 89.3651 40.9837C89.286 40.7068 88.9752 40.1134 87.8901 40.1134C85.6861 40.1134 84.9966 42.2779 84.9062 43.719C84.8892 43.9315 84.8892 44.1451 84.9062 44.3576C84.7918 44.546 84.6382 44.7076 84.4559 44.8314C84.2735 44.9553 84.0667 45.0384 83.8494 45.0753C83.5216 45.0753 83.2842 44.9058 83.3351 44.188C83.3633 43.8546 83.7589 41.5489 83.742 41.1363C83.6911 40.4299 83.3633 40.1247 82.5609 40.1247C81.9146 40.1276 81.2932 40.3738 80.8202 40.8142C80.8202 40.8142 81.2102 37.915 81.2893 37.3499C81.3684 36.7848 80.2042 36.7508 80.159 37.3499C80.1308 37.6042 79.8143 39.8987 79.5317 42.0349C78.8705 43.4421 77.5707 45.5783 75.6379 45.5783C71.9758 45.5783 73.66 37.819 77.096 37.819C77.8985 37.819 77.5368 39.0736 77.0056 39.8195C76.6269 40.3847 77.5707 40.9837 78.1358 40.1134C79.6108 37.6833 78.3732 36.7848 77.1921 36.7848C72.1058 36.7848 70.2183 46.6464 75.4966 46.6464C76.2247 46.6426 76.9406 46.4596 77.5813 46.1137C78.2219 45.7677 78.7675 45.2694 79.17 44.6628C79.0909 45.2279 79.0457 45.6404 79.0287 45.7196C78.9383 46.3299 80.1138 46.2847 80.159 45.7648C80.2042 45.4427 80.3794 44.0694 80.5207 43.0295C80.5998 42.4361 81.3515 41.3341 82.2161 41.3341C82.2615 41.3362 82.3059 41.3475 82.3467 41.3673C82.3876 41.3872 82.4239 41.4152 82.4535 41.4496C82.4832 41.484 82.5055 41.524 82.5191 41.5673C82.5327 41.6107 82.5373 41.6563 82.5326 41.7014C82.4987 41.8992 82.1426 44.4819 82.154 44.8606C82.2161 45.9456 83.0186 46.1886 83.7759 46.1886C84.0576 46.1843 84.3351 46.1195 84.5896 45.9986C84.8441 45.8777 85.0696 45.7035 85.2509 45.4879C85.3764 45.7053 85.558 45.8851 85.7767 46.0084C85.9954 46.1316 86.2432 46.1939 86.4942 46.1886C86.8299 46.2077 87.1646 46.1358 87.463 45.9806C87.7613 45.8255 88.0124 45.5928 88.1896 45.307C88.2565 45.581 88.4205 45.8214 88.6513 45.9836C88.882 46.1457 89.1638 46.2186 89.4442 46.1886C91.6765 46.1886 92.1908 42.4192 92.3038 41.1476C92.4281 41.1476 93.2137 41.1985 93.355 41.6223C93.4963 42.0462 93.0894 43.3516 93.0554 44.708C93.0236 44.9037 93.0375 45.1042 93.0962 45.2936C93.1548 45.483 93.2566 45.6563 93.3935 45.7998C93.5304 45.9433 93.6987 46.0531 93.8852 46.1205C94.0717 46.188 94.2713 46.2113 94.4683 46.1886C95.0982 46.1873 95.7041 45.9469 96.1637 45.5161C96.2909 45.7262 96.4712 45.899 96.6866 46.017C96.9019 46.1351 97.1445 46.1943 97.39 46.1886C97.8604 46.2042 98.3229 46.0653 98.7068 45.793C98.7068 45.9174 98.6785 46.0247 98.6616 46.1434C98.6616 46.1434 95.7229 48.1892 95.7229 50.0994C95.7018 50.2722 95.721 50.4475 95.7788 50.6116C95.8367 50.7758 95.9317 50.9244 96.0564 51.0459C96.1811 51.1673 96.3322 51.2583 96.4978 51.3117C96.6635 51.3652 96.8392 51.3796 97.0114 51.354C98.8481 51.354 99.4302 48.9578 99.6958 46.9855C99.7147 46.9 99.7261 46.813 99.7297 46.7255L100.544 46.1152C100.922 45.8269 101.301 45.55 101.725 45.2449L101.787 45.3353C101.984 45.5956 102.241 45.8042 102.536 45.9431C102.831 46.0819 103.156 46.1468 103.482 46.1321C104.822 46.1321 106.059 45.1375 106.941 44.1598C107.066 44.641 107.302 45.0862 107.63 45.4596C107.846 45.6818 108.106 45.8572 108.393 45.9748C108.68 46.0925 108.988 46.1498 109.297 46.1434C110.569 46.1434 111.451 45.1544 111.92 44.0072C112.279 44.1603 112.661 44.2538 113.05 44.2841C113.13 44.6701 113.303 45.0309 113.553 45.3353C113.791 45.6059 114.086 45.8192 114.418 45.9591C114.75 46.0991 115.109 46.1621 115.469 46.1434C116.443 46.078 117.38 45.7391 118.17 45.1657L118.266 45.307C118.509 45.5857 118.811 45.8057 119.151 45.9506C119.49 46.0955 119.858 46.1614 120.227 46.1434C120.796 46.1265 121.352 45.9803 121.856 45.7159C122.359 45.4515 122.796 45.0759 123.132 44.6176C123.179 44.4912 123.179 44.3523 123.132 44.2258C123.086 44.0994 122.995 43.9938 122.878 43.9281V43.9281ZM97.0849 50.3424C97.0431 50.3443 97.0013 50.3371 96.9626 50.3213C96.9238 50.3055 96.889 50.2814 96.8605 50.2507C96.832 50.2201 96.8105 50.1836 96.7975 50.1438C96.7845 50.104 96.7804 50.0618 96.7854 50.0203C96.7854 49.0426 98.3395 47.7145 98.3564 47.7145C98.1699 49.0313 97.6218 50.3424 97.0849 50.3424V50.3424ZM104.03 41.1759C104.172 41.1759 104.2 41.2832 104.234 41.3454C104.296 41.5602 104.076 42.3683 102.391 43.4986C102.488 42.4305 103.166 41.1759 104.03 41.1759V41.1759ZM109.371 37.316C109.857 37.316 109.461 38.9323 107.907 41.1928C108.269 38.1863 108.772 37.299 109.371 37.299V37.316ZM115.587 41.1759C115.842 41.1759 115.859 41.4245 115.87 41.5149C115.932 41.9727 115.497 42.7978 114.05 43.2725C114.209 42.2779 114.881 41.1759 115.587 41.1759V41.1759ZM120.301 41.1759C120.476 41.1759 120.566 41.3002 120.617 41.4528C120.708 41.7749 120.272 42.5831 118.73 43.4986C118.764 42.4305 119.425 41.1759 120.301 41.1759Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.5052 18.7512C27.5911 18.8833 27.6368 19.0374 27.6368 19.1949C27.6368 19.3524 27.5911 19.5065 27.5052 19.6385L24.0692 25.1825C23.9888 25.3073 23.8784 25.41 23.7481 25.4811C23.6177 25.5521 23.4717 25.5894 23.3232 25.5894H0L3.95596 19.2147L7.91192 12.8173L11.8679 19.2147H19.8081L15.8521 12.8173L19.8081 6.41996H11.9074L7.95148 12.8173H0L3.95596 6.41996L7.91192 0.0226043H23.2949C23.4432 0.0204506 23.5894 0.0574928 23.7188 0.129982C23.8506 0.202373 23.9615 0.307475 24.0409 0.43516L27.477 5.9735C27.5617 6.10909 27.6066 6.26574 27.6066 6.42561C27.6066 6.58547 27.5617 6.74213 27.477 6.87772L23.7866 12.8343L27.5052 18.7512Z"
        />
        <path d="M48.0818 13.1733V13.1168C48.9695 12.7768 49.7274 12.1657 50.2479 11.3703C50.7683 10.5749 51.0249 9.63569 50.981 8.68615C50.981 5.61181 48.8391 3.80337 44.3915 3.80337H36.8469V23.8431H45.6291C49.9129 23.8431 52.0208 21.4695 52.0208 18.2539C52.0208 15.7673 50.7832 13.908 48.0818 13.1733ZM41.4641 7.95148H43.5155C45.3974 7.95148 46.2169 8.74267 46.2169 9.87294C46.2169 11.1388 45.0866 11.7888 43.6851 11.7888H41.4584L41.4641 7.95148ZM44.1654 19.7176H41.4641V15.4847H44.1654C46.1943 15.4847 47.1211 16.3607 47.1211 17.604C47.1211 19.0169 45.9117 19.7176 44.1654 19.7176Z" />
        <path d="M62.3233 9.75992C61.5347 9.77199 60.7604 9.97274 60.0653 10.3454C59.3702 10.718 58.7744 11.2517 58.3278 11.9018H58.2939V10.0425H53.8745V23.8431H58.2939V17.6266C58.2939 15.8182 59.3676 14.4958 61.453 14.4958C61.6734 14.4958 62.069 14.4958 62.4646 14.524V9.78252C62.4216 9.7586 62.3716 9.7506 62.3233 9.75992V9.75992Z" />
        <path d="M66.2114 8.37533C66.7124 8.34009 67.1921 8.15924 67.5917 7.85502C67.9913 7.5508 68.2932 7.13647 68.4605 6.66295C68.6277 6.18943 68.653 5.67736 68.5332 5.18968C68.4133 4.70199 68.1536 4.25995 67.7859 3.91789C67.4182 3.57582 66.9586 3.34864 66.4636 3.26427C65.9685 3.17989 65.4596 3.24201 64.9994 3.44297C64.5391 3.64393 64.1476 3.97497 63.873 4.39543C63.5984 4.81588 63.4526 5.30742 63.4536 5.80961C63.4583 6.16162 63.5344 6.50903 63.6771 6.83084C63.8198 7.15265 64.0263 7.4422 64.284 7.68199C64.5418 7.92179 64.8455 8.10686 65.1768 8.22602C65.508 8.34519 65.86 8.39598 66.2114 8.37533V8.37533ZM64.0187 23.8431H68.3816V10.0425H64.0187V23.8431Z" />
        <path d="M80.4755 10.0425V11.4214C79.967 10.8857 79.3529 10.4614 78.6719 10.1754C77.9909 9.88943 77.258 9.74794 76.5195 9.75992C73.027 9.75992 70.3821 12.7212 70.3821 16.7846C70.3821 20.7066 73.027 23.5662 76.7456 23.5662C77.4447 23.5959 78.1423 23.4779 78.7928 23.2198C79.4433 22.9618 80.032 22.5695 80.5207 22.0686H80.6055V23.3684C80.6055 24.8039 79.3904 25.9907 76.9999 25.9907C75.523 25.9641 74.0783 25.5552 72.8066 24.8039L71.8176 28.3586C73.5506 29.2938 75.5008 29.7521 77.469 29.6866C83.0412 29.6866 84.9005 26.5275 84.9005 22.0403V10.0425H80.4755ZM77.7685 19.6498C77.179 19.6633 76.5988 19.5008 76.1021 19.1831C75.6053 18.8654 75.2145 18.4068 74.9795 17.866C74.7445 17.3252 74.676 16.7266 74.7827 16.1467C74.8894 15.5668 75.1665 15.0318 75.5786 14.61C75.9907 14.1883 76.5191 13.8989 77.0964 13.7788C77.6738 13.6587 78.2738 13.7134 78.8199 13.9358C79.366 14.1583 79.8334 14.5384 80.1625 15.0277C80.4916 15.5169 80.6675 16.0932 80.6676 16.6828C80.6856 17.071 80.6234 17.4587 80.4849 17.8216C80.3463 18.1846 80.1343 18.5152 79.8622 18.7925C79.5902 19.0699 79.2638 19.2882 78.9035 19.4338C78.5433 19.5793 78.1569 19.649 77.7685 19.6385V19.6498Z" />
        <path d="M96.0111 9.75992C95.2026 9.7427 94.4001 9.90276 93.66 10.2289C92.9199 10.555 92.2603 11.0392 91.7274 11.6475V3.06869H87.308V23.8431H91.7274V16.8693C91.7274 14.7275 92.7446 13.7102 94.2931 13.7102C95.8416 13.7102 96.5536 14.3884 96.5536 16.5868V23.8431H100.979V15.513C100.996 11.1671 98.899 9.75992 96.0111 9.75992Z" />
        <path d="M107.862 24.0918C109.209 24.1609 110.548 23.839 111.716 23.165L110.62 19.8872C110.201 20.104 109.74 20.2292 109.269 20.2545C108.427 20.2545 108.229 19.582 108.229 18.6778V13.6255H111.552V10.0425H108.229V5.1597L103.81 5.61181V10.0425H102.29V13.6255H103.838V19.4972C103.81 22.6055 105.5 24.0918 107.862 24.0918Z" />
        <path d="M121.776 9.75992C121.034 9.7436 120.299 9.89174 119.622 10.1937C118.944 10.4956 118.343 10.9439 117.859 11.5062H117.803V3.06869H113.383V23.8431H117.577V22.3455H117.633C118.106 22.9308 118.711 23.3947 119.399 23.6985C120.088 24.0022 120.838 24.1371 121.589 24.0918C125.359 24.0918 128.066 21.2152 128.066 16.9541C128.066 12.693 125.347 9.75992 121.776 9.75992ZM120.645 20.2262C118.899 20.2262 117.605 18.9321 117.605 16.9541C117.605 15.0665 118.871 13.682 120.617 13.682C122.363 13.682 123.573 15.01 123.573 16.9541C123.573 18.8982 122.392 20.2262 120.674 20.2262H120.645Z" />
        <path d="M139.329 10.0425V11.5062H139.301C138.837 10.9509 138.256 10.506 137.599 10.2039C136.942 9.90182 136.226 9.75013 135.503 9.75991C131.926 9.75991 129.196 12.7212 129.196 16.9541C129.196 21.187 131.897 24.0918 135.701 24.0918C136.431 24.1268 137.16 23.9865 137.825 23.6827C138.491 23.379 139.074 22.9205 139.527 22.3455H139.583V23.8431H143.748V10.0425H139.329ZM136.599 20.2149C134.904 20.2149 133.672 18.8925 133.672 16.9428C133.672 14.9931 134.938 13.6707 136.627 13.6707C138.317 13.6707 139.527 15.0552 139.527 16.9428C139.527 18.9321 138.204 20.2262 136.599 20.2262V20.2149Z" />
        <path d="M152.672 24.12C155.571 24.12 157.707 22.9898 158.888 21.5543L155.882 18.9321C155.532 19.3263 155.102 19.6407 154.62 19.8543C154.139 20.0678 153.617 20.1754 153.09 20.1697C151.236 20.1697 149.965 18.8473 149.965 16.8976C149.965 14.9479 151.18 13.7102 153.033 13.7102C153.575 13.7002 154.111 13.8148 154.601 14.0451C155.091 14.2754 155.521 14.6152 155.859 15.0383L158.815 12.5234C158.096 11.6446 157.188 10.9395 156.159 10.461C155.129 9.98246 154.005 9.7428 152.87 9.75992C148.535 9.75992 145.495 12.693 145.495 16.9541C145.456 17.9064 145.616 18.8562 145.963 19.7438C146.31 20.6313 146.838 21.4371 147.512 22.1105C148.187 22.7839 148.993 23.3101 149.881 23.656C150.769 24.0019 151.72 24.1599 152.672 24.12V24.12Z" />
        <path d="M166.258 18.7908L169.129 23.8431H174L169.157 15.4282L173.887 10.0425H168.801L164.805 14.6144H164.777V3.06869H160.358V23.8431H164.777V20.424L166.212 18.7908H166.258Z" />
        <path
          d="M66.6862 45.7761C66.6052 45.7839 66.5235 45.7754 66.4458 45.7511C66.3682 45.7268 66.2962 45.6873 66.2341 45.6348C66.1392 45.5274 66.0887 45.3881 66.0928 45.2449C66.0941 45.1441 66.1055 45.0438 66.1267 44.9453L66.2227 44.448H66.1888C65.9896 44.8837 65.6962 45.2697 65.3298 45.5783C64.9881 45.8332 64.5691 45.9629 64.143 45.9456C63.8706 45.9482 63.6008 45.8923 63.3518 45.7818C63.1332 45.6684 62.9407 45.5106 62.7867 45.3183C62.6202 45.1064 62.4956 44.8648 62.4194 44.6063C62.3253 44.2987 62.2796 43.9784 62.2837 43.6568C62.2846 43.1653 62.3454 42.6757 62.4646 42.1988C62.5785 41.735 62.7695 41.2937 63.0297 40.8933C63.2694 40.5152 63.5898 40.1949 63.9678 39.9552C64.3504 39.7053 64.7996 39.5773 65.2564 39.5878C65.6443 39.5758 66.0268 39.6823 66.3527 39.893C66.6606 40.0923 66.8809 40.4016 66.9687 40.7577H67.0026L67.2061 39.7291H67.8164L66.7257 45.211H67.6525L67.5339 45.7761H66.6862ZM64.3013 45.324C64.5366 45.3363 64.7717 45.2978 64.9907 45.211C65.2104 45.1055 65.4109 44.9642 65.5841 44.7928C65.8064 44.5951 65.997 44.3645 66.1493 44.1089C66.3242 43.8217 66.4413 43.503 66.494 43.1708L66.7822 41.758C66.8209 41.5716 66.8209 41.3792 66.7822 41.1928C66.7505 41.0071 66.6727 40.8323 66.5562 40.6842C66.4237 40.5223 66.2499 40.3993 66.0532 40.3282C65.8142 40.2262 65.5557 40.178 65.2959 40.1869C65.0341 40.1782 64.7734 40.224 64.5302 40.3213C64.287 40.4185 64.0667 40.5652 63.8831 40.752C63.4884 41.193 63.2294 41.7385 63.1371 42.3231L62.9958 43.0352L62.945 43.363C62.945 43.476 62.945 43.6003 62.945 43.7303C62.9423 43.9473 62.967 44.1637 63.0184 44.3745C63.0677 44.562 63.152 44.7385 63.2671 44.8945C63.3863 45.041 63.537 45.1588 63.7079 45.2392C63.8959 45.3075 64.096 45.3364 64.2956 45.324H64.3013Z"
          fill="black"
        />
        <path
          d="M128.766 45.9174C128.458 45.9244 128.151 45.8647 127.868 45.7422C127.611 45.6279 127.384 45.458 127.201 45.2449C127.018 45.0153 126.882 44.7523 126.8 44.4706C126.706 44.1475 126.66 43.8124 126.664 43.476C126.661 42.9622 126.729 42.4505 126.868 41.9558C126.988 41.5119 127.179 41.0902 127.433 40.7068C127.676 40.3612 127.992 40.0737 128.36 39.8648C128.741 39.657 129.169 39.5518 129.603 39.5596C130.059 39.5412 130.507 39.6788 130.874 39.9495C131.204 40.204 131.434 40.566 131.524 40.9724L130.959 41.1928C130.898 40.8788 130.725 40.5975 130.473 40.4012C130.22 40.2048 129.905 40.1066 129.586 40.1247C129.339 40.1226 129.095 40.1717 128.868 40.269C128.641 40.3662 128.437 40.5096 128.269 40.6899C127.89 41.0927 127.641 41.6011 127.557 42.1479L127.388 42.9787C127.388 43.0917 127.359 43.1991 127.342 43.3008C127.325 43.4025 127.342 43.4929 127.342 43.6003C127.327 44.0436 127.456 44.4798 127.71 44.8436C127.843 45.013 128.015 45.1469 128.213 45.2337C128.41 45.3204 128.625 45.3573 128.84 45.3409C129.186 45.3446 129.526 45.242 129.812 45.0471C130.151 44.785 130.431 44.4537 130.631 44.075L131.151 44.3237C130.912 44.785 130.572 45.1867 130.157 45.4992C129.75 45.7839 129.263 45.9305 128.766 45.9174V45.9174Z"
          fill="black"
        />
        <path
          d="M134.186 45.9174C133.899 45.929 133.613 45.8791 133.347 45.7709C133.081 45.6627 132.841 45.4987 132.643 45.2901C132.241 44.8002 132.039 44.1764 132.078 43.5438C132.076 43.0349 132.148 42.5284 132.293 42.0405C132.42 41.5853 132.625 41.1552 132.898 40.769C133.155 40.4069 133.489 40.1058 133.875 39.8873C134.268 39.6658 134.713 39.5526 135.164 39.5596C135.449 39.5462 135.734 39.5954 135.999 39.7037C136.264 39.8121 136.501 39.977 136.695 40.1869C137.102 40.6742 137.305 41.2999 137.26 41.9332C137.264 42.4459 137.192 42.9563 137.046 43.4477C136.914 43.9036 136.706 44.3337 136.43 44.7193C136.175 45.0805 135.843 45.3799 135.458 45.5952C135.069 45.8112 134.631 45.9222 134.186 45.9174V45.9174ZM134.271 45.3522C134.525 45.3572 134.777 45.3096 135.011 45.2123C135.245 45.1151 135.457 44.9703 135.633 44.7871C136.048 44.3413 136.319 43.7795 136.407 43.1764L136.548 42.4531C136.571 42.34 136.588 42.2327 136.599 42.1309C136.599 42.0236 136.599 41.9049 136.599 41.7862C136.6 41.5697 136.567 41.3544 136.503 41.1476C136.445 40.9576 136.347 40.7823 136.215 40.6333C136.087 40.4834 135.924 40.367 135.74 40.2942C135.532 40.1872 135.302 40.1293 135.068 40.1247C134.813 40.1206 134.561 40.1686 134.325 40.2658C134.09 40.363 133.877 40.5073 133.7 40.6899C133.289 41.1405 133.022 41.7031 132.931 42.3061L132.79 43.0295C132.762 43.1387 132.745 43.2504 132.739 43.363C132.739 43.4647 132.739 43.5777 132.739 43.6964C132.73 44.1058 132.864 44.5057 133.118 44.8267C133.257 44.9955 133.434 45.1295 133.634 45.2178C133.834 45.3061 134.052 45.3464 134.271 45.3353V45.3522Z"
          fill="black"
        />
        <path
          d="M138.176 45.7761L139.385 39.7009H140.052L139.804 40.9216H139.849C140.023 40.5291 140.288 40.1841 140.623 39.9156C140.949 39.6738 141.347 39.5484 141.753 39.5596C141.944 39.5465 142.134 39.5746 142.313 39.6418C142.491 39.7091 142.653 39.8141 142.787 39.9495C143.041 40.225 143.189 40.5813 143.206 40.9555H143.262C143.434 40.5491 143.708 40.1945 144.059 39.9269C144.406 39.6744 144.828 39.5451 145.257 39.5596C145.465 39.5443 145.674 39.5743 145.869 39.6475C146.064 39.7206 146.241 39.8353 146.387 39.9834C146.671 40.3199 146.813 40.7536 146.783 41.1928C146.783 41.3115 146.783 41.4415 146.783 41.5771C146.773 41.7123 146.752 41.8465 146.721 41.9784L146.082 45.2109H147.003L146.885 45.7761H146.009C145.857 45.7839 145.706 45.7423 145.579 45.6574C145.527 45.6099 145.486 45.5511 145.46 45.4855C145.433 45.42 145.422 45.3493 145.427 45.2788C145.423 45.2279 145.423 45.177 145.427 45.1262C145.427 45.0697 145.427 45.0075 145.466 44.9453L146.031 41.9897C146.059 41.8652 146.076 41.7385 146.082 41.611C146.089 41.5038 146.089 41.3962 146.082 41.2889C146.082 40.5354 145.726 40.1586 145.014 40.1586C144.79 40.1581 144.568 40.2063 144.364 40.2999C144.145 40.4002 143.952 40.549 143.799 40.7351C143.616 40.9377 143.464 41.1662 143.347 41.4132C143.217 41.6678 143.126 41.9401 143.076 42.2214L142.414 45.7761H141.736L142.494 41.9897C142.522 41.8653 142.539 41.7354 142.556 41.611C142.563 41.5 142.563 41.3886 142.556 41.2776C142.556 40.526 142.217 40.1473 141.539 40.1473C141.305 40.1472 141.075 40.1976 140.863 40.2952C140.652 40.3927 140.464 40.5351 140.312 40.7125C140.117 40.924 139.95 41.1595 139.815 41.4132C139.679 41.6728 139.574 41.948 139.504 42.2327L138.826 45.7761H138.176Z"
          fill="black"
        />
        <path
          d="M149.196 39.7009H149.852L149.58 41.0289H149.614C149.812 40.5937 150.103 40.2077 150.468 39.8987C150.809 39.6438 151.228 39.5141 151.654 39.5313C151.925 39.5249 152.194 39.5809 152.44 39.6952C152.661 39.8057 152.854 39.964 153.005 40.1586C153.179 40.372 153.307 40.6179 153.384 40.882C153.472 41.1868 153.516 41.5028 153.514 41.8201C153.515 42.3162 153.45 42.8103 153.322 43.2895C153.211 43.7542 153.019 44.196 152.756 44.595C152.518 44.97 152.202 45.2899 151.83 45.5331C151.442 45.775 150.992 45.8987 150.536 45.8891C150.147 45.9005 149.764 45.7984 149.433 45.5952C149.131 45.3854 148.916 45.0717 148.829 44.7136H148.789L148.117 48.1044H147.501L149.196 39.7009ZM150.519 45.324C150.778 45.332 151.036 45.2859 151.276 45.1886C151.516 45.0913 151.734 44.9449 151.914 44.7588C152.318 44.3193 152.583 43.7711 152.677 43.1821L152.819 42.47C152.836 42.3596 152.847 42.2483 152.853 42.1366C152.862 42.0143 152.862 41.8915 152.853 41.7693C152.856 41.5538 152.829 41.3388 152.773 41.1307C152.73 40.9445 152.645 40.7705 152.525 40.622C152.414 40.4716 152.266 40.3527 152.095 40.2773C151.903 40.185 151.692 40.1404 151.479 40.1473C151.242 40.1427 151.006 40.1909 150.79 40.2886C150.582 40.3965 150.391 40.5356 150.225 40.7012C150.006 40.9042 149.816 41.1362 149.66 41.3906C149.495 41.6812 149.384 41.999 149.332 42.3288L149.044 43.7416C149.008 43.9283 149.008 44.1201 149.044 44.3067C149.083 44.4922 149.164 44.6662 149.281 44.8153C149.412 44.9746 149.578 45.1005 149.767 45.1827C150.003 45.2742 150.254 45.3221 150.507 45.324H150.519Z"
          fill="black"
        />
        <path
          d="M159.035 45.7761C158.954 45.7839 158.873 45.7754 158.795 45.7511C158.717 45.7268 158.645 45.6873 158.583 45.6348C158.488 45.5274 158.438 45.3881 158.442 45.2449C158.443 45.1441 158.455 45.0438 158.476 44.9453L158.572 44.448H158.532C158.337 44.8844 158.045 45.2708 157.679 45.5783C157.393 45.7766 157.062 45.8993 156.716 45.9349C156.37 45.9705 156.021 45.9178 155.701 45.7818C155.471 45.6706 155.267 45.5127 155.102 45.3183C154.938 45.1047 154.814 44.8636 154.734 44.6063C154.645 44.2978 154.601 43.978 154.605 43.6568C154.605 43.1653 154.666 42.6757 154.785 42.1988C154.899 41.735 155.09 41.2937 155.35 40.8933C155.59 40.5166 155.908 40.1965 156.283 39.9552C156.667 39.7042 157.118 39.5761 157.577 39.5878C157.965 39.5765 158.347 39.6829 158.673 39.893C158.981 40.0923 159.202 40.4016 159.289 40.7577H159.323L159.527 39.7291H160.177L159.08 45.211H160.007L159.889 45.7761H159.035ZM156.645 45.324C156.882 45.3287 157.118 45.2804 157.334 45.1827C157.555 45.08 157.756 44.9383 157.928 44.7645C158.151 44.5681 158.342 44.3373 158.493 44.0807C158.665 43.7923 158.782 43.4741 158.837 43.1426L159.12 41.7297C159.159 41.5433 159.159 41.351 159.12 41.1646C159.091 40.978 159.013 40.8024 158.894 40.656C158.764 40.4938 158.592 40.3706 158.397 40.2999C158.158 40.1979 157.899 40.1497 157.639 40.1586C157.378 40.15 157.117 40.1957 156.874 40.293C156.63 40.3903 156.41 40.537 156.226 40.7238C155.83 41.1635 155.571 41.7096 155.48 42.2948L155.334 43.0069L155.288 43.3347C155.288 43.4477 155.288 43.5721 155.288 43.702C155.286 43.919 155.31 44.1355 155.362 44.3463C155.409 44.5346 155.493 44.7115 155.61 44.8662C155.729 45.0113 155.877 45.1289 156.046 45.211C156.235 45.2893 156.439 45.3278 156.645 45.324V45.324Z"
          fill="black"
        />
        <path
          d="M161.064 45.7761L162.279 39.7009H162.94L162.692 40.9216H162.759C162.935 40.5221 163.207 40.1725 163.551 39.9043C163.895 39.6657 164.307 39.5448 164.726 39.5596C164.942 39.5417 165.159 39.5715 165.362 39.6466C165.565 39.7218 165.749 39.8406 165.902 39.9947C166.18 40.3361 166.319 40.7701 166.292 41.2098C166.299 41.3359 166.299 41.4623 166.292 41.5884C166.283 41.7235 166.265 41.8576 166.235 41.9897L165.585 45.2109H166.512L166.393 45.7761H165.517C165.365 45.7847 165.214 45.743 165.088 45.6574C165.035 45.6099 164.995 45.5511 164.968 45.4855C164.942 45.42 164.93 45.3493 164.935 45.2788C164.932 45.2279 164.932 45.177 164.935 45.1262C164.942 45.0651 164.953 45.0046 164.969 44.9453L165.562 41.9897C165.562 41.8653 165.602 41.741 165.613 41.6223C165.625 41.5036 165.613 41.3906 165.613 41.3115C165.613 40.5373 165.246 40.153 164.483 40.153C164.248 40.1521 164.015 40.2002 163.799 40.2943C163.564 40.3937 163.352 40.542 163.178 40.7294C162.994 40.9363 162.834 41.1639 162.703 41.4076C162.564 41.6733 162.461 41.9566 162.398 42.2496L161.731 45.7761H161.064Z"
          fill="black"
        />
        <path
          d="M172.101 39.7009H172.802L168.484 47.4376C168.383 47.6542 168.236 47.8468 168.055 48.0027C167.892 48.1226 167.691 48.1807 167.49 48.1666H166.563L166.681 47.6015H167.738L168.659 45.9061L167.653 39.6896H168.292L169.134 45.0414H169.185L172.101 39.7009Z"
          fill="black"
        />
      </g>
    </svg>
  ),
  brightbackIcon,
  brightbackjs: brightbackIcon, // referencedy by integration.data_type
  brightbackMiniLogo: (
    <svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1">
      <g
        id="Reasons-map"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="v3-01-TAB:-Reasons---default"
          transform="translate(-1130.000000, -828.000000)"
        >
          <g id="Group-13" transform="translate(1101.000000, 694.000000)">
            <g
              id="Dynamic-group-Copy"
              transform="translate(29.000000, 131.000000)"
            >
              <g id="logomark" transform="translate(0.000000, 3.000000)">
                <polygon
                  id="Fill-110-Copy-11"
                  fill="#FF75B3"
                  points="16.7930029 18.3603635 11.1953353 18.3603635 13.9941691 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-10"
                  fill="#FF7575"
                  points="19.5918367 13.7702624 13.9941691 13.7702624 16.7930029 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-14"
                  fill="#C76ECC"
                  points="11.1953353 18.3603635 5.59766764 18.3603635 8.39650146 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-13"
                  fill="#EB73D5"
                  points="13.9941691 13.7702624 8.39650146 13.7702624 11.1953353 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-16"
                  fill="#745185"
                  points="5.59766764 18.3603635 0 18.3603635 2.79883382 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-15"
                  fill="#9260AB"
                  points="8.39650146 13.7702624 2.79883382 13.7702624 5.59766764 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-17"
                  fill="#745185"
                  points="8.39650146 13.7702761 2.79883382 13.7702761 5.59766764 9.18017493"
                />
                <polygon
                  id="Fill-110-Copy-12"
                  fill="#FF9C75"
                  points="19.5918367 13.7702761 13.9941691 13.7702761 16.7930029 9.18017493"
                />
                <polygon
                  id="Fill-110-Copy-9"
                  fill="#FFB575"
                  points="16.7930029 9.18017493 11.1953353 9.18017493 13.9941691 13.7702487"
                />
                <polygon
                  id="Fill-110"
                  fill="#5E3799"
                  points="5.59766764 9.18018859 0 9.18018859 2.79883382 4.59008746"
                />
                <polygon
                  id="Fill-110-Copy"
                  fill="#425AB8"
                  points="8.39650146 4.59008746 2.79883382 4.59008746 5.59766764 9.18016126"
                />
                <polygon
                  id="Fill-110-Copy-8"
                  fill="#FFD175"
                  points="16.7930029 9.18018859 11.1953353 9.18018859 13.9941691 4.59008746"
                />
                <polygon
                  id="Fill-110-Copy-7"
                  fill="#FFF175"
                  points="19.5918367 4.59008746 13.9941691 4.59008746 16.7930029 9.18016126"
                />
                <polygon
                  id="Fill-110-Copy-2"
                  fill="#0E96B8"
                  points="8.39650146 4.59010113 2.79883382 4.59010113 5.59766764 0"
                />
                <polygon
                  id="Fill-110-Copy-6"
                  fill="#A5ED4E"
                  points="19.5918367 4.59010113 13.9941691 4.59010113 16.7930029 0"
                />
                <polygon
                  id="Fill-110-Copy-3"
                  fill="#0CB07C"
                  points="11.1953353 0 5.59766764 0 8.39650146 4.5900738"
                />
                <polygon
                  id="Fill-110-Copy-5"
                  fill="#27BA51"
                  points="13.9941691 4.59010113 8.39650146 4.59010113 11.1953353 0"
                />
                <polygon
                  id="Fill-110-Copy-4"
                  fill="#6FD640"
                  points="16.7930029 0 11.1953353 0 13.9941691 4.5900738"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  brightbackPurple: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="174"
      height="30"
      viewBox="0 0 174 30"
    >
      <title>Brightback</title>
      <g fill="none" fillRule="evenodd">
        <polygon
          fill="#FF75B3"
          points="24.466 26.776 16.311 26.776 20.389 20.082"
        />
        <polygon
          fill="#FF7575"
          points="28.544 20.082 20.389 20.082 24.466 26.775"
        />
        <polygon
          fill="#C76ECC"
          points="16.311 26.776 8.155 26.776 12.233 20.082"
        />
        <polygon
          fill="#EB73D5"
          points="20.389 20.082 12.233 20.082 16.311 26.775"
        />
        <polygon fill="#745185" points="8.155 26.776 0 26.776 4.078 20.082" />
        <polygon
          fill="#9260AB"
          points="12.233 20.082 4.078 20.082 8.155 26.775"
        />
        <polygon
          fill="#745185"
          points="12.233 20.082 4.078 20.082 8.155 13.388"
        />
        <polygon
          fill="#FF9C75"
          points="28.544 20.082 20.389 20.082 24.466 13.388"
        />
        <polygon
          fill="#FFB575"
          points="24.466 13.388 16.311 13.388 20.389 20.082"
        />
        <polygon fill="#5E3799" points="8.155 13.388 0 13.388 4.078 6.694" />
        <polygon
          fill="#425AB8"
          points="12.233 6.694 4.078 6.694 8.155 13.388"
        />
        <polygon
          fill="#FFD175"
          points="24.466 13.388 16.311 13.388 20.389 6.694"
        />
        <polygon
          fill="#FFF175"
          points="28.544 6.694 20.389 6.694 24.466 13.388"
        />
        <polygon fill="#0E96B8" points="12.233 6.694 4.078 6.694 8.155 0" />
        <polygon fill="#A5ED4E" points="28.544 6.694 20.389 6.694 24.466 0" />
        <polygon fill="#0CB07C" points="16.311 0 8.155 0 12.233 6.694" />
        <polygon fill="#27BA51" points="20.389 6.694 12.233 6.694 16.311 0" />
        <polygon fill="#6FD640" points="24.466 0 16.311 0 20.389 6.694" />
        <path
          fill="#230067"
          d="M45.9274368,12.8 C48.5534928,13.4571429 50.0377854,15.2857143 50.0377854,17.9714286 C50.0377854,21.2 47.8684347,23.5714286 43.4441012,23.5714286 L35.0521394,23.5714286 L35.0521394,3.28571429 L42.3594258,3.28571429 C46.669583,3.28571429 48.9816541,5 48.9816541,8.22857143 C48.9816541,10.0571429 48.1538756,11.9142857 45.9274368,12.7714286 L45.9274368,12.8 Z M38.9912235,6.82857143 L38.9912235,11.6 L41.8741763,11.6 C43.4726452,11.6 44.9283937,10.8571429 44.9283937,9.2 C44.9283937,7.77142857 43.9578947,6.82857143 41.6172796,6.82857143 L38.9912235,6.82857143 Z M42.2452495,20.0285714 C44.386056,20.0285714 45.8418045,19.2 45.8418045,17.4571429 C45.8418045,15.8571429 44.6714969,14.8285714 42.2737936,14.8285714 L38.9912235,14.8285714 L38.9912235,20.0285714 L42.2452495,20.0285714 Z M60.370745,9.4 C60.4849214,9.4 60.5990977,9.4 60.6561859,9.42857143 L60.6561859,13.4857143 C60.2851128,13.4571429 59.8854956,13.4571429 59.6856869,13.4571429 C57.3736159,13.4571429 56.117676,15.0285714 56.117676,17.0857143 L56.117676,23.5714286 L52.3784005,23.5714286 L52.3784005,9.62857143 L56.117676,9.62857143 L56.117676,11.6857143 L56.1462201,11.6857143 C57.2023513,10.2 58.715188,9.4 60.370745,9.4 Z M64.4240055,7.65714286 C63.1680656,7.65714286 62.1119344,6.62857143 62.1119344,5.37142857 C62.1119344,4.11428571 63.1680656,3.08571429 64.4240055,3.08571429 C65.7084894,3.08571429 66.7646206,4.11428571 66.7646206,5.37142857 C66.7646206,6.62857143 65.7084894,7.65714286 64.4240055,7.65714286 Z M62.5400957,23.5714286 L62.5400957,9.62857143 L66.2793712,9.62857143 L66.2793712,23.5714286 L62.5400957,23.5714286 Z M79.4096514,9.62857143 L83.1203828,9.62857143 L83.1203828,21.9714286 C83.1203828,26.3142857 81.2079289,29.4571429 75.8701846,29.4571429 C73.6722898,29.4571429 71.78838,28.9714286 70.132823,28.0571429 L71.0176897,24.8857143 C72.3878059,25.6571429 73.7579221,26.2 75.5276555,26.2 C78.1537116,26.2 79.4952837,24.8 79.4952837,23.0857143 L79.4952837,21.6857143 L79.4096514,21.6857143 C78.4391524,22.7428571 77.0404921,23.3142857 75.356391,23.3142857 C71.5029392,23.3142857 68.7056186,20.5142857 68.7056186,16.4571429 C68.7056186,12.3428571 71.4173069,9.4 75.1565824,9.4 C76.7265072,9.4 78.2107997,9.94285714 79.3240191,11.0571429 L79.4096514,11.0571429 L79.4096514,9.62857143 Z M76.0414491,19.9428571 C78.0966234,19.9428571 79.5523718,18.4285714 79.5523718,16.3142857 C79.5523718,14.1714286 78.0109911,12.8 76.0414491,12.8 C73.9577307,12.8 72.5019822,14.2285714 72.5019822,16.3428571 C72.5019822,18.5428571 74.043363,19.9428571 76.0414491,19.9428571 Z M94.3952973,9.4 C97.3924265,9.4 99.5332331,10.9428571 99.5332331,15.2 L99.5332331,23.5714286 L95.7939576,23.5714286 L95.7939576,16.1428571 C95.7939576,13.5714286 94.8520027,12.7428571 93.0822693,12.7428571 C91.0841832,12.7428571 89.7996992,14 89.7996992,16.4857143 L89.7996992,23.5714286 L86.0604238,23.5714286 L86.0604238,2.54285714 L89.7996992,2.54285714 L89.7996992,11.3142857 L89.8567874,11.3142857 C90.9985509,10.0285714 92.6255639,9.4 94.3952973,9.4 Z M106.726343,23.8 C104.32864,23.8 102.758715,22.3142857 102.758715,19.1714286 L102.758715,12.7142857 L101.103158,12.7142857 L101.103158,9.62857143 L102.758715,9.62857143 L102.758715,5.05714286 L106.469446,4.65714286 L106.469446,9.62857143 L110.26581,9.62857143 L110.26581,12.7142857 L106.469446,12.7142857 L106.469446,18.6571429 C106.469446,19.8571429 106.840519,20.4285714 107.696842,20.4285714 C108.153548,20.4285714 108.838606,20.2571429 109.466576,19.9428571 L110.437075,22.9428571 C109.523664,23.4285714 108.610253,23.8 106.726343,23.8 Z M120.341873,9.4 C124.081148,9.4 126.907013,12.4 126.907013,16.6285714 C126.907013,20.9428571 124.109692,23.8 120.227697,23.8 C118.372331,23.8 116.945126,23.1142857 115.974627,21.8857143 L115.888995,21.8857143 L115.888995,23.5714286 L112.320984,23.5714286 L112.320984,2.54285714 L116.06026,2.54285714 L116.06026,11.2 L116.145892,11.2 C117.173479,10 118.629228,9.4 120.341873,9.4 Z M119.542638,20.4571429 C121.654901,20.4571429 123.110649,18.9142857 123.110649,16.6571429 C123.110649,14.2571429 121.540725,12.7428571 119.542638,12.7428571 C117.401832,12.7428571 115.888995,14.4285714 115.888995,16.6571429 C115.888995,18.9428571 117.516008,20.4571429 119.542638,20.4571429 Z M139.180971,9.62857143 L142.891702,9.62857143 L142.891702,23.5714286 L139.352235,23.5714286 L139.352235,21.8857143 L139.266603,21.8857143 C138.324648,23.1142857 136.897444,23.8 135.099166,23.8 C131.245714,23.8 128.448394,20.9428571 128.448394,16.6285714 C128.448394,12.4 131.274258,9.4 135.013534,9.4 C136.669091,9.4 138.096295,10 139.095338,11.2 L139.180971,11.2 L139.180971,9.62857143 Z M135.784224,20.4571429 C137.725222,20.4571429 139.323691,18.9428571 139.323691,16.6571429 C139.323691,14.4285714 137.839398,12.7428571 135.812768,12.7428571 C133.814682,12.7428571 132.216213,14.2571429 132.216213,16.6571429 C132.216213,18.9142857 133.700506,20.4571429 135.784224,20.4571429 Z M152.254163,23.8 C148.11527,23.8 145.089597,20.8857143 145.089597,16.6 C145.089597,12.3142857 148.11527,9.4 152.425427,9.4 C154.651866,9.4 156.935393,10.2857143 158.334053,12.0571429 L155.822174,14.2285714 C155.080027,13.3714286 153.995352,12.7428571 152.568148,12.7428571 C150.341709,12.7428571 148.857416,14.3142857 148.857416,16.5714286 C148.857416,18.8571429 150.398797,20.4571429 152.596692,20.4571429 C154.080984,20.4571429 155.194204,19.7714286 155.850718,19.0285714 L158.391141,21.2857143 C157.19229,22.6857143 155.051483,23.8 152.254163,23.8 Z M166.012413,18.0285714 L165.955325,18.0285714 L164.014327,20.2285714 L164.014327,23.5714286 L160.275051,23.5714286 L160.275051,2.54285714 L164.014327,2.54285714 L164.014327,15.2571429 L164.042871,15.2571429 L169.038086,9.62857143 L173.405332,9.62857143 L168.495748,15.1714286 L173.490964,23.5714286 L169.323527,23.5714286 L166.012413,18.0285714 Z"
        />
      </g>
    </svg>
  ),
  brightbackSolidPurple: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="174"
      height="30"
      viewBox="0 0 174 30"
    >
      <title>Brightback</title>
      <g fill="none" fillRule="evenodd">
        <polygon
          fill="#230067"
          points="24.466 26.776 16.311 26.776 20.389 20.082"
        />
        <polygon
          fill="#230067"
          points="28.544 20.082 20.389 20.082 24.466 26.775"
        />
        <polygon
          fill="#230067"
          points="16.311 26.776 8.155 26.776 12.233 20.082"
        />
        <polygon
          fill="#230067"
          points="20.389 20.082 12.233 20.082 16.311 26.775"
        />
        <polygon fill="#230067" points="8.155 26.776 0 26.776 4.078 20.082" />
        <polygon
          fill="#230067"
          points="12.233 20.082 4.078 20.082 8.155 26.775"
        />
        <polygon
          fill="#230067"
          points="12.233 20.082 4.078 20.082 8.155 13.388"
        />
        <polygon
          fill="#230067"
          points="28.544 20.082 20.389 20.082 24.466 13.388"
        />
        <polygon
          fill="#230067"
          points="24.466 13.388 16.311 13.388 20.389 20.082"
        />
        <polygon fill="#230067" points="8.155 13.388 0 13.388 4.078 6.694" />
        <polygon
          fill="#230067"
          points="12.233 6.694 4.078 6.694 8.155 13.388"
        />
        <polygon
          fill="#230067"
          points="24.466 13.388 16.311 13.388 20.389 6.694"
        />
        <polygon
          fill="#230067"
          points="28.544 6.694 20.389 6.694 24.466 13.388"
        />
        <polygon fill="#230067" points="12.233 6.694 4.078 6.694 8.155 0" />
        <polygon fill="#230067" points="28.544 6.694 20.389 6.694 24.466 0" />
        <polygon fill="#230067" points="16.311 0 8.155 0 12.233 6.694" />
        <polygon fill="#230067" points="20.389 6.694 12.233 6.694 16.311 0" />
        <polygon fill="#230067" points="24.466 0 16.311 0 20.389 6.694" />
        <path
          fill="#230067"
          d="M45.9274368,12.8 C48.5534928,13.4571429 50.0377854,15.2857143 50.0377854,17.9714286 C50.0377854,21.2 47.8684347,23.5714286 43.4441012,23.5714286 L35.0521394,23.5714286 L35.0521394,3.28571429 L42.3594258,3.28571429 C46.669583,3.28571429 48.9816541,5 48.9816541,8.22857143 C48.9816541,10.0571429 48.1538756,11.9142857 45.9274368,12.7714286 L45.9274368,12.8 Z M38.9912235,6.82857143 L38.9912235,11.6 L41.8741763,11.6 C43.4726452,11.6 44.9283937,10.8571429 44.9283937,9.2 C44.9283937,7.77142857 43.9578947,6.82857143 41.6172796,6.82857143 L38.9912235,6.82857143 Z M42.2452495,20.0285714 C44.386056,20.0285714 45.8418045,19.2 45.8418045,17.4571429 C45.8418045,15.8571429 44.6714969,14.8285714 42.2737936,14.8285714 L38.9912235,14.8285714 L38.9912235,20.0285714 L42.2452495,20.0285714 Z M60.370745,9.4 C60.4849214,9.4 60.5990977,9.4 60.6561859,9.42857143 L60.6561859,13.4857143 C60.2851128,13.4571429 59.8854956,13.4571429 59.6856869,13.4571429 C57.3736159,13.4571429 56.117676,15.0285714 56.117676,17.0857143 L56.117676,23.5714286 L52.3784005,23.5714286 L52.3784005,9.62857143 L56.117676,9.62857143 L56.117676,11.6857143 L56.1462201,11.6857143 C57.2023513,10.2 58.715188,9.4 60.370745,9.4 Z M64.4240055,7.65714286 C63.1680656,7.65714286 62.1119344,6.62857143 62.1119344,5.37142857 C62.1119344,4.11428571 63.1680656,3.08571429 64.4240055,3.08571429 C65.7084894,3.08571429 66.7646206,4.11428571 66.7646206,5.37142857 C66.7646206,6.62857143 65.7084894,7.65714286 64.4240055,7.65714286 Z M62.5400957,23.5714286 L62.5400957,9.62857143 L66.2793712,9.62857143 L66.2793712,23.5714286 L62.5400957,23.5714286 Z M79.4096514,9.62857143 L83.1203828,9.62857143 L83.1203828,21.9714286 C83.1203828,26.3142857 81.2079289,29.4571429 75.8701846,29.4571429 C73.6722898,29.4571429 71.78838,28.9714286 70.132823,28.0571429 L71.0176897,24.8857143 C72.3878059,25.6571429 73.7579221,26.2 75.5276555,26.2 C78.1537116,26.2 79.4952837,24.8 79.4952837,23.0857143 L79.4952837,21.6857143 L79.4096514,21.6857143 C78.4391524,22.7428571 77.0404921,23.3142857 75.356391,23.3142857 C71.5029392,23.3142857 68.7056186,20.5142857 68.7056186,16.4571429 C68.7056186,12.3428571 71.4173069,9.4 75.1565824,9.4 C76.7265072,9.4 78.2107997,9.94285714 79.3240191,11.0571429 L79.4096514,11.0571429 L79.4096514,9.62857143 Z M76.0414491,19.9428571 C78.0966234,19.9428571 79.5523718,18.4285714 79.5523718,16.3142857 C79.5523718,14.1714286 78.0109911,12.8 76.0414491,12.8 C73.9577307,12.8 72.5019822,14.2285714 72.5019822,16.3428571 C72.5019822,18.5428571 74.043363,19.9428571 76.0414491,19.9428571 Z M94.3952973,9.4 C97.3924265,9.4 99.5332331,10.9428571 99.5332331,15.2 L99.5332331,23.5714286 L95.7939576,23.5714286 L95.7939576,16.1428571 C95.7939576,13.5714286 94.8520027,12.7428571 93.0822693,12.7428571 C91.0841832,12.7428571 89.7996992,14 89.7996992,16.4857143 L89.7996992,23.5714286 L86.0604238,23.5714286 L86.0604238,2.54285714 L89.7996992,2.54285714 L89.7996992,11.3142857 L89.8567874,11.3142857 C90.9985509,10.0285714 92.6255639,9.4 94.3952973,9.4 Z M106.726343,23.8 C104.32864,23.8 102.758715,22.3142857 102.758715,19.1714286 L102.758715,12.7142857 L101.103158,12.7142857 L101.103158,9.62857143 L102.758715,9.62857143 L102.758715,5.05714286 L106.469446,4.65714286 L106.469446,9.62857143 L110.26581,9.62857143 L110.26581,12.7142857 L106.469446,12.7142857 L106.469446,18.6571429 C106.469446,19.8571429 106.840519,20.4285714 107.696842,20.4285714 C108.153548,20.4285714 108.838606,20.2571429 109.466576,19.9428571 L110.437075,22.9428571 C109.523664,23.4285714 108.610253,23.8 106.726343,23.8 Z M120.341873,9.4 C124.081148,9.4 126.907013,12.4 126.907013,16.6285714 C126.907013,20.9428571 124.109692,23.8 120.227697,23.8 C118.372331,23.8 116.945126,23.1142857 115.974627,21.8857143 L115.888995,21.8857143 L115.888995,23.5714286 L112.320984,23.5714286 L112.320984,2.54285714 L116.06026,2.54285714 L116.06026,11.2 L116.145892,11.2 C117.173479,10 118.629228,9.4 120.341873,9.4 Z M119.542638,20.4571429 C121.654901,20.4571429 123.110649,18.9142857 123.110649,16.6571429 C123.110649,14.2571429 121.540725,12.7428571 119.542638,12.7428571 C117.401832,12.7428571 115.888995,14.4285714 115.888995,16.6571429 C115.888995,18.9428571 117.516008,20.4571429 119.542638,20.4571429 Z M139.180971,9.62857143 L142.891702,9.62857143 L142.891702,23.5714286 L139.352235,23.5714286 L139.352235,21.8857143 L139.266603,21.8857143 C138.324648,23.1142857 136.897444,23.8 135.099166,23.8 C131.245714,23.8 128.448394,20.9428571 128.448394,16.6285714 C128.448394,12.4 131.274258,9.4 135.013534,9.4 C136.669091,9.4 138.096295,10 139.095338,11.2 L139.180971,11.2 L139.180971,9.62857143 Z M135.784224,20.4571429 C137.725222,20.4571429 139.323691,18.9428571 139.323691,16.6571429 C139.323691,14.4285714 137.839398,12.7428571 135.812768,12.7428571 C133.814682,12.7428571 132.216213,14.2571429 132.216213,16.6571429 C132.216213,18.9142857 133.700506,20.4571429 135.784224,20.4571429 Z M152.254163,23.8 C148.11527,23.8 145.089597,20.8857143 145.089597,16.6 C145.089597,12.3142857 148.11527,9.4 152.425427,9.4 C154.651866,9.4 156.935393,10.2857143 158.334053,12.0571429 L155.822174,14.2285714 C155.080027,13.3714286 153.995352,12.7428571 152.568148,12.7428571 C150.341709,12.7428571 148.857416,14.3142857 148.857416,16.5714286 C148.857416,18.8571429 150.398797,20.4571429 152.596692,20.4571429 C154.080984,20.4571429 155.194204,19.7714286 155.850718,19.0285714 L158.391141,21.2857143 C157.19229,22.6857143 155.051483,23.8 152.254163,23.8 Z M166.012413,18.0285714 L165.955325,18.0285714 L164.014327,20.2285714 L164.014327,23.5714286 L160.275051,23.5714286 L160.275051,2.54285714 L164.014327,2.54285714 L164.014327,15.2571429 L164.042871,15.2571429 L169.038086,9.62857143 L173.405332,9.62857143 L168.495748,15.1714286 L173.490964,23.5714286 L169.323527,23.5714286 L166.012413,18.0285714 Z"
        />
      </g>
    </svg>
  ),
  apiAndChargebeejs: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#1d485f"
    >
      <path d="m384-336 56-57-87-87 87-87-56-57-144 144 144 144Zm192 0 144-144-144-144-56 57 87 87-87 87 56 57ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
    </svg>
  ),
  calendar: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M17.99944,9.92849072 L17.99944,15.0512409 C17.99944,16.287622 16.9839753,17.3036607 15.7470202,17.3036607 L6.25241981,17.3036607 C5.01603872,17.3036607 4,16.2881959 4,15.0512409 L4,9.92849072 L17.99944,9.92849072 Z M13.4951604,5.86545576 L13.4951604,7.0575444 C13.4951604,8.55920426 15.7475802,8.55920426 15.7475802,7.0575444 L15.7475802,5.86545576 C16.9839613,5.86545576 18,6.88092053 18,8.11787557 L18,9.3099642 L4.00111991,9.3099642 L4.00111991,8.11787557 C4.00111991,6.89056342 4.93372557,5.94697095 6.10013137,5.870469 L6.252,5.865 L6.25297976,7.0575444 C6.25297976,8.51482781 8.46102312,8.51482781 8.46102312,7.0575444 L8.46102312,5.86545576 L13.4951604,5.86545576 Z M7.974982,4.62913067 L7.974982,7.05821634 C7.974982,7.89705724 6.73860091,7.89705724 6.73860091,7.05821634 L6.73860091,4.62913067 C6.73860091,3.79028978 7.974982,3.79028978 7.974982,4.62913067 Z M13.9807815,4.62913067 C13.9807815,3.79028978 15.2171626,3.79028978 15.2171626,4.62913067 L15.2171626,4.62913067 L15.2171626,7.05821634 C15.2171626,7.89705724 13.9807815,7.89705724 13.9807815,7.05821634 L13.9807815,7.05821634 Z" />
    </svg>
  ),
  chat: (
    <svg width="20" height="18">
      <path
        d="M10 15.511c.933 0 1.845-.088 2.734-.289l4.421 2.356-.377-4.111c.155-.111.31-.222.467-.356C19.023 11.667 20 9.755 20 7.755 20 3.466 15.511 0 10 0S0 3.467 0 7.755c0 4.267 4.489 7.756 10 7.756zm3.155-7.578c0-.667.533-1.2 1.2-1.2.667 0 1.2.533 1.2 1.2 0 .667-.533 1.2-1.2 1.2-.666-.022-1.2-.555-1.2-1.2zm-1.955 0c0 .667-.533 1.2-1.2 1.2-.667 0-1.2-.533-1.2-1.2 0-.667.533-1.2 1.2-1.2.667 0 1.2.533 1.2 1.2zm-5.556-1.2c.667 0 1.2.533 1.2 1.2 0 .667-.533 1.2-1.2 1.2-.666 0-1.2-.533-1.2-1.2.023-.667.556-1.2 1.2-1.2z"
        fill="#000"
        opacity=".3"
      />
    </svg>
  ),
  check: (
    <svg width="18" height="14">
      <path
        d="M0 7.558l1.94-2.492L7.123 9.34 15.641 0 18 2.114 7.454 13.764z"
        fill="#10a069"
      />
    </svg>
  ),
  checkCircle: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m7.759 12.009 4.993-4.994-.991-.992-4.002 4.002-2.02-2.018-.99.991zm.991 3.825q-1.47 0-2.762-.558a7.2 7.2 0 0 1-2.25-1.514 7.2 7.2 0 0 1-1.513-2.25 6.9 6.9 0 0 1-.558-2.762q0-1.47.558-2.762a7.2 7.2 0 0 1 1.514-2.25 7.2 7.2 0 0 1 2.249-1.513 6.9 6.9 0 0 1 2.762-.558q1.47 0 2.763.558a7.2 7.2 0 0 1 2.249 1.514 7.2 7.2 0 0 1 1.514 2.249q.558 1.293.558 2.762t-.558 2.763a7.2 7.2 0 0 1-1.514 2.249 7.2 7.2 0 0 1-2.25 1.514 6.9 6.9 0 0 1-2.762.558m0-1.417q2.373 0 4.02-1.647t1.647-4.02-1.647-4.02-4.02-1.646T4.73 4.73Q3.085 6.376 3.085 8.75q0 2.371 1.647 4.02 1.645 1.646 4.02 1.646"
        fill="currentColor"
      />
    </svg>
  ),
  checkmark: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 11"
      width="14"
      height="11"
    >
      <path
        d="M9.06764833,13.1413828 L5.89389204,9.98890436 C5.78562148,9.8806338 5.60955304,9.88282178 5.50345786,9.98890436 L4.08120292,11.4199784 C3.97293236,11.528249 3.97293236,11.7043174 4.08120292,11.8125964 C5.68179967,13.4026942 7.2805766,14.992932 8.88117335,16.58079 C8.98944391,16.6890606 9.16551235,16.6890606 9.27379131,16.58079 L17.9207094,7.89397603 C18.026792,7.78570547 18.026792,7.60963703 17.9185221,7.50135807 L16.4874481,6.08120292 C16.3791775,5.97293236 16.2031091,5.97293236 16.0948301,6.08120292 L9.06824677,13.1422227 L9.06764833,13.1413828 Z"
        transform="translate(-4 -6)"
      />
    </svg>
  ),
  checkmarkEmpty: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="21"
        height="21"
        rx="1.5"
        stroke="black"
        strokeOpacity="0.15"
      />
    </svg>
  ),
  checkmarkSelected: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="21"
        height="21"
        rx="1.5"
        fill={tailwindColors.cbrprimary['600']}
        stroke={tailwindColors.cbrprimary['600']}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.665 6.46807C17.3406 6.03535 16.8537 5.60261 16.4752 5.22407C15.9883 4.84551 15.4472 4.95388 14.9068 5.49426C13.3384 7.22519 11.7693 8.90193 10.1467 10.6328C9.33544 11.4982 9.01107 11.3899 8.30743 10.7953C7.76634 10.3626 7.27944 9.87568 6.73905 9.38877C6.25215 8.90187 5.76524 8.90187 5.27832 9.44295C5.00813 9.76732 4.68305 10.1459 4.35867 10.4709C3.92595 11.012 3.81759 11.3906 4.41285 11.9859C5.71104 13.1215 7.11766 14.4198 8.41585 15.556C9.22713 16.3131 9.65985 16.3131 10.5253 15.3935C12.9057 12.8513 15.3396 10.1465 17.7198 7.60435C18.1526 7.17163 18.0436 6.79245 17.665 6.46807Z"
        fill="white"
      />
    </svg>
  ),
  chevronDown: (
    <svg width="10" height="5">
      <path d="M.273.192a1.004 1.004 0 0 1 1.182 0L5 3.355 8.546.192a1.004 1.004 0 0 1 1.181 0 .619.619 0 0 1 0 1.026l-4.273 3.59a1.004 1.004 0 0 1-1.181 0l-4-3.59C.09 1.048 0 .876 0 .705 0 .45.091.278.273.193" />
    </svg>
  ),
  chevronDownSmall: (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.283145 1.4369L4.30131 4.92476C4.30583 4.92868 4.30712 4.93428 4.31164 4.93764C4.50067 5.10172 4.75101 5.18349 5.00069 5.18293C5.25038 5.18349 5.50006 5.10228 5.68975 4.93764C5.69427 4.93372 5.69556 4.92868 5.70007 4.92476L9.71692 1.4369C10.0944 1.10928 10.0944 0.573342 9.71692 0.245718C9.33948 -0.0819061 8.72206 -0.0819061 8.34462 0.245718L5 3.14892L1.65538 0.245718C1.27794 -0.0819061 0.660518 -0.0819061 0.283079 0.245718C-0.0943594 0.573342 -0.0943594 1.10984 0.283079 1.4369H0.283145Z" />
    </svg>
  ),
  chevronDownMed: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="6"
      viewBox="0 0 12 6"
    >
      <path
        fill="#9013FE"
        d="M993.327801,489.230703 C993.764218,488.923099 994.309862,488.923099 994.745762,489.230703 L999.000245,493.025498 L1003.25473,489.230703 C1003.69114,488.923099 1004.23679,488.923099 1004.67269,489.230703 C1005.1091,489.538308 1005.1091,490.153945 1004.67269,490.461527 L999.5453,494.769297 C999.108884,495.076901 998.56324,495.076901 998.127339,494.769297 L993.327201,490.461527 C993.109227,490.256608 993,490.051249 993,489.846329 C993,489.538725 993.109222,489.333366 993.327201,489.231132"
        transform="translate(-993 -489)"
      />
    </svg>
  ),
  chevronDownMedThick: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="8"
      viewBox="0 0 14 8"
    >
      <path d="M0.391343 2.40394L5.94628 7.22574C5.95253 7.23116 5.95431 7.2389 5.96055 7.24355C6.22188 7.47039 6.56797 7.58342 6.91314 7.58265C7.25832 7.58342 7.60349 7.47116 7.86574 7.24355C7.87198 7.23813 7.87376 7.23116 7.88001 7.22574L13.4331 2.40394C13.9549 1.95101 13.9549 1.2101 13.4331 0.757175C12.9113 0.304249 12.0578 0.304249 11.536 0.757175L6.91219 4.77072L2.2884 0.757175C1.76661 0.304249 0.913044 0.304249 0.391253 0.757175C-0.130539 1.2101 -0.130539 1.95178 0.391253 2.40394H0.391343Z" />
    </svg>
  ),
  checkBadge: (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.75016 17.2083V10.6969L0.177246 6.52083L3.8387 0.583332H11.1616L14.8231 6.52083L12.2502 10.6969V17.2083L7.50016 15.625L2.75016 17.2083ZM4.3335 15.0115L7.50016 13.9625L10.6668 15.0115V12.4583H4.3335V15.0115ZM4.72933 2.16667L2.03766 6.52083L4.72933 10.875H10.271L12.9627 6.52083L10.271 2.16667H4.72933ZM6.66891 9.74687L3.8585 6.95625L4.98662 5.82812L6.66891 7.51042L10.0137 4.14583L11.1418 5.25417L6.66891 9.74687Z"
        fill="black"
      />
    </svg>
  ),
  close: (
    <svg width="16" height="16" viewBox="0 0 16 16">
      <path d="M7.557 9.514l-5.349 5.348c-.41.411-1.182.306-1.722-.234-.541-.541-.646-1.312-.235-1.723l5.348-5.348L.251 2.208C-.16 1.798-.055 1.026.486.486 1.026-.055 1.797-.16 2.208.25l5.349 5.348L12.905.251c.41-.411 1.182-.306 1.723.235.54.54.645 1.311.234 1.722L9.514 7.557l5.348 5.348c.411.41.306 1.182-.234 1.723-.541.54-1.312.645-1.723.234L7.557 9.514z" />
    </svg>
  ),
  close18: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.8 14.25 3.75 13.2 7.95 9l-4.2-4.2L4.8 3.75 9 7.95l4.2-4.2 1.05 1.05-4.2 4.2 4.2 4.2-1.05 1.05-4.2-4.2z"
        fill="#000"
      />
    </svg>
  ),
  closeThin: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="currentColor">
        <line
          y1="-0.5"
          x2="27.25"
          y2="-0.5"
          transform="matrix(0.707107 0.707107 -0.699928 0.714214 1 1.75)"
        />
        <line
          y1="-0.5"
          x2="27.25"
          y2="-0.5"
          transform="matrix(0.707107 -0.707107 0.699928 0.714214 1.75 21)"
        />
      </g>
    </svg>
  ),
  exclamation: (
    <svg viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="currentColor" />
      <path
        d="M14.637 9.30859L14.8391 17.8076H16.8694L17.0715 9.30859H14.637ZM15.8586 22.2285C16.7463 22.2285 17.3176 21.6748 17.3176 20.8311C17.3176 19.9785 16.7463 19.4248 15.8586 19.4248C14.9709 19.4248 14.3997 19.9785 14.3997 20.8311C14.3997 21.6748 14.9709 22.2285 15.8586 22.2285Z"
        fill="white"
      />
    </svg>
  ),
  close14: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <path
        fill={tailwindColors.cbrprimary['800']}
        d="M315,21.8133821 L310.04574,26.7676421 C309.665014,27.1483678 308.950535,27.0510518 308.449742,26.5502582 C307.948948,26.0494646 307.851632,25.3349857 308.232358,24.95426 L313.186618,20 L308.232358,15.04574 C307.851632,14.6650143 307.948948,13.9505354 308.449742,13.4497418 C308.950535,12.9489482 309.665014,12.8516322 310.04574,13.2323579 L315,18.1866179 L319.95426,13.2323579 C320.334986,12.8516322 321.049465,12.9489482 321.550258,13.4497418 C322.051052,13.9505354 322.148368,14.6650143 321.767642,15.04574 L316.813382,20 L321.767642,24.95426 C322.148368,25.3349857 322.051052,26.0494646 321.550258,26.5502582 C321.049465,27.0510518 320.334986,27.1483678 319.95426,26.7676421 L315,21.8133821 Z"
        transform="translate(-308 -13)"
      />
    </svg>
  ),
  closeModal: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        d="M563.790488,48.3397954 L558,54.1367632 L552.209512,48.3397954 C551.760654,47.8904355 551.064566,47.8904355 550.615708,48.3397954 L549.336643,49.6202915 C548.887786,50.0696514 548.887786,50.7665188 549.336643,51.2158787 L555.127131,57.0128464 L549.359535,62.7868968 C548.910677,63.2362567 548.910677,63.9331241 549.359535,64.382484 L550.6386,65.6629801 C551.087457,66.11234 551.783546,66.11234 552.232404,65.6629801 L558,59.8433197 L563.790488,65.6402874 C564.239346,66.0896473 564.935434,66.0896473 565.384292,65.6402874 L566.663357,64.3597913 C567.112214,63.9104314 567.112214,63.213564 566.663357,62.7642041 L560.850201,56.9901537 L566.640689,51.193186 C567.089547,50.7438261 567.089547,50.0469587 566.640689,49.5975988 L565.361625,48.3171028 C564.934694,47.8905703 564.216679,47.8905703 563.790623,48.3399213 L563.790488,48.3397954 Z"
        transform="translate(-549 -48)"
      />
    </svg>
  ),
  closeProper: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        fillRule="evenodd"
        d="M18.4484158,6.18737276 C18.8164093,5.82577537 19.0007944,5.38593235 18.9999974,4.86947851 C19.0007956,4.35302466 18.8164012,3.90999378 18.4484158,3.54120327 C18.0868184,3.17960588 17.6469754,2.99920567 17.1305215,3.00000264 C16.6140677,2.99920445 16.1710368,3.17960793 15.8022463,3.54120327 L11.0000205,8.35385097 L6.18737276,3.54120327 C5.82577537,3.17960588 5.38593235,2.99920567 4.86947851,3.00000264 C4.35302466,2.99920445 3.90999378,3.17960793 3.54120327,3.54120327 C3.17960588,3.90999378 2.99920567,4.35302466 3.00000264,4.86947851 C2.99920445,5.38593235 3.17960793,5.82577537 3.54120327,6.18737276 L8.35385097,11.0000205 L3.54120327,15.8022463 C3.17960588,16.1710368 2.99920567,16.6140677 3.00000264,17.1305215 C2.99920445,17.6469754 3.17960793,18.0868184 3.54120327,18.4484158 C3.90999378,18.8164093 4.35302466,19.0007944 4.86947851,18.9999974 C5.38593235,19.0007956 5.82577537,18.8164012 6.18737276,18.4484158 L11.0000205,13.64619 L15.8022463,18.4484158 C16.1710368,18.8164093 16.6140677,19.0007944 17.1305215,18.9999974 C17.6469754,19.0007956 18.0868184,18.8164012 18.4484158,18.4484158 C18.8164093,18.0868184 19.0007944,17.6469754 18.9999974,17.1305215 C19.0007956,16.6140677 18.8164012,16.1710368 18.4484158,15.8022463 L13.64619,11.0000205 L18.4484158,6.18737276 Z"
      />
    </svg>
  ),
  clear: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100pt"
      height="100pt"
      viewBox="0 0 100 100"
    >
      <path d="M89.199 50c0-21.602-17.602-39.199-39.199-39.199-21.602 0-39.199 17.598-39.199 39.199S28.399 89.199 50 89.199 89.199 71.601 89.199 50zM36.601 69.301a5.85 5.85 0 0 1-4.102-10l9.301-9.3-9.3-9.302c-2.301-2.3-2.301-6 0-8.3 2.3-2.301 6-2.301 8.3 0l9.301 9.3 9.3-9.3c2.302-2.301 6-2.301 8.302 0 2.3 2.3 2.3 6 0 8.3L58.3 50l9.301 9.301c2.3 2.3 2.3 6 0 8.3-1.101 1.102-2.601 1.7-4.101 1.7s-3-.602-4.102-1.7L50 58.302l-9.301 9.3c-1.2 1.098-2.7 1.7-4.098 1.7z" />
    </svg>
  ),
  columns: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15">
      <path
        fill="#FFF"
        d="M15 2.699a.298.298 0 0 1-.298.301H.302A.3.3 0 0 1 0 2.699V.75C0 .337.337 0 .75 0h13.5c.413 0 .75.337.75.75v1.949zM3.449 4.5c.168 0 .301.133.301.301V14.7A.3.3 0 0 1 3.45 15H.75a.751.751 0 0 1-.75-.75V4.801A.3.3 0 0 1 .301 4.5H3.45zm1.801.301c0-.168.133-.301.301-.298H14.7a.3.3 0 0 1 .301.301v9.449c0 .413-.337.75-.75.75H5.551a.3.3 0 0 1-.301-.301v-9.9z"
      />
    </svg>
  ),
  columnsTable: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      viewBox="0 0 16 12"
    >
      <path
        fill="#9013FE"
        fillRule="evenodd"
        d="M833,20.4498997 C833,19.6489769 832.339639,19 831.524666,19 L818.475334,19 C817.660361,19 817,19.6489769 817,20.4498997 L817,29.5501003 C817,30.3510231 817.660361,31 818.475334,31 L831.524666,31 C832.339639,31 833,30.3510231 833,29.5501003 L833,20.4498997 Z M822.894684,30.1724495 L822.894684,19.8275505 L827.105232,19.8275505 L827.105232,30.1724495 L822.894684,30.1724495 Z M832.15789,20.4482445 L832.15789,29.5501003 C832.15789,29.8935924 831.874984,30.1724081 831.526308,30.1724081 L827.947342,30.1724081 L827.947342,19.8275092 L831.526308,19.8275092 C831.874984,19.8275092 832.15789,20.1055387 832.15789,20.4482031 L832.15789,20.4482445 Z M817.842025,20.4482445 C817.842025,20.10558 818.124932,19.8275505 818.473608,19.8275505 L822.052574,19.8275505 L822.052574,30.1724495 L818.473608,30.1724495 C818.124932,30.1724495 817.842025,29.8936131 817.842025,29.5501417 L817.842025,20.4482445 Z"
        transform="translate(-817 -19)"
      />
    </svg>
  ),
  contacts: (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14">
      <path
        fill="#FFF"
        d="M12.73 13.392H0v-1.793a1.26 1.26 0 0 1 .455-.976 20.596 20.596 0 0 1 3.732-2.394.115.115 0 0 0 .065-.104V6.892a2.91 2.91 0 0 1-.362-.99c-.139-.011-.32-.206-.517-.9-.269-.949.017-1.087.258-1.066a2.627 2.627 0 0 1-.105-.386 2.78 2.78 0 0 1 0-1.25 2.72 2.72 0 0 1 .73-1.28c.201-.213.428-.4.675-.557.202-.143.423-.256.656-.335a2.18 2.18 0 0 1 .596-.114 2.452 2.452 0 0 1 1.49.318c.3.155.553.39.729.677 0 0 1.21.087.8 2.543h.001c-.025.131-.06.26-.104.386.241-.023.527.118.258 1.067-.192.693-.385.888-.517.9v-.001c-.06.346-.183.677-.363.978V8.13c0 .043.026.084.066.104 1.326.66 2.577 1.46 3.731 2.388.29.241.458.6.455.976v1.793zm-.552-4.936v.718a.419.419 0 0 1-.062.226c.237.175.476.36.714.555.493.411.777 1.021.772 1.664v1.79H19v-1.694a1.348 1.348 0 0 0-.772-1.092 6.197 6.197 0 0 0-1.126-.432c-.022-.011-1.221-.326-1.791-.63l-.05-.03a.422.422 0 0 1-.193-.355v-.74s1.65.05 2.432-.75c0 0-1.138-.322-.934-2.396.204-2.074-.255-3.893-1.93-3.739 0 0-.72-.868-2.159-.322-.486.193-1.82.667-1.742 3.54.077 2.873-1.022 2.894-1.022 2.894s.559.81 2.465.793z"
      />
    </svg>
  ),
  copy: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
    >
      <path
        d="M13.8857143,16.1142857 L11.8285714,16.1142857 L11.8285714,13.5428571 C11.8285714,12.6990994 11.129472,12 10.2857143,12 L1.54285714,12 C0.699099429,12 0,12.6990994 0,13.5428571 L0,24.3428571 C0,25.1866149 0.699099429,25.8857143 1.54285714,25.8857143 L3.6,25.8857143 L3.6,28.4571429 C3.6,29.3009006 4.29909943,30 5.14285714,30 L13.8857143,30 C14.729472,30 15.4285714,29.3009006 15.4285714,28.4571429 L15.4285714,17.6571429 C15.4285714,16.8133851 14.729472,16.1142857 13.8857143,16.1142857 Z M3.6,17.6571429 L3.6,24.3428571 L1.54285714,24.3428571 L1.54285714,13.5428571 L10.2857143,13.5428571 L10.2857143,16.1142857 L5.14285714,16.1142857 C4.29909943,16.1142857 3.6,16.8133851 3.6,17.6571429 Z M13.8857143,28.4571429 L5.14285714,28.4571429 L5.14285714,17.6571429 L13.8857143,17.6571429 L13.8857143,28.4571429 Z"
        transform="translate(0 -12)"
      />
    </svg>
  ),
  copyItem: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M7,7 L7,16 L15,16 L15,17 C15,17.551872 14.551872,18 14,18 L6,18 C5.448128,18 5,17.551872 5,17 L5,8 C5,7.448128 5.448128,7 6,7 L7,7 Z M14,4 L18,8 L14,8 L14,4 Z M13,9 L18,9 L18,14 C18,14.551872 17.551872,15 17,15 L8,15 L8,5 C8,4.448128 8.448128,4 9,4 L13,4 L13,9 Z" />
    </svg>
  ),
  customers: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M21,17.2803628 L21,19 L1,19 L1,16.2962854 C1.05352311,15.7493075 1.38105463,15.272048 1.86436189,15.0366932 C2.27177725,14.8308611 2.69675961,14.6652185 3.13452355,14.543017 C3.15928709,14.5307163 4.50693784,14.1649714 5.14922748,13.8164632 L5.19635981,13.7869426 C5.33456036,13.6950973 5.41603935,13.5360108 5.41284906,13.3670785 L5.41284906,12.5486795 C3.26963404,12.5675406 2.63996237,11.6253145 2.63996237,11.6253145 C2.63996237,11.6253145 3.86699388,11.6064535 3.78950684,8.28928456 C3.71201775,4.97214853 5.20267902,4.42443586 5.75866744,4.20799593 C7.37634488,3.57819984 8.18798532,4.57947066 8.18798532,4.57947066 C10.0612943,4.40070094 10.5788562,6.50249006 10.3496058,8.89777255 C10.120335,11.293097 11.4008855,11.6646767 11.4008855,11.6646767 C10.5213493,12.5880418 8.66480976,12.5298276 8.66480976,12.5298276 L8.66480976,13.3695557 L8.66401096,13.3695557 C8.66081557,13.5384859 8.74309723,13.6975745 8.88129779,13.7894198 L8.93881489,13.8255029 C9.57869137,14.1740321 10.9287532,14.5389359 10.9535188,14.5520567 L10.9527198,14.5512365 C11.203566,14.6209402 11.4504038,14.7054064 11.6908611,14.8054432 C12.347507,14.4003373 12.8563774,14.1354661 13.0265258,14.0518292 C13.0640709,14.032968 13.0880369,13.9936066 13.0880369,13.9509631 L13.0880369,12.7586122 C12.9202791,12.465862 12.805247,12.144393 12.7501328,11.8098244 C12.6215174,11.7991638 12.4513711,11.6121922 12.2676231,10.9487671 C12.0159794,10.0401603 12.2836001,9.89910698 12.508878,9.92616722 L12.508878,9.92698742 C12.4665393,9.80480068 12.4337857,9.68014934 12.4106193,9.55305649 C12.3219479,9.1586152 12.3219479,8.74859695 12.4106193,8.35415565 C12.5240564,7.88919819 12.7597098,7.46521946 13.0920308,7.12819458 C13.2789609,6.92318335 13.4906525,6.74359909 13.7215185,6.59269995 C13.9108453,6.45657162 14.1169498,6.34831807 14.3350342,6.27207076 C14.5131767,6.21138781 14.6985014,6.17694636 14.8854396,6.16874431 C15.370342,6.11462174 15.8600299,6.22040649 16.2818219,6.47134034 C16.5622191,6.61976859 16.7978705,6.84445254 16.9632334,7.11998833 C16.9632334,7.11998833 18.0920002,7.20199198 17.7117636,9.55708928 C17.6885972,9.68419683 17.6558436,9.80883978 17.6135049,9.93102022 C17.8387879,9.90969952 18.1039903,10.0441862 17.8547598,10.9536201 C17.6710241,11.6195035 17.5008634,11.8040128 17.3722501,11.8146774 L17.3722501,11.8138574 C17.3155326,12.1476073 17.1996988,12.4682575 17.0287426,12.7585515 L17.0287426,13.9549961 C17.0287426,13.9984584 17.0527086,14.0369998 17.0902537,14.0558622 C18.3260789,14.6913894 19.4915543,15.4614201 20.566843,16.3527285 C20.8384464,16.579875 20.9974288,16.9201958 20.9998215,17.2802082 L21,17.2803628 Z" />
    </svg>
  ),
  dashboard: (
    <svg width="20" height="12">
      <path
        d="M8.971 11.555c-1.005-.67-1.316-2.01-.67-3.038.67-1.029 6.46-8.278 7.488-7.632 1.029.646-3.134 8.971-3.78 10-.646 1.029-2.01 1.316-3.038.67zm7.56-8.229a.715.715 0 0 1 1.005.048A10.058 10.058 0 0 1 20 9.953a.705.705 0 0 1-.718.717.705.705 0 0 1-.717-.717 8.539 8.539 0 0 0-2.106-5.622c-.262-.287-.215-.741.072-1.005zM.718 10.693A.715.715 0 0 1 0 10C0 4.498 4.473 0 10 0c.98 0 1.961.144 2.918.43a.691.691 0 0 1 .479.886.691.691 0 0 1-.885.478A8.085 8.085 0 0 0 10 1.411c-4.713 0-8.565 3.852-8.565 8.565a.705.705 0 0 1-.717.717z"
        fill="#FFF"
      />
    </svg>
  ),
  designer: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M19.85158,1.2101431e-15 L1.99218,1.2101431e-15 C1.4453,1.2101431e-15 1,0.44532 1,0.99218 L1,18.85158 C1,19.39846 1.44532,19.84376 1.99218,19.84376 L19.85158,19.84376 C20.39846,19.84376 20.84376,19.39844 20.84376,18.85158 L20.84376,0.99218 C20.84376,0.4453 20.39844,0 19.85158,1.2101431e-15 Z M17.8672,1.98438 C18.41408,1.98438 18.85938,2.4297 18.85938,2.97656 C18.85938,3.52344 18.41406,3.96874 17.8672,3.96874 C17.32032,3.96874 16.87502,3.52342 16.87502,2.97656 C16.87502,2.42968 17.32034,1.98438 17.8672,1.98438 Z M13.8984,1.98438 C14.44528,1.98438 14.89058,2.4297 14.89058,2.97656 C14.89058,3.52344 14.44526,3.96874 13.8984,3.96874 C13.35152,3.96874 12.90622,3.52342 12.90622,2.97656 C12.90622,2.42968 13.35154,1.98438 13.8984,1.98438 Z M9.9296,1.98438 C10.47648,1.98438 10.92178,2.4297 10.92178,2.97656 C10.92178,3.52344 10.47646,3.96874 9.9296,3.96874 C9.38272,3.96874 8.93742,3.52342 8.93742,2.97656 C8.93742,2.42968 9.38274,1.98438 9.9296,1.98438 Z M18.8592,17.85938 L2.9842,17.85938 L2.9842,5.95318 L18.8592,5.95318 L18.8592,17.85938 Z" />
    </svg>
  ),
  directionalArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="83"
      viewBox="0 0 80 83"
    >
      <path
        fill="#F5A623"
        d="M750.942845,490.635919 C756.295302,486.026528 761.641815,481.87011 767.441896,477.707748 C767.145828,477.85868 767.441896,481.127044 767.441896,481.719119 C767.441896,482.311254 767.888895,485.283461 767.441896,485.73049 C764.469629,487.808699 761.497363,490.037899 758.525096,492.41809 C774.281081,489.892852 789.733895,484.836432 803.109094,476.22221 C810.243723,471.612819 816.635285,466.115315 821.981501,459.579003 C824.802776,456.159708 827.333958,452.444375 829.261176,448.433004 C830.30031,446.203804 831.339384,443.974604 831.937404,441.745404 C832.233472,440.555338 832.384404,439.516204 832.680471,438.326109 C832.233472,435.800871 833.12747,432.973651 832.680471,430.448413 C833.719605,437.287004 833.574469,445.309746 831.194338,451.84576 C828.518109,459.427418 823.467634,466.115017 817.97013,471.908559 C807.567197,482.758521 794.040412,490.333639 779.777991,495.09521 C774.727516,496.732335 769.671096,498.067477 764.620918,499.257572 C766.107051,500.151571 767.442193,501.190735 768.928326,502.078848 C769.224394,502.374915 768.928326,505.498143 768.928326,506.090219 C768.928326,506.537218 768.481327,509.805552 768.928326,510.10159 C763.134785,506.090219 757.190252,502.519932 750.943142,499.402619 C750.647074,499.251687 750.943142,496.279361 750.943142,495.536295 L750.943142,494.94416 C750.943142,494.055957 750.496143,491.083631 750.943142,490.636751 L750.942845,490.635919 Z"
        transform="rotate(-90 201.52 631.775)"
      />
    </svg>
  ),
  doubleDash: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="9"
      viewBox="0 0 16 9"
    >
      <g opacity=".3">
        <rect width="16" height="3" rx="1.5" />
        <rect width="16" height="3" y="6" rx="1.5" />
      </g>
    </svg>
  ),
  doubleChevron: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M8.99757839,12.8790738 L11.4287111,15.5896417 L13.8598439,12.8790738 C14.1092248,12.6593564 14.4210212,12.6593564 14.6701072,12.8790738 C14.9194881,13.0987912 14.9194881,13.5385322 14.6701072,13.7582335 L11.7401715,16.8352119 C11.4907906,17.0549294 11.1789943,17.0549294 10.9299082,16.8352119 L8.18697223,13.7582335 C8.06241551,13.6118627 8,13.4651776 8,13.3188067 C8,13.0990893 8.06241277,12.9524042 8.18697223,12.87938 C8.43669598,12.6593564 8.74849238,12.6593564 8.99757839,12.8790738 Z M10.9299082,6.16478805 C11.1789943,5.94507065 11.4907906,5.94507065 11.7401715,6.16478805 L11.7401715,6.16478805 L14.6701072,9.24176651 C14.9194881,9.4614678 14.9194881,9.90120882 14.6701072,10.1209262 C14.4210212,10.3406436 14.1092248,10.3406436 13.8598439,10.1209262 L13.8598439,10.1209262 L11.4287111,7.41035834 L8.99757839,10.1209262 C8.74849238,10.3406436 8.43669598,10.3406436 8.1873151,10.1209262 L8.1873151,10.1209262 C8.06241277,10.0475958 8,9.90091067 8,9.68119326 C8,9.53482243 8.06241551,9.38813733 8.18697223,9.24176651 L8.18697223,9.24176651 Z" />
    </svg>
  ),
  dragBurger: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M17,6.875 C17,7.358434 16.608434,7.75 16.125,7.75 L5.875,7.75 C5.391566,7.75 5,7.358434 5,6.875 C5,6.391566 5.391566,6 5.875,6 L16.125,6 C16.608434,6 17,6.391566 17,6.875 Z M16.125,10.375 L5.875,10.375 C5.391566,10.375 5,10.766566 5,11.25 C5,11.733434 5.391566,12.125 5.875,12.125 L16.125,12.125 C16.608434,12.125 17,11.733434 17,11.25 C17,10.766566 16.608434,10.375 16.125,10.375 Z M16.125,14.75 L5.875,14.75 C5.391566,14.75 5,15.141566 5,15.625 C5,16.108434 5.391566,16.5 5.875,16.5 L16.125,16.5 C16.608434,16.5 17,16.108434 17,15.625 C17,15.141566 16.608434,14.75 16.125,14.75 Z" />
    </svg>
  ),
  dragHandle: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.067 6.783a1.65 1.65 0 1 0 0-3.3 1.65 1.65 0 0 0 0 3.3m5.867 0a1.65 1.65 0 1 0 0-3.3 1.65 1.65 0 0 0 0 3.3M15.583 11a1.65 1.65 0 1 1-3.3 0 1.65 1.65 0 0 1 3.3 0m-7.516 1.65a1.65 1.65 0 1 0 0-3.3 1.65 1.65 0 0 0 0 3.3m7.517 4.217a1.65 1.65 0 1 1-3.3 0 1.65 1.65 0 0 1 3.3 0m-7.517 1.65a1.65 1.65 0 1 0 0-3.3 1.65 1.65 0 0 0 0 3.3"
        fill="currentColor"
      />
    </svg>
  ),
  errorArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="19"
      viewBox="0 0 12 19"
    >
      <path
        fill="#D0021B"
        d="M4.90471318,26.3359586 C5.50998908,26.9546805 6.49004812,26.9546805 7.09532401,26.3359586 L14.584293,18.6683762 C15.1527774,18.0427246 15.1363154,17.069015 14.5465247,16.4651678 C13.955777,15.8603307 13.0047495,15.8434761 12.3946392,16.4255062 L5.99999628,22.9696165 L-0.394646615,16.4255062 C-1.00475698,15.8434634 -1.9557844,15.860318 -2.54653209,16.4651678 C-3.13631288,17.069015 -3.15277488,18.0426992 -2.58430047,18.6683762 L4.90471318,26.3359586 Z"
        transform="rotate(-90 0 15.4)"
      />
    </svg>
  ),
  expand: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <g fill={tailwindColors.cbrprimary['700']} fillRule="evenodd">
        <circle cx="14" cy="14" r="14" fillRule="nonzero" opacity=".1" />
        <g transform="translate(6 12)">
          <circle cx="7.75" cy="1.75" r="1.75" />
          <circle cx="13.75" cy="1.75" r="1.75" />
          <circle cx="1.75" cy="1.75" r="1.75" />
        </g>
        <g transform="translate(6 12)">
          <circle cx="7.75" cy="1.75" r="1.75" />
          <circle cx="13.75" cy="1.75" r="1.75" />
          <circle cx="1.75" cy="1.75" r="1.75" />
        </g>
      </g>
    </svg>
  ),
  export: (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.26 0h1.5v10.18l2.6-2.6 1.06 1.06L6 13.06 1.58 8.64l1.06-1.06 2.62 2.6V0zM0 14.5h12V16H0v-1.5z"
        fill="currentColor"
      />
    </svg>
  ),
  exportSquare: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 17.679q-.797 0-1.363-.566a1.86 1.86 0 0 1-.566-1.363V2.25q0-.797.566-1.363Q1.454.321 2.25.321h13.5q.796 0 1.363.566.566.567.566 1.363v13.5q0 .796-.566 1.363-.568.566-1.363.566h-3.857V15.75h3.857V4.179H2.25V15.75h3.857v1.929zm5.786 0v-5.931l-1.543 1.543-1.35-1.398L9 8.036l3.857 3.857-1.35 1.399-1.543-1.543v5.93z"
        fill="#00324D"
      />
    </svg>
  ),
  percent: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.625 8.25a2.53 2.53 0 0 1-1.856-.769A2.53 2.53 0 0 1 3 5.625q0-1.088.769-1.856A2.53 2.53 0 0 1 5.625 3a2.53 2.53 0 0 1 1.856.769 2.53 2.53 0 0 1 .769 1.856 2.53 2.53 0 0 1-.769 1.856 2.53 2.53 0 0 1-1.856.769m0-1.5q.469 0 .797-.328t.328-.797-.328-.797a1.1 1.1 0 0 0-.797-.328q-.468 0-.797.328a1.1 1.1 0 0 0-.328.797q0 .469.328.797t.797.328m6.75 8.25a2.53 2.53 0 0 1-1.856-.769 2.53 2.53 0 0 1-.769-1.856q0-1.088.769-1.856a2.53 2.53 0 0 1 1.856-.769 2.53 2.53 0 0 1 1.856.769q.77.768.769 1.856a2.53 2.53 0 0 1-.769 1.856 2.53 2.53 0 0 1-1.856.769m0-1.5q.469 0 .797-.328.328-.329.328-.797t-.328-.797a1.1 1.1 0 0 0-.797-.328q-.468 0-.797.328a1.1 1.1 0 0 0-.328.797q0 .469.328.797.329.328.797.328M4.05 15 3 13.95 13.95 3 15 4.05z"
        fill="#340E4C"
      />
    </svg>
  ),
  split: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9.75v-1.5h5.7l3.75-3.75H10.5V3H15v4.5h-1.5V5.55l-4.2 4.2zM10.5 15v-1.5h1.95l-2.4-2.363 1.087-1.087 2.363 2.4V10.5H15V15z"
        fill="#340B0B"
      />
    </svg>
  ),
  upsell: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 15v-1.5h7.5V15zm3-3V5.869L6.3 7.8 5.25 6.75 9 3l3.75 3.75L11.7 7.8 9.75 5.869V12z"
        fill="#212121"
      />
    </svg>
  ),
  acquisition: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={8.774} cy={11.226} r={7.524} fill="url(#aq_sm_a)" />
      <circle cx={8.774} cy={11.226} r={7.524} fill="url(#aq_sm_b)" />
      <circle cx={8.774} cy={11.226} r={7.524} fill="url(#aq_sm_c)" />
      <circle cx={8.774} cy={11.226} r={7.524} fill="url(#aq_sm_d)" />
      <circle cx={8.774} cy={11.226} r={7.524} fill="url(#aq_sm_e)" />
      <circle cx={8.774} cy={11.226} r={7.524} fill="url(#aq_sm_f)" />
      <circle cx={8.774} cy={11.226} r={5.503} fill="url(#aq_sm_g)" />
      <circle cx={8.774} cy={11.226} r={5.503} fill="url(#aq_sm_h)" />
      <circle cx={8.774} cy={11.226} r={5.503} fill="url(#aq_sm_i)" />
      <circle cx={8.774} cy={11.226} r={3.599} fill="url(#aq_sm_j)" />
      <circle cx={8.774} cy={11.226} r={3.599} fill="url(#aq_sm_k)" />
      <circle cx={8.774} cy={11.226} r={1.787} fill="#B7ABC8" />
      <circle cx={8.774} cy={11.226} r={1.787} fill="url(#aq_sm_l)" />
      <circle cx={8.774} cy={11.226} r={1.787} fill="url(#aq_sm_m)" />
      <path
        d="M8.834 11.172c-.212-.212-.29-.452-.078-.664l1.072-1.077a.542.542 0 0 1 .766.766l-1.072 1.077c-.212.212-.477.11-.688-.102"
        fill="#7C7088"
      />
      <path
        d="M8.834 11.172c-.212-.212-.29-.452-.078-.664l1.072-1.077a.542.542 0 0 1 .766.766l-1.072 1.077c-.212.212-.477.11-.688-.102"
        fill="url(#aq_sm_n)"
      />
      <path
        d="M8.834 11.172c-.212-.212-.29-.452-.078-.664l1.072-1.077a.542.542 0 0 1 .766.766l-1.072 1.077c-.212.212-.477.11-.688-.102"
        fill="url(#aq_sm_o)"
      />
      <path
        d="m14.329 2.165.603 1.595-2.803 1.963c-.732-1.936-.036-3.177.785-3.963.46-.44 1.19-.19 1.415.405"
        fill="#2983DF"
      />
      <path
        d="m14.329 2.165.603 1.595-2.803 1.963c-.732-1.936-.036-3.177.785-3.963.46-.44 1.19-.19 1.415.405"
        fill="url(#aq_sm_p)"
      />
      <path
        d="m14.329 2.165.603 1.595-2.803 1.963c-.732-1.936-.036-3.177.785-3.963.46-.44 1.19-.19 1.415.405"
        fill="url(#aq_sm_q)"
      />
      <path
        d="m14.329 2.165.603 1.595-2.803 1.963c-.732-1.936-.036-3.177.785-3.963.46-.44 1.19-.19 1.415.405"
        fill="url(#aq_sm_r)"
        fillOpacity={0.8}
      />
      <path
        d="m14.329 2.165.603 1.595-2.803 1.963c-.732-1.936-.036-3.177.785-3.963.46-.44 1.19-.19 1.415.405"
        fill="url(#aq_sm_s)"
        fillOpacity={0.8}
      />
      <path
        d="m17.813 5.661-1.602-.583-1.928 2.826c1.945.708 3.177-.002 3.952-.833.434-.465.175-1.192-.422-1.41"
        fill="#2980EB"
      />
      <path
        d="m17.813 5.661-1.602-.583-1.928 2.826c1.945.708 3.177-.002 3.952-.833.434-.465.175-1.192-.422-1.41"
        fill="url(#aq_sm_t)"
      />
      <path
        d="m17.813 5.661-1.602-.583-1.928 2.826c1.945.708 3.177-.002 3.952-.833.434-.465.175-1.192-.422-1.41"
        fill="url(#aq_sm_u)"
      />
      <path
        d="m17.813 5.661-1.602-.583-1.928 2.826c1.945.708 3.177-.002 3.952-.833.434-.465.175-1.192-.422-1.41"
        fill="url(#aq_sm_v)"
        fillOpacity={0.7}
      />
      <path
        d="m17.813 5.661-1.602-.583-1.928 2.826c1.945.708 3.177-.002 3.952-.833.434-.465.175-1.192-.422-1.41"
        fill="url(#aq_sm_w)"
        fillOpacity={0.6}
      />
      <path
        d="m17.813 5.661-1.602-.583-1.928 2.826c1.945.708 3.177-.002 3.952-.833.434-.465.175-1.192-.422-1.41"
        fill="url(#aq_sm_x)"
        fillOpacity={0.4}
      />
      <path
        d="m10.425 6.694 4.141-3.069c.55-.41 1.371-.304 1.786.123.46.495.515 1.223.12 1.76L13.416 9.66a2.13 2.13 0 1 1-2.99-2.967"
        fill="#52BCF0"
      />
      <path
        d="m10.425 6.694 4.141-3.069c.55-.41 1.371-.304 1.786.123.46.495.515 1.223.12 1.76L13.416 9.66a2.13 2.13 0 1 1-2.99-2.967"
        fill="url(#aq_sm_y)"
      />
      <path
        d="m10.425 6.694 4.141-3.069c.55-.41 1.371-.304 1.786.123.46.495.515 1.223.12 1.76L13.416 9.66a2.13 2.13 0 1 1-2.99-2.967"
        fill="url(#aq_sm_z)"
      />
      <path
        d="m10.425 6.694 4.141-3.069c.55-.41 1.371-.304 1.786.123.46.495.515 1.223.12 1.76L13.416 9.66a2.13 2.13 0 1 1-2.99-2.967"
        fill="url(#aq_sm_A)"
      />
      <path
        d="m10.425 6.694 4.141-3.069c.55-.41 1.371-.304 1.786.123.46.495.515 1.223.12 1.76L13.416 9.66a2.13 2.13 0 1 1-2.99-2.967"
        fill="url(#aq_sm_B)"
      />
      <path
        d="m10.425 6.694 4.141-3.069c.55-.41 1.371-.304 1.786.123.46.495.515 1.223.12 1.76L13.416 9.66a2.13 2.13 0 1 1-2.99-2.967"
        fill="url(#aq_sm_C)"
        fillOpacity={0.8}
      />
      <rect
        x={16.265}
        y={2.964}
        width={1.105}
        height={5.649}
        rx={0.553}
        transform="rotate(45 16.265 2.964)"
        fill="#2984E4"
      />
      <rect
        x={16.265}
        y={2.964}
        width={1.105}
        height={5.649}
        rx={0.553}
        transform="rotate(45 16.265 2.964)"
        fill="url(#aq_sm_D)"
      />
      <rect
        x={16.265}
        y={2.964}
        width={1.105}
        height={5.649}
        rx={0.553}
        transform="rotate(45 16.265 2.964)"
        fill="url(#aq_sm_E)"
        fillOpacity={0.8}
      />
      <rect
        x={16.265}
        y={2.964}
        width={1.105}
        height={5.649}
        rx={0.553}
        transform="rotate(45 16.265 2.964)"
        fill="url(#aq_sm_F)"
      />
      <rect
        x={16.265}
        y={2.964}
        width={1.105}
        height={5.649}
        rx={0.553}
        transform="rotate(45 16.265 2.964)"
        fill="url(#aq_sm_G)"
      />
      <rect
        x={16.265}
        y={2.964}
        width={1.105}
        height={5.649}
        rx={0.553}
        transform="rotate(45 16.265 2.964)"
        fill="url(#aq_sm_H)"
        fillOpacity={0.6}
      />
      <rect
        x={16.265}
        y={2.964}
        width={1.105}
        height={5.649}
        rx={0.553}
        transform="rotate(45 16.265 2.964)"
        fill="url(#aq_sm_I)"
      />
      <rect
        x={16.265}
        y={2.964}
        width={1.105}
        height={5.649}
        rx={0.553}
        transform="rotate(45 16.265 2.964)"
        fill="url(#aq_sm_J)"
      />
      <defs>
        <radialGradient
          id="aq_sm_b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-1.90405 2.73702 -3.98039 -2.76902 12.483 6.456)"
        >
          <stop offset={0.219} stopColor="#B82974" />
          <stop offset={1} stopColor="#B82974" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_c"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-29.109 25.6 -11.438)scale(7.63532)"
        >
          <stop stopColor="#FF6AA2" stopOpacity={0} />
          <stop offset={0.807} stopColor="#FF6AA2" stopOpacity={0} />
          <stop offset={0.837} stopColor="#FF6AA2" stopOpacity={0.217} />
          <stop offset={0.878} stopColor="#FF6AA2" stopOpacity={0.87} />
          <stop offset={0.895} stopColor="#FF6AA2" />
          <stop offset={0.91} stopColor="#FF6AA2" />
          <stop offset={0.952} stopColor="#FF6AA2" stopOpacity={0.312} />
          <stop offset={1} stopColor="#FF6AA2" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_e"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-4.86434 -7.06708 6.73224 -4.63387 9.44 12.02)"
        >
          <stop offset={0.004} stopColor="#BF577D" stopOpacity={0} />
          <stop offset={0.885} stopColor="#BF577D" stopOpacity={0.133} />
          <stop offset={0.973} stopColor="#BF577D" />
        </radialGradient>
        <radialGradient
          id="aq_sm_f"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(107.442 .402 8.68)scale(7.95967)"
        >
          <stop stopColor="#BC2954" stopOpacity={0} />
          <stop offset={0.886} stopColor="#BC2954" stopOpacity={0.133} />
          <stop offset={0.924} stopColor="#BC2954" stopOpacity={0.361} />
          <stop offset={0.991} stopColor="#BC2954" />
        </radialGradient>
        <radialGradient
          id="aq_sm_h"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.009 11.226)scale(7.26873)"
        >
          <stop offset={0.861} stopColor="#CBC4DF" stopOpacity={0} />
          <stop offset={1} stopColor="#CBC4DF" />
        </radialGradient>
        <radialGradient
          id="aq_sm_i"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(118.217 3.862 6.451)scale(3.69139 2.02046)"
        >
          <stop stopColor="#9DA8B4" />
          <stop offset={1} stopColor="#9DA8B4" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_k"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(131.253 3.29 6.863)scale(2.79642)"
        >
          <stop stopColor="#962359" />
          <stop offset={0.947} stopColor="#962359" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_l"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(67.204 -3.774 11.66)scale(2.96895)"
        >
          <stop offset={0.613} stopColor="#C9BED9" stopOpacity={0} />
          <stop offset={1} stopColor="#C9BED9" />
        </radialGradient>
        <radialGradient
          id="aq_sm_m"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(103.843 1.096 8.475)scale(2.32108)"
        >
          <stop stopColor="#857D97" />
          <stop offset={1} stopColor="#857D97" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_p"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-157.278 7.13 .569)scale(1.69396 3.0756)"
        >
          <stop offset={0.75} stopColor="#6897C2" stopOpacity={0} />
          <stop offset={1} stopColor="#6897C2" />
        </radialGradient>
        <radialGradient
          id="aq_sm_r"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(159.124 6.778 2.469)scale(.504 1.63429)"
        >
          <stop stopColor="#61CEFF" stopOpacity={0.91} />
          <stop offset={0.13} stopColor="#61CEFF" stopOpacity={0.81} />
          <stop offset={0.343} stopColor="#61CEFF" stopOpacity={0.63} />
          <stop offset={0.644} stopColor="#61CEFF" stopOpacity={0.231} />
          <stop offset={0.84} stopColor="#61CEFF" stopOpacity={0.048} />
          <stop offset={1} stopColor="#61CEFF" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_s"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-.4607 .00207 -.00286 -.63606 13.79 1.871)"
        >
          <stop stopColor="#61CEFF" stopOpacity={0.69} />
          <stop offset={0.275} stopColor="#61CEFF" stopOpacity={0.467} />
          <stop offset={0.551} stopColor="#61CEFF" stopOpacity={0.231} />
          <stop offset={0.753} stopColor="#61CEFF" stopOpacity={0.08} />
          <stop offset={1} stopColor="#61CEFF" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_u"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(.46875 2.54883 -3.28335 .60383 16.016 5.771)"
        >
          <stop offset={0.814} stopColor="#5066D2" stopOpacity={0} />
          <stop offset={0.926} stopColor="#5066D2" />
        </radialGradient>
        <radialGradient
          id="aq_sm_v"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-160.121 9.571 1.5)scale(.48569 .44815)"
        >
          <stop stopColor="#61CEFF" stopOpacity={0.62} />
          <stop offset={0.188} stopColor="#61CEFF" stopOpacity={0.623} />
          <stop offset={0.442} stopColor="#61CEFF" stopOpacity={0.42} />
          <stop offset={0.613} stopColor="#61CEFF" stopOpacity={0.286} />
          <stop offset={0.832} stopColor="#61CEFF" stopOpacity={0.096} />
          <stop offset={1} stopColor="#61CEFF" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_w"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(.1986 -.5626 1.52475 .53822 17.719 6.065)"
        >
          <stop stopColor="#61CEFF" stopOpacity={0.92} />
          <stop offset={0.21} stopColor="#61CEFF" stopOpacity={0.83} />
          <stop offset={0.419} stopColor="#61CEFF" stopOpacity={0.586} />
          <stop offset={0.57} stopColor="#61CEFF" stopOpacity={0.29} />
          <stop offset={0.708} stopColor="#61CEFF" stopOpacity={0.15} />
          <stop offset={0.855} stopColor="#61CEFF" stopOpacity={0.058} />
          <stop offset={1} stopColor="#61CEFF" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_x"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(.17464 -.46095 1.19443 .45253 17.118 5.806)"
        >
          <stop stopColor="#61CEFF" stopOpacity={0.92} />
          <stop offset={0.272} stopColor="#61CEFF" stopOpacity={0.83} />
          <stop offset={0.438} stopColor="#61CEFF" stopOpacity={0.586} />
          <stop offset={0.602} stopColor="#61CEFF" stopOpacity={0.29} />
          <stop offset={0.733} stopColor="#61CEFF" stopOpacity={0.15} />
          <stop offset={0.855} stopColor="#61CEFF" stopOpacity={0.058} />
          <stop offset={1} stopColor="#61CEFF" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_y"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(143.326 7.878 4.649)scale(2.28908 2.35877)"
        >
          <stop offset={0.423} stopColor="#6BFFFF" />
          <stop offset={1} stopColor="#6BFFFF" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_z"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-5.01292 4.56397 -4.62345 -5.07825 15.004 5.341)"
        >
          <stop offset={0.838} stopColor="#5E9BDB" stopOpacity={0} />
          <stop offset={1} stopColor="#5E9BDB" />
        </radialGradient>
        <radialGradient
          id="aq_sm_A"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(134.318 5.066 6.224)scale(1.23157 .64804)"
        >
          <stop offset={0.361} stopColor="#49A0E1" />
          <stop offset={1} stopColor="#49A0E1" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_B"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(174.74 7.74 4.347)scale(6.31501 7.24725)"
        >
          <stop stopColor="#73A6BC" stopOpacity={0} />
          <stop offset={0.863} stopColor="#73A6BC" stopOpacity={0} />
          <stop offset={0.928} stopColor="#73A6BC" stopOpacity={0.368} />
          <stop offset={1} stopColor="#73A6BC" />
        </radialGradient>
        <radialGradient
          id="aq_sm_D"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(.01382 -1.83682 .69968 .00526 16.77 3.516)"
        >
          <stop stopColor="#60CAFF" />
          <stop offset={1} stopColor="#60CAFF" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_F"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-.27862 .25632 -1.0299 -1.1195 17.272 3.006)"
        >
          <stop stopColor="#3C6FD4" />
          <stop offset={0.546} stopColor="#3C6FD4" stopOpacity={0.324} />
          <stop offset={0.782} stopColor="#3C6FD4" stopOpacity={0.09} />
          <stop offset={1} stopColor="#3C6FD4" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_G"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-.3109 -.38646 2.10806 -1.69589 17.186 8.446)"
        >
          <stop stopColor="#3C6FD4" />
          <stop offset={0.364} stopColor="#3C6FD4" stopOpacity={0.324} />
          <stop offset={0.615} stopColor="#3C6FD4" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_I"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(.28178 -.33475 .71951 .60566 16.462 8.474)"
        >
          <stop stopColor="#2985C3" />
          <stop offset={0.513} stopColor="#2985C3" stopOpacity={0.313} />
          <stop offset={1} stopColor="#2985C3" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="aq_sm_J"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(34.439 3.08 27.854)scale(.27402 .58898)"
        >
          <stop stopColor="#2985C3" />
          <stop offset={0.313} stopColor="#2985C3" stopOpacity={0.313} />
          <stop offset={1} stopColor="#2985C3" stopOpacity={0} />
        </radialGradient>
        <linearGradient
          id="aq_sm_a"
          x1={12.209}
          y1={4.451}
          x2={5.896}
          y2={17.291}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6378B" />
          <stop offset={1} stopColor="#EF3A5C" />
        </linearGradient>
        <linearGradient
          id="aq_sm_d"
          x1={12.209}
          y1={4.451}
          x2={5.896}
          y2={17.291}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6378B" stopOpacity={0} />
          <stop offset={1} stopColor="#EF3A5C" />
        </linearGradient>
        <linearGradient
          id="aq_sm_g"
          x1={12.721}
          y1={13.993}
          x2={4.549}
          y2={5.504}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CEC3DF" />
          <stop offset={1} stopColor="#C5BCD3" />
        </linearGradient>
        <linearGradient
          id="aq_sm_j"
          x1={11.174}
          y1={8.796}
          x2={6.929}
          y2={14.508}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D2347A" />
          <stop offset={1} stopColor="#ED3963" />
        </linearGradient>
        <linearGradient
          id="aq_sm_n"
          x1={10.093}
          y1={10.8}
          x2={9.692}
          y2={10.389}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7E5F8A" />
          <stop offset={1} stopColor="#7E5F8A" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="aq_sm_o"
          x1={9.313}
          y1={9.889}
          x2={9.462}
          y2={10.03}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#746D7C" />
          <stop offset={1} stopColor="#746D7C" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="aq_sm_q"
          x1={14.668}
          y1={2.695}
          x2={13.672}
          y2={3.047}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58C3FF" />
          <stop offset={1} stopColor="#58C3FF" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="aq_sm_t"
          x1={17.579}
          y1={5.332}
          x2={17.208}
          y2={6.133}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#49B6FF" />
          <stop offset={1} stopColor="#49B6FF" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="aq_sm_C"
          x1={12.458}
          y1={5.154}
          x2={12.899}
          y2={5.686}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73A6BC" />
          <stop offset={0.216} stopColor="#73A6BC" stopOpacity={0.752} />
          <stop offset={0.649} stopColor="#73A6BC" stopOpacity={0.246} />
          <stop offset={1} stopColor="#73A6BC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="aq_sm_E"
          x1={17.389}
          y1={5.592}
          x2={16.25}
          y2={5.592}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C6FD4" />
          <stop offset={0.117} stopColor="#3C6FD4" stopOpacity={0.324} />
          <stop offset={0.23} stopColor="#3C6FD4" stopOpacity={0} />
          <stop offset={1} stopColor="#3C6FD4" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="aq_sm_H"
          x1={16.21}
          y1={5.744}
          x2={17.446}
          y2={5.738}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.042} stopColor="#2985C3" />
          <stop offset={0.123} stopColor="#2985C3" stopOpacity={0.635} />
          <stop offset={0.156} stopColor="#2985C3" stopOpacity={0.313} />
          <stop offset={0.204} stopColor="#2985C3" stopOpacity={0} />
          <stop offset={0.35} stopColor="#2985C3" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  ),
  churn_prevention: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          d="m16.506 8.885-1.107-1.107a1.14 1.14 0 0 0-1.61 0l-1.207 1.207-.403.403-1.74 1.74a2.02 2.02 0 0 1-2.858 0 2.02 2.02 0 0 1 0-2.857l1.73-1.73.403-.403 1.208-1.207a1.14 1.14 0 0 0 0-1.61L9.815 2.214a1.14 1.14 0 0 0-1.61 0L6.998 3.422l-.403.402-1.73 1.73c-2.284 2.284-2.294 6.017-.01 8.3 2.284 2.285 6.016 2.275 8.3-.01l1.73-1.73.403-.402 1.207-1.207a1.136 1.136 0 0 0 .01-1.62M9.196 5.62l-1.68-1.68 1.207-1.208c.222-.22.352-.22.574 0l1.106 1.107c.222.221.222.352 0 .574zm5.574 5.574-1.657-1.678L14.32 8.31c.221-.221.33-.224.55-.003l1.107 1.107c.222.221.222.352 0 .573z"
          fill="#212121"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  churn_deflection: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.5a6.5 6.5 0 0 1-2.634-.534 6.9 6.9 0 0 1-2.138-1.444 6.9 6.9 0 0 1-1.444-2.138A6.5 6.5 0 0 1 2.25 9.75h1.5q0 2.194 1.528 3.722T9 15t3.722-1.528T14.25 9.75t-1.528-3.722T9 4.5h-.113l1.163 1.162L9 6.75l-3-3 3-3 1.05 1.088L8.887 3H9a6.5 6.5 0 0 1 2.634.534 6.9 6.9 0 0 1 2.138 1.444 6.9 6.9 0 0 1 1.444 2.138 6.5 6.5 0 0 1 .534 2.634 6.5 6.5 0 0 1-.534 2.634 6.9 6.9 0 0 1-1.444 2.138 6.9 6.9 0 0 1-2.138 1.444A6.5 6.5 0 0 1 9 16.5"
        fill="#000"
      />
    </svg>
  ),
  image_modal: (
    <svg
      width="72"
      height="45"
      viewBox="0 0 72 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="70"
        height="43"
        rx="3"
        fill="#fff"
        stroke="#ADD9ED"
      />
      <rect
        x="38.386"
        y="11.341"
        width="27.046"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="38.386"
        y="16.113"
        width="27.046"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="38.386"
        y="20.887"
        width="21.477"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="38.386"
        y="34"
        width="27.046"
        height="7"
        rx="3.5"
        fill="#ADD9ED"
      />
      <path d="M1 4a3 3 0 0 1 3-3h29v43H4a3 3 0 0 1-3-3z" fill="#ADD9ED" />
    </svg>
  ),
  loss_aversion_card: (
    <svg
      width="72"
      height="45"
      viewBox="0 0 72 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="70"
        height="42.955"
        rx="3"
        fill="#fff"
        stroke="#ADD9ED"
      />
      <rect
        x="12.136"
        y="32"
        width="47.727"
        height="7"
        rx="3.5"
        fill="#ADD9ED"
      />
      <rect
        x="16.114"
        y="8.956"
        width="9.545"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="16.114"
        y="12.934"
        width="16.704"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="5.773"
        y="8.16"
        width="7.955"
        height="7.955"
        rx="3.977"
        fill="#ADD9ED"
      />
      <rect
        x="49.523"
        y="8.956"
        width="9.545"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="49.523"
        y="12.934"
        width="16.704"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="39.182"
        y="8.16"
        width="7.955"
        height="7.955"
        rx="3.977"
        fill="#ADD9ED"
      />
      <rect
        x="16.114"
        y="20.889"
        width="9.545"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="16.114"
        y="24.866"
        width="16.704"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="5.773"
        y="20.093"
        width="7.955"
        height="7.955"
        rx="3.977"
        fill="#ADD9ED"
      />
      <rect
        x="49.523"
        y="20.889"
        width="9.545"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="49.523"
        y="24.866"
        width="16.704"
        height="2.386"
        rx="1.193"
        fill="#ADD9ED"
      />
      <rect
        x="39.182"
        y="20.093"
        width="7.955"
        height="7.955"
        rx="3.977"
        fill="#ADD9ED"
      />
    </svg>
  ),
  modal: (
    <svg
      width="70"
      height="56"
      viewBox="0 0 70 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x=".418"
        y=".418"
        width="69.164"
        height="55.164"
        rx="2.09"
        fill="#fff"
        stroke="#ADD9ED"
        strokeWidth=".836"
      />
      <path fill="#ADD9ED" d="M16.18 18h37.117v19H16.18z" />
    </svg>
  ),
  modalSmall: (
    <svg
      width="22"
      height="17.6"
      viewBox="0 0 22 17.6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        stroke="#232323"
        d="M1.838.367h18.324a1.47 1.47 0 0 1 1.471 1.471v13.924a1.47 1.47 0 0 1-1.472 1.472H1.838a1.47 1.47 0 0 1-1.471-1.472V1.838A1.47 1.47 0 0 1 1.838.367z"
        strokeWidth=".733"
      />
      <path fill="#232323" d="M5.084 5.658h11.665v5.972H5.084z" />
    </svg>
  ),
  popup: (
    <svg
      width="70"
      height="56"
      viewBox="0 0 70 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x=".418"
        y=".418"
        width="69.164"
        height="55.164"
        rx="2.09"
        fill="#fff"
        stroke="#ADD9ED"
        strokeWidth=".836"
      />
      <path fill="#ADD9ED" d="M49.488 28h16.179v23H49.488z" />
    </svg>
  ),
  popupSmall: (
    <svg
      width="22"
      height="24"
      viewBox="0.5 0.5 29 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        stroke="#232323"
        d="M2.507.5h24.986A2.007 2.007 0 0 1 29.5 2.507v18.986a2.007 2.007 0 0 1-2.007 2.007H2.507A2.007 2.007 0 0 1 .5 21.493V2.507A2.007 2.007 0 0 1 2.507.5z"
      />
      <path fill="#232323" d="M21.211 12h6.934v9.857h-6.934z" />
    </svg>
  ),
  banner: (
    <svg
      width="70"
      height="56"
      viewBox="0 0 70 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x=".418"
        y=".418"
        width="69.164"
        height="55.164"
        rx="2.09"
        fill="#fff"
        stroke="#ADD9ED"
        strokeWidth=".836"
      />
      <path fill="#ADD9ED" d="M.797.836h68.409v10.03H.797z" />
    </svg>
  ),
  offerPack: (
    <svg
      width="70"
      height="56"
      viewBox="0 0 70 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x=".5"
        y=".5"
        width="69"
        height="55"
        rx="2.007"
        fill="#fff"
        stroke="#ADD9ED"
      />
      <path fill="#ADD9ED" d="M7 18h16v24H7zm20 0h16v24H27zm20 0h16v24H47z" />
      <rect x="28" y="10" width="15" height="2" rx="1" fill="#ADD9ED" />
      <rect x="20" y="5" width="30" height="3" rx="1.5" fill="#ADD9ED" />
    </svg>
  ),
  offerCardPack: (
    <svg
      width="70"
      height="56"
      viewBox="0 0 70 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="69"
        height="55"
        rx="2.00746"
        fill="white"
        stroke="#ADD9ED"
      />
      <rect x="7" y="18" width="16" height="24" fill="#ADD9ED" />
      <rect x="27" y="18" width="16" height="24" fill="#ADD9ED" />
      <rect x="47" y="18" width="16" height="24" fill="#ADD9ED" />
      <rect x="28" y="10" width="15" height="2" rx="1" fill="#ADD9ED" />
      <rect x="20" y="5" width="30" height="3" rx="1.5" fill="#ADD9ED" />
    </svg>
  ),
  offerCardPackSmall: (
    <svg
      width="22"
      height="17.6"
      viewBox="0 0 22 17.6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="surface1">
        <path
          fill="white"
          stroke="#232323"
          d="M 1.077009 0.501838 L 28.922991 0.501838 C 29.241071 0.501838 29.497768 0.755515 29.497768 1.075368 L 29.497768 22.924632 C 29.497768 23.244485 29.241071 23.498162 28.922991 23.498162 L 1.077009 23.498162 C 0.758929 23.498162 0.502232 23.244485 0.502232 22.924632 L 0.502232 1.075368 C 0.502232 0.755515 0.758929 0.501838 1.077009 0.501838 Z M 1.077009 0.501838 "
          transform="matrix(0.7,0,0,0.708333,0,0)"
        />
        <path
          fill="#232323"
          d="M 2.101562 5.464844 L 6.898438 5.464844 L 6.898438 12.75 L 2.101562 12.75 Z M 2.101562 5.464844 "
        />
        <path
          fill="#232323"
          d="M 8.101562 5.464844 L 12.898438 5.464844 L 12.898438 12.75 L 8.101562 12.75 Z M 8.101562 5.464844 "
        />
        <path
          fill="#232323"
          d="M 14.101562 5.464844 L 18.898438 5.464844 L 18.898438 12.75 L 14.101562 12.75 Z M 14.101562 5.464844 "
        />
        <path
          fill="#232323"
          d="M 8.699219 3.035156 L 12.601562 3.035156 C 12.765625 3.035156 12.898438 3.171875 12.898438 3.339844 C 12.898438 3.507812 12.765625 3.644531 12.601562 3.644531 L 8.699219 3.644531 C 8.535156 3.644531 8.398438 3.507812 8.398438 3.339844 C 8.398438 3.171875 8.535156 3.035156 8.699219 3.035156 Z M 8.699219 3.035156 "
        />
        <path
          fill="#232323"
          d="M 6.449219 1.519531 L 14.550781 1.519531 C 14.796875 1.519531 15 1.722656 15 1.972656 C 15 2.226562 14.796875 2.429688 14.550781 2.429688 L 6.449219 2.429688 C 6.203125 2.429688 6 2.226562 6 1.972656 C 6 1.722656 6.203125 1.519531 6.449219 1.519531 Z M 6.449219 1.519531 "
        />
      </g>
    </svg>
  ),
  bannerSmall: (
    <svg
      width="22"
      height="17.6"
      viewBox="0 0 22 17.6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        stroke="#232323"
        d="M1.838.367h18.324a1.47 1.47 0 0 1 1.471 1.471v13.924a1.47 1.47 0 0 1-1.471 1.471H1.838a1.47 1.47 0 0 1-1.471-1.471V1.838A1.47 1.47 0 0 1 1.838.367z"
        strokeWidth=".733"
      />
      <path fill="#232323" d="M.249.262h21.5v3.153H.249z" />
    </svg>
  ),
  landingPage: (
    <svg
      width="70"
      height="56"
      viewBox="0 0 70 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x=".418"
        y=".418"
        width="69.164"
        height="55.164"
        rx="2.09"
        fill="#fff"
        stroke="#ADD9ED"
        strokeWidth=".836"
      />
      <path fill="#ADD9ED" d="M6 20h30v24H6z" />
      <rect x="40" y="24" width="21" height="2" rx="1" fill="#ADD9ED" />
      <rect x="40" y="28" width="16" height="2" rx="1" fill="#ADD9ED" />
      <rect x="40" y="32" width="12" height="2" rx="1" fill="#ADD9ED" />
      <rect x="40" y="38" width="23" height="6" rx="3" fill="#ADD9ED" />
      <rect x="28" y="10" width="15" height="2" rx="1" fill="#ADD9ED" />
      <rect x="20" y="5" width="30" height="3" rx="1.5" fill="#ADD9ED" />
    </svg>
  ),
  landingPageSmall: (
    <svg
      width="22"
      height="17.6"
      viewBox="0 0 22 17.6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        stroke="#232323"
        d="M1.838.367h18.324a1.47 1.47 0 0 1 1.471 1.471v13.924a1.47 1.47 0 0 1-1.471 1.471H1.838a1.47 1.47 0 0 1-1.471-1.471V1.838A1.47 1.47 0 0 1 1.838.367z"
        strokeWidth=".733"
      />
      <path
        fill="#232323"
        d="M1.888 6.285h9.428v7.543H1.888zm11 1.257h5.97a.315.314 0 0 1 .315.315.315.314 0 0 1-.315.314h-5.97a.315.314 0 0 1-.315-.314.315.314 0 0 1 .315-.315m0 1.258h4.399a.315.314 0 0 1 .314.314.315.314 0 0 1-.314.314h-4.399a.315.314 0 0 1-.315-.314.315.314 0 0 1 .315-.314m0 1.256h3.142a.315.314 0 0 1 .315.314.315.314 0 0 1-.315.315h-3.142a.315.314 0 0 1-.315-.315.315.314 0 0 1 .315-.314m.628 1.886h5.342a.943.943 0 0 1 .943.943.943.943 0 0 1-.943.943h-5.342a.943.943 0 0 1-.943-.943.943.943 0 0 1 .943-.943m-4.398-8.8h4.085a.315.314 0 0 1 .315.315.315.314 0 0 1-.315.314H9.118a.315.314 0 0 1-.315-.314.315.314 0 0 1 .315-.315m-2.359-1.57h8.486a.47.47 0 0 1 .471.471.47.47 0 0 1-.471.472H6.759a.47.47 0 0 1-.471-.472.47.47 0 0 1 .471-.471"
      />
    </svg>
  ),
  api: (
    <svg
      width="70"
      height="56"
      viewBox="0 0 70 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x=".418"
        y=".418"
        width="69.164"
        height="55.164"
        rx="2.09"
        fill="#fff"
        stroke="#ADD9ED"
        strokeWidth=".836"
      />
      <path
        d="m35 30-2-2 2-2 2 2zm-2.125-5.875-2.5-2.5L35 17l4.625 4.625-2.5 2.5L35 22zm-4.25 8.5L24 28l4.625-4.625 2.5 2.5L29 28l2.125 2.125zm12.75 0-2.5-2.5L41 28l-2.125-2.125 2.5-2.5L46 28zM35 39l-4.625-4.625 2.5-2.5L35 34l2.125-2.125 2.5 2.5z"
        fill="#ADD9ED"
      />
    </svg>
  ),
  aiStar: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)" fill="#3d8cb8">
        <path d="M5.53 2.738c.08-.22.394-.22.474 0 .334.934.978 2.557 1.622 3.238.645.683 2.104 1.365 2.934 1.718.203.087.203.409 0 .495-.83.353-2.289 1.036-2.934 1.718-.644.68-1.288 2.305-1.622 3.238a.251.251 0 0 1-.473 0c-.335-.933-.979-2.557-1.622-3.238-.644-.68-2.18-1.361-3.063-1.715-.208-.084-.208-.416 0-.5.883-.354 2.419-1.035 3.063-1.716.643-.68 1.287-2.304 1.622-3.238M10.627.866c.04-.11.197-.11.237 0 .167.467.489 1.279.81 1.62.324.34 1.053.682 1.468.858.101.043.101.204 0 .248-.415.176-1.144.517-1.467.859-.322.34-.644 1.152-.811 1.619a.126.126 0 0 1-.237 0c-.167-.467-.489-1.279-.81-1.62-.323-.34-1.09-.68-1.532-.857-.104-.042-.104-.208 0-.25.442-.177 1.21-.517 1.531-.858.322-.34.644-1.152.811-1.619" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  gift: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12.75v1.5h12v-1.5zM3 4.5h1.65a1 1 0 0 1-.122-.356A3 3 0 0 1 4.5 3.75q0-.938.656-1.594A2.17 2.17 0 0 1 6.75 1.5q.563 0 1.04.291.479.29.835.722L9 3l.375-.488q.338-.45.825-.731t1.05-.281q.938 0 1.594.656T13.5 3.75q0 .206-.028.394t-.121.356H15q.618 0 1.06.441.44.44.44 1.059v8.25q0 .618-.44 1.06a1.45 1.45 0 0 1-1.06.44H3q-.618 0-1.059-.44a1.45 1.45 0 0 1-.441-1.06V6q0-.618.44-1.059A1.45 1.45 0 0 1 3 4.5m0 6h12V6h-3.825l1.575 2.138-1.2.862L9 5.55 6.45 9l-1.2-.863L6.788 6H3zm3.75-6q.318 0 .535-.215A.73.73 0 0 0 7.5 3.75a.73.73 0 0 0-.215-.535A.73.73 0 0 0 6.75 3a.73.73 0 0 0-.535.215A.73.73 0 0 0 6 3.75q0 .318.215.535.217.215.535.215m4.5 0q.318 0 .535-.215A.73.73 0 0 0 12 3.75a.73.73 0 0 0-.215-.535A.73.73 0 0 0 11.25 3a.73.73 0 0 0-.535.215.73.73 0 0 0-.215.535q0 .318.215.535.217.215.535.215"
        fill="#00324D"
      />
    </svg>
  ),
  warining1: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.75 15.75 9 1.5l8.251 14.25zm2.587-1.5h11.325L9 4.5zM9 13.5a.73.73 0 0 0 .534-.216.73.73 0 0 0 .216-.534.73.73 0 0 0-.216-.534.73.73 0 0 0-.534-.215.73.73 0 0 0-.534.215.73.73 0 0 0-.215.534q0 .32.215.534.216.216.534.216m-.749-2.25h1.5V7.5h-1.5z"
        fill="#232323"
      />
    </svg>
  ),
  threeDots: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.25 10.125a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25M7.875 9a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0m-5.25 0a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0"
        fill="#202023"
      />
    </svg>
  ),
  gauge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M17.8767949,9.23308312 L17.8767706,9.23298733 C18.6031875,8.85039387 19.4752752,9.13758442 19.8375393,9.83165018 C20.5885575,11.2452129 21,12.849342 21,14.4535669 C21,15.2439934 20.3464185,15.8903577 19.5471662,15.8903577 C18.747914,15.8903577 18.0943325,15.2439934 18.0943325,14.4535669 C18.0943325,13.3039905 17.8039595,12.1786959 17.2714475,11.1731339 C16.908239,10.4781103 17.1749793,9.59228083 17.8767949,9.23308312 Z M12.1630418,7.53359901 L12.1630418,7.53358464 C11.7752321,7.46155832 11.3883909,7.43723824 11.0005811,7.43723824 C7.10165962,7.43723824 3.9056675,10.5747105 3.9056675,14.4538063 C3.9056675,15.2442329 3.25208603,15.8905972 2.45283375,15.8905972 C1.65358148,15.8905972 1,15.2442329 1,14.4538063 C1,8.99376165 5.47957074,4.56367906 11.0005811,4.56461441 C11.5330931,4.56461441 12.0902064,4.58893449 12.6227184,4.68434698 C13.4219707,4.80407955 13.9544827,5.54584677 13.8334132,6.33627331 C13.7123438,7.12669984 12.9622941,7.65333158 12.1630418,7.53359901 Z M18.5550261,4.08458259 L18.5549777,4.0847981 C18.7006388,4.20453068 18.7242861,4.39627999 18.6514555,4.54033264 L12.1865874,15.2918385 C11.7751449,15.9868574 10.8784559,16.2019976 10.1766404,15.7950985 C9.4738611,15.3881993 9.25631862,14.501412 9.66776113,13.8073462 C9.7169444,13.7353199 9.76518332,13.6876137 9.81342225,13.6155873 L18.0461468,4.13228883 C18.1672163,3.96485002 18.409365,3.96485002 18.5550261,4.08458259 Z" />
    </svg>
  ),
  gear: (
    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 9.985v-2l-2.39-.997a5.356 5.356 0 0 0-.223-.547l.965-2.402-1.414-1.415-2.382.981a5.726 5.726 0 0 0-.558-.23L9.984 1h-2l-.988 2.368c-.2.07-.39.144-.58.234L4.04 2.647 2.625 4.06l.969 2.356c-.094.194-.17.39-.243.594L1 8.016v2l2.354.98c.072.204.15.401.244.594l-.951 2.371 1.414 1.415 2.362-.973c.189.09.383.162.581.23L8.016 17h2l.99-2.379c.19-.07.377-.144.557-.23l2.398.961 1.414-1.414-.984-2.387c.084-.18.152-.362.219-.547L17 9.984zM8.984 12A3 3 0 1 1 8.986 6 3 3 0 0 1 8.984 12z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
  globe: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C3.15 0 0 3.15 0 7C0 10.85 3.15 14 7 14C10.85 14 14 10.85 14 7C14 3.15 10.85 0 7 0ZM12.1625 6.125H10.5C10.4125 4.725 10.15 3.5 9.7125 2.45C10.9375 3.2375 11.9 4.55 12.1625 6.125ZM7 12.25C6.5625 12.25 5.5125 10.675 5.25 7.875H8.75C8.4875 10.675 7.4375 12.25 7 12.25ZM5.25 6.125C5.425 3.325 6.5625 1.75 7 1.75C7.4375 1.75 8.4875 3.325 8.75 6.125H5.25ZM4.2875 2.45C3.9375 3.5 3.5875 4.725 3.5 6.125H1.8375C2.1 4.55 3.0625 3.2375 4.2875 2.45ZM1.8375 7.875H3.5C3.5875 9.275 3.85 10.5 4.2875 11.55C3.0625 10.7625 2.1 9.45 1.8375 7.875ZM9.7125 11.55C10.0625 10.5 10.4125 9.275 10.5 7.875H12.1625C11.9 9.45 10.9375 10.7625 9.7125 11.55Z"
        fill="#393B48"
      />
    </svg>
  ),
  google_analytics: (
    <svg width="22" height="22" viewBox="0 0 2195.9 2430.9">
      <path
        d="M2195.9,2126.7c.9,166.9-133.7,302.8-300.5,303.7a289,289,0,0,1-37.2-2.1c-154.8-22.9-268.2-157.6-264.4-314V316.1c-3.7-156.6,110-291.3,264.9-314,165.7-19.4,315.8,99.2,335.2,264.9a299.84,299.84,0,0,1,2,36.7Z"
        fill="#f9ab00"
      />
      <path
        d="M301.1,1828.7c166.3,0,301.1,134.8,301.1,301.1s-134.8,301.1-301.1,301.1S0,2296.1,0,2129.8,134.8,1828.7,301.1,1828.7Zm792.2-912.5c-167.1,9.2-296.7,149.3-292.8,316.6v808.7c0,219.5,96.6,352.7,238.1,381.1,163.3,33.1,322.4-72.4,355.5-235.7a294.74,294.74,0,0,0,6-60.7V1218.8c.3-166.9-134.7-302.4-301.6-302.7C1096.8,916.1,1095,916.1,1093.3,916.2Z"
        fill="#e37400"
      />
    </svg>
  ),
  insights: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M15.2402701,13.2637206 L15.2401879,13.2636964 C14.4978942,14.0051198 14.0946612,15.020334 14.1277144,16.0685725 C14.3656912,16.1044493 14.5413427,16.3103304 14.5385095,16.5520884 L14.5385095,19.017778 L14.4903465,19.017778 C14.280694,20.162357 13.285328,20.9952782 12.1209249,21 L10.0905447,21 C8.92614162,20.9952857 7.93077326,20.162357 7.72112316,19.017778 L7.67296014,19.017778 L7.67296014,16.5520884 C7.67013157,16.3235618 7.83445689,16.1280788 8.05921686,16.0921922 C8.08283661,15.0430593 7.69186561,14.0269022 6.97130597,13.2638656 C5.95800158,12.1853833 5.40366553,10.7546838 5.42444173,9.27485904 C5.47259992,7.80255296 6.07878387,6.40388637 7.12051899,5.36224795 C8.16225411,4.32060954 9.56087235,3.71433372 11.0331301,3.6661707 L11.105846,3.6661707 C12.5921741,3.67562343 14.0154275,4.2649085 15.0740615,5.30843263 C16.1317526,6.35089302 16.7418023,7.76650685 16.7729673,9.25198873 C16.803187,10.7375915 16.2535744,12.1767526 15.2402701,13.2637206 Z M7.67300366,12.5866048 L7.67287794,12.5867499 C8.55870334,13.5271884 9.04410936,14.7756991 9.02616656,16.0685483 L10.622156,16.0685483 L10.622156,12.9974967 C9.967693,12.77462 9.52384784,12.1655108 9.50968252,11.4751709 C9.50968252,10.5931169 10.2245609,9.87918145 11.105672,9.87918145 C11.9867831,9.87918145 12.7016614,10.5931411 12.7016614,11.4751709 C12.6874944,12.1655108 12.2436268,12.7746249 11.5891879,12.9974967 L11.5891879,16.0685483 L13.1606148,16.0685483 C13.1266236,14.7756508 13.6243066,13.5253027 14.5384418,12.6111675 C15.3638277,11.7348673 15.8218411,10.5752027 15.8199525,9.37112706 C15.8199525,8.11894163 15.3241552,6.91771877 14.4402397,6.0290648 C13.5573396,5.14137787 12.3579058,4.63990993 11.105672,4.6332993 L11.032956,4.6332993 C9.81766284,4.68051464 8.66459817,5.1847976 7.80427824,6.04511753 C6.9439583,6.90628362 6.439656,8.05937246 6.39149298,9.27476234 C6.36221609,10.5052137 6.82402217,11.6960652 7.67300366,12.5866048 Z M11.1057252,12.1030889 L11.1057445,12.1030696 C11.272896,12.1030696 11.4324852,12.0369633 11.5505308,11.9189177 C11.6676336,11.8008914 11.7346827,11.6412828 11.7346827,11.4750742 C11.7346827,11.1275471 11.4532522,10.8461167 11.1057252,10.8461167 C10.7581981,10.8461167 10.4767676,11.1275471 10.4767676,11.4750742 C10.4767676,11.8216584 10.7581981,12.1030889 11.1057252,12.1030889 Z M12.1209153,20.0329923 L12.1209636,20.0329923 C12.7527497,20.0301637 13.3099172,19.6203114 13.4987907,19.0178022 L8.71270801,19.0178022 C8.90156934,19.6203114 9.45874895,20.0301591 10.0905351,20.0329923 L12.1209153,20.0329923 Z M8.64008391,18.0507703 L13.5714631,18.0507703 L13.5714631,17.0355802 L8.64008391,17.0355802 L8.64008391,18.0507703 Z M11.5892411,1.65933774 C11.5892411,1.92659393 11.3729813,2.14285369 11.1057252,2.14285369 C10.838469,2.14285369 10.6222092,1.92660118 10.6222092,1.65933774 L10.6222092,-0.516484048 C10.6222092,-0.783740238 10.838469,-1 11.1057252,-1 C11.3729813,-1 11.5892411,-0.78374749 11.5892411,-0.516484048 L11.5892411,1.65933774 Z M20.7279344,7.75139698 C20.9951906,7.75139698 21.2114503,7.96765674 21.2114503,8.23491293 C21.2114503,8.50216912 20.9951978,8.71842888 20.7279344,8.71842888 L18.5521126,8.71842888 C18.2848564,8.71842888 18.0685966,8.50216912 18.0685966,8.23491293 C18.0685966,7.96765674 18.2848491,7.75139698 18.5521126,7.75139698 L20.7279344,7.75139698 Z M3.65933774,8.71842888 L1.48351595,8.71842888 C1.21625976,8.71842888 1,8.50216912 1,8.23491293 C1,7.96765674 1.21625251,7.75139698 1.48351595,7.75139698 L3.65933774,7.75139698 C3.92659393,7.75139698 4.14285369,7.96765674 4.14285369,8.23491293 C4.14285369,8.50216912 3.92660118,8.71842888 3.65933774,8.71842888 Z M4.14285369,2.38461167 C3.99836462,2.19195473 4.01820328,1.92281041 4.18818331,1.75282555 C4.35816334,1.58284068 4.62731733,1.56300685 4.81996943,1.70749593 L6.36683366,3.23076458 C6.53304227,3.43473579 6.53304227,3.72749261 6.36683366,3.9314759 C6.26295026,4.00985867 6.13546403,4.05235489 6.0041967,4.05235489 C5.88143683,4.04952148 5.76339125,4.00702527 5.66612234,3.9314759 L4.14285369,2.38461167 Z M18.0685966,1.70744757 L18.0686208,1.70747175 C18.1630563,1.79433539 18.2168861,1.91710976 18.2168861,2.04648896 C18.2168861,2.17491321 18.1630563,2.29768033 18.0686208,2.38456331 L16.5453521,3.93142755 C16.4480905,4.00697692 16.3300449,4.04947337 16.2072778,4.05230654 C16.0760105,4.05230654 15.9485218,4.00981032 15.8446408,3.93142755 C15.6784322,3.72745634 15.6784322,3.43469952 15.8446408,3.23071623 L17.3915051,1.70744757 C17.4783687,1.61301207 17.6011455,1.55918224 17.7295794,1.55918224 C17.8589465,1.55918224 17.9817136,1.61301207 18.0685966,1.70744757 Z" />
    </svg>
  ),
  installation: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="190"
      height="150"
      viewBox="0 0 190 150"
    >
      <g fill="none" fillRule="evenodd" transform="translate(-11 -26)">
        <path
          fill="#E9FEF9"
          d="M72.045891,21.6208333 C104.957532,17.1553077 144.588907,34.6113077 171.738918,59.6937521 C215.231564,99.874283 204.532264,144.860629 154.338907,164.143881 C104.145549,183.427132 79.3233021,180.237736 44.5498247,140.015599 C9.77634728,99.7934625 -3.03942994,31.8085788 72.045891,21.6208333 Z"
          transform="rotate(-15 107.935 98.258)"
        />
        <path
          fill="#52B8A0"
          fillRule="nonzero"
          d="M111.121 90.879C111.55069 90.879 111.97647 90.71494 112.3007 90.39072L140.0897 62.59772C140.73814 61.94928 140.73814 60.89072 140.0897 60.23832 139.44126 59.58988 138.3827 59.58988 137.7303 60.23832L109.9413 88.03132C109.29286 88.67976 109.29286 89.73832 109.9413 90.39072 110.26161 90.71103 110.6913 90.879 111.121 90.879zM116.609 97.059C116.93322 97.38322 117.36291 97.54728 117.7887 97.54728 118.21448 97.54728 118.64417 97.38322 118.9684 97.059L146.7614 69.266C147.40984 68.61756 147.40984 67.559 146.7614 66.9066 146.11296 66.25816 145.0544 66.25816 144.402 66.9066L116.609 94.6996C115.95666 95.35194 115.95666 96.4105 116.609 97.059z"
        />
        <path
          fill="#52B8A0"
          fillRule="nonzero"
          d="M140.512,149.047 C141.01981,148.82044 141.387,148.3595 141.48466,147.8126 C141.582316,147.26182 141.402629,146.6993 141.00028,146.3165 L129.51228,135.2305 C129.149,134.86722 128.94978,134.37503 128.94978,133.8438 C128.94978,133.30083 129.15681,132.793 129.55525,132.4063 L134.43025,127.5235 C135.22712,126.72662 136.43415,126.73053 137.22715,127.519593 L148.66115,138.957593 C149.05568,139.348213 149.61427,139.516183 150.15335,139.410713 C150.69632,139.309153 151.14944,138.945873 151.36815,138.434153 C154.57905,130.992753 152.90725,122.180153 147.20015,116.504153 C141.66495,111.000253 133.01615,109.051053 125.53615,111.605753 L119.28225,105.351853 C119.54397,105.176073 119.84866,105.066693 120.07913,104.840133 L154.54013,70.383133 C155.45029,69.469073 155.95033,68.262033 155.95033,66.972933 C155.95033,65.683833 155.45033,64.480733 154.54013,63.578433 L143.42313,52.457433 C141.59893,50.644933 138.43873,50.637133 136.61453,52.457433 L102.15353,86.918433 C101.92697,87.148903 101.82541,87.441873 101.65353,87.703593 L95.34883,81.320793 C97.85663,74.355993 95.7668,65.418793 90.37613,60.058793 C84.55973,54.277593 75.97813,52.660393 68.50513,55.902593 C67.99341,56.129153 67.62622,56.590093 67.52857,57.136993 C67.430914,57.687773 67.610601,58.250293 68.00904,58.633093 L79.50904,69.738093 C79.93873,70.163873 80.18092,70.738093 80.18092,71.347493 C80.18092,71.812333 80.01686,72.230303 79.70826,72.531093 L74.66526,77.581893 C73.9426,78.292833 72.61836,78.202983 71.77856,77.363143 L60.36056,66.011143 C59.95431,65.608803 59.36447,65.452553 58.82146,65.565833 C58.26287,65.694743 57.81366,66.089273 57.61836,66.624433 C56.57926,69.476033 56.05586,72.233833 56.05586,74.827533 C56.05586,79.925233 58.10666,84.765033 61.82536,88.456533 C67.36056,93.960433 76.00536,95.897933 83.48936,93.354933 L94.05936,103.920933 L71.35636,126.678933 L65.79776,130.014833 C65.58682,130.139833 65.40714,130.311713 65.27042,130.518743 L56.37592,143.862743 C55.93842,144.522903 56.02045,145.401843 56.58295,145.964343 L61.02435,150.409643 C61.34466,150.733863 61.77435,150.901833 62.20405,150.901833 C62.52436,150.901833 62.84467,150.811989 63.12983,150.624493 L76.46983,141.733893 C76.67686,141.597173 76.84874,141.417483 76.97374,141.206553 L80.05574,135.964353 L103.06774,112.952353 L113.65374,123.640353 C111.13034,130.745853 113.17327,139.488353 118.63424,144.890353 C122.45454,148.695053 127.48194,150.706753 132.59924,150.702853 C135.26724,150.69504 137.95474,150.152073 140.51334,149.046653 L140.512,149.047 Z M104.516,89.277 L138.977,54.816 C139.53559,54.2535 140.5161,54.25741 141.0629,54.816 L152.1839,65.933 C152.45734,66.20644 152.61749,66.57753 152.61749,66.976 C152.61749,67.37053 152.46515,67.74553 152.1839,68.0229 L117.7229,102.4799 C117.28931,102.90959 116.594,103.02287 116.0471,102.75334 C115.60179,102.5385 115.07054,102.56584 114.6213,102.772872 C114.17208,102.975992 113.82442,103.405682 113.69552,103.886172 C113.58615,104.284612 112.7424,106.370572 111.95722,108.206472 C111.39081,108.604912 110.55882,108.522882 110.07442,108.034592 L101.17992,99.140092 C101.17992,99.140092 101.172107,99.136186 101.172107,99.132279 L98.949407,96.909579 C98.675967,96.636139 98.515817,96.265049 98.515817,95.866579 C98.515817,95.561889 98.605661,95.265019 98.777537,95.026739 C100.609537,94.249399 102.687737,93.401739 103.043137,93.304039 C103.550947,93.214195 103.988447,92.878259 104.218937,92.417319 C104.453317,91.960289 104.457217,91.413419 104.230656,90.940719 C103.972846,90.386029 104.074406,89.710219 104.515816,89.276619 L104.516,89.277 Z M85.848,90.9997 C84.89488,90.05048 83.473,89.7224 82.2347,90.17939 C76.0667,92.35519 68.8127,90.72236 64.1757,86.10129 C61.0859,83.03489 59.3866,79.02709 59.3866,74.82829 C59.3866,73.39079 59.57801,71.88689 59.96472,70.32439 L69.42562,79.72669 C71.57792,81.87509 74.98812,81.95719 77.01942,79.94153 L82.05462,74.90243 C82.99603,73.98055 83.51552,72.71103 83.51552,71.33213 C83.51552,69.85163 82.90614,68.40633 81.83582,67.34773 L72.27332,58.11723 C77.84752,56.66803 83.81232,58.24223 88.02332,62.42583 C92.54282,66.91413 94.30062,74.38283 92.21082,80.17983 C91.75769,81.42593 92.0741,82.85173 93.02723,83.82043 L100.09363,90.88683 C99.28113,91.21105 98.33193,91.60167 97.12883,92.12123 C96.92571,92.203261 96.74602,92.32045 96.59758,92.47279 C95.68742,93.38685 95.18738,94.59389 95.18738,95.88299 C95.18738,97.17209 95.68738,98.37519 96.59758,99.27749 L97.64448,100.32439 L96.41008,101.55879 L85.848,90.9997 Z M77.4496,133.9257 L74.309,139.1679 L62.418,147.0898 L59.9063,144.5742 L67.836,132.6792 L73.3907,129.2925 L97.5357,105.1475 C97.551325,105.131874 97.578669,105.127968 97.5982,105.104531 C97.617732,105.085 97.621638,105.061562 97.641169,105.042031 L100.004469,102.678731 L104.316969,106.991231 L101.941969,109.370131 C101.930251,109.381849 101.914625,109.385756 101.899001,109.397475 C101.887282,109.409193 101.883375,109.424818 101.871657,109.440443 L77.4496,133.9257 Z M120.9926,142.5195 C116.4887,138.0625 114.727,130.5895 116.8051,124.7465 C117.2426,123.4965 116.92619,122.0785 115.9926,121.1332 L105.4416,110.5822 L106.676,109.3478 L107.7229,110.3908 C108.63306,111.30096 109.8401,111.7931 111.1213,111.7931 C112.4065,111.7931 113.6135,111.29701 114.5158,110.3908 C114.66424,110.24236 114.78533,110.06268 114.87518,109.86736 C115.3908,108.65646 115.78924,107.69936 116.11348,106.89076 L123.19158,113.96496 C124.13299,114.90246 125.55488,115.21886 126.79708,114.77355 C132.96508,112.60165 140.21908,114.25011 144.85608,118.85555 C148.99668,122.97665 150.58268,129.08955 149.13338,134.70355 L139.58258,125.14885 C137.48098,123.05905 134.19198,123.05905 132.07478,125.156662 L127.20758,130.031662 C126.18418,131.035562 125.61778,132.387162 125.61778,133.836362 C125.61778,135.262162 126.16856,136.590262 127.18418,137.598062 L136.73888,146.824662 C131.17248,148.309062 125.19988,146.715282 120.99288,142.519962 L120.9926,142.5195 Z"
        />
      </g>
    </svg>
  ),
  intercom: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>intercom</title>
      <path
        d="M15.75 0H2.25A2.25 2.25 0 0 0 0 2.25v13.5A2.25 2.25 0 0 0 2.25 18h13.5A2.25 2.25 0 0 0 18 15.75V2.25A2.25 2.25 0 0 0 15.75 0zM11.4 3.3a.6.6 0 0 1 1.2 0v8.016a.6.6 0 0 1-1.2 0V3.3zm-3-.304a.6.6 0 0 1 1.2 0v8.7a.6.6 0 0 1-1.2 0v-8.7zm-3 .304a.6.6 0 0 1 1.2 0v8.016a.6.6 0 1 1-1.2 0V3.3zm-3 1.2a.6.6 0 1 1 1.2 0v5.397a.6.6 0 0 1-1.2 0V4.5zm12.99 9.152c-.092.08-2.315 1.944-6.39 1.944-4.075 0-6.297-1.864-6.39-1.944a.6.6 0 0 1 .779-.912c.034.03 2.02 1.657 5.61 1.657 3.636 0 5.59-1.64 5.61-1.656a.6.6 0 1 1 .782.91zm.21-3.755a.6.6 0 0 1-1.2 0V4.5a.6.6 0 1 1 1.2 0v5.397z"
        fill="#286EFA"
        fillRule="evenodd"
      />
    </svg>
  ),
  italics: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M9.51607336,3 L9.25045898,4.0624575 L11.1098446,4.0624575 C11.5481041,4.0624575 11.8143814,4.40975361 11.6948592,4.83473661 L8.13367165,18.1652634 C8.01414433,18.5902464 7.56325947,18.9375425 7.125,18.9375425 L5.26561438,18.9375425 L5,20 L12.7027319,20 L12.9683463,18.9375425 L10.8434313,18.9375425 C10.4051718,18.9375425 10.1388944,18.5909094 10.2584167,18.1652634 L13.8196042,4.83473661 C13.9391298,4.40975361 14.3900164,4.0624575 14.8282759,4.0624575 L16.6876615,4.0624575 L16.9532759,3 L9.51607336,3 Z" />
    </svg>
  ),
  flag: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M18.936 2.473l-.156.051c-.129.052-.258.103-.387.13-.051.025-.077.025-.129.05-.077.027-.18.052-.258.078-.051.026-.103.026-.155.052a.757.757 0 0 1-.258.051c-.052 0-.103.026-.155.026-.078.027-.156.027-.232.052-.052 0-.13.026-.18.026-.078 0-.156.026-.233.026-.051 0-.129.026-.18.026-.078 0-.155.027-.232.027h-.18c-.078 0-.156 0-.232.026h-.851c-.078 0-.155 0-.232-.026-.077 0-.129 0-.207-.027-.077 0-.155-.026-.231-.026-.052 0-.13-.026-.18-.026-.078 0-.156-.026-.233-.051-.051 0-.129-.027-.18-.027-.078-.026-.155-.026-.232-.051-.051 0-.103-.026-.18-.026-.078-.027-.18-.052-.258-.078-.052-.026-.103-.026-.156-.051-.103-.027-.18-.052-.284-.078-.051-.026-.078-.026-.129-.051a7.838 7.838 0 0 0-.413-.156 7.838 7.838 0 0 0-.414-.155c-.051-.026-.103-.026-.129-.051-.077-.026-.18-.052-.258-.078-.051-.026-.103-.026-.155-.051a3.321 3.321 0 0 0-.258-.078c-.051-.026-.13-.026-.18-.051-.078-.027-.156-.027-.232-.052-.052 0-.13-.026-.18-.026-.078-.026-.156-.026-.233-.026-.051 0-.129-.026-.18-.026-.078 0-.155-.027-.232-.027-.051 0-.129 0-.18-.026-.078 0-.156 0-.232-.026h-.825c-.079 0-.156 0-.233.026h-.18c-.078 0-.155.026-.232.026-.051 0-.13 0-.18.027-.078 0-.156.026-.232.026-.052 0-.13.026-.18.026-.078.026-.156.026-.233.051-.051 0-.129.027-.18.027a.745.745 0 0 1-.232.051c-.051.026-.103.026-.155.051-.078.027-.18.052-.258.078-.052.026-.103.026-.13.052-.128.05-.257.077-.386.129l-.156.05V1H4v20h1.548l-.007-9.675.156-.052c.129-.051.258-.103.387-.129.051-.026.077-.026.129-.051.077-.026.18-.052.258-.078.051-.026.103-.026.155-.051a.757.757 0 0 1 .258-.052c.051 0 .103-.026.18-.026.078-.026.156-.026.232-.051.052 0 .13-.026.18-.026.078 0 .156-.027.233-.027.051 0 .129-.026.18-.026.078 0 .155-.026.232-.026h.18c.078 0 .156 0 .232-.026h.826c.077 0 .155 0 .232.026.051 0 .129 0 .18.026.078 0 .155.026.232.026.051 0 .13.027.18.027.078 0 .156.026.232.05.052 0 .13.027.18.027.078.026.156.026.233.052.051 0 .102.026.18.026.078.026.18.051.258.077.052.027.103.027.155.052.103.026.18.051.258.077.052.027.103.027.13.052.129.051.258.103.413.155h.026c.129.051.258.103.387.13.052.025.103.025.155.05.078.027.18.052.258.078.052.026.103.026.156.052a.745.745 0 0 0 .231.051c.052.026.13.026.18.051.079.027.156.027.233.052.051 0 .129.026.18.026a.705.705 0 0 0 .232.026c.052 0 .13.026.18.026.078 0 .156.027.232.027.078 0 .13 0 .207.026.078 0 .155 0 .232.026H15.96c.078 0 .156 0 .233-.026h.18c.078 0 .155-.026.232-.026.051 0 .129 0 .18-.027.078 0 .156-.026.232-.026.052 0 .13-.026.18-.026.078-.026.156-.026.232-.051.052 0 .103-.027.18-.027a.757.757 0 0 1 .259-.051c.051-.026.103-.026.155-.051.078-.027.18-.052.258-.078.052-.026.078-.026.13-.051.128-.052.257-.078.386-.13l.156-.05-.018-8.905z" />
    </svg>
  ),
  lifesaver: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M18.0773784,3.92262162 C14.1805496,0.025792794 7.81945044,0.025792794 3.92262162,3.92262162 C0.025792794,7.81945044 0.025792794,14.1805496 3.92262162,18.0773784 C7.81945044,21.9742072 14.1805496,21.9742072 18.0773784,18.0773784 C21.9742072,14.1813921 21.9742072,7.81945044 18.0773784,3.92262162 Z M19.5090733,13.8226732 L16.3075651,12.7480753 C16.6868845,11.6109596 16.6868845,10.3676395 16.3075651,9.23060801 L19.5090733,8.15601007 C20.0990321,10.0106268 20.0990321,11.990279 19.5090733,13.8226311 L19.5090733,13.8226732 Z M2.49004202,8.17816933 L5.6915502,9.25276728 C5.31223078,10.389883 5.31223078,11.6332031 5.6915502,12.7702345 L2.49004202,13.8448325 C1.9000832,11.9902158 1.9000832,10.0105636 2.49004202,8.17821146 L2.49004202,8.17816933 Z M7.79794416,14.2020348 C6.02891026,12.4330009 6.02891026,9.54648285 7.79794416,7.7775332 C9.56697806,6.0084993 12.4534961,6.0084993 14.2224457,7.7775332 C15.9914796,9.5465671 15.9914796,12.4330851 14.2224457,14.2020348 C12.4320109,15.9718902 9.56689381,15.9718902 7.79794416,14.2020348 Z M13.8218096,2.49090564 L12.7472117,5.69241382 C11.6100959,5.3130944 10.3667758,5.3130944 9.22974439,5.69241382 L8.15514645,2.49090564 C10.0097631,1.90094682 11.9894154,1.90094682 13.8217675,2.49090564 L13.8218096,2.49090564 Z M8.17730571,19.5099369 L9.25190365,16.3084287 C10.3890194,16.6877482 11.6323395,16.6877482 12.7693709,16.3084287 L13.8439689,19.5099369 C11.9893522,20.0998957 10.0096999,20.0998957 8.17734784,19.5099369 L8.17730571,19.5099369 Z" />
    </svg>
  ),
  contactSupport: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.5294 22L11.2647 18.85H11C8.49412 18.85 6.36765 17.9837 4.62059 16.2512C2.87353 14.5187 2 12.41 2 9.925C2 7.44 2.87353 5.33125 4.62059 3.59875C6.36765 1.86625 8.49412 1 11 1C12.2529 1 13.4221 1.23188 14.5074 1.69562C15.5926 2.15937 16.5456 2.79812 17.3662 3.61187C18.1868 4.42562 18.8309 5.37062 19.2985 6.44687C19.7662 7.52312 20 8.6825 20 9.925C20 11.2375 19.7838 12.4975 19.3515 13.705C18.9191 14.9125 18.3279 16.0325 17.5779 17.065C16.8279 18.0975 15.9368 19.0337 14.9044 19.8737C13.8721 20.7137 12.7471 21.4225 11.5294 22ZM10.9735 15.6737C11.2735 15.6737 11.5294 15.5687 11.7412 15.3587C11.9529 15.1487 12.0588 14.895 12.0588 14.5975C12.0588 14.3 11.9529 14.0462 11.7412 13.8362C11.5294 13.6262 11.2735 13.5212 10.9735 13.5212C10.6735 13.5212 10.4176 13.6262 10.2059 13.8362C9.99412 14.0462 9.88824 14.3 9.88824 14.5975C9.88824 14.895 9.99412 15.1487 10.2059 15.3587C10.4176 15.5687 10.6735 15.6737 10.9735 15.6737ZM10.2059 12.34H11.7941C11.7941 11.815 11.8471 11.4475 11.9529 11.2375C12.0588 11.0275 12.3941 10.6425 12.9588 10.0825C13.2765 9.7675 13.5412 9.42625 13.7529 9.05875C13.9647 8.69125 14.0706 8.2975 14.0706 7.8775C14.0706 6.985 13.7662 6.31562 13.1574 5.86937C12.5485 5.42312 11.8294 5.2 11 5.2C10.2235 5.2 9.57059 5.41437 9.04118 5.84312C8.51176 6.27187 8.14118 6.7925 7.92941 7.405L9.41176 7.9825C9.5 7.685 9.66765 7.39187 9.91471 7.10312C10.1618 6.81437 10.5235 6.67 11 6.67C11.4765 6.67 11.8338 6.80125 12.0721 7.06375C12.3103 7.32625 12.4294 7.615 12.4294 7.93C12.4294 8.2275 12.3412 8.49437 12.1647 8.73062C11.9882 8.96687 11.7765 9.2075 11.5294 9.4525C10.9118 9.9775 10.5368 10.3931 10.4044 10.6994C10.2721 11.0056 10.2059 11.5525 10.2059 12.34Z" />
    </svg>
  ),
  lightbulb: (
    <svg width="23" height="25">
      <path
        d="M11.2.92c-.264 0-.56.283-.56.56v1.68a.582.582 0 0 0 .56.568.582.582 0 0 0 .56-.568V1.48c0-.318-.296-.56-.56-.56zm7.49 3.351a.565.565 0 0 0-.324.167l-1.12 1.12a.582.582 0 0 0-.012.8c.21.21.593.21.8-.004l1.12-1.12a.573.573 0 0 0 .139-.621.575.575 0 0 0-.533-.35.51.51 0 0 0-.07.008zm-15.586.374c-.07.202-.01.441.142.589l1.12 1.12c.207.213.59.214.8.003a.582.582 0 0 0-.012-.8l-1.12-1.12a.57.57 0 0 0-.455-.166.572.572 0 0 0-.475.374zM11.2 5.96c-3.13 0-6.16 2.552-6.16 6.16 0 4.402 2.97 5.053 3.325 7.84h5.67c.354-2.787 3.325-3.438 3.325-7.84 0-3.608-3.03-6.16-6.16-6.16zm8.12 6.44c0 .264.266.56.56.56h1.96a.575.575 0 0 0 .56-.56.575.575 0 0 0-.56-.56h-1.96c-.323 0-.56.296-.56.56zM0 12.4c0 .264.267.56.56.56h1.68a.582.582 0 0 0 .568-.56.582.582 0 0 0-.568-.56H.56c-.322 0-.56.296-.56.56zm4.725 5.618l-1.444 1.435a.582.582 0 0 0-.012.8c.21.21.593.21.8-.004l1.444-1.444a.575.575 0 0 0 .126-.619.574.574 0 0 0-.529-.343.566.566 0 0 0-.385.175zm12.02.199c-.07.2-.01.44.143.588l1.443 1.444c.207.213.59.214.8.003a.582.582 0 0 0-.012-.8l-1.444-1.434a.566.566 0 0 0-.455-.175.572.572 0 0 0-.475.374zM8.4 21.08v2.8c0 .643.53 1.12 1.12 1.12h3.36c.59 0 1.12-.477 1.12-1.12v-2.8H8.4z"
        fill="#000"
        opacity=".3"
      />
    </svg>
  ),
  lightning: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M15.8812882,10.3054063 L12.8318611,10.3054063 L15.6673183,3.49421086 C15.810104,3.13759443 15.364337,2.83461312 15.0787586,3.10207544 L6.10967716,12.0704436 C5.87773383,12.302387 6.03863203,12.6764063 6.35902336,12.6764063 L9.40845043,12.6764063 L6.57370645,19.5057891 C6.4309208,19.8624056 6.87668777,20.1653869 7.1622662,19.8979246 L16.1313476,10.9288431 C16.3625956,10.6975952 16.2023928,10.3054598 15.881306,10.3054598 L15.8812882,10.3054063 Z" />
    </svg>
  ),
  bell: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.33325 15.8332V14.1665H4.99992V8.33317C4.99992 7.18039 5.34714 6.15595 6.04159 5.25984C6.73603 4.36428 7.63881 3.77761 8.74992 3.49984V2.9165C8.74992 2.56928 8.87158 2.27428 9.11492 2.0315C9.3577 1.78817 9.6527 1.6665 9.99992 1.6665C10.3471 1.6665 10.6421 1.78817 10.8849 2.0315C11.1283 2.27428 11.2499 2.56928 11.2499 2.9165V3.49984C12.361 3.77761 13.2638 4.36428 13.9583 5.25984C14.6527 6.15595 14.9999 7.18039 14.9999 8.33317V14.1665H16.6666V15.8332H3.33325ZM9.99992 18.3332C9.54159 18.3332 9.14936 18.1701 8.82325 17.844C8.49659 17.5173 8.33325 17.1248 8.33325 16.6665H11.6666C11.6666 17.1248 11.5035 17.5173 11.1774 17.844C10.8508 18.1701 10.4583 18.3332 9.99992 18.3332Z" />
    </svg>
  ),
  link: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="-2 -2 17 17"
    >
      <path d="M12.9068 1.09546C11.4488 -0.36255 9.08448 -0.36255 7.62703 1.09546L5.54389 3.17804C5.70906 3.15999 5.87531 3.15234 6.04266 3.15234C6.56987 3.15234 7.08231 3.23601 7.56802 3.39735L8.74822 2.21714C9.15347 1.81135 9.69271 1.58821 10.2664 1.58821C10.8396 1.58821 11.3788 1.81135 11.7847 2.21714C12.1899 2.62239 12.413 3.16054 12.413 3.7348C12.413 4.30795 12.1899 4.84718 11.7847 5.25246L9.47513 7.56198C9.06934 7.96777 8.53009 8.19091 7.95691 8.19091C7.38267 8.19091 6.84453 7.96777 6.43869 7.56198C6.24126 7.36565 6.08759 7.13649 5.98149 6.88712C5.71844 6.90188 5.47234 7.01126 5.2842 7.19885L4.66895 7.81465C4.83739 8.12639 5.05341 8.42061 5.31647 8.68475C6.77448 10.1428 9.13875 10.1428 10.5968 8.68475L12.9068 6.37411C14.3643 4.91665 14.3643 2.55295 12.9068 1.09549L12.9068 1.09546Z" />
      <path d="M7.98158 10.8511C7.45329 10.8511 6.93591 10.7657 6.43929 10.5973L5.25088 11.7857C4.84564 12.1915 4.30694 12.4146 3.73322 12.4146C3.16007 12.4146 2.62139 12.1915 2.21557 11.7857C1.80978 11.3805 1.58664 10.8418 1.58664 10.268C1.58664 9.69489 1.80978 9.15566 2.21557 8.74983L4.52509 6.4403C4.93088 6.03506 5.46904 5.81246 6.04275 5.81246C6.617 5.81246 7.15513 6.0356 7.56097 6.4403C7.7584 6.63774 7.91262 6.86688 8.01926 7.11626C8.28341 7.10259 8.53005 6.99211 8.71765 6.80452L9.33181 6.18927C9.16337 5.87644 8.94679 5.58277 8.68319 5.31861C7.22518 3.86059 4.86091 3.86059 3.40346 5.31861L1.09393 7.62925C-0.364643 9.08727 -0.364643 11.4504 1.09393 12.909C2.55194 14.367 4.91509 14.367 6.37311 12.909L8.45288 10.8292C8.29756 10.8434 8.14115 10.8516 7.9831 10.8516L7.98158 10.8511Z" />
    </svg>
  ),
  loader: (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="#333"
        strokeWidth="4"
        r="24"
        strokeDasharray="113.09733552923255 39.69911184307752"
        transform="rotate(132 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),
  loaderSW6: (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="currentColor"
        strokeWidth="6"
        r="24"
        strokeDasharray="113.09733552923255 39.69911184307752"
        transform="rotate(132 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),

  lock: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M18.1417811,21 L4.85712858,21 C4.38331597,21 4,20.6132993 4,20.1353029 L4,11.4014813 C4,10.9234848 4.38331597,10.5367841 4.85712858,10.5367841 L5.71425716,10.5367841 L5.71425716,6.83637347 C5.71425716,3.61306556 8.30422378,1 11.5004543,1 C14.6955491,1 17.2857428,3.6128364 17.2857428,6.83637347 L17.2857428,10.5367841 L18.1428714,10.5367841 C18.616684,10.5367841 19,10.9234848 19,11.4014813 L19,20.1343862 C19,20.6132764 18.6157981,20.9999771 18.1419855,20.9999771 L18.1417811,21 Z M14.5614396,7.00888209 C14.5614396,5.30274712 13.1905427,3.91985957 11.4994548,3.91985957 C9.808367,3.91985957 8.43747009,5.3028617 8.43747009,7.00888209 L8.43747009,10.5367383 L14.5625753,10.5367383 L14.5625753,7.00888209 L14.5614396,7.00888209 Z" />
    </svg>
  ),
  oval: (
    <svg width="190" height="150">
      <path
        d="M42.295 7.437C72.93-5.395 115.73 1.209 148.445 18.41c52.41 27.555 53.72 73.777 10.227 105.395-43.492 31.617-68.294 34.96-112.293 5.11C2.38 99.061-27.595 36.71 42.295 7.436z"
        fill="#E9FEF9"
      />
    </svg>
  ),
  pencil: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M15.1874888,5.11199306 L13.6237203,4.12914578 C13.2293041,3.88140866 12.7095854,4.00094722 12.4606952,4.39478538 L11.8445308,5.37532647 L14.8351752,7.25382961 L15.4519162,6.27444161 C15.6996533,5.87944889 15.5818473,5.35915363 15.1874297,5.11199306 L15.1874888,5.11199306 Z M6.52319424,13.8496124 L9.51383866,15.7269328 L14.3883082,7.96811022 L11.3958898,6.08842442 L6.52319424,13.8496124 Z M6.06583114,16.2363624 L6,18 L7.56095968,17.1742244 L9.01156267,16.4084982 L6.12587908,14.5945977 L6.06583114,16.2363624 Z" />
    </svg>
  ),
  percentBars: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        fillRule="evenodd"
        d="M4,7.5 L7.5,7.5 L7.5,18 L4,18 L4,7.5 Z M4,6.625 L4,4 L7.5,4 L7.5,6.625 L4,6.625 Z M9.25,11.875 L12.75,11.875 L12.75,18 L9.25,18 L9.25,11.875 Z M9.25,11 L9.25,4 L12.75,4 L12.75,11 L9.25,11 Z M14.5,10.125 L18,10.125 L18,18 L14.5,18 L14.5,10.125 Z M14.5,9.25 L14.5,4 L18,4 L18,9.25 L14.5,9.25 Z"
      />
    </svg>
  ),
  person: (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36">
      <path
        d="M18.018 19.285c8.743 0 17.685 1.76 17.685 14.854v.807A1.061 1.061 0 0 1 34.642 36H1.394C.81 36 .337 35.53.333 34.946v.002-.807c0-13.76 7.662-14.856 17.685-14.856zm0-1.414a8.952 8.952 0 0 1-6.311-2.622 8.935 8.935 0 0 1 .002-12.632 8.935 8.935 0 0 1 12.636.003 8.942 8.942 0 0 1 2.615 6.32 8.94 8.94 0 0 1-8.942 8.93z"
        opacity=".2"
      />
    </svg>
  ),
  phone: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        fill="#FFF"
        d="M9.57560753,15.3000245 C7.86047343,13.8898026 6.71495377,12.1494796 6.11334603,11.1596384 L5.6640018,10.3130996 C5.82147256,10.1445955 7.01804287,8.86277043 7.53761318,8.16667203 C8.18957315,7.29306981 7.24474345,6.50368754 7.24474345,6.50368754 C7.24474345,6.50469048 4.5838553,3.84382646 3.97788251,3.31616795 C3.37206378,2.78758507 2.67398825,3.08146647 2.67398825,3.08146647 C1.40018723,3.90492187 0.0793462788,4.62107387 4.92596427e-06,8.06328177 C-0.0040070761,11.2859786 2.44330776,14.6098421 5.08914931,17.1836858 C7.73899643,20.0903011 11.3779144,23.0030788 14.895381,22.9999976 C18.3376146,22.9217629 19.0527139,21.6008167 19.8761693,20.3260142 C19.8761693,20.3260142 20.1700404,19.6289401 19.6414678,19.02212 C19.1128849,18.4152998 16.4518941,15.754232 16.4518941,15.754232 C16.4518941,15.754232 15.6635389,14.8084009 14.789911,15.4613622 C14.1389524,15.9478095 12.9694763,17.0310628 12.6876219,17.292838 C12.6886251,17.2948438 10.7327691,16.2517202 9.57533535,15.2998807 L9.57560753,15.3000245 Z"
        transform="translate(0 -3)"
      />
    </svg>
  ),
  plus: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>plus</title>
      <path
        d="M8.99 2c.703 0 1.258.555 1.258 1.258v4.494h4.494c.684 0 1.258.555 1.258 1.239 0 .702-.573 1.257-1.258 1.257h-4.494v4.494A1.26 1.26 0 0 1 8.991 16c-.684 0-1.24-.573-1.24-1.258v-4.494H3.259A1.248 1.248 0 0 1 2 8.991c0-.684.555-1.24 1.258-1.24h4.494V3.259C7.752 2.555 8.307 2 8.99 2z"
        fillRule="evenodd"
      />
    </svg>
  ),
  minus: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="4"
      viewBox="0 0 14 4"
    >
      <path d="M8.248,0.752 L12.742,0.752 C13.426,0.752 14,1.307 14,1.991 C14,2.693 13.427,3.248 12.742,3.248 L8.248,3.248 L5.751,3.248 L1.259,3.248 C0.924542101,3.25095685 0.602894314,3.11953785 0.366199697,2.88321924 C0.129505079,2.64690062 -0.00242512038,2.32546218 -6.48273768e-05,1.991 C-6.48273768e-05,1.307 0.555,0.751 1.258,0.751 L5.752,0.751 L8.248,0.752 Z" />
    </svg>
  ),
  minusCircle: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.96 8.208h7.083V6.79H3.96zm3.54 6.375q-1.47 0-2.762-.558a7.2 7.2 0 0 1-2.25-1.514 7.2 7.2 0 0 1-1.513-2.25A6.9 6.9 0 0 1 .418 7.5q0-1.47.558-2.762a7.2 7.2 0 0 1 1.514-2.25A7.2 7.2 0 0 1 4.739.975 6.9 6.9 0 0 1 7.5.416q1.47 0 2.763.558a7.2 7.2 0 0 1 2.249 1.514 7.2 7.2 0 0 1 1.514 2.249q.558 1.292.558 2.762t-.558 2.763a7.2 7.2 0 0 1-1.514 2.249 7.2 7.2 0 0 1-2.25 1.514 6.9 6.9 0 0 1-2.762.558m0-1.417q2.373 0 4.02-1.647t1.647-4.02-1.647-4.02T7.5 1.833 3.48 3.48 1.836 7.5q0 2.371 1.647 4.02 1.646 1.646 4.02 1.646"
        fill="#E65051"
      />
    </svg>
  ),
  plusSharp: (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.1615 0.5H8.8385V5.6615H14V9.3385H8.8385V14.5H5.1615V9.3385H0V5.6615H5.1615V0.5Z"
        fill={tailwindColors.cbrprimary['600']}
      />
    </svg>
  ),
  whatsNew: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 20 20"
    >
      <path d="M15 10.8333V9.16667H18.3334V10.8333H15ZM16 16.6667L13.3334 14.6667L14.3334 13.3333L17 15.3333L16 16.6667ZM14.3334 6.66667L13.3334 5.33334L16 3.33334L17 4.66667L14.3334 6.66667ZM4.16669 15.8333V12.5H3.33335C2.87502 12.5 2.48266 12.3368 2.15627 12.0104C1.82988 11.684 1.66669 11.2917 1.66669 10.8333V9.16667C1.66669 8.70834 1.82988 8.31597 2.15627 7.98959C2.48266 7.6632 2.87502 7.5 3.33335 7.5H6.66669L10.8334 5V15L6.66669 12.5H5.83335V15.8333H4.16669ZM11.6667 12.7917V7.20834C12.0417 7.54167 12.3438 7.94792 12.5729 8.42709C12.8021 8.90625 12.9167 9.43056 12.9167 10C12.9167 10.5694 12.8021 11.0938 12.5729 11.5729C12.3438 12.0521 12.0417 12.4583 11.6667 12.7917Z" />
    </svg>
  ),
  profile: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M13.6479555,15.2073287 C12.8538229,14.7808816 13.2776992,13.9819326 13.6479555,13.6094307 C14.1244351,13.1300613 14.7071378,11.4792409 14.7071378,11.4792409 C15.6600969,11.0527939 15.7663201,10.3607123 15.8715268,9.88134288 C16.295403,8.49615706 15.2362207,8.28344488 15.2362207,8.28344488 C15.2362207,8.28344488 16.0829566,5.9934653 15.3950472,4.2357775 C14.4946914,1.94579792 10.8416816,1.09290389 10.2063755,3.22411632 C5.86545622,2.26438043 6.76479549,8.28242223 6.76479549,8.28242223 C6.76479549,8.28242223 5.70561322,8.49514208 6.12948943,9.88032023 C6.23570498,10.3596896 6.34092691,11.0517712 7.29387838,11.4782182 C7.29387838,11.4782182 7.8765811,13.1290386 8.35306065,13.608408 C8.72331703,13.98091 9.14719324,14.779859 8.35306065,15.206306 C6.76479549,16.0581774 2,16.2719122 2,20 L20,20 C20.0009925,16.2719122 15.2362207,16.0592 13.6479555,15.2073287 Z" />
    </svg>
  ),
  question: (
    <svg width="12" height="18">
      <path
        d="M8.101.38c.66.24 1.26.62 1.78 1.1.54.5.96 1.08 1.26 1.72.3.66.46 1.38.46 2.1 0 .72-.16 1.44-.46 2.1-.3.64-.74 1.12-1.32 1.68-.34.34-1.3 1.04-1.92 2.22-.56 1.06-1.12 2.1-1.84 2.1-.74 0-1.36-1-1.04-2.16.74-2.64 2.66-3.84 3.02-4.12.38-.34.54-.56.7-.8.18-.3.22-.66.22-1.02s-.08-.7-.22-1.02c-.16-.32-.36-.62-.64-.86a2.85 2.85 0 0 0-.94-.58c-.34-.14-.72-.2-1.1-.2-.38 0-.74.06-1.1.2-.36.14-.66.34-.94.58-.16.14-.42.46-.6.86-.259.54-.859 1.02-1.58 1.02-.72 0-1.32-.5-1.2-1.08.08-.34.18-.68.34-1.02.3-.66.721-1.22 1.26-1.72.52-.48 1.12-.84 1.78-1.1.64-.26 1.34-.38 2.04-.38s1.38.12 2.04.38zm-.36 15.98C7.74 17.26 7 18 6.1 18c-.9 0-1.64-.74-1.64-1.64 0-.9.74-1.64 1.64-1.64.9 0 1.64.74 1.64 1.64z"
        fill="#000"
        opacity=".5"
      />
    </svg>
  ),
  questionMark: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none">
        <path
          fill="#959595"
          d="M7.9367619,1.58779048 C11.4285714,1.58779048 14.2857143,4.44493333 14.2857143,7.93674286 C14.2857143,11.4285524 11.4285714,14.2856952 7.9367619,14.2856952 C4.44495238,14.2856952 1.58780952,11.4285524 1.58780952,7.93674286 C1.58780952,4.44493333 4.44495238,1.58779048 7.9367619,1.58779048 Z M7.9367619,-2.78972612e-13 C3.57142857,-2.78972612e-13 6.28830321e-13,3.57142857 6.28830321e-13,7.9367619 C6.28830321e-13,12.3020952 3.57142857,15.8735238 7.9367619,15.8735238 C12.3020952,15.8735238 15.8735238,12.3020952 15.8735238,7.9367619 C15.8735238,3.57142857 12.3020952,-2.80664381e-13 7.9367619,-2.78972612e-13 Z"
        />
        <path
          fill="#959595"
          d="M7.58706095,9.55506552 C7.58706095,8.44420838 8.06325143,8.04687505 8.45982286,7.65030362 C8.6979181,7.49182171 8.85639429,7.25373219 8.93601333,7.01563695 C9.09449524,6.77754171 9.09449524,6.53944648 9.09449524,6.22173219 C9.09449524,5.9040179 9.0148819,5.66592267 8.8564,5.42782743 C8.6979181,5.26934552 8.53868571,5.11011314 8.22173333,5.11011314 C7.9836381,5.11011314 7.42782857,5.18972648 7.42782857,6.30058933 L6,6.30133333 L6,5.98361905 C6,5.26933333 6.23809524,4.79314286 6.63466667,4.39657143 C7.11085714,4.15847619 7.66666667,4 8.30133333,4 C9.0952381,4 9.65028571,4.1584819 10.047619,4.63466667 C10.4441905,5.11085714 10.6822857,5.58704762 10.6822857,6.22171429 C10.6822857,8.12647619 9.0952381,8.20609524 9.0952381,9.55504762 L7.58706095,9.55506552 Z"
        />
        <polygon fill="#959595" points="9.587 11.587 8 11.587 8 10 9.587 10" />
      </g>
    </svg>
  ),
  reset: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.347 3.006l.956.954a.388.388 0 0 1-.27.666h-.864a.366.366 0 0 1-.27-.108L1.972 2.592c-.144-.145-.144-.396 0-.559L3.898.107A.37.37 0 0 1 4.168 0h.865c.342 0 .521.414.27.666l-.974.974H9.19c4.519 0 8.19 3.671 8.19 8.189 0 4.5-3.671 8.171-8.19 8.171C4.673 18 1 14.328 1 9.81a.684.684 0 1 1 1.367 0 6.83 6.83 0 0 0 6.822 6.82 6.83 6.83 0 0 0 6.822-6.82c0-3.763-3.058-6.804-6.82-6.804H4.346zm7.845 9.9a.486.486 0 0 1-.685 0L9.55 10.95a.486.486 0 0 0-.687 0l-1.937 1.936a.486.486 0 0 1-.686 0l-.418-.418a.486.486 0 0 1 0-.685L7.76 9.845a.486.486 0 0 0 0-.685L5.823 7.223a.486.486 0 0 1 0-.685l.432-.432a.486.486 0 0 1 .686 0l1.937 1.937c.19.188.495.188.685 0L11.5 6.106a.486.486 0 0 1 .685 0l.418.418c.189.19.189.496 0 .686l-1.936 1.937a.486.486 0 0 0 0 .686l1.956 1.956c.19.19.19.497 0 .686l-.432.431z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  ),
  resetArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        fillRule="evenodd"
        d="M10.6003264,6.2003072 L10.6003264,3 L6.60051841,6.999808 L10.6003264,11.000384 L10.6003264,7.8000768 L11.4005952,7.8000768 C14.0473576,7.8000768 16.200672,9.95262324 16.200672,12.6001536 C16.200672,15.247684 14.0473576,17.4002304 11.4005952,17.4002304 C8.75306485,17.4002304 6.60051841,15.247684 6.60051841,12.6001536 L6.60051841,11.7998848 L5,11.7998848 L5,12.6001536 C5,16.1289781 7.87178995,19 11.4006144,19 C14.9294389,19 17.8004608,16.1289781 17.8004608,12.6001536 C17.8004608,9.07132914 14.9294389,6.2003072 11.4006144,6.2003072 L10.6003264,6.2003072 Z"
      />
    </svg>
  ),
  sortableArrow: (
    <svg
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.49401 5.99994C4.56792 6.00152 4.63743 5.97145 4.67539 5.92143L6.82315 3.08387L8.97092 0.245664C9.00888 0.195644 9.00968 0.133279 8.97332 0.0823092C8.93736 0.0316558 8.86905 0.000315678 8.79554 -4.58962e-07L0.204463 2.92093e-07C0.130953 0.000316918 0.0626397 0.0316585 0.0266795 0.08231C-0.00967554 0.13328 -0.00887731 0.195644 0.029077 0.245665L2.17684 3.08387L4.32461 5.9211C4.36057 5.96859 4.42409 5.99803 4.4936 5.99993L4.49401 5.99994Z"
        fill="black"
      />
    </svg>
  ),
  salesforce: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>salesforce</title>
      <path
        d="M7.49 4.374a3.154 3.154 0 0 1 2.283-.98c1.188 0 2.225.663 2.777 1.646a3.84 3.84 0 0 1 1.57-.333c2.142 0 3.88 1.752 3.88 3.914s-1.738 3.915-3.88 3.915c-.257 0-.513-.025-.765-.076a2.837 2.837 0 0 1-3.717 1.167 3.236 3.236 0 0 1-6.016-.146c-.203.043-.41.064-.618.064C1.345 13.545 0 12.186 0 10.51a3.04 3.04 0 0 1 1.502-2.63A3.496 3.496 0 0 1 7.49 4.374"
        fill="#139CD8"
        fillRule="evenodd"
      />
    </svg>
  ),
  salesforce_sync: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>salesforce sync</title>
      <path
        d="M7.49 4.374a3.154 3.154 0 0 1 2.283-.98c1.188 0 2.225.663 2.777 1.646a3.84 3.84 0 0 1 1.57-.333c2.142 0 3.88 1.752 3.88 3.914s-1.738 3.915-3.88 3.915c-.257 0-.513-.025-.765-.076a2.837 2.837 0 0 1-3.717 1.167 3.236 3.236 0 0 1-6.016-.146c-.203.043-.41.064-.618.064C1.345 13.545 0 12.186 0 10.51a3.04 3.04 0 0 1 1.502-2.63A3.496 3.496 0 0 1 7.49 4.374"
        fill="#139CD8"
        fillRule="evenodd"
      />
    </svg>
  ),
  search: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8833 11.6069L14.8112 15.3634C16.1922 17.1313 13.3199 19.12 12.1043 17.2418L9.6181 13.1539C6.63541 14.4799 3.09966 13.4852 1.2213 10.8337C-0.933511 7.68499 -0.159654 3.43103 2.93358 1.2213C6.02757 -0.933511 10.3363 -0.159654 12.4904 2.93358C14.3687 5.58508 14.0922 9.23123 11.8826 11.6068L11.8833 11.6069ZM9.34238 10.3912C11.2755 9.01029 11.718 6.35807 10.392 4.42496C9.01103 2.49185 6.35881 1.99443 4.4257 3.37536C2.49259 4.70144 1.99517 7.40853 3.3761 9.34164C4.70218 11.2748 7.40927 11.7172 9.34238 10.3912Z"
      />
    </svg>
  ),
  segment: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 256 238"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M159.58,162.38H12.29a12.3,12.3,0,0,1,0-24.59H159.58a12.3,12.3,0,0,1,0,24.59Zm84.13-62.46H96.43a12.29,12.29,0,1,1,0-24.58H243.71a12.29,12.29,0,0,1,0,24.58ZM213.26,40.78A12.3,12.3,0,1,1,201,28.49,12.3,12.3,0,0,1,213.26,40.78ZM67.33,197A12.3,12.3,0,1,1,55,184.65,12.3,12.3,0,0,1,67.33,197Z"
        fill="#93c8a2"
      />
      <path
        d="M127.93,237.52a118.88,118.88,0,0,1-35.2-5.3A12.29,12.29,0,0,1,100,208.74a94.3,94.3,0,0,0,118-62.39,12.29,12.29,0,0,1,23.5,7.19A118.15,118.15,0,0,1,127.93,237.52ZM26.11,99.84A12.29,12.29,0,0,1,14.36,84,118.89,118.89,0,0,1,163.13,5.31a12.29,12.29,0,1,1-7.27,23.47,94.87,94.87,0,0,0-27.93-4.18A93.69,93.69,0,0,0,37.85,91.19a12.3,12.3,0,0,1-11.74,8.7Z"
        fill="#43af79"
      />
    </svg>
  ),
  send: (
    <svg width="16" height="16">
      <path
        d="M.439 7.86L15.178.13c.606-.317.954-.037.775.623l-3.181 11.695c-.18.66-.858.964-1.492.706l-2.088-.85c-.634-.258-1.673-.672-2.311-.919l-.22-.085c-.639-.247-.777-.858-.309-1.357l6.462-6.915c.466-.5.409-.562-.129-.14L4.512 9.335c-.54.42-1.502.558-2.137.305L.493 8.895c-.635-.251-.66-.717-.054-1.035zm5.165 7.656c.038-.114-1.302-3.344-1.301-3.345-.262-.632.041-.936.674-.677l1.444.591c.632.26.845.942.47 1.514 0 0-1.324 2.028-1.287 1.917z"
        fill="#9013FE"
      />
    </svg>
  ),
  share: (
    <svg width="14" height="12">
      <path
        d="M13.295.012a.837.837 0 0 1 .395.18.753.753 0 0 1 .245.328.814.814 0 0 1 .065.318V4.566a.87.87 0 0 1-.242.592c-.15.163-.374.234-.587.244a.835.835 0 0 1-.587-.244.873.873 0 0 1-.242-.592V2.86L8.816 6.414a.851.851 0 0 1-.587.244c-.223.01-.43-.1-.587-.244a.855.855 0 0 1-.242-.592c0-.216.09-.44.242-.592l.008-.008c.197-.205.4-.404.601-.606L9.486 3.37l1.428-1.439.256-.258H9.472a.87.87 0 0 1-.587-.244c-.162-.152-.232-.377-.242-.592a.848.848 0 0 1 .242-.592.859.859 0 0 1 .587-.244h3.699c.042 0 .083.003.124.01zm-.954 8.147c0-.226.094-.428.242-.597.15-.163.374-.234.587-.244a.835.835 0 0 1 .587.244c.15.152.242.378.242.592v2.238c0 .333-.11.644-.335.89-.229.249-.555.377-.889.384H1.23a1.249 1.249 0 0 1-.848-.338A1.263 1.263 0 0 1 0 10.43c-.003-.232 0-.464 0-.697V1.334c0-.263.039-.528.186-.752C.426.219.797.008 1.23 0h4.677c.225 0 .424.094.586.244.163.152.233.376.242.592a.848.848 0 0 1-.242.591.859.859 0 0 1-.587.244H1.668c-.165 0-.332-.01-.494.004l.22-.03a.452.452 0 0 0-.106.028l.197-.084a.695.695 0 0 0-.074.044c.056-.044.11-.087.167-.13a.44.44 0 0 0-.078.074l.13-.168a.465.465 0 0 0-.055.093c.026-.065.055-.132.083-.199a.49.49 0 0 0-.028.108l.03-.222a.562.562 0 0 0-.004.06c-.003.369 0 .739 0 1.108V10.2c0 .094-.004.189.004.282l-.03-.222a.456.456 0 0 0 .028.109l-.083-.2a.528.528 0 0 0 .054.094l-.13-.168a.475.475 0 0 0 .06.061c-.055-.043-.11-.087-.167-.13.029.021.059.04.092.055l-.198-.084c.035.013.07.023.106.028l-.22-.03c.022.003.042.003.063.003.148.002.296 0 .443 0H12.48c.114 0 .231.007.345-.003l-.22.03a.452.452 0 0 0 .106-.028l-.198.084a.511.511 0 0 0 .092-.055c-.056.043-.11.087-.167.13a.74.74 0 0 0 .06-.061l-.13.168c.021-.03.04-.06.055-.093l-.083.199a.53.53 0 0 0 .028-.109l-.03.222c.01-.103.003-.21.003-.315v-2.01z"
        fill="#9013FE"
      />
    </svg>
  ),
  shield: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M11.0000696,1 C8.77451978,2.99273981 5.95654745,4.14687295 3,4.21652374 L3,14.7417648 C4.28668945,17.6441607 6.79064166,19.8117268 9.85188567,20.6858582 L11,21 L12.1481143,20.6503474 C15.2092888,19.8117408 17.7133801,17.6427761 19,14.7062541 L19,4.21667759 C16.0434526,4.11150909 13.2253411,2.99289366 10.9999304,1.00015385 L11.0000696,1 Z M13.5734485,14.8112757 L11.0000696,13.4468266 L8.42669067,14.8099121 L8.9130949,11.9075162 L6.82612023,9.8451256 L9.71338012,9.42582226 L11.0000696,6.80342813 L12.286759,9.42582226 L15.1740189,9.8451256 L13.0870442,11.9075162 L13.5734485,14.8112757 Z" />
    </svg>
  ),
  slack: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g fill="none">
        <path
          fill="#E01E5A"
          d="M3.57966102 1.78983051C3.57966102 2.75254237 2.79322034 3.53898305 1.83050847 3.53898305.86779661 3.53898305.0813559322 2.75254237.0813559322 1.78983051.0813559322.827118644.86779661.0406779661 1.83050847.0406779661L3.57966102.0406779661 3.57966102 1.78983051zM4.46101695 1.78983051C4.46101695.827118644 5.24745763.0406779661 6.21016949.0406779661 7.17288136.0406779661 7.95932203.827118644 7.95932203 1.78983051L7.95932203 6.16949153C7.95932203 7.13220339 7.17288136 7.91864407 6.21016949 7.91864407 5.24745763 7.91864407 4.46101695 7.13220339 4.46101695 6.16949153L4.46101695 1.78983051z"
          transform="translate(0 10)"
        />
        <path
          fill="#36C5F0"
          d="M6.21016949 3.57966102C5.24745763 3.57966102 4.46101695 2.79322034 4.46101695 1.83050847 4.46101695.86779661 5.24745763.0813559322 6.21016949.0813559322 7.17288136.0813559322 7.95932203.86779661 7.95932203 1.83050847L7.95932203 3.57966102 6.21016949 3.57966102zM6.21016949 4.46101695C7.17288136 4.46101695 7.95932203 5.24745763 7.95932203 6.21016949 7.95932203 7.17288136 7.17288136 7.95932203 6.21016949 7.95932203L1.83050847 7.95932203C.86779661 7.95932203.0813559322 7.17288136.0813559322 6.21016949.0813559322 5.24745763.86779661 4.46101695 1.83050847 4.46101695L6.21016949 4.46101695z"
        />
        <path
          fill="#2EB67D"
          d="M4.42033898 6.21016949C4.42033898 5.24745763 5.20677966 4.46101695 6.16949153 4.46101695 7.13220339 4.46101695 7.91864407 5.24745763 7.91864407 6.21016949 7.91864407 7.17288136 7.13220339 7.95932203 6.16949153 7.95932203L4.42033898 7.95932203 4.42033898 6.21016949zM3.53898305 6.21016949C3.53898305 7.17288136 2.75254237 7.95932203 1.78983051 7.95932203.827118644 7.95932203.0406779661 7.17288136.0406779661 6.21016949L.0406779661 1.83050847C.0406779661.86779661.827118644.0813559322 1.78983051.0813559322 2.75254237.0813559322 3.53898305.86779661 3.53898305 1.83050847L3.53898305 6.21016949z"
          transform="translate(10)"
        />
        <path
          fill="#ECB22E"
          d="M1.78983051 4.42033898C2.75254237 4.42033898 3.53898305 5.20677966 3.53898305 6.16949153 3.53898305 7.13220339 2.75254237 7.91864407 1.78983051 7.91864407.827118644 7.91864407.0406779661 7.13220339.0406779661 6.16949153L.0406779661 4.42033898 1.78983051 4.42033898zM1.78983051 3.53898305C.827118644 3.53898305.0406779661 2.75254237.0406779661 1.78983051.0406779661.827118644.827118644.0406779661 1.78983051.0406779661L6.16949153.0406779661C7.13220339.0406779661 7.91864407.827118644 7.91864407 1.78983051 7.91864407 2.75254237 7.13220339 3.53898305 6.16949153 3.53898305L1.78983051 3.53898305z"
          transform="translate(10 10)"
        />
      </g>
    </svg>
  ),
  slack2: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
    >
      <g fill="none">
        <path
          fill="#E01E5A"
          d="M12.5288136 6.26440678C12.5288136 9.63389831 9.77627119 12.3864407 6.40677966 12.3864407 3.03728814 12.3864407.284745763 9.63389831.284745763 6.26440678.284745763 2.89491525 3.03728814.142372881 6.40677966.142372881L12.5288136.142372881 12.5288136 6.26440678zM15.6135593 6.26440678C15.6135593 2.89491525 18.3661017.142372881 21.7355932.142372881 25.1050847.142372881 27.8576271 2.89491525 27.8576271 6.26440678L27.8576271 21.5932203C27.8576271 24.9627119 25.1050847 27.7152542 21.7355932 27.7152542 18.3661017 27.7152542 15.6135593 24.9627119 15.6135593 21.5932203L15.6135593 6.26440678z"
          transform="translate(0 36)"
        />
        <path
          fill="#36C5F0"
          d="M21.7355932 12.5288136C18.3661017 12.5288136 15.6135593 9.77627119 15.6135593 6.40677966 15.6135593 3.03728814 18.3661017.284745763 21.7355932.284745763 25.1050847.284745763 27.8576271 3.03728814 27.8576271 6.40677966L27.8576271 12.5288136 21.7355932 12.5288136zM21.7355932 15.6135593C25.1050847 15.6135593 27.8576271 18.3661017 27.8576271 21.7355932 27.8576271 25.1050847 25.1050847 27.8576271 21.7355932 27.8576271L6.40677966 27.8576271C3.03728814 27.8576271.284745763 25.1050847.284745763 21.7355932.284745763 18.3661017 3.03728814 15.6135593 6.40677966 15.6135593L21.7355932 15.6135593z"
        />
        <path
          fill="#2EB67D"
          d="M15.4711864 21.7355932C15.4711864 18.3661017 18.2237288 15.6135593 21.5932203 15.6135593 24.9627119 15.6135593 27.7152542 18.3661017 27.7152542 21.7355932 27.7152542 25.1050847 24.9627119 27.8576271 21.5932203 27.8576271L15.4711864 27.8576271 15.4711864 21.7355932zM12.3864407 21.7355932C12.3864407 25.1050847 9.63389831 27.8576271 6.26440678 27.8576271 2.89491525 27.8576271.142372881 25.1050847.142372881 21.7355932L.142372881 6.40677966C.142372881 3.03728814 2.89491525.284745763 6.26440678.284745763 9.63389831.284745763 12.3864407 3.03728814 12.3864407 6.40677966L12.3864407 21.7355932z"
          transform="translate(36)"
        />
        <path
          fill="#ECB22E"
          d="M6.26440678 15.4711864C9.63389831 15.4711864 12.3864407 18.2237288 12.3864407 21.5932203 12.3864407 24.9627119 9.63389831 27.7152542 6.26440678 27.7152542 2.89491525 27.7152542.142372881 24.9627119.142372881 21.5932203L.142372881 15.4711864 6.26440678 15.4711864zM6.26440678 12.3864407C2.89491525 12.3864407.142372881 9.63389831.142372881 6.26440678.142372881 2.89491525 2.89491525.142372881 6.26440678.142372881L21.5932203.142372881C24.9627119.142372881 27.7152542 2.89491525 27.7152542 6.26440678 27.7152542 9.63389831 24.9627119 12.3864407 21.5932203 12.3864407L6.26440678 12.3864407z"
          transform="translate(36 36)"
        />
      </g>
    </svg>
  ),
  email: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
    >
      <path d="M64 16v33.513C64 53.115 61.18 56 57.652 56H6.348C2.823 56 0 53.118 0 49.513V16l31.03 21.262c.705.36 1.41.36 1.94 0L64 16zm-6.221-8c2.843 0 5.334 1.973 6.221 4.482L32 34 0 12.482C.71 9.973 3.199 8 6.045 8H57.78z" />
    </svg>
  ),
  chargebee: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#FF3300">
        <path d="M6.562 10.4712L19.1115 7.48322V0.979996H12.6082L6.562 10.4712Z" />
        <path d="M0.339996 10.366C0.339996 11.1394 0.427878 11.8952 0.621217 12.6158L6.562 10.4715L0.568488 8.3096C0.427878 8.9775 0.339996 9.66297 0.339996 10.366Z" />
        <path d="M2.55524 4.30182L6.56263 10.4711L8.40814 1.06779C6.07049 1.40174 4.01407 2.57935 2.55524 4.30182Z" />
        <path d="M6.562 10.4712L19.1115 13.4592V19.98H12.6082L6.562 10.4712Z" />
        <path d="M2.55524 16.6405L6.56263 10.4712L8.40814 19.8745C6.07049 19.5582 4.01407 18.363 2.55524 16.6405Z" />
      </g>
    </svg>
  ),
  recharge: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 203 203"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M102.319 172.836C141.841 172.862 173.902 140.842 173.927 101.32C173.952 61.7974 141.927 29.7371 102.41 29.7119C62.8941 29.6866 30.8215 61.7059 30.7962 101.228C30.771 140.751 62.7903 172.811 102.319 172.836Z"
        fill="#E6E0F9"
      />
      <path
        d="M107.32 128.082L71.8476 128.06C71.7408 128.057 71.6357 128.032 71.5384 127.988C71.3871 127.918 71.2626 127.801 71.1835 127.655C71.1045 127.508 71.0751 127.34 71.0999 127.175L78.0086 91.6794C78.0351 91.5498 78.0985 91.4306 78.1912 91.3363C78.283 91.2408 78.4006 91.1742 78.5297 91.1446C78.6588 91.115 78.7938 91.1237 78.9179 91.1697C79.0409 91.2146 79.1483 91.2942 79.227 91.3988L107.914 126.932C107.981 127.044 108.019 127.17 108.025 127.3C108.029 127.431 107.999 127.562 107.938 127.678C107.878 127.792 107.79 127.889 107.681 127.96C107.573 128.031 107.449 128.073 107.32 128.082Z"
        fill="#3901F1"
      />
      <path
        d="M71.2233 74.4647L106.711 74.4873C106.878 74.4842 107.041 74.5375 107.174 74.6386C107.307 74.7397 107.401 74.8827 107.443 75.0444C107.468 75.1522 107.468 75.2643 107.443 75.3721L100.543 110.867C100.513 110.996 100.448 111.114 100.355 111.208C100.261 111.301 100.143 111.367 100.014 111.396C99.8846 111.426 99.7498 111.418 99.6248 111.374C99.5031 111.328 99.3962 111.25 99.3158 111.148L70.6753 75.5434C70.5919 75.4457 70.5402 75.3248 70.5271 75.197C70.5125 75.0687 70.5351 74.9388 70.5922 74.8229C70.6513 74.7084 70.7428 74.6138 70.8552 74.551C70.9664 74.4856 71.0947 74.4555 71.2233 74.4647Z"
        fill="#3901F1"
      />
      <path
        d="M110.987 74.4901C110.83 74.4927 110.678 74.5457 110.554 74.6414C110.43 74.7369 110.341 74.8704 110.3 75.0215C109.92 77.983 110.171 80.9913 111.037 83.8489C111.902 86.7065 113.362 89.3487 115.321 91.602C117.28 93.8553 119.693 95.6688 122.403 96.9232C125.112 98.1776 128.056 98.8447 131.042 98.8806L131.787 98.8811C131.944 98.8882 132.098 98.8377 132.22 98.7392C132.344 98.6413 132.429 98.5019 132.458 98.3466L137.244 75.2645C137.252 75.1597 137.238 75.0545 137.204 74.9552C137.171 74.8566 137.117 74.766 137.046 74.6892C136.976 74.614 136.893 74.553 136.799 74.5097C136.702 74.4665 136.597 74.4443 136.49 74.4446L110.987 74.4901Z"
        fill="#3901F1"
      />
    </svg>
  ),
  recurly: (
    <svg
      width="26"
      height="26"
      preserveAspectRatio="xMidYMid"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 162 162"
    >
      <path fill="#fff" className="cls-1" d="M80.56,35.24h0Z" />
      <path fill="#723080" d="M81,9a72,72,0,1,0,72,72A72,72,0,0,0,81,9Z" />
      <path fill="#fff" d="M80.56,35.24h0Z" />
      <path
        fill="#fff"
        d="M91.24,86.46c10.39-2.63,20.66-11.33,20.66-25.52,0-17.39-11.93-25.69-30.81-25.7h0c-16.66,0-26.29,7.87-28.54,21.5H44.26L60.78,70.79,78.25,56.74H68.87S68.94,47,81.29,47c10.54,0,14.14,7.69,14.14,14.08,0,9.31-4.92,16.36-16.72,16.36H52.51v45.3H69V88.63h0c3.64,0,7.17,1.34,13.27,10.38l14.72,23.71h18.39L100.28,98.41C96.28,92.19,93.31,88.09,91.24,86.46Z"
      />
    </svg>
  ),
  stackedBars: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        fillRule="evenodd"
        d="M4,12 L8,12 L8,18 L4,18 L4,12 Z M4,11 L4,7 L8,7 L8,11 L4,11 Z M9,14 L13,14 L13,18 L9,18 L9,14 Z M9,13 L9,8 L13,8 L13,13 L9,13 Z M14,11 L18,11 L18,18 L14,18 L14,11 Z M14,10 L14,4 L18,4 L18,10 L14,10 Z"
      />
    </svg>
  ),
  stopWatch: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M13.1237372,9.4819032 L13.1236431,9.48190061 C13.2144015,9.4059771 13.3514184,9.42080639 13.4427629,9.49672945 C13.5341075,9.57265251 13.5341075,9.72450471 13.4581844,9.81584926 L11.4539674,12.3817451 C11.3169415,12.5484174 11.1045999,12.639762 10.9070784,12.639762 C10.78548,12.639762 10.6638847,12.6095112 10.5577109,12.5335881 C10.4058617,12.4422375 10.3145171,12.2903914 10.2842664,12.1082975 C10.2688449,11.9416312 10.3145171,11.758936 10.420691,11.6225114 C10.4509418,11.5922606 10.4811926,11.5465883 10.5268648,11.5163376 L13.1237372,9.4819032 Z M16.039031,7.68996709 L15.6144692,8.13000197 C16.4798706,9.16270746 17.0113321,10.513895 17.0113321,11.9718607 C17.0113321,15.2969872 14.3230483,18 10.9979219,18 C7.67279547,18 5,15.2969872 5,11.9718607 C5,8.88999182 7.33812661,6.33879473 10.3750491,5.98942717 L10.3750491,5.06292286 L9.16028009,5.06292286 L9.16028009,4 L12.8045871,4 L12.8045871,5.06292286 L11.7416642,5.06292286 L11.7416642,5.98942717 C12.9564332,6.12584573 13.97362,6.61163185 14.8390214,7.34061472 L15.264312,6.89991171 L14.8087737,6.44437334 L15.598252,5.65489498 L17.2840477,7.3560271 L16.4945693,8.14550546 L16.039031,7.68996709 Z M10.9670667,16.5729653 C13.5033525,16.5729653 15.5681561,14.5075543 15.5681561,11.9718759 C15.5681561,9.43619751 13.5027452,7.37078654 10.9670667,7.37078654 C8.43138833,7.37078654 6.36597736,9.43619751 6.36597736,11.9718759 C6.36597736,14.5075543 8.43138833,16.5729653 10.9670667,16.5729653 Z" />
    </svg>
  ),
  stripe: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      id="svg_resize"
    >
      <defs>
        <linearGradient x1="100%" y1="58.356%" x2="0%" y2="0%" id="a">
          <stop stopColor="#2697D4" offset="0%" />
          <stop stopColor="#207BCB" offset="50%" />
          <stop stopColor="#2285CE" offset="100%" />
        </linearGradient>
        <filter
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
          filterUnits="objectBoundingBox"
          id="b"
        >
          <feOffset
            dx="2"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="3.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.185125113 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <path fill="url(#a)" d="M0 0h256v256H0z" />
      <path
        d="M139.688 111c-12.927-4.78-20.011-8.5-20.011-14.343 0-4.96 4.073-7.792 11.334-7.792 13.281 0 26.916 5.136 36.302 9.739l5.312-32.76c-7.438-3.542-22.667-9.385-43.74-9.385-14.874 0-27.27 3.895-36.124 11.156-9.21 7.614-13.99 18.594-13.99 31.875 0 24.083 14.698 34.354 38.604 43.031 15.406 5.49 20.542 9.386 20.542 15.406 0 5.844-4.96 9.208-13.99 9.208-11.157 0-29.572-5.489-41.615-12.572L77 187.677c10.27 5.844 29.395 11.864 49.23 11.864 15.76 0 28.864-3.718 37.718-10.801 9.916-7.792 15.052-19.302 15.052-34.177 0-24.615-15.052-34.886-39.313-43.562z"
        fill="#FFF"
        filter="url(#b)"
      />
    </svg>
  ),
  stripe_api_key: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      id="svg_resize"
    >
      <defs>
        <linearGradient x1="100%" y1="58.356%" x2="0%" y2="0%" id="a">
          <stop stopColor="#2697D4" offset="0%" />
          <stop stopColor="#207BCB" offset="50%" />
          <stop stopColor="#2285CE" offset="100%" />
        </linearGradient>
        <filter
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
          filterUnits="objectBoundingBox"
          id="b"
        >
          <feOffset
            dx="2"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="3.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.185125113 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <path fill="url(#a)" d="M0 0h256v256H0z" />
      <path
        d="M139.688 111c-12.927-4.78-20.011-8.5-20.011-14.343 0-4.96 4.073-7.792 11.334-7.792 13.281 0 26.916 5.136 36.302 9.739l5.312-32.76c-7.438-3.542-22.667-9.385-43.74-9.385-14.874 0-27.27 3.895-36.124 11.156-9.21 7.614-13.99 18.594-13.99 31.875 0 24.083 14.698 34.354 38.604 43.031 15.406 5.49 20.542 9.386 20.542 15.406 0 5.844-4.96 9.208-13.99 9.208-11.157 0-29.572-5.489-41.615-12.572L77 187.677c10.27 5.844 29.395 11.864 49.23 11.864 15.76 0 28.864-3.718 37.718-10.801 9.916-7.792 15.052-19.302 15.052-34.177 0-24.615-15.052-34.886-39.313-43.562z"
        fill="#FFF"
        filter="url(#b)"
      />
    </svg>
  ),
  switch: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M8.16779338,10.5058732 C7.46699744,9.28754651 6.82148535,8.58404562 5.87228342,8.58404562 L2.00009284,8.58404562 L2.00009284,6.74219169 L5.87321178,6.74219169 C7.37179409,6.74219169 8.39261902,7.56699853 9.1886183,8.66401922 C8.79696633,9.27675916 8.46607552,9.91827303 8.16779338,10.5058732 Z M15.3454106,14.4169204 L15.3454106,12.6748667 L19.9990484,15.3378934 L15.3444823,18 L15.3444823,16.2587743 L13.6146918,16.2587743 C12.1161095,16.2587743 11.0952846,15.4339675 10.2992853,14.3369468 C10.6909373,13.7242069 11.0209229,13.082693 11.3201102,12.4950929 C12.0209062,13.7134195 12.6664182,14.4169204 13.6156202,14.4169204 L15.3454106,14.4169204 Z M13.6156434,8.58393062 L13.6156434,8.58397662 C12.3463196,8.58397662 11.6192279,9.84099052 10.5757278,11.9119549 C9.54756879,13.9505112 8.38247668,16.2586363 5.87219058,16.2586363 L2,16.2586363 L2,14.4167824 L5.87219058,14.4167824 C7.14151434,14.4167824 7.86860608,13.1588715 8.9121062,11.0888041 C9.94026518,9.05024779 11.1053573,6.74212269 13.6156434,6.74212269 L15.3454338,6.74212269 L15.3454338,5 L20,7.66302665 L15.3454338,10.3260533 L15.3454338,8.58393062 L13.6156434,8.58393062 Z" />
    </svg>
  ),
  tag: (
    <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.071 21.465a1.845 1.845 0 0 1-2.598 0L1.354 11.996c-.567-.53-1.24-1.532-1.289-2.305C-.064 7.6.028 3.6.091 1.48A1.503 1.503 0 0 1 1.541.042c2.717-.063 8.471-.13 9.006.403l11.142 10.06c.715.713.068 2.52-.652 3.24l-6.966 7.72zM5.575 2.98a1.835 1.835 0 1 0 0 2.593 1.835 1.835 0 0 0 0-2.593z" />
    </svg>
  ),
  team: (
    <svg width="99" height="77">
      <g fill="#4BE0BF">
        <path d="M70.129 76.344a2.762 2.762 0 0 0 2.762-2.762V45.81c0-5.722-2.797-10.62-7.743-13.832 2.317-3.218 3.704-7.156 3.704-11.418C68.852 9.762 60.066.977 49.266.977c-10.797 0-19.578 8.785-19.578 19.582 0 4.313 1.418 8.29 3.785 11.527-4.828 3.18-7.559 8.047-7.559 13.723v27.773a2.762 2.762 0 1 0 5.524 0V45.81c0-4.191 2.09-7.504 6.011-9.672 3.29 2.504 7.375 4.004 11.816 4.004 4.496 0 8.63-1.535 11.938-4.093 3.973 2.187 6.164 5.605 6.164 9.757v27.773a2.765 2.765 0 0 0 2.762 2.766zM35.207 20.559c0-7.754 6.305-14.059 14.055-14.059 7.754 0 14.062 6.305 14.062 14.059s-6.309 14.062-14.062 14.062c-7.75 0-14.055-6.309-14.055-14.062z" />
        <path d="M2.938 60.297a2.76 2.76 0 0 0 2.761-2.762l-.004-16.12c0-1.926.79-3.38 2.39-4.423a12.669 12.669 0 0 0 7.11 2.168c7.055 0 12.79-5.734 12.79-12.777 0-7.046-5.735-12.785-12.79-12.785-7.043 0-12.773 5.735-12.773 12.785 0 2.407.68 4.657 1.844 6.579-2.644 2.054-4.09 4.968-4.09 8.456v16.126a2.755 2.755 0 0 0 2.762 2.753zm12.257-41.18c4.008 0 7.266 3.258 7.266 7.262 0 4-3.262 7.257-7.265 7.257-4 0-7.254-3.257-7.254-7.257-.004-4.004 3.253-7.262 7.253-7.262zM83.441 13.598c-7.047 0-12.781 5.734-12.781 12.785 0 7.047 5.734 12.777 12.781 12.777 2.664 0 5.144-.82 7.195-2.227 1.653 1.055 2.465 2.524 2.465 4.485v16.12a2.762 2.762 0 1 0 5.523 0v-16.12c0-3.54-1.48-6.485-4.19-8.547a12.691 12.691 0 0 0 1.784-6.488c.004-7.051-5.73-12.785-12.777-12.785zm-7.258 12.781c0-4.004 3.258-7.262 7.258-7.262 4.004 0 7.258 3.258 7.258 7.262 0 4-3.25 7.258-7.258 7.258-4.004 0-7.258-3.258-7.258-7.258z" />
      </g>
    </svg>
  ),
  tip: (
    <svg width="16" height="16">
      <g fill="#959595">
        <path d="M8 1.651c3.492 0 6.349 2.857 6.349 6.349S11.492 14.349 8 14.349 1.651 11.492 1.651 8 4.508 1.651 8 1.651zM8 .063C3.635.063.063 3.635.063 8S3.635 15.937 8 15.937 15.937 12.365 15.937 8 12.365.063 8 .063z" />
        <path d="M7.206 9.587c0-1.11.476-1.508.873-1.905.238-.158.396-.396.476-.634.159-.238.159-.477.159-.794 0-.318-.08-.556-.239-.794-.158-.159-.317-.318-.634-.318-.238 0-.794.08-.794 1.19l-1.428.001v-.317c0-.715.238-1.19.635-1.587a3.69 3.69 0 0 1 1.666-.397c.794 0 1.35.158 1.747.635.396.476.634.952.634 1.587 0 1.904-1.587 1.984-1.587 3.333H7.206zM8.794 11.968H7.207v-1.587h1.587z" />
      </g>
    </svg>
  ),
  thumbsDown: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        d="M5.4,10.1100449 C5.6125,10.1100449 5.815616,10.193625 5.96562,10.3422029 C6.115624,10.4907809 6.2,10.6919753 6.2,10.9024608 L6.2,18.82662 C6.2,19.0371055 6.11562,19.2382959 5.96562,19.3868779 C5.81562,19.5354598 5.6125,19.6190359 5.4,19.6190359 L1.8,19.6190359 C1.5875,19.6190359 1.384384,19.5354558 1.23438,19.3868779 C1.084376,19.2382999 1,19.0371055 1,18.82662 L1,10.9024608 C1,10.4644727 1.35782,10.1100449 1.8,10.1100449 L5.4,10.1100449 Z M3.4,18.430412 L3.39999,18.4304219 C3.506248,18.4304219 3.60781,18.3886339 3.68281,18.3143449 C3.75781,18.2400559 3.799998,18.1394488 3.799998,18.0342061 C3.799998,17.8740192 3.702338,17.7293042 3.553118,17.6681693 C3.403898,17.6070344 3.23124,17.6410846 3.117178,17.7540652 C3.003116,17.8670439 2.96874,18.0380631 3.03046,18.1858725 C3.09218,18.3336818 3.238282,18.430412 3.4,18.430412 Z M21,10.4210681 L21,11.0532972 C20.9859376,11.1028232 20.967968,11.1523492 20.957812,11.2018752 C20.89453,11.6213009 20.724212,12.0175089 20.461712,12.3525819 C20.346088,12.4818131 20.314836,12.6644372 20.382024,12.8238515 C20.624984,13.5690592 20.505462,14.3831477 20.057804,15.0285507 C19.987492,15.1276027 19.966398,15.2521903 19.999992,15.3674868 C20.149992,16.0484692 20.022648,16.7603955 19.646092,17.3485266 C19.542186,17.5187732 19.361712,17.6534284 19.303912,17.8321776 C19.275788,18.0287344 19.270318,18.2283856 19.288287,18.4264896 C19.2718808,19.2359226 18.867967,19.9888762 18.200007,20.4546781 C17.710947,20.7912964 17.131247,20.9739285 16.535947,20.9801093 C15.760167,21.0056469 14.975787,21.0056469 14.199947,20.9855263 C13.849167,20.971597 13.499947,20.9344531 13.153847,20.8725456 C11.984307,20.6620601 10.835847,20.35175 9.720247,19.9454784 C9.399927,19.8371393 9.064007,19.7156381 8.731967,19.6189238 L7.799927,19.6189238 C7.360087,19.6135068 7.005387,19.2621781 6.999927,18.8265079 L6.999927,18.6028683 C6.9975832,18.563402 6.9975832,18.5247103 6.999927,18.4860186 L6.999927,16.5800404 L6.999927,10.8605804 L6.999927,10.6230141 C7.034303,10.2755596 7.294467,9.99155771 7.639767,9.92346937 C7.857727,9.89406281 8.059307,9.79501082 8.213987,9.64024011 C8.599927,9.24403215 8.989767,8.84782419 9.352267,8.42608063 C9.952267,7.72497083 10.540547,7.00761651 11.130387,6.29646285 L11.1296058,6.29646285 C11.2631998,6.14633767 11.3850658,5.98692538 11.4936658,5.81899264 C11.8217858,5.26802585 11.9233458,4.64429547 12.0460058,4.03605682 C12.1678818,3.42781817 12.3280458,2.83736926 12.7342858,2.34210931 C12.8975678,2.10763344 13.1764658,1.97763761 13.4639658,2.00317321 C13.7319258,2.02019767 13.9991258,2.05192462 14.2639658,2.09835623 C15.2780258,2.29646021 15.8256858,2.84356397 16.0639658,3.79771198 L16.0639658,3.79848577 C16.3100658,4.72400775 16.2631838,5.70291876 15.9295918,6.60126088 C15.7616238,7.03693115 15.5295918,7.44706582 15.3295918,7.87114701 C15.2616238,8.01585602 15.2077158,8.16443995 15.1295918,8.33700832 L15.3600518,8.33700832 C16.4623918,8.33700832 17.5600518,8.32694841 18.6662518,8.33700832 L18.6654706,8.33700832 C19.5037506,8.33546074 20.2732906,8.79280596 20.6654706,9.5256322 C20.8037526,9.8134971 20.9154706,10.1129709 20.9998506,10.4209631 L21,10.4210681 Z"
        transform="matrix(1 0 0 -1 0 23)"
      />
    </svg>
  ),
  thumbsUp: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M5.4,10.1100449 C5.6125,10.1100449 5.815616,10.193625 5.96562,10.3422029 C6.115624,10.4907809 6.2,10.6919753 6.2,10.9024608 L6.2,18.82662 C6.2,19.0371055 6.11562,19.2382959 5.96562,19.3868779 C5.81562,19.5354598 5.6125,19.6190359 5.4,19.6190359 L1.8,19.6190359 C1.5875,19.6190359 1.384384,19.5354558 1.23438,19.3868779 C1.084376,19.2382999 1,19.0371055 1,18.82662 L1,10.9024608 C1,10.4644727 1.35782,10.1100449 1.8,10.1100449 L5.4,10.1100449 Z M3.4,18.430412 L3.39999,18.4304219 C3.506248,18.4304219 3.60781,18.3886339 3.68281,18.3143449 C3.75781,18.2400559 3.799998,18.1394488 3.799998,18.0342061 C3.799998,17.8740192 3.702338,17.7293042 3.553118,17.6681693 C3.403898,17.6070344 3.23124,17.6410846 3.117178,17.7540652 C3.003116,17.8670439 2.96874,18.0380631 3.03046,18.1858725 C3.09218,18.3336818 3.238282,18.430412 3.4,18.430412 Z M21,10.4210681 L21,11.0532972 C20.9859376,11.1028232 20.967968,11.1523492 20.957812,11.2018752 C20.89453,11.6213009 20.724212,12.0175089 20.461712,12.3525819 C20.346088,12.4818131 20.314836,12.6644372 20.382024,12.8238515 C20.624984,13.5690592 20.505462,14.3831477 20.057804,15.0285507 C19.987492,15.1276027 19.966398,15.2521903 19.999992,15.3674868 C20.149992,16.0484692 20.022648,16.7603955 19.646092,17.3485266 C19.542186,17.5187732 19.361712,17.6534284 19.303912,17.8321776 C19.275788,18.0287344 19.270318,18.2283856 19.288287,18.4264896 C19.2718808,19.2359226 18.867967,19.9888762 18.200007,20.4546781 C17.710947,20.7912964 17.131247,20.9739285 16.535947,20.9801093 C15.760167,21.0056469 14.975787,21.0056469 14.199947,20.9855263 C13.849167,20.971597 13.499947,20.9344531 13.153847,20.8725456 C11.984307,20.6620601 10.835847,20.35175 9.720247,19.9454784 C9.399927,19.8371393 9.064007,19.7156381 8.731967,19.6189238 L7.799927,19.6189238 C7.360087,19.6135068 7.005387,19.2621781 6.999927,18.8265079 L6.999927,18.6028683 C6.9975832,18.563402 6.9975832,18.5247103 6.999927,18.4860186 L6.999927,16.5800404 L6.999927,10.8605804 L6.999927,10.6230141 C7.034303,10.2755596 7.294467,9.99155771 7.639767,9.92346937 C7.857727,9.89406281 8.059307,9.79501082 8.213987,9.64024011 C8.599927,9.24403215 8.989767,8.84782419 9.352267,8.42608063 C9.952267,7.72497083 10.540547,7.00761651 11.130387,6.29646285 L11.1296058,6.29646285 C11.2631998,6.14633767 11.3850658,5.98692538 11.4936658,5.81899264 C11.8217858,5.26802585 11.9233458,4.64429547 12.0460058,4.03605682 C12.1678818,3.42781817 12.3280458,2.83736926 12.7342858,2.34210931 C12.8975678,2.10763344 13.1764658,1.97763761 13.4639658,2.00317321 C13.7319258,2.02019767 13.9991258,2.05192462 14.2639658,2.09835623 C15.2780258,2.29646021 15.8256858,2.84356397 16.0639658,3.79771198 L16.0639658,3.79848577 C16.3100658,4.72400775 16.2631838,5.70291876 15.9295918,6.60126088 C15.7616238,7.03693115 15.5295918,7.44706582 15.3295918,7.87114701 C15.2616238,8.01585602 15.2077158,8.16443995 15.1295918,8.33700832 L15.3600518,8.33700832 C16.4623918,8.33700832 17.5600518,8.32694841 18.6662518,8.33700832 L18.6654706,8.33700832 C19.5037506,8.33546074 20.2732906,8.79280596 20.6654706,9.5256322 C20.8037526,9.8134971 20.9154706,10.1129709 20.9998506,10.4209631 L21,10.4210681 Z" />
    </svg>
  ),
  totango: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>totango</title>
      <g transform="translate(1)" fill="none" fillRule="evenodd">
        <ellipse fill="#40AD90" cx="13.178" cy="2.585" rx="2.581" ry="2.585" />
        <ellipse fill="#65D45B" cx="2.922" cy="15.07" rx="2.577" ry="2.591" />
        <ellipse fill="#40AD90" cx="6.985" cy="3.206" rx="2.133" ry="2.137" />
        <ellipse fill="#65D45B" cx="2.144" cy="8.826" rx="2.126" ry="2.138" />
        <ellipse fill="#40AD90" cx="13.867" cy="8.756" rx="2.133" ry="2.137" />
        <ellipse fill="#65D45B" cx="9.06" cy="14.393" rx="2.143" ry="2.155" />
        <ellipse fill="#40AD90" cx="1.789" cy="3.689" rx="1.514" ry="1.517" />
        <ellipse fill="#65D45B" cx="14.282" cy="13.944" rx="1.545" ry="1.554" />
      </g>
    </svg>
  ),
  trash: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        fillRule="evenodd"
        d="M7.74336873,17.1349004 L6.62069357,8.09422766 L15.9452134,8.09422766 L14.822572,17.1349004 C14.7598349,17.6301873 14.3371919,18 13.8386083,18 L8.72733245,18 C8.2287489,18 7.80610417,17.6301873 7.74336873,17.1349004 Z M14.3736237,5.48584387 L16.5792625,5.48584387 L16.5792625,7.43389018 L6,7.43389018 L6,5.48584387 L8.19571512,5.48584387 L8.22213031,5.19858185 C8.28816406,4.51839705 8.85278135,4 9.53627968,4 L13.0330591,4 C13.7165406,4 14.2811714,4.51839705 14.3472085,5.19858185 L14.3736237,5.48584387 Z M8.85610333,5.48584387 L13.7066558,5.48584387 L13.686844,5.26131898 C13.6538271,4.92122658 13.3698617,4.6603713 13.0297693,4.6603713 L9.53298983,4.6603713 C9.19289742,4.6603713 8.90893371,4.92122658 8.87591514,5.26131898 L8.85610333,5.48584387 Z"
      />
    </svg>
  ),
  trash1: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .824-.587 1.413A1.93 1.93 0 0 1 17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z"
        fill="#E65051"
      />
    </svg>
  ),
  trends: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M20.2849674,9.999518 L15.9993905,9.999518 C15.6721224,9.999518 15.3866816,10.222189 15.3071627,10.5402628 L14.1160723,15.3024767 L12.4236123,0.631823298 C12.3825972,0.282762849 12.0955085,0.0157334272 11.7447769,0.00066869057 C11.3940667,-0.0143988319 11.0843695,0.226682599 11.0140432,0.570728612 L8.75083005,11.8922104 L7.40320897,6.95427684 C7.32285441,6.65795369 7.06169135,6.44616878 6.75535832,6.42859682 C6.44816817,6.41018098 6.16442012,6.59098954 6.05057377,6.87642451 L4.80257093,9.999518 L1.71481279,9.999518 C1.31972546,9.999518 1,10.3192847 1,10.7135394 C1,11.1086512 1.31974689,11.4283965 1.71481279,11.4283965 L5.28555544,11.4283965 C5.57851748,11.4283965 5.84135191,11.250099 5.94932702,10.9788759 L6.58547805,9.38674966 L8.16745589,15.1876376 L8.16829287,15.1876376 C8.2528323,15.4981897 8.53490254,15.7141533 8.85715649,15.7141533 L8.88143,15.7141533 C9.21206226,15.7024341 9.49163186,15.4663888 9.5569012,15.1424219 L11.5239167,5.30255597 L13.1477432,19.3663341 L13.1477432,19.3671711 C13.1870827,19.7095457 13.4658187,19.9757179 13.8106791,19.9983257 L13.8567148,20 C14.1848185,19.9991628 14.4702594,19.7764933 14.5489426,19.4584195 L16.5578067,11.4282506 L20.2851872,11.4282506 C20.6802745,11.4282506 21,11.1084838 21,10.7133934 C21,10.3191388 20.6802531,9.99937207 20.2851872,9.99937207 L20.2849674,9.999518 Z" />
    </svg>
  ),
  underline: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M10.7742052,17.257803 L10.7742242,17.2579478 C7.42918109,17.2579478 4.74214363,14.5434029 4.74214363,11.226591 L4.74214363,4.09729142 L3.9192927,4.09729142 L3.9192927,3.00016287 L7.75784008,3.00016287 L7.75854713,4.09658563 L6.9356962,4.09658563 L6.93498933,11.2264282 C6.93498933,13.6391156 8.90936829,15.6134946 11.3220558,15.6134946 C13.7347432,15.6134946 15.7091222,13.6391156 15.7091222,11.2264282 L15.7091222,4.09712854 L14.3384218,4.09712854 L14.3384218,3 L18.1776931,3 L18.1769862,4.09642276 L16.8062858,4.09642276 L16.8062858,11.2257224 C16.8062858,14.5432581 14.091741,17.257803 10.7742052,17.257803 Z M2,18.355022 L19.5484466,18.355022 L19.5484466,20 L2,20 L2,18.355022 Z" />
    </svg>
  ),
  strikethrough: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 0.72 0.72"
    >
      <g fill="none">
        <path d="M.72 0v.72H0V0zM.378.698.376.699H.375L.373.698H.372L.371.711v.001l.003.002.003-.002V.711L.376.698.375.697M.383.694.377.697.378.71l.006.003h.001L.384.695zm-.021 0H.361L.36.712l.001.001L.367.71.368.697z" />
        <path
          d="M.57.36a.03.03 0 0 1 .004.06H.507q.01.015.016.032A.135.135 0 0 1 .401.63H.343A.17.17 0 0 1 .192.541L.189.535.184.524A.03.03 0 0 1 .181.506.03.03 0 0 1 .236.493l.001.002.007.013A.11.11 0 0 0 .338.57h.057A.075.075 0 0 0 .434.43L.429.427.414.42H.15A.03.03 0 0 1 .146.36H.15zM.377.09a.17.17 0 0 1 .154.095l.005.011a.03.03 0 0 1-.042.04L.485.227.484.225.478.212A.11.11 0 0 0 .377.15H.326a.075.075 0 0 0-.034.143L.367.33H.24A.14.14 0 0 1 .198.268.135.135 0 0 1 .326.09z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  warning: (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.816 10.449L8.284.727C8.03.27 7.556 0 7.004 0 6.45 0 5.991.269 5.721.727L.19 10.45a1.518 1.518 0 0 0 0 1.47c.253.458.727.727 1.264.727h11.05c.537 0 1.01-.268 1.264-.727.3-.459.3-1.012.048-1.47zm-6.006-.111H6.34v-1.28h1.47v1.28zm0-2.023H6.34V4.647h1.47v3.668z"
        fill="#F5A623"
        fillRule="nonzero"
      />
    </svg>
  ),
  warningLarge: (
    <svg
      width="32"
      height="28"
      viewBox="0 0 14 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Shape</title>
      <path
        d="M13.816 10.449L8.284.727C8.03.27 7.556 0 7.004 0 6.45 0 5.991.269 5.721.727L.19 10.45a1.518 1.518 0 0 0 0 1.47c.253.458.727.727 1.264.727h11.05c.537 0 1.01-.268 1.264-.727.3-.459.3-1.012.048-1.47zm-6.006-.111H6.34v-1.28h1.47v1.28zm0-2.023H6.34V4.647h1.47v3.668z"
        fill="#F5A623"
        fillRule="nonzero"
      />
    </svg>
  ),
  x: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>X v2</title>
      <path
        d="M6 7.554l-4.247 4.247c-.326.326-.938.243-1.368-.186-.429-.43-.512-1.042-.186-1.368L4.446 6 .199 1.753C-.127 1.427-.044.815.385.385.815-.044 1.427-.127 1.753.2L6 4.446 10.247.199c.326-.326.938-.243 1.368.186.429.43.512 1.042.186 1.368L7.554 6l4.247 4.247c.326.326.243.938-.186 1.368-.43.429-1.042.512-1.368.186L6 7.554z"
        fill="#000"
        fillRule="nonzero"
      />
    </svg>
  ),
  zendesk: (
    <svg width="22" height="22" viewBox="0 0 205.41 158.2">
      <polygon points="95 42.93 95 155.79 1.52 155.79 95 42.93" />
      <path d="M95,2.42a46.74,46.74,0,0,1-93.48,0Z" />
      <path d="M110.4,155.79a46.74,46.74,0,0,1,93.48,0Z" />
      <polygon points="110.4 115.28 110.4 2.42 203.89 2.42 110.4 115.28" />
    </svg>
  ),
  // drift exit
  dblChat: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="19"
      viewBox="0 0 22 19"
    >
      <path
        fill="#111"
        d="M18.7644445,25.5885368 L25.8825302,25.5885368 C27.8470603,25.5885368 29.4412431,23.995256 29.4412431,22.0307039 L29.4412431,18.4711111 L30.4106052,18.4711111 C31.8406023,18.4711111 33,19.6312567 33,21.0620459 L33,25.9088562 C33,27.3397113 31.8415703,28.499791 30.4114852,28.499791 L30.4114852,30.1179978 C30.4114852,30.6413547 29.8228104,30.9481441 29.3939872,30.6482407 L26.3252133,28.499813 L21.3512433,28.499813 C19.9229622,28.499813 18.7644885,27.3405253 18.7644885,25.9121782 L18.7644445,25.5885368 Z M13.5885148,24.6182948 C12.1585177,24.6174354 11,23.4598651 11,22.0306599 L11,14.5876348 C11,13.1593537 12.1601457,12 13.5900548,12 L25.8798902,12 C27.3107454,12 28.4699451,13.1584297 28.4699451,14.5876348 L28.4699451,22.0306599 C28.4699451,23.4589411 27.3115154,24.6182948 25.8823102,24.6182948 L18.2923254,24.6182948 L14.5609129,26.7942224 C14.1295157,27.0460119 13.5880968,26.7349259 13.5880968,26.2356215 L13.5885148,24.6182948 Z M19.7355225,19.4414851 C20.2709135,19.4414851 20.7057646,19.007492 20.7057646,18.4712431 C20.7057646,17.9349941 20.2709135,17.500143 19.7355225,17.500143 C19.1992736,17.500143 18.7644225,17.9349941 18.7644225,18.4712431 C18.7644225,19.007492 19.1992736,19.4414851 19.7355225,19.4414851 Z M22.9701761,19.4414851 C23.506425,19.4414851 23.9412761,19.007492 23.9412761,18.4712431 C23.9412761,17.9349941 23.506425,17.500143 22.9701761,17.500143 C22.4347851,17.500143 21.999934,17.9349941 21.999934,18.4712431 C21.999934,19.007492 22.4347851,19.4414851 22.9701761,19.4414851 Z M16.499989,19.4414851 C17.0362379,19.4414851 17.4702311,19.007492 17.4702311,18.4712431 C17.4702311,17.9349941 17.0362379,17.500143 16.499989,17.500143 C15.9637401,17.500143 15.5297469,17.9349941 15.5297469,18.4712431 C15.5297469,19.007492 15.9637401,19.4414851 16.499989,19.4414851 Z"
        transform="translate(-11 -12)"
      />
    </svg>
  ),
  play: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.667 20.167c-0.505 0 -0.935 -0.179 -1.295 -0.539a1.766 1.766 0 0 1 -0.539 -1.295V9.167c0 -0.505 0.18 -0.935 0.539 -1.295 0.359 -0.359 0.791 -0.539 1.295 -0.539h14.666c0.505 0 0.936 0.179 1.295 0.539 0.359 0.359 0.539 0.791 0.539 1.295v9.166c0 0.505 -0.179 0.935 -0.539 1.295a1.766 1.766 0 0 1 -1.294 0.539H3.667Zm0 -1.834h14.666V9.167H3.669v9.166Zm5.5 -0.916 5.5 -3.667 -5.5 -3.667v7.334Zm-5.5 -11V4.583h14.666v1.834H3.669Zm2.75 -2.75V1.833h9.167v1.834H6.417Z" />
    </svg>
  ),
  playCircle: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.708 15.125 15.125 11 8.708 6.875v8.25ZM11 20.167a8.917 8.917 0 0 1-3.575-.722 9.267 9.267 0 0 1-2.91-1.959 9.267 9.267 0 0 1-1.959-2.91A8.926 8.926 0 0 1 1.833 11c0-1.269.241-2.46.722-3.575a9.267 9.267 0 0 1 1.959-2.91 9.253 9.253 0 0 1 2.91-1.959A8.922 8.922 0 0 1 11 1.833c1.269 0 2.46.241 3.575.722a9.267 9.267 0 0 1 2.91 1.959 9.233 9.233 0 0 1 1.959 2.91A8.922 8.922 0 0 1 20.167 11a8.917 8.917 0 0 1-.722 3.575 9.267 9.267 0 0 1-1.959 2.91 9.247 9.247 0 0 1-2.91 1.959 8.926 8.926 0 0 1-3.576.723Zm0-1.834c2.047 0 3.782-.711 5.202-2.132 1.42-1.419 2.131-3.154 2.131-5.201 0-2.047-.711-3.782-2.132-5.202-1.419-1.42-3.154-2.131-5.201-2.131-2.047 0-3.782.71-5.202 2.132C4.378 7.22 3.667 8.953 3.667 11c0 2.047.71 3.782 2.132 5.202 1.421 1.42 3.154 2.131 5.201 2.131Z"
        fill="#2F4C0E"
      />
    </svg>
  ),
  playbook: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="23"
      viewBox="0 0 17 23"
    >
      <path
        d="M17.1556567,96.005254 C17.0346423,96.1262684 16.8654157,96.1990658 16.6961892,96.1990658 C16.5269626,96.1990658 16.357736,96.1262684 16.2367216,96.005254 C15.9946928,95.7632251 15.9946928,95.3519697 16.2367216,95.0853508 L17.3258514,93.996221 L16.2367216,92.9070913 C15.9946928,92.6650624 15.9946928,92.253807 16.2367216,91.9871881 C16.4787505,91.7451592 16.8900059,91.7451592 17.1566248,91.9871881 L18.2457546,93.0763178 L19.3348843,91.9871881 C19.5769132,91.7451592 19.9881686,91.7451592 20.2547875,91.9871881 C20.4968164,92.2292169 20.4968164,92.6404723 20.2547875,92.9070913 L19.1401237,93.996221 L20.2292535,95.0853508 C20.4712823,95.3273796 20.4712823,95.738635 20.2292535,96.005254 C20.1082391,96.1262684 19.9390125,96.1990658 19.769786,96.1990658 C19.6005546,96.1990658 19.4313328,96.1262684 19.3103184,96.005254 L18.2211887,94.9161242 L17.1556567,96.005254 Z M28.8940552,90.8979615 C29.0150696,91.0189759 29.1842962,91.0917733 29.3535228,91.0917733 C29.5227493,91.0917733 29.6919759,91.0189759 29.8129903,90.8979615 C30.0550191,90.6559326 30.0550191,90.2446773 29.8129903,89.9780583 L28.7002143,88.9135187 L29.7893441,87.8243889 C30.0313729,87.5823601 30.0313729,87.1711047 29.7893441,86.9044857 C29.5473153,86.6624569 29.1360599,86.6624569 28.8694409,86.9044857 L27.7803111,87.9936155 L26.6911814,86.9044857 C26.4491525,86.6624569 26.0378971,86.6624569 25.7712782,86.9044857 C25.5292493,87.1465145 25.5292493,87.5577699 25.7712782,87.8243889 L26.8604079,88.9135187 L25.7712782,90.0026484 C25.5292493,90.2446773 25.5292493,90.6559326 25.7712782,90.9225516 C25.8922926,91.043566 26.0615192,91.1163635 26.2307457,91.1163635 C26.3999771,91.1163635 26.5691988,91.043566 26.6902133,90.9225516 L27.779343,89.8334219 L28.8940552,90.8979615 Z M31.2169754,95.1097473 L32.3061051,94.0206175 C32.548134,93.7785887 32.548134,93.3673333 32.3061051,93.1007143 C32.0640763,92.8586855 31.6528209,92.8586855 31.3862019,93.1007143 L30.2970722,94.1898441 L29.2079424,93.1007143 C28.9659136,92.8586855 28.5546582,92.8586855 28.2880392,93.1007143 C28.0460104,93.3427432 28.0460104,93.7539986 28.2880392,94.0206175 L29.377169,95.1097473 L28.2880392,96.198877 C28.0460104,96.4409059 28.0460104,96.8521613 28.2880392,97.1187802 C28.4090536,97.2397947 28.5782802,97.3125921 28.7475068,97.3125921 C28.9167382,97.3125921 29.0859599,97.2397947 29.2069743,97.1187802 L30.2961041,96.0296505 L31.3852338,97.1187802 C31.5062482,97.2397947 31.6754748,97.3125921 31.8447014,97.3125921 C32.0139279,97.3125921 32.1831545,97.2397947 32.3041689,97.1187802 C32.5461977,96.8767514 32.5461977,96.465496 32.3041689,96.198877 L31.2169754,95.1097473 Z M22.6249517,101.668245 C22.6249517,103.241432 21.3420053,104.49974 19.7934564,104.49974 C18.2449075,104.49974 16.961961,103.216794 16.961961,101.668245 C16.961961,100.119647 18.2203174,98.8367493 19.7934564,98.8367493 C21.3665954,98.8367493 22.6249517,100.119696 22.6249517,101.668245 Z M21.3183833,101.668245 C21.3183833,100.821144 20.6168869,100.119647 19.769786,100.119647 C18.922685,100.119647 18.2211887,100.821144 18.2211887,101.668245 C18.2211887,102.515346 18.922685,103.216842 19.769786,103.216842 C20.615943,103.217787 21.3183833,102.539912 21.3183833,101.668245 Z M19.212926,83.516082 L21.9962576,84.2667586 C22.213706,84.3149756 22.407513,84.1939612 22.4803153,84.0001397 C22.5285323,83.7826913 22.4075179,83.5888843 22.2136963,83.516082 L18.5104131,82.5243204 C18.4858327,82.5243204 18.4621961,82.5243204 18.4376157,82.49974 L18.4130352,82.49974 L18.3648182,82.49974 L18.3166013,82.49974 L18.2920208,82.49974 C18.2438038,82.5243204 18.1955868,82.547957 18.1710064,82.5725374 L18.1464259,82.5971179 C18.1218455,82.6216983 18.1218455,82.6216983 18.1218455,82.6453349 L18.0972651,82.6699153 L18.0726846,82.6944958 C18.0726846,82.7190762 18.0481042,82.7427127 18.0481042,82.7672932 L17.1045789,86.3013982 C17.056362,86.5188466 17.1773764,86.7126536 17.3711979,86.7854559 C17.3957784,86.7854559 17.4439953,86.8100364 17.4676319,86.8100364 C17.6368633,86.8100364 17.806085,86.689022 17.8306751,86.5197954 L18.5321715,83.9056419 L24.8249212,94.8451033 L22.4774351,98.1606563 C22.3564207,98.3298877 22.4046377,98.5719117 22.5738691,98.6929261 C22.6466665,98.7411431 22.719464,98.7657235 22.7913175,98.7657235 C22.9123319,98.7657235 23.0333463,98.7175065 23.1061486,98.5964921 L25.5992876,95.087074 C25.6957216,94.9660596 25.6957216,94.796833 25.6238681,94.6758186 L19.212926,83.516082 Z"
        transform="translate(-16 -82)"
      />
    </svg>
  ),
  people: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          d="M0 16.5v-1.444c0 -0.657 0.336 -1.192 1.008 -1.604C1.681 13.039 2.567 12.833 3.667 12.833c0.199 0 0.39 0.004 0.573 0.012 0.183 0.007 0.359 0.027 0.527 0.057a3.814 3.814 0 0 0 -0.481 1.008 3.757 3.757 0 0 0 -0.161 1.1V16.5H0Zm5.5 0v-1.49c0 -0.489 0.134 -0.935 0.401 -1.34 0.268 -0.405 0.645 -0.76 1.134 -1.066s1.074 -0.535 1.754 -0.688c0.68 -0.153 1.417 -0.229 2.211 -0.229 0.81 0 1.555 0.076 2.234 0.229 0.68 0.153 1.264 0.382 1.753 0.688 0.489 0.306 0.864 0.661 1.123 1.066A2.432 2.432 0 0 1 16.5 15.011V16.5H5.5Zm12.375 0v-1.49c0 -0.397 -0.05 -0.771 -0.149 -1.123a3.588 3.588 0 0 0 -0.447 -0.986c0.168 -0.031 0.34 -0.049 0.516 -0.057 0.175 -0.008 0.355 -0.012 0.538 -0.012 1.1 0 1.986 0.202 2.658 0.607 0.672 0.405 1.008 0.944 1.008 1.615V16.5h-4.125ZM3.667 11.917a1.766 1.766 0 0 1 -1.295 -0.538A1.766 1.766 0 0 1 1.833 10.083c0 -0.519 0.18 -0.955 0.538 -1.306A1.784 1.784 0 0 1 3.667 8.25c0.519 0 0.955 0.175 1.306 0.527 0.351 0.351 0.527 0.786 0.527 1.306a1.784 1.784 0 0 1 -0.527 1.295c-0.351 0.359 -0.786 0.538 -1.306 0.538Zm14.667 0a1.766 1.766 0 0 1 -1.295 -0.538A1.766 1.766 0 0 1 16.5 10.083c0 -0.519 0.18 -0.955 0.538 -1.306A1.784 1.784 0 0 1 18.333 8.25c0.519 0 0.955 0.175 1.307 0.527 0.351 0.351 0.527 0.786 0.527 1.306a1.784 1.784 0 0 1 -0.527 1.295c-0.351 0.359 -0.787 0.538 -1.307 0.538ZM11 11c-0.764 0 -1.414 -0.268 -1.948 -0.802 -0.534 -0.535 -0.802 -1.184 -0.802 -1.948 0 -0.779 0.268 -1.432 0.802 -1.959C9.587 5.763 10.236 5.5 11 5.5c0.779 0 1.432 0.263 1.959 0.791 0.527 0.527 0.791 1.18 0.791 1.959 0 0.764 -0.263 1.414 -0.791 1.948C12.432 10.733 11.779 11 11 11Z"
          fill="#4E3B0E"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h22v22H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  peopleGroup: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.667 13.333v-1.866q0-.566.292-1.042.292-.474.775-.725 1.033-.517 2.101-.776a9 9 0 0 1 2.167-.258q1.099 0 2.167.258 1.066.259 2.1.776.484.25.775.725t.292 1.042v1.866zm12 0v-2a2.7 2.7 0 0 0-.408-1.408q-.409-.675-1.158-1.158a8.4 8.4 0 0 1 3 .932q.6.335.917.743t.316.891v2zM6.001 8Q4.9 8 4.118 7.216a2.57 2.57 0 0 1-.784-1.882q0-1.101.784-1.884A2.57 2.57 0 0 1 6 2.667q1.101 0 1.884.783.783.784.783 1.883 0 1.101-.783 1.883A2.57 2.57 0 0 1 6.001 8m6.666-2.667q0 1.101-.783 1.883A2.57 2.57 0 0 1 10.001 8q-.184 0-.467-.042-.282-.042-.467-.091.451-.534.692-1.183.242-.649.242-1.351 0-.699-.242-1.35A4 4 0 0 0 9.067 2.8q.232-.085.467-.108.232-.025.467-.025 1.1 0 1.882.783.785.784.784 1.883"
        fill="#232323"
      />
    </svg>
  ),
  robot: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.666 14v-3.334c0-.367.13-.68.392-.942A1.282 1.282 0 0 1 4 9.332h8c.367 0 .681.13.942.392.262.261.392.574.392.942V14H2.666ZM6 8.666a3.213 3.213 0 0 1-2.359-.975 3.213 3.213 0 0 1-.975-2.358c0-.922.326-1.709.975-2.359A3.213 3.213 0 0 1 6 2h4c.922 0 1.709.325 2.359.975a3.213 3.213 0 0 1 .975 2.359c0 .922-.326 1.709-.975 2.358A3.213 3.213 0 0 1 10 8.667H6ZM6 6a.647.647 0 0 0 .475-.192.645.645 0 0 0 .191-.474.647.647 0 0 0-.191-.475A.645.645 0 0 0 6 4.667a.647.647 0 0 0-.475.192.645.645 0 0 0-.191.475.64.64 0 0 0 .191.474A.645.645 0 0 0 6 6Zm4 0a.647.647 0 0 0 .475-.192.645.645 0 0 0 .191-.474.647.647 0 0 0-.191-.475.645.645 0 0 0-.475-.192.647.647 0 0 0-.475.192.645.645 0 0 0-.191.475.64.64 0 0 0 .191.474A.645.645 0 0 0 10 6Z"
        fill="#062531"
      />
    </svg>
  ),
  magic: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.278 3.109a.285.285 0 0 1 .536 0c.38 1.06 1.111 2.903 1.842 3.676.732.775 2.388 1.549 3.332 1.951.23.098.23.462 0 .561-.943.401-2.599 1.176-3.332 1.95-.731.773-1.461 2.617-1.842 3.676a.285.285 0 0 1-.536 0c-.38-1.06-1.111-2.903-1.842-3.676C3.705 10.475 1.962 9.702.96 9.3c-.238-.095-.238-.473 0-.568 1.002-.402 2.745-1.174 3.476-1.947.731-.773 1.461-2.617 1.842-3.676ZM12.063.983a.142.142 0 0 1 .268 0c.19.53.556 1.452.921 1.838.366.387 1.194.774 1.666.975.116.049.116.231 0 .28-.471.201-1.3.588-1.666.976-.365.386-.731 1.308-.921 1.837a.142.142 0 0 1-.268 0c-.189-.53-.556-1.452-.921-1.837-.364-.387-1.236-.773-1.738-.974-.118-.047-.118-.236 0-.284.501-.201 1.372-.587 1.738-.973.365-.387.731-1.308.921-1.838Z"
        fill="#232323"
      />
    </svg>
  ),
  heart: (
    <svg
      width="16"
      height="15.111"
      viewBox="0 0 16 15.111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m8.338 13.222-.914-.819a71.159 71.159 0 0 1-2.628-2.471c-.693-.693-1.244-1.315-1.653-1.866-.409-.551-.695-1.057-.858-1.518a4.235 4.235 0 0 1-.244-1.417c0-.987.331-1.811.992-2.471.66-.661 1.484-.992 2.471-.992.546 0 1.065.116 1.558.347a3.733 3.733 0 0 1 1.275.975 3.733 3.733 0 0 1 1.276-.975 3.626 3.626 0 0 1 1.558-.347c.987 0 1.81.331 2.471.992.661.66.992 1.484.992 2.471 0 .483-.082.955-.244 1.417-.163.461-.449.968-.858 1.518-.409.551-.96 1.173-1.653 1.866a70.495 70.495 0 0 1-2.628 2.471l-.913.818Z"
        fill="#232323"
      />
    </svg>
  ),
  tasks: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m13.2 18.333-1.283-1.283 2.383-2.383-2.383-2.383 1.283-1.283 2.383 2.383 2.383-2.383 1.283 1.283-2.383 2.383 2.383 2.383-1.283 1.283-2.383-2.383-2.383 2.383Zm1.81-8.25-3.254-3.254 1.283-1.283 1.948 1.948 3.896-3.896 1.284 1.306-5.157 5.179Zm-13.177 5.5V13.75h8.25v1.833h-8.25Zm0-7.333V6.417h8.25V8.25h-8.25Z"
        fill="#4C2F0E"
      />
    </svg>
  ),
  export1: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.583 19.25c-.504 0-.935-.18-1.295-.538a1.765 1.765 0 0 1-.538-1.295V4.583c0-.504.18-.935.538-1.295a1.765 1.765 0 0 1 1.295-.538h12.833c.504 0 .935.18 1.295.538.358.36.539.791.539 1.295v12.833c0 .504-.18.935-.538 1.295a1.765 1.765 0 0 1-1.295.539H13.75v-1.833h3.667v-11H4.583v11H8.25v1.833H4.583Zm5.5 0v-5.638l-1.467 1.467-1.283-1.329L11 10.083l3.667 3.667-1.283 1.329-1.467-1.467v5.638h-1.833Z"
        fill="#00324D"
      />
    </svg>
  ),
  inApp: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17h9v-6h-9v6Zm-6 3c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 20H4Zm0-2h16V6H4v12Z"
        fill="#333"
      />
    </svg>
  ),
  plusWhite: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.083 11.917h-5.5v-1.833h5.5V4.583h1.833v5.5h5.5v1.833h-5.5v5.5h-1.833v-5.5Z"
        fill="#fff"
      />
    </svg>
  ),
  message: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 11c.283 0 .52-.096.713-.287A.968.968 0 0 0 9 10a.968.968 0 0 0-.287-.713A.968.968 0 0 0 8 9a.968.968 0 0 0-.713.287A.968.968 0 0 0 7 10c0 .283.096.52.287.713.192.191.43.287.713.287Zm4 0c.283 0 .52-.096.713-.287A.968.968 0 0 0 13 10a.967.967 0 0 0-.287-.713A.968.968 0 0 0 12 9a.968.968 0 0 0-.713.287A.967.967 0 0 0 11 10c0 .283.096.52.287.713.192.191.43.287.713.287Zm4 0a.97.97 0 0 0 .712-.287A.968.968 0 0 0 17 10a.967.967 0 0 0-.288-.713A.968.968 0 0 0 16 9a.968.968 0 0 0-.713.287A.967.967 0 0 0 15 10c0 .283.096.52.287.713.192.191.43.287.713.287ZM2 22V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h16c.55 0 1.02.196 1.413.587.39.393.587.863.587 1.413v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 18H6l-4 4Zm3.15-6H20V4H4v13.125L5.15 16Z"
        fill="#333"
      />
    </svg>
  ),
  personD: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
    >
      <path
        fill="#111"
        fillRule="evenodd"
        d="M205.524173,25.5953489 C204.641803,25.1243753 205.112777,24.2420058 205.524173,23.8306098 C206.053595,23.3011881 206.701042,21.4780008 206.701042,21.4780008 C207.759886,21.0070273 207.877911,20.2426835 207.994808,19.7132618 C208.465781,18.1834447 207.288912,17.9485227 207.288912,17.9485227 C207.288912,17.9485227 208.22973,15.4194398 207.465386,13.4782268 C206.464991,10.9491439 202.406091,10.0071968 201.700195,12.3609352 C196.876951,11.3009905 197.876217,17.9473932 197.876217,17.9473932 C197.876217,17.9473932 196.699348,18.1823238 197.170322,19.7121323 C197.288339,20.241554 197.405252,21.0058978 198.464087,21.4768714 C198.464087,21.4768714 199.111535,23.3000586 199.640956,23.8294804 C200.052352,24.2408763 200.523326,25.1232459 199.640956,25.5942195 C197.876217,26.5350372 192.582,26.7710887 192.582,30.8884367 L212.582,30.8884367 C212.583103,26.7710887 207.288912,26.5361666 205.524173,25.5953489 Z"
        transform="translate(-192 -11)"
      />
    </svg>
  ),
  personDouble: (
    <svg
      width="44"
      height="32"
      viewBox="0 0 44 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 32v-5.6q0-1.7.875-3.125A5.83 5.83 0 0 1 3.2 21.1a29.7 29.7 0 0 1 6.3-2.325Q12.7 18 16 18t6.5.775a29.7 29.7 0 0 1 6.3 2.325 5.83 5.83 0 0 1 2.325 2.175Q32 24.7 32 26.4V32zm36 0v-6q0-2.2-1.225-4.225T31.3 18.3q2.55.3 4.8 1.025t4.2 1.775q1.8 1 2.75 2.225T44 26v6zM16 16q-3.3 0-5.65-2.35T8 8t2.35-5.65T16 0t5.65 2.35T24 8t-2.35 5.65T16 16m20-8q0 3.3-2.35 5.65T28 16q-.55 0-1.4-.125a12 12 0 0 1-1.4-.275q1.35-1.6 2.075-3.55T28 8t-.725-4.05A11.9 11.9 0 0 0 25.2.4a6 6 0 0 1 1.4-.325Q27.3 0 28 0q3.3 0 5.65 2.35T36 8"
        fill="#A9AAAC"
      />
    </svg>
  ),
  // crazy egg exit
  recordings: (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>recordings-icon_BETA Copy</title>
      <desc>Created with Sketch.</desc>
      <g
        id="recordings-icon_BETA-Copy"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M20,7.2198039 L15,8.2198039 L15,6 L2,6 L2,16 L15,16 L15,13.7801961 L20,14.7801961 L20,7.2198039 Z"
          id="Combined-Shape"
          stroke="#0086E6"
          strokeWidth="2"
        />
      </g>
    </svg>
  ),
  snapshots: (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>snapshot-icon_BETA</title>
      <desc>Created with Sketch.</desc>
      <g
        id="snapshot-icon_BETA"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
      >
        <path
          d="M15.3177951,18 C14.3674888,18.6318473 13.2267377,19 12,19 C10.7732623,19 9.63251117,18.6318473 8.68220488,18 L1,18 C0.44771525,18 6.76353751e-17,17.5522847 0,17 L0,4 C-6.76353751e-17,3.44771525 0.44771525,3 1,3 L8,3 C8,2.44771525 8.44771525,2 9,2 L14,2 C14.5522847,2 15,2.44771525 15,3 L21,3 C21.5522847,3 22,3.44771525 22,4 L22,17 C22,17.5522847 21.5522847,18 21,18 L15.3177951,18 Z M17.1973068,16 L20,16 L20,5 L13,5 L13,4 L10,4 L10,5 L2,5 L2,16 L6.80269317,16 C6.29218286,15.1174799 6,14.0928614 6,13 C6,9.6862915 8.6862915,7 12,7 C15.3137085,7 18,9.6862915 18,13 C18,14.0928614 17.7078171,15.1174799 17.1973068,16 Z M12,17 C14.209139,17 16,15.209139 16,13 C16,10.790861 14.209139,9 12,9 C9.790861,9 8,10.790861 8,13 C8,15.209139 9.790861,17 12,17 Z M5,8 C4.44771525,8 4,7.55228475 4,7 C4,6.44771525 4.44771525,6 5,6 C5.55228475,6 6,6.44771525 6,7 C6,7.55228475 5.55228475,8 5,8 Z"
          fill="#0086E6"
        />
      </g>
    </svg>
  ),
  abtests: (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>abtest-icon-v3_BETA</title>
      <desc>Created with Sketch.</desc>
      <g
        id="abtest-icon-v3_BETA"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
      >
        <path
          d="M16,7 L19,7 C19.5522847,7 20,7.44771525 20,8 L20,19 C20,19.5522847 19.5522847,20 19,20 L8,20 C7.44771525,20 7,19.5522847 7,19 L7,16 L9,16 L9,18 L18,18 L18,9 L16,9 L16,7 Z M2,1 L13,1 C13.5522847,1 14,1.44771525 14,2 L14,13 C14,13.5522847 13.5522847,14 13,14 L2,14 C1.44771525,14 1,13.5522847 1,13 L1,2 C1,1.44771525 1.44771525,1 2,1 Z M3,3 L3,12 L12,12 L12,3 L3,3 Z"
          id="Combined-Shape"
          fill="#0086E6"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  teammembers: (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>team-icon-v1_BETA</title>
      <desc>Created with Sketch.</desc>
      <g
        id="team-icon-v1_BETA"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
      >
        <path
          d="M0,14.0574984 L0,16.245106 L6.39397201,16.245106 L6.39397201,18 L15.606028,18 L15.606028,16.2210664 L22,16.2210664 L22,14.0574984 C21.987233,11.8151933 20.2066212,9.99694779 17.9978471,9.97075902 C19.4832737,9.65653988 20.4941289,8.25303618 20.3385407,6.72086544 C20.1829524,5.1886947 18.9113068,4.02403964 17.393972,4.02403964 C15.8766373,4.02403964 14.6049916,5.1886947 14.4494034,6.72086544 C14.2938151,8.25303618 15.3046703,9.65653988 16.7900969,9.97075902 C15.3217911,9.99350745 13.9806762,10.8213883 13.285253,12.1343269 C12.7680405,11.8787515 12.2026328,11.7393609 11.6275565,11.725653 C13.112983,11.4114339 14.1238383,10.0079302 13.96825,8.47575943 C13.8126618,6.94358869 12.5410161,5.77893363 11.0236814,5.77893363 C9.50634664,5.77893363 8.234701,6.94358869 8.07911272,8.47575943 C7.92352445,10.0079302 8.93437971,11.4114339 10.4198062,11.725653 C9.8384799,11.7283811 9.26471736,11.8596359 8.73842842,12.1102873 C8.04300514,10.7973486 6.70189031,9.96946781 5.2335845,9.94671937 C6.71901104,9.63250024 7.7298663,8.22899654 7.57427802,6.6968258 C7.41868974,5.16465506 6.1470441,4 4.62970936,4 C3.11237463,4 1.84072899,5.16465506 1.68514071,6.6968258 C1.52955243,8.22899654 2.54040769,9.63250024 4.02583423,9.94671937 C1.79860221,9.95994139 -3.80850354e-05,11.7965329 0,14.0574984 Z M14.1851453,16.5576214 L7.83853606,16.5576214 L7.83853606,15.8123924 C7.85139169,14.3573921 9.01017135,13.1810817 10.4434876,13.1680316 L11.5801938,13.1680316 C13.01351,13.1810817 14.1722897,14.3573921 14.1851453,15.8123924 L14.1851453,16.5576214 Z M15.8665231,7.03792249 C15.856912,6.40382268 16.2257928,5.82671401 16.8001579,5.57726418 C17.3745231,5.32781436 18.0404453,5.45550266 18.4856026,5.90044245 C18.93076,6.34538223 19.066854,7.01931808 18.8300556,7.60616972 C18.5932573,8.19302135 18.0305364,8.57638463 17.4058127,8.57645968 C16.564949,8.56332606 15.890105,7.86756865 15.8902045,7.01388284 L15.8665231,7.03792249 Z M16.8374596,11.4131376 L17.9741658,11.4131376 C19.407482,11.4261878 20.5662617,12.6024981 20.5791173,14.0574984 L20.5791173,14.8027274 L15.4876211,14.8027274 C15.3106839,14.1141071 14.9596711,13.4843268 14.4693219,12.9757145 C14.8891292,12.0147566 15.8256025,11.3935457 16.861141,11.389098 L16.8374596,11.4131376 Z M9.47255113,8.76877683 C9.47255113,7.90578947 10.1617145,7.20619999 11.0118407,7.20619999 C11.8619668,7.20619999 12.5511302,7.90578947 12.5511302,8.76877683 C12.5511302,9.63176419 11.8619668,10.3313537 11.0118407,10.3313537 C10.1617145,10.3313537 9.47255113,9.63176419 9.47255113,8.76877683 Z M3.07857912,7.01388284 C3.07857912,6.15089549 3.76774253,5.45130601 4.61786868,5.45130601 C5.46799482,5.45130601 6.15715823,6.15089549 6.15715823,7.01388284 C6.15715823,7.8768702 5.46799482,8.57645968 4.61786868,8.57645968 C4.2096237,8.57645968 3.81809938,8.41183152 3.52942659,8.11879152 C3.2407538,7.82575152 3.07857912,7.42830399 3.07857912,7.01388284 Z M1.42088267,14.0574984 C1.4337383,12.6024981 2.59251796,11.4261878 4.02583423,11.4131376 L5.16254037,11.4131376 C6.19253235,11.4133242 7.12751601,12.0241495 7.55435953,12.9757145 C7.06401024,13.4843268 6.71299746,14.1141071 6.53606028,14.8027274 L1.42088267,14.8027274 L1.42088267,14.0574984 Z"
          id="Shape"
          fill="#0086E6"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  success: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 0C5.871 0 0 5.87 0 13s5.87 13 13 13 13-5.87 13-13S20.13 0 13 0zm7.213 10.064l-9.477 9.478a.51.51 0 0 1-.671 0l-4.278-4.278a.51.51 0 0 1 0-.67l1.426-1.427a.51.51 0 0 1 .67 0l2.014 2.013a.658.658 0 0 0 .922 0l7.297-7.297a.51.51 0 0 1 .671 0l1.426 1.426c.168.252.168.587 0 .755z"
        fill="#21B851"
        fillRule="nonzero"
      />
    </svg>
  ),
  bbkSegment: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        d="M14.9999995,7.75680026 C14.9999995,11.2132074 12.1917915,14.0204336 8.73636654,14.0204336 L8.73636654,7.75680026 L14.9999995,7.75680026 Z M7.26363254,0.000404355061 C10.7583305,-0.0387153449 13.5272665,2.76875046 13.5272665,6.26403766 L7.26363254,6.26403766 L7.26363254,12.527671 C3.80722554,12.527671 0.999999545,9.71946296 0.999999545,6.26403766 C0.999999545,2.80763056 3.80820754,0.000404355061 7.26363254,0.000404355061 Z"
        transform="rotate(-90 11.5 7.51)"
      />
    </svg>
  ),
  publish: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.344 9.41c0-.053.009-.106.009-.16 0-2.902-2.313-5.25-5.166-5.25-2.058 0-3.826 1.223-4.656 2.991a2.645 2.645 0 0 0-1.196-.29c-1.317 0-2.415.978-2.625 2.254A4.048 4.048 0 0 0 1 12.795c0 2.24 1.79 4.062 3.995 4.062h4.576v-3.571H7.42L11 9.549l3.58 3.732h-2.15v3.572h4.924c2.018 0 3.647-1.675 3.647-3.724 0-2.049-1.638-3.714-3.656-3.719z" />
    </svg>
  ),
  mobile: (
    <svg
      width="9"
      height="14"
      viewBox="0 0 9 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.24463 0C0.559976 0 0 0.559976 0 1.24463V12.7554C0 13.44 0.559976 14 1.24463 14H7.03087C7.71552 14 8.2755 13.44 8.2755 12.7554V1.24463C8.2755 0.559976 7.71552 0 7.03087 0L1.24463 0ZM3.44464 1.1987H4.83201C4.92333 1.1987 4.99716 1.30315 4.99716 1.43221C4.99716 1.56127 4.92334 1.66572 4.83201 1.66572H3.44464C3.35332 1.66572 3.27949 1.56127 3.27949 1.43221C3.27949 1.30315 3.35331 1.1987 3.44464 1.1987ZM0.684095 2.86225H7.59252V11.1372H0.684095V2.86225ZM4.13803 11.7978C4.56349 11.7978 4.90854 12.1429 4.90854 12.5683C4.90854 12.9938 4.56349 13.3388 4.13803 13.3388C3.71257 13.3388 3.36752 12.9938 3.36752 12.5683C3.36752 12.1429 3.71257 11.7978 4.13803 11.7978Z" />
    </svg>
  ),
  tablet: (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.62 1.61879C12.6184 0.724147 11.8416 0 10.8834 0L6.41067 0.00300451H6.27181L1.7319 0.00450705C0.774521 0.00600949 -0.00153814 0.730884 2.28927e-06 1.62629L0.0100311 14.3812C0.0115741 15.2759 0.78919 16 1.74657 16L6.28648 15.997H6.42534L10.8997 15.994C11.8571 15.994 12.6316 15.2676 12.6316 14.3737L12.62 1.61879ZM6.42528 15.236C6.41834 15.2375 6.4114 15.2375 6.40445 15.2375C6.36511 15.2375 6.325 15.2345 6.28642 15.2292C5.88759 15.1781 5.58132 14.8657 5.58132 14.4878C5.57978 14.1107 5.88682 13.7975 6.28488 13.7449C6.32345 13.7396 6.3628 13.7366 6.40291 13.7366C6.40986 13.7366 6.4168 13.7366 6.42451 13.7381C6.86733 13.7479 7.22451 14.0792 7.22451 14.487C7.22528 14.8949 6.86887 15.2262 6.42528 15.236ZM6.4222 13.2964L6.28334 13.2979L0.51523 13.3009L0.505201 1.75983L6.27331 1.75682H6.41217L12.0784 1.75382L12.0884 13.2934L6.4222 13.2964Z" />
    </svg>
  ),
  desktop: (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.6829 13.7345C21.1655 13.1974 20.6422 12.6723 20.1163 12.1438L20.1171 12.1447C20.0612 12.0905 20.0295 12.0149 20.0312 11.9376V10.4697V0.836174C20.0312 0.374681 19.6565 0 19.195 0H2.72165C2.25244 0 1.87258 0.380709 1.87258 0.849924L1.9654 11.9711L1.96454 11.9703C1.95938 12.0399 1.92759 12.1052 1.87688 12.1533C1.34924 12.6836 0.820708 13.2138 0.301641 13.7526C0.190781 13.8832 0.090235 14.0216 0 14.166V14.3224C0.0893748 14.5853 0.256102 14.8148 0.477817 14.9824C0.519067 15.009 0.565474 15.0288 0.613599 15.0399C0.636802 15.0425 0.659145 15.0425 0.682348 15.0399H21.3176C21.407 15.0425 21.4938 15.0107 21.56 14.9514C21.7611 14.7856 21.9132 14.5681 22 14.3224V14.166C21.9046 14.0156 21.7989 13.8712 21.6829 13.7346L21.6829 13.7345ZM8.10232 14.3111L9.05967 13.4071H13.0436L13.897 14.2673L8.10232 14.3111ZM19.1401 10.7542H2.86017V1.09995H19.1401V10.7542Z" />
    </svg>
  ),
  hide: (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.2">
        <path d="M17.5308 7.16685C16.9055 6.48462 15.9776 5.65146 14.7648 4.91309L11.9428 7.73512C11.9997 7.94378 12.0182 8.17094 12.0182 8.37885C12.0182 10.0459 10.6738 11.4096 9.00679 11.4096C8.77963 11.4096 8.57096 11.3904 8.3438 11.3342L6.4873 13.1907C7.26424 13.3801 8.0974 13.494 9.00682 13.494C13.2312 13.494 16.1102 11.1262 17.5309 9.61085C18.1561 8.9094 18.1561 7.86757 17.5309 7.16691L17.5308 7.16685Z" />
        <path d="M15.8638 0.764116C15.485 0.385269 14.879 0.385269 14.5001 0.764116L11.6588 3.60547C10.8441 3.3968 9.95397 3.2836 9.00685 3.2836C4.78252 3.2836 1.90348 5.65139 0.482802 7.16678C-0.160934 7.849 -0.160934 8.90932 0.482802 9.60996C1.12654 10.3106 2.0929 11.1823 3.34347 11.9207L1.39222 13.872C1.01338 14.2508 1.01338 14.8568 1.39222 15.2357C1.58165 15.4251 1.82805 15.5198 2.07445 15.5198C2.32085 15.5198 2.56725 15.4251 2.75668 15.2357L15.8638 2.12777C16.2427 1.74893 16.2427 1.14292 15.8638 0.764078V0.764116ZM5.99525 8.37875C5.99525 6.71167 7.34046 5.36729 9.0067 5.36729C9.27159 5.36729 9.53724 5.40503 9.80213 5.48124L6.08981 9.17424C6.03283 8.92784 5.9951 8.66295 5.9951 8.37881L5.99525 8.37875Z" />
      </g>
    </svg>
  ),
  externalLink: (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fas"
      data-icon="external-link-alt"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
      />
    </svg>
  ),
  externalLink16: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 10H12.5C12.3674 10 12.2402 10.0527 12.1464 10.1464C12.0527 10.2402 12 10.3674 12 10.5V14H2V4H6.5C6.63261 4 6.75979 3.94732 6.85355 3.85355C6.94732 3.75979 7 3.63261 7 3.5V2.5C7 2.36739 6.94732 2.24021 6.85355 2.14645C6.75979 2.05268 6.63261 2 6.5 2H1.5C1.10218 2 0.720644 2.15804 0.43934 2.43934C0.158035 2.72064 0 3.10218 0 3.5L0 14.5C0 14.8978 0.158035 15.2794 0.43934 15.5607C0.720644 15.842 1.10218 16 1.5 16H12.5C12.8978 16 13.2794 15.842 13.5607 15.5607C13.842 15.2794 14 14.8978 14 14.5V10.5C14 10.3674 13.9473 10.2402 13.8536 10.1464C13.7598 10.0527 13.6326 10 13.5 10ZM15.25 0H11.25C10.5822 0 10.2484 0.809687 10.7188 1.28125L11.8353 2.39781L4.21875 10.0116C4.14883 10.0812 4.09335 10.164 4.0555 10.2552C4.01764 10.3464 3.99816 10.4441 3.99816 10.5428C3.99816 10.6415 4.01764 10.7393 4.0555 10.8304C4.09335 10.9216 4.14883 11.0044 4.21875 11.0741L4.92719 11.7812C4.99687 11.8512 5.07966 11.9066 5.17082 11.9445C5.26199 11.9824 5.35973 12.0018 5.45844 12.0018C5.55715 12.0018 5.65489 11.9824 5.74605 11.9445C5.83722 11.9066 5.92001 11.8512 5.98969 11.7812L13.6025 4.16625L14.7188 5.28125C15.1875 5.75 16 5.42188 16 4.75V0.75C16 0.551088 15.921 0.360322 15.7803 0.21967C15.6397 0.0790176 15.4489 0 15.25 0V0Z"
        fill="currentColor"
      />
    </svg>
  ),
  externalLink10: (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4375 6.25H7.8125C7.72962 6.25 7.65013 6.28292 7.59153 6.34153C7.53292 6.40013 7.5 6.47962 7.5 6.5625V8.75H1.25V2.5H4.0625C4.14538 2.5 4.22487 2.46708 4.28347 2.40847C4.34208 2.34987 4.375 2.27038 4.375 2.1875V1.5625C4.375 1.47962 4.34208 1.40013 4.28347 1.34153C4.22487 1.28292 4.14538 1.25 4.0625 1.25H0.9375C0.68886 1.25 0.450403 1.34877 0.274587 1.52459C0.098772 1.7004 0 1.93886 0 2.1875L0 9.0625C0 9.31114 0.098772 9.5496 0.274587 9.72541C0.450403 9.90123 0.68886 10 0.9375 10H7.8125C8.06114 10 8.2996 9.90123 8.47541 9.72541C8.65123 9.5496 8.75 9.31114 8.75 9.0625V6.5625C8.75 6.47962 8.71708 6.40013 8.65847 6.34153C8.59987 6.28292 8.52038 6.25 8.4375 6.25ZM9.53125 0H7.03125C6.61387 0 6.40527 0.506055 6.69922 0.800781L7.39707 1.49863L2.63672 6.25723C2.59302 6.30077 2.55835 6.35252 2.53469 6.4095C2.51103 6.46648 2.49885 6.52756 2.49885 6.58926C2.49885 6.65095 2.51103 6.71204 2.53469 6.76902C2.55835 6.82599 2.59302 6.87774 2.63672 6.92129L3.07949 7.36328C3.12304 7.40698 3.17479 7.44165 3.23176 7.46531C3.28874 7.48897 3.34983 7.50115 3.41152 7.50115C3.47322 7.50115 3.5343 7.48897 3.59128 7.46531C3.64826 7.44165 3.70001 7.40698 3.74355 7.36328L8.50156 2.60391L9.19922 3.30078C9.49219 3.59375 10 3.38867 10 2.96875V0.46875C10 0.34443 9.95061 0.225201 9.86271 0.137294C9.7748 0.049386 9.65557 0 9.53125 0V0Z"
        fill="currentColor"
      />
    </svg>
  ),
  funnel: (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="2" rx="1" fill="#7B7C7D" />
      <rect
        x="2.13379"
        y="4"
        width="11.7333"
        height="2"
        rx="1"
        fill="#7B7C7D"
      />
      <rect x="4.2666" y="8" width="7.46667" height="2" rx="1" fill="#7B7C7D" />
    </svg>
  ),
  reports: (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 15q.624 0 1.063-.437Q17 14.125 17 13.5t-.437-1.062A1.45 1.45 0 0 0 15.5 12q-.625 0-1.062.438A1.45 1.45 0 0 0 14 13.5q0 .624.438 1.063.437.437 1.062.437m0 3q.8 0 1.425-.35a3.1 3.1 0 0 0 1.05-.975 3.3 3.3 0 0 0-1.138-.588A4.7 4.7 0 0 0 15.5 15.9q-.7 0-1.338.187-.638.188-1.137.588.425.626 1.05.975.625.35 1.425.35m-13 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 .5 16V2q0-.824.587-1.412A1.93 1.93 0 0 1 2.5 0h14q.824 0 1.413.588.587.587.587 1.412v6.7a8 8 0 0 0-.975-.387 6 6 0 0 0-1.025-.238V2h-14v14h6.05q.076.55.237 1.05.163.5.388.95zm0-3v1V2v6.075V8zm2-1h4.075q.076-.525.238-1.025T9.175 12H4.5zm0-4h6.1q.8-.75 1.787-1.25a7 7 0 0 1 2.113-.675V8h-10zm0-4h10V4h-10zm11 14q-2.075 0-3.537-1.462Q10.5 17.074 10.5 15q0-2.075 1.463-3.537Q13.426 10 15.5 10q2.075 0 3.538 1.463T20.5 15t-1.462 3.538Q17.574 20 15.5 20"
        fill="#2D6A8A"
      />
    </svg>
  ),
  listView: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="5" width="14" height="3" rx="1" />
      <rect x="4" y="10" width="14" height="3" rx="1" />
      <rect x="4" y="15" width="14" height="3" rx="1" />
    </svg>
  ),
  unorderedList: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 0.66 0.66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.22.165h.357M.22.33h.357M.22.495h.357M.11.165a.014.014 0 1 1-.028 0 .014.014 0 0 1 .028 0m0 .165a.014.014 0 1 1-.028 0 .014.014 0 0 1 .028 0m0 .165a.014.014 0 1 1-.028 0 .014.014 0 0 1 .028 0"
        stroke="#000"
        strokeWidth=".055"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  orderedList: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 0.44 0.44"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.099 0.084h0.336v0.035H0.099zm0 0.118h0.336v0.035H0.099zm0 0.12h0.336v0.035H0.099zM0.028 0.132h0.013V0.069H0.017v0.012h0.011zm0.024 0.107H0.025L0.03 0.235 0.037 0.229q0.014 -0.011 0.013 -0.022A0.022 0.022 0 0 0 0.028 0.187a0.022 0.022 0 0 0 -0.022 0.023h0.014a0.011 0.011 0 0 1 0.008 -0.011 0.011 0.011 0 0 1 0.009 0.009A0.022 0.022 0 0 1 0.03 0.22L0.006 0.241v0.011h0.045zM0.042 0.337A0.011 0.011 0 0 0 0.05 0.323a0.019 0.019 0 0 0 -0.022 -0.017 0.022 0.022 0 0 0 -0.021 0.021h0.014A0.011 0.011 0 0 1 0.029 0.319a0.008 0.008 0 1 1 0 0.014H0.025v0.011h0.002q0.01 0 0.01 0.008a0.011 0.011 0 0 1 -0.009 0.008 0.011 0.011 0 0 1 -0.01 -0.01H0.006a0.022 0.022 0 0 0 0.023 0.022A0.022 0.022 0 0 0 0.052 0.352 0.014 0.014 0 0 0 0.042 0.338" />
    </svg>
  ),
  image: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 0.66 0.66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.392.438.346.392C.324.37.313.359.3.355a.06.06 0 0 0-.034 0C.253.359.243.37.221.393l-.11.11M.392.439.401.43C.423.408.434.397.447.393a.06.06 0 0 1 .034 0c.013.004.023.016.045.038l.023.023M.391.439l.11.11m0 0L.46.55H.198C.167.55.152.55.14.544A.1.1 0 0 1 .116.52L.111.503m.391.046L.519.544A.1.1 0 0 0 .543.52C.55.508.55.493.55.462V.454M.111.503.11.462V.198C.11.167.11.152.116.14A.1.1 0 0 1 .14.116C.152.11.167.11.198.11h.264C.493.11.508.11.52.116A.1.1 0 0 1 .544.14C.55.152.55.167.55.198v.256M.468.247a.055.055 0 1 1-.11 0 .055.055 0 0 1 .11 0"
        stroke="#000"
        strokeWidth=".055"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  gridView: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5" y="5" width="6" height="6" rx="1" />
      <rect x="12" y="5" width="6" height="6" rx="1" />
      <rect x="5" y="12" width="6" height="6" rx="1" />
      <rect x="12" y="12" width="6" height="6" rx="1" />
    </svg>
  ),
  categoryPause: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 5.25C8 4.55965 7.32843 4 6.5 4C5.67157 4 5 4.55965 5 5.25V17.75C5 18.4404 5.67157 19 6.5 19C7.32843 19 8 18.4404 8 17.75V5.25Z" />
      <path d="M16 5.25C16 4.55965 15.3284 4 14.5 4C13.6716 4 13 4.55965 13 5.25V17.75C13 18.4404 13.6716 19 14.5 19C15.3284 19 16 18.4404 16 17.75V5.25Z" />
    </svg>
  ),
  categoryExtension: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.7 10.3L15.7 7.3C15.3 6.9 14.7 6.9 14.3 7.3C13.9 7.7 13.9 8.3 14.3 8.7L15.6 10H6.4L7.7 8.7C8.1 8.3 8.1 7.7 7.7 7.3C7.3 6.9 6.7 6.9 6.3 7.3L3.3 10.3C2.9 10.7 2.9 11.3 3.3 11.7L6.3 14.7C6.5 14.9 6.7 15 7 15C7.3 15 7.5 14.9 7.7 14.7C8.1 14.3 8.1 13.7 7.7 13.3L6.4 12H15.6L14.3 13.3C13.9 13.7 13.9 14.3 14.3 14.7C14.5 14.9 14.8 15 15 15C15.2 15 15.5 14.9 15.7 14.7L18.7 11.7C19.1 11.3 19.1 10.7 18.7 10.3Z" />
    </svg>
  ),
  categoryPlanChange: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.5" cy="7.5" r="2.5" strokeWidth="2" />
      <path d="M15 12C15 9.79086 13.2091 8 11 8" />
      <circle cx="15" cy="15" r="2" />
    </svg>
  ),
  categoryDiscount: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.625 10.25C6.2 10.25 5 9.05 5 7.625C5 6.2 6.2 5 7.625 5C9.05 5 10.25 6.2 10.25 7.625C10.25 9.05 9.05 10.25 7.625 10.25ZM7.625 6.5C7.025 6.5 6.5 7.025 6.5 7.625C6.5 8.225 7.025 8.75 7.625 8.75C8.225 8.75 8.75 8.225 8.75 7.625C8.75 7.025 8.225 6.5 7.625 6.5Z" />
      <path d="M14.375 17C12.95 17 11.75 15.8 11.75 14.375C11.75 12.95 12.95 11.75 14.375 11.75C15.8 11.75 17 12.95 17 14.375C17 15.8 15.8 17 14.375 17ZM14.375 13.25C13.775 13.25 13.25 13.775 13.25 14.375C13.25 14.975 13.775 15.5 14.375 15.5C14.975 15.5 15.5 14.975 15.5 14.375C15.5 13.775 14.975 13.25 14.375 13.25Z" />
      <path d="M5.75 17C5.525 17 5.375 16.925 5.225 16.775C4.925 16.475 4.925 16.025 5.225 15.725L15.725 5.225C16.025 4.925 16.475 4.925 16.775 5.225C17.075 5.525 17.075 5.975 16.775 6.275L6.275 16.775C6.125 16.925 5.975 17 5.75 17Z" />
    </svg>
  ),
  categorySupport: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.5 4C6.375 4 3 7.375 3 11.5C3 15.625 6.375 19 10.5 19C14.625 19 18 15.625 18 11.5C18 7.375 14.625 4 10.5 4ZM16.0313 10.5625H14.0625C13.7813 9.25 12.75 8.21875 11.4375 7.84375V5.96875C13.7812 6.34375 15.6563 8.21875 16.0313 10.5625ZM10.5 13.375C9.46875 13.375 8.625 12.5312 8.625 11.5C8.625 10.4688 9.46875 9.625 10.5 9.625C11.5312 9.625 12.375 10.4688 12.375 11.5C12.375 12.5312 11.5312 13.375 10.5 13.375ZM9.5625 5.96875V7.9375C8.25 8.21875 7.21875 9.25 6.84375 10.5625H4.96875C5.34375 8.21875 7.21875 6.34375 9.5625 5.96875ZM4.96875 12.4375H6.9375C7.3125 13.75 8.34375 14.7813 9.65625 15.1563V17.125C7.21875 16.6562 5.34375 14.7812 4.96875 12.4375ZM11.4375 17.0313V15.0625C12.75 14.6875 13.7813 13.6563 14.1563 12.3438H16.125C15.6562 14.7813 13.7812 16.6563 11.4375 17.0313Z" />
    </svg>
  ),
  categoryCustomerFeedback: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.5 18C10.9687 18 10.4375 17.7941 10.0125 17.3824L4.0625 11.5147C3.95625 11.4118 3.95625 11.3088 3.85 11.2059C3 10.0735 2.7875 8.73529 3.2125 7.39706C3.6375 5.75 5.01875 4.41176 6.825 4.10294C7.14375 4 7.4625 4 7.78125 4C9.5875 4 10.7562 5.02941 11.5 5.95588C12.2437 5.02941 13.4125 4 15.2187 4C15.5375 4 15.9625 4 16.2812 4.10294C17.9812 4.51471 19.3625 5.75 19.7875 7.39706C20.2125 8.83824 20 10.1765 19.15 11.3088C19.15 11.4118 19.0437 11.5147 18.9375 11.5147L12.9875 17.3824C12.5625 17.7941 12.0312 18 11.5 18ZM5.65625 10.1765L11.5 15.9412L17.3437 10.1765C17.875 9.55882 17.9812 8.73529 17.7687 8.01471C17.5562 7.08824 16.8125 6.36765 15.8562 6.16176C15.6437 6.05882 15.4312 6.05882 15.2187 6.05882C13.4125 6.05882 12.5625 8.42647 12.4563 8.42647C12.35 8.83824 11.925 9.14706 11.5 9.14706C11.075 9.14706 10.65 8.83824 10.4375 8.42647C10.4375 8.42647 9.69375 6.05882 7.78125 6.05882C7.56875 6.05882 7.35625 6.05882 7.25 6.16176C6.29375 6.36765 5.44375 7.08824 5.23125 7.91176C5.01875 8.73529 5.125 9.55882 5.65625 10.1765Z" />
    </svg>
  ),
  categoryGifts: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 5.8125C18 4.21875 16.7813 3 15.1875 3C14.3438 3 12.75 4.125 10.5 6.375C8.25 4.125 6.65625 3 5.8125 3C4.21875 3 3 4.21875 3 5.8125C3 7.03125 3.75 8.0625 4.875 8.4375V17.0625C4.875 17.625 5.25 18 5.8125 18H15.1875C15.75 18 16.125 17.625 16.125 17.0625V8.4375C17.25 8.0625 18 7.03125 18 5.8125ZM6.75 8.625H9.5625V11.4375H6.75V8.625ZM5.71875 4.875C6.09375 4.96875 7.125 5.8125 8.15625 6.75H5.8125C5.25 6.75 4.875 6.375 4.875 5.8125C4.875 5.25 5.25 4.875 5.71875 4.875ZM6.75 13.3125H9.5625V16.125H6.75V13.3125ZM14.25 16.125H11.4375V13.3125H14.25V16.125ZM14.25 11.4375H11.4375V8.625H14.25V11.4375ZM15.1875 6.75H12.8438C13.875 5.8125 14.9062 4.96875 15.1875 4.875C15.75 4.875 16.125 5.25 16.125 5.8125C16.125 6.375 15.75 6.75 15.1875 6.75Z" />
    </svg>
  ),
  categoryMultiOffer: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="6" width="13.3333" height="2.22222" rx="1.11111" />
      <rect
        x="4.66669"
        y="9.88889"
        width="13.3333"
        height="2.22222"
        rx="1.11111"
      />
      <rect
        x="6.33334"
        y="13.7778"
        width="13.3333"
        height="2.22222"
        rx="1.11111"
      />
    </svg>
  ),
  categoryMultiAction: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.6 20L11 14.4V6.875L8.4 9.475L6.975 8.05L12 3.025L17 8.025L15.575 9.45L13 6.875V13.6L18 18.6L16.6 20ZM7.4 20.025L6 18.625L9.175 15.425L10.6 16.85L7.4 20.025Z" />
    </svg>
  ),
  categoryTrialConversionPlusDiscount: (
    <svg
      width="68"
      height="24"
      viewBox="0 0 68 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 19.5q-3.125 0-5.312-2.187Q1 15.125 1 12t2.188-5.312T8.5 4.5t5.313 2.188T16 12t-2.187 5.313T8.5 19.5m10 .5V7.8l-1.1 1.1L16 7.5 19.5 4 23 7.5l-1.425 1.4L20.5 7.825V20zm-10-2.5q2.3 0 3.9-1.6T14 12t-1.6-3.9-3.9-1.6-3.9 1.6T3 12t1.6 3.9 3.9 1.6m2-2 1.4-1.4-2.4-2.425V8h-2v4.5zm22.834-2.833h-4v-1.333h4v-4h1.333v4h4v1.333h-4v4h-1.334zM51.5 11a3.37 3.37 0 0 1-2.475-1.025A3.37 3.37 0 0 1 48 7.5q0-1.45 1.025-2.475A3.37 3.37 0 0 1 51.5 4q1.45 0 2.475 1.025A3.37 3.37 0 0 1 55 7.5q0 1.45-1.025 2.475A3.37 3.37 0 0 1 51.5 11m0-2q.624 0 1.063-.437Q53 8.124 53 7.5t-.437-1.062A1.45 1.45 0 0 0 51.5 6q-.625 0-1.062.438A1.45 1.45 0 0 0 50 7.5q0 .624.438 1.063Q50.874 9 51.5 9m9 11a3.37 3.37 0 0 1-2.475-1.025A3.37 3.37 0 0 1 57 16.5q0-1.45 1.025-2.475A3.37 3.37 0 0 1 60.5 13q1.45 0 2.475 1.025A3.37 3.37 0 0 1 64 16.5q0 1.45-1.025 2.475A3.37 3.37 0 0 1 60.5 20m0-2q.624 0 1.063-.437Q62 17.125 62 16.5t-.437-1.062A1.45 1.45 0 0 0 60.5 15q-.625 0-1.062.438A1.45 1.45 0 0 0 59 16.5q0 .625.438 1.063.436.437 1.062.437m-11.1 2L48 18.6 62.6 4 64 5.4z"
        fill="#336989"
      />
    </svg>
  ),
  categoryTrialConversion: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 19.5q-3.125 0-5.312-2.187Q1 15.125 1 12t2.188-5.312T8.5 4.5t5.313 2.188T16 12t-2.187 5.313T8.5 19.5m10 .5V7.8l-1.1 1.1L16 7.5 19.5 4 23 7.5l-1.425 1.4L20.5 7.825V20zm-10-2.5q2.3 0 3.9-1.6T14 12t-1.6-3.9-3.9-1.6-3.9 1.6T3 12t1.6 3.9 3.9 1.6m2-2 1.4-1.4-2.4-2.425V8h-2v4.5z"
        fill="#336989"
      />
    </svg>
  ),
  categoryOther: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.3 12.75L9 10.05L11.7 12.75L12.75 11.7L10.05 9L12.75 6.3L11.7 5.25L9 7.95L6.3 5.25L5.25 6.3L7.95 9L5.25 11.7L6.3 12.75ZM9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.48438 12.8375 2.09063 11.925C1.69688 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69688 6.9875 2.09063 6.075C2.48438 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48438 6.075 2.09063C6.9875 1.69688 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69688 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5ZM9 15C10.675 15 12.0938 14.4188 13.2563 13.2563C14.4188 12.0938 15 10.675 15 9C15 7.325 14.4188 5.90625 13.2563 4.74375C12.0938 3.58125 10.675 3 9 3C7.325 3 5.90625 3.58125 4.74375 4.74375C3.58125 5.90625 3 7.325 3 9C3 10.675 3.58125 12.0938 4.74375 13.2563C5.90625 14.4188 7.325 15 9 15Z"
        fill="#3C6A87"
      />
    </svg>
  ),
  upTriangle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="22"
      zoomAndPan="magnify"
      viewBox="0 0 1440 809.999993"
      height="22"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="ebc7666453">
          <path
            d="M 330 243.71875 L 1110 243.71875 L 1110 566.21875 L 330 566.21875 Z M 330 243.71875 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#ebc7666453)">
        <path
          fill={tailwindColors.cbrsuccess['400']}
          d="M 720 243.71875 L 1109.996094 566.21875 L 330.003906 566.21875 L 720 243.71875 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  downTriangle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="22"
      zoomAndPan="magnify"
      viewBox="0 0 1440 809.999993"
      height="22"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="5192e549c5">
          <path
            d="M 330 243.390625 L 1110 243.390625 L 1110 565.890625 L 330 565.890625 Z M 330 243.390625 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#5192e549c5)">
        <path
          fill={tailwindColors.cbrwarn['400']}
          d="M 720 565.890625 L 330.003906 243.390625 L 1109.996094 243.390625 L 720 565.890625 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  rightArrowLink: (
    <svg
      width="10"
      height="10"
      version="1.1"
      viewBox="0 0 1200 1200"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m369.96 1200 600-600-600-600-139.92 140.04 459.96 459.96-459.96 459.96z"
        fill="currentColor"
      />
    </svg>
  ),
  leftArrowLink: (
    <svg
      width="10"
      height="10"
      viewBox="0 0 1200 1200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M710.041 -0.000155283L110.041 600L710.041 1200L849.961 1059.96L390.001 600L849.961 140.04L710.041 -0.000155283Z"
        fill="currentColor"
      />
    </svg>
  ),
  rightArrow: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 10L5.2875 9.3L8.0875 6.5L2 6.5L2 5.5L8.0875 5.5L5.2875 2.7L6 2L10 6L6 10Z"
        fill="currentColor"
      />
    </svg>
  ),
  leftArrow: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2L6.7125 2.7L3.9125 5.5L10 5.5L10 6.5L3.9125 6.5L6.7125 9.3L6 10L2 6L6 2Z"
        fill="currentColor"
      />
    </svg>
  ),
  athena: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 256 256"
    >
      <defs>
        <linearGradient
          id="logosAwsAthena0"
          x1="0%"
          x2="100%"
          y1="100%"
          y2="0%"
        >
          <stop offset="0%" stopColor="#4D27A8" />
          <stop offset="100%" stopColor="#A166FF" />
        </linearGradient>
      </defs>
      <path fill="url(#logosAwsAthena0)" d="M0 0h256v256H0z" />
      <path
        fill="#FFF"
        d="M122.544 87.126c14.375 0 22.25 3.22 23.685 4.835c-1.436 1.615-9.31 4.836-23.685 4.836c-14.375 0-22.249-3.22-23.684-4.836c1.435-1.615 9.309-4.835 23.684-4.835Zm-1.636 25.778a1.628 1.628 0 0 1-.898-1.448c0-.896.724-1.628 1.61-1.628c.257 0 .492.074.711.187l-1.423 2.889Zm18.508 26.587c-.238.193-.785.567-1.909 1.019c-1 .4-2.185.76-3.529 1.076c-3.57.839-7.96 1.3-12.361 1.3c-9.627 0-16.335-2.08-17.78-3.37L99.57 99.684c6.54 2.675 16.173 3.562 22.973 3.562c6.686 0 16.11-.86 22.646-3.434l-2.55 17.519c-4.806-1.812-10.802-4.443-16.485-7.209c-.578-2.005-2.378-3.481-4.535-3.481c-2.617 0-4.745 2.163-4.745 4.816c0 2.66 2.128 4.82 4.745 4.82c.62 0 1.21-.13 1.75-.348c7.94 3.92 13.858 6.434 18.31 7.985l-2.264 15.578ZM92.39 92.31l5.142 48.01c.362 8.91 23.106 9.013 24.085 9.013c4.869 0 9.766-.522 13.79-1.463c1.649-.387 3.142-.845 4.434-1.364c3.755-1.509 5.724-3.566 5.86-6.11l2.141-14.713c1.458.3 2.65.432 3.599.432c2.989 0 3.776-1.225 4.32-2.07c.571-.89.736-1.982.47-3.082c-.61-2.527-4.177-5.854-6.56-7.83l3.012-20.701l-.029-.003c.013-.158.064-.306.064-.468c0-8.907-18.968-11.283-30.174-11.283c-11.205 0-30.173 2.376-30.173 11.283c0 .12.041.226.047.345l-.028.004Zm28.684-28.12c27.683 0 50.205 22.861 50.205 50.96c0 28.1-22.522 50.96-50.205 50.96c-27.687 0-50.209-22.86-50.209-50.96c0-28.099 22.522-50.96 50.209-50.96Zm-79.522 69.682v6.447h28.586v-.38c9.137 19.26 28.506 32.619 50.936 32.619c31.183 0 56.557-25.752 56.557-57.407c0-31.656-25.374-57.408-56.557-57.408c-24.263 0-44.943 15.617-52.96 37.442H41.552v6.448h24.612c-.99 4.15-1.572 8.453-1.62 12.895H35.2v6.448h29.605c.448 4.478 1.455 8.779 2.858 12.896h-26.11Zm173.104 77.44c-3.843 3.907-10.507 3.93-14.347.036l-34.125-34.64a76.788 76.788 0 0 0 14.595-14.544l33.915 34.59a10.278 10.278 0 0 1 2.954 7.275a10.283 10.283 0 0 1-2.992 7.283Zm4.535-19.11l-34.674-35.37c7.687-12.012 12.171-26.32 12.171-41.681c0-42.323-33.921-76.751-75.614-76.751c-29.961 0-57.13 17.983-69.221 45.814l5.812 2.599c11.075-25.491 35.963-41.965 63.409-41.965c38.193 0 69.262 31.536 69.262 70.303c0 38.763-31.07 70.303-69.262 70.303c-25.514 0-48.89-14.176-61.014-36.994l-5.59 3.062c13.228 24.908 38.752 40.38 66.604 40.38c14.578 0 28.2-4.22 39.759-11.507l34.988 35.514c3.106 3.153 7.239 4.891 11.628 4.891c4.415 0 8.572-1.75 11.691-4.92c3.126-3.153 4.854-7.356 4.86-11.84c.01-4.479-1.702-8.683-4.809-11.839Z"
      />
    </svg>
  ),
  dynamodb: (
    <svg
      width="50px"
      height="50px"
      viewBox="-57.8 -57.8 404.60 404.60"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        {' '}
        <g>
          {' '}
          <path
            d="M165.258,288.501 L168.766,288.501 L226.027,259.867 L226.98,258.52 L226.98,29.964 L226.027,28.61 L168.766,0 L165.215,0 L165.258,288.501"
            fill="#5294CF"
          >
            {' '}
          </path>{' '}
          <path
            d="M90.741,288.501 L87.184,288.501 L29.972,259.867 L28.811,257.87 L28.222,31.128 L29.972,28.61 L87.184,0 L90.785,0 L90.741,288.501"
            fill="#1F5B98"
          >
            {' '}
          </path>{' '}
          <path
            d="M87.285,0 L168.711,0 L168.711,288.501 L87.285,288.501 L87.285,0 Z"
            fill="#2D72B8"
          >
            {' '}
          </path>{' '}
          <path
            d="M256,137.769 L254.065,137.34 L226.437,134.764 L226.027,134.968 L168.715,132.676 L87.285,132.676 L29.972,134.968 L29.972,91.264 L29.912,91.296 L29.972,91.168 L87.285,77.888 L168.715,77.888 L226.027,91.168 L247.096,102.367 L247.096,95.167 L256,94.193 L255.078,92.395 L226.886,72.236 L226.027,72.515 L168.715,54.756 L87.285,54.756 L29.972,72.515 L29.972,28.61 L0,63.723 L0,94.389 L0.232,94.221 L8.904,95.167 L8.904,102.515 L0,107.28 L0,137.793 L0.232,137.769 L8.904,137.897 L8.904,150.704 L1.422,150.816 L0,150.68 L0,181.205 L8.904,185.993 L8.904,193.426 L0.373,194.368 L0,194.088 L0,224.749 L29.972,259.867 L29.972,215.966 L87.285,233.725 L168.715,233.725 L226.196,215.914 L226.96,216.249 L254.781,196.387 L256,194.408 L247.096,193.426 L247.096,186.142 L245.929,185.676 L226.886,195.941 L226.196,197.381 L168.715,210.584 L168.715,210.6 L87.285,210.6 L87.285,210.584 L29.972,197.325 L29.972,153.461 L87.285,155.745 L87.285,155.801 L168.715,155.801 L226.027,153.461 L227.332,154.061 L254.111,151.755 L256,150.832 L247.096,150.704 L247.096,137.897 L256,137.769"
            fill="#1A476F"
          >
            {' '}
          </path>{' '}
          <path
            d="M226.027,215.966 L226.027,259.867 L256,224.749 L256,194.288 L226.2,215.914 L226.027,215.966"
            fill="#2D72B8"
          >
            {' '}
          </path>{' '}
          <path
            d="M226.027,197.421 L226.2,197.381 L256,181.353 L256,150.704 L226.027,153.461 L226.027,197.421"
            fill="#2D72B8"
          >
            {' '}
          </path>{' '}
          <path
            d="M226.2,91.208 L226.027,91.168 L226.027,134.968 L256,137.769 L256,107.135 L226.2,91.208"
            fill="#2D72B8"
          >
            {' '}
          </path>{' '}
          <path
            d="M226.2,72.687 L256,94.193 L256,63.731 L226.027,28.61 L226.027,72.515 L226.2,72.575 L226.2,72.687"
            fill="#2D72B8"
          >
            {' '}
          </path>{' '}
        </g>{' '}
      </g>
    </svg>
  ),
  mysql: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48px"
      height="48px"
    >
      <path
        fill="#00796b"
        d="M0.002,35.041h1.92v-7.085l2.667,6.057c0.329,0.755,0.779,1.022,1.662,1.022 s1.315-0.267,1.644-1.022l2.667-5.902v6.93h1.92v-7.258c0-0.697-0.277-1.035-0.849-1.209c-1.367-0.43-2.285-0.059-2.7,0.872 l-2.735,6.16l-2.649-6.16c-0.398-0.93-1.332-1.302-2.7-0.872C0.277,26.748,0,27.085,0,27.782v7.258H0.002z"
      />
      <path
        fill="#00796b"
        d="M13.441,29.281h1.92v4.055c-0.015,0.2,0.064,0.731,0.99,0.745c0.472,0.008,2.821,0,2.85,0v-4.8h1.92 c0.008,0,0,5.968,0,5.993c0.01,1.472-1.828,1.662-2.673,1.687h-5.006v-0.96c0.01,0,4.787,0.001,4.801,0 c1.088-0.115,0.959-0.714,0.959-0.896v-0.064H16.19c-1.67-0.015-2.735-0.751-2.747-1.59C13.441,33.373,13.479,29.317,13.441,29.281 z"
      />
      <path
        fill="#f57f17"
        d="M22.081,35.041h4.807c0.63,0,1.242-0.132,1.728-0.36c0.81-0.372,1.144-0.875,1.144-1.536v-1.368 c0-1.476-1.83-1.536-2.88-1.536h-1.92c-0.755,0-0.87-0.456-0.96-0.96v-0.96c0.09-0.384,0.258-0.9,0.923-0.96 c0.773,0,4.836,0,4.836,0v-0.96h-4.566c-0.755,0-3.114,0.09-3.114,1.92v1.187c0,0.84,0.738,1.524,2.34,1.692 c0.18,0.012,0.36,0.024,0.539,0.024c0,0,1.866-0.036,1.92-0.024c1.08,0,0.96,0.84,0.96,0.96v0.96c0,0.132-0.03,0.96-0.971,0.96 c-0.072,0-4.789,0-4.789,0V35.041z"
      />
      <path
        fill="#f57f17"
        d="M40.32,33.08c0,1.159,0.655,1.809,2.392,1.939c0.162,0.011,0.325,0.021,0.488,0.021H48v-0.96h-4.435 c-0.991,0-1.325-0.416-1.325-1.011v-6.669h-1.92V33.08z"
      />
      <path
        fill="#f57f17"
        d="M30.704,33.121v-4.8c0-1.02,0.5-1.724,1.916-1.92h0.672h3.447h0.525 c1.416,0.196,2.08,0.899,2.08,1.92v4.782c0,0.827-0.215,1.271-0.916,1.559L39.916,36h-2.16l-1.07-0.96h-1.257l-2.136,0.012 c-0.309,0-0.635-0.043-0.993-0.141C31.226,34.618,30.704,34.054,30.704,33.121z M32.624,33.121c0.098,0.467,0.473,0.96,1.14,0.96 h1.864l-1.068-0.96h2.175l0.519,0.482c0,0,0.186-0.152,0.186-0.482c0-0.33-0.016-4.8-0.016-4.8c-0.098-0.434-0.538-0.96-1.188-0.96 h-2.471c-0.749,0-1.14,0.548-1.14,1.058L32.624,33.121L32.624,33.121z"
      />
      <path
        fill="#00796b"
        d="M46.199,25.389c-1.031-0.028-1.818,0.068-2.491,0.351c-0.191,0.081-0.496,0.083-0.528,0.323 c0.105,0.11,0.121,0.275,0.205,0.41c0.16,0.26,0.432,0.609,0.674,0.791c0.265,0.2,0.538,0.414,0.821,0.587 c0.504,0.307,1.067,0.483,1.553,0.791c0.286,0.181,0.57,0.411,0.85,0.615c0.138,0.102,0.23,0.259,0.41,0.323 c0-0.01,0-0.019,0-0.029c-0.094-0.12-0.119-0.285-0.205-0.411c-0.127-0.127-0.254-0.254-0.381-0.381 c-0.372-0.494-0.846-0.929-1.348-1.289c-0.401-0.288-1.298-0.677-1.466-1.143c-0.01-0.01-0.019-0.019-0.03-0.03 c0.284-0.032,0.617-0.135,0.879-0.205c0.441-0.118,0.834-0.087,1.289-0.205c0.205-0.059,0.41-0.117,0.615-0.176 c0-0.039,0-0.078,0-0.117c-0.23-0.236-0.395-0.548-0.645-0.762c-0.657-0.559-1.373-1.117-2.11-1.583 c-0.409-0.258-0.915-0.426-1.348-0.645c-0.146-0.074-0.402-0.112-0.498-0.234c-0.228-0.29-0.351-0.659-0.527-0.996 c-0.368-0.708-0.73-1.482-1.055-2.227c-0.223-0.508-0.368-1.01-0.645-1.466c-1.331-2.188-2.764-3.509-4.982-4.807 c-0.472-0.276-1.041-0.385-1.642-0.528c-0.323-0.019-0.645-0.039-0.968-0.059c-0.197-0.083-0.401-0.323-0.587-0.44 c-0.735-0.465-2.621-1.475-3.165-0.147c-0.344,0.838,0.514,1.656,0.821,2.081c0.215,0.298,0.491,0.632,0.645,0.968 c0.101,0.22,0.119,0.441,0.205,0.674c0.213,0.574,0.55,1.228,0.826,1.759c0.139,0.269,0.293,0.551,0.469,0.791 c0.108,0.147,0.293,0.212,0.323,0.44c-0.181,0.253-0.191,0.646-0.293,0.968c-0.458,1.445-0.285,3.24,0.381,4.308 c0.204,0.328,0.686,1.032,1.348,0.762c0.579-0.236,0.45-0.967,0.615-1.612c0.037-0.146,0.014-0.253,0.088-0.351 c0,0.01,0,0.019,0,0.03c0.176,0.351,0.351,0.704,0.528,1.055c0.391,0.629,1.084,1.286,1.67,1.73 c0.304,0.23,0.544,0.628,0.938,0.762c0-0.01,0-0.019,0-0.03c-0.01,0-0.019,0-0.03,0c-0.076-0.119-0.196-0.168-0.293-0.264 c-0.229-0.225-0.485-0.504-0.674-0.762c-0.534-0.725-1.006-1.519-1.436-2.345c-0.205-0.395-0.384-0.829-0.557-1.231 c-0.067-0.155-0.066-0.389-0.205-0.469c-0.19,0.294-0.468,0.532-0.615,0.879c-0.234,0.555-0.265,1.233-0.351,1.934 c-0.052,0.018-0.029,0.006-0.059,0.029c-0.408-0.099-0.552-0.518-0.704-0.879c-0.384-0.912-0.455-2.38-0.117-3.429 c0.087-0.272,0.482-1.127,0.323-1.378c-0.076-0.251-0.328-0.396-0.468-0.587c-0.175-0.236-0.348-0.548-0.469-0.821 c-0.314-0.711-0.612-1.538-0.943-2.257c-0.158-0.344-0.425-0.691-0.645-0.996c-0.243-0.338-0.516-0.587-0.704-0.996 c-0.067-0.145-0.158-0.378-0.059-0.528c0.032-0.101,0.076-0.143,0.176-0.176c0.17-0.132,0.643,0.043,0.821,0.117 c0.47,0.195,0.862,0.381,1.26,0.645c0.191,0.127,0.384,0.372,0.615,0.44c0.088,0,0.176,0,0.264,0 c0.413,0.095,0.875,0.03,1.26,0.147c0.682,0.207,1.292,0.529,1.846,0.879c1.69,1.067,3.071,2.585,4.016,4.397 c0.152,0.292,0.218,0.57,0.351,0.879c0.27,0.624,0.611,1.266,0.879,1.876c0.268,0.609,0.53,1.223,0.909,1.73 c0.2,0.266,0.97,0.409,1.319,0.557c0.245,0.104,0.647,0.211,0.879,0.351c0.444,0.268,0.874,0.587,1.289,0.879 C45.528,24.803,46.167,25.124,46.199,25.389z"
      />
      <path
        fill="#00796b"
        d="M33.098,14.223c-0.215-0.004-0.367,0.023-0.528,0.059c0,0.01,0,0.019,0,0.03c0.01,0,0.019,0,0.03,0 c0.103,0.21,0.283,0.347,0.41,0.528c0.098,0.205,0.195,0.41,0.293,0.615c0.01-0.01,0.019-0.019,0.029-0.029 c0.181-0.128,0.265-0.332,0.264-0.645c-0.073-0.077-0.084-0.173-0.147-0.264C33.365,14.394,33.203,14.325,33.098,14.223z"
      />
    </svg>
  ),
  postgress1: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48px"
      height="48px"
    >
      <path
        fill="#fff"
        d="M44.083,29.79c-0.183-0.829-0.935-1.796-2.452-1.796c-0.31,0-0.649,0.039-1.035,0.119c-0.708,0.146-1.311,0.217-1.842,0.241c4.133-7.04,6.816-16.819,4.159-20.214c-3.501-4.473-8.214-5.141-10.711-5.141L31.967,3c-0.929,0.015-1.893,0.129-2.863,0.339l-3.583,0.774C25.033,4.052,24.536,4.009,24.018,4l-0.03,0l-0.016,0l-0.152-0.001c-1.593,0-3.046,0.338-4.341,0.973l-1.251-0.493c-1.72-0.678-4.308-1.485-6.868-1.485c-0.144,0-0.287,0.003-0.431,0.008C8.407,3.093,6.241,4.05,4.664,5.769C2.696,7.915,1.8,11.054,2.003,15.1C2.013,15.309,4.461,36,11.4,36h0.025l0.064-0.001c0.901-0.022,1.76-0.384,2.563-1.077c0.613,0.46,1.406,0.732,2.145,0.84c0.488,0.115,1.366,0.278,2.418,0.278c1.284,0,2.442-0.263,3.44-0.738c-0.001,0.88-0.006,1.994-0.016,3.418l-0.001,0.075l0.005,0.075c0.097,1.419,0.342,2.698,0.711,3.701c1.051,2.859,2.866,4.434,5.111,4.434c0.093,0,0.188-0.003,0.284-0.009c1.846-0.114,3.717-1.151,5.004-2.772c1.393-1.755,1.715-3.607,1.839-5.026L35,39.111v-0.088v-4.079l0.103,0.01l0.436,0.038l0.042,0.004l0.042,0.002c0.124,0.006,0.252,0.008,0.381,0.008c1.507,0,3.362-0.391,4.616-0.974C41.819,33.476,44.559,31.948,44.083,29.79z"
      />
      <path
        fill="#0277bd"
        d="M33,34c0-0.205,0.012-0.376,0.018-0.565C33.008,33.184,33,33,33,33s0.012-0.009,0.032-0.022c0.149-2.673,0.886-3.703,1.675-4.29c-0.11-0.153-0.237-0.318-0.356-0.475c-0.333-0.437-0.748-0.979-1.192-1.674l-0.082-0.158c-0.067-0.164-0.229-0.447-0.435-0.819c-1.183-2.14-3.645-6.592-1.96-9.404c0.738-1.232,2.122-1.942,4.121-2.117C33.986,11.718,30.925,6.115,23.985,6c-0.002,0-0.004,0-0.006,0c-6.041-0.098-8.026,5.392-8.672,8.672c0.89-0.377,1.906-0.606,2.836-0.606c0.014,0,0.029,0,0.043,0c2.29,0.017,3.865,1.239,4.323,3.354c0.335,1.552,0.496,2.91,0.492,4.153c-0.01,2.719-0.558,4.149-1.042,5.411l-0.154,0.408c-0.124,0.334-0.255,0.645-0.379,0.937c-0.126,0.298-0.237,0.563-0.318,0.802c0.484,0.11,0.864,0.265,1.125,0.38l0.151,0.066c0.047,0.02,0.094,0.043,0.137,0.069c0.848,0.516,1.376,1.309,1.489,2.233c0.061,0.498,0.051,3.893,0.03,6.855c0.087,1.285,0.305,2.364,0.593,3.146c0.409,1.114,1.431,3.241,3.394,3.119c1.37-0.085,2.687-0.919,3.561-2.019c0.938-1.181,1.284-2.487,1.414-3.958V34z"
      />
      <path
        fill="#0277bd"
        d="M15.114 28.917c-1.613-1.683-2.399-3.947-2.104-6.056.285-2.035.124-4.027.037-5.098-.029-.357-.048-.623-.047-.77 0-.008.002-.015.003-.023 0-.004-.002-.007-.002-.011.121-3.021 1.286-7.787 4.493-10.62C15.932 5.724 13.388 4.913 11 5 7.258 5.136 3.636 7.724 4 15c.137 2.73 3.222 19.103 7.44 19 .603-.015 1.229-.402 1.872-1.176 1.017-1.223 2.005-2.332 2.708-3.104C15.705 29.481 15.401 29.217 15.114 28.917zM37.023 14.731c.015.154.002.286-.022.408.031.92-.068 1.813-.169 2.677-.074.636-.15 1.293-.171 1.952-.021.645.07 1.282.166 1.956.225 1.578.459 3.359-.765 5.437.225.296.423.571.581.837 4.61-7.475 6.468-16.361 4.695-18.626C38.655 5.944 34.941 4.952 31.999 5c-.921.015-1.758.139-2.473.294C34.602 7.754 36.863 13.026 37.023 14.731zM41 30.071c-2.665.55-3.947.257-4.569-.126-.1.072-.2.133-.293.19-.372.225-.961.583-1.105 2.782.083.016.156.025.246.044L35.714 33c1.32.06 3.049-.31 4.063-.781C41.962 31.205 43.153 29.627 41 30.071zM22.023 32.119c-.037-.298-.198-.539-.492-.732l-.108-.047C21.062 31.181 20.653 31 20 31h-.004c-.127.01-.253.019-.38.019-.052 0-.103-.007-.155-.009-.474.365-1.148.647-2.816.99-2.98.759-1.221 1.655-.078 1.794 1.106.277 3.735.614 5.481-.809C22.043 32.537 22.035 32.229 22.023 32.119z"
      />
      <path
        fill="#0277bd"
        d="M20.681 18.501c-.292.302-.753.566-1.262.484-.828-.134-1.463-1.133-1.417-1.508h0c.044-.374.751-.569 1.578-.435.287.047.548.128.768.228-.32-.688-.899-1.085-1.782-1.182-1.565-.174-3.226.644-3.56 1.097.007.11.02.251.033.417.093 1.147.265 3.284-.05 5.537-.208 1.485.393 3.169 1.567 4.395.757.79 1.641 1.29 2.513 1.438.111-.478.309-.944.513-1.425.113-.265.233-.547.346-.852l.162-.427c.443-1.155.9-2.35.909-4.703C21.003 20.66 20.892 19.627 20.681 18.501zM34.847 22.007c-.104-.729-.211-1.484-.185-2.303.023-.742.105-1.442.184-2.119.062-.533.11-1.045.138-1.55-1.289.107-2.145.479-2.551 1.108.168-.057.358-.102.568-.129.892-.116 1.543.141 1.618.637.055.363-.253.705-.388.836-.277.269-.626.442-.981.488-.064.008-.129.012-.192.012-.353 0-.69-.121-.949-.3.112 1.973 1.567 4.612 2.283 5.907.153.277.271.498.369.688C35.154 24.163 35.009 23.143 34.847 22.007z"
      />
    </svg>
  ),
  postgress2: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="50px"
      height="50px"
    >
      <path d="M 34.902344 2 C 32.863281 2 31.097656 2.550781 29.875 3.09375 C 28.675781 2.691406 26.6875 2.003906 24.300781 2.5 C 22.910156 2.742188 21.632813 3.316406 20.460938 4.195313 C 18.53125 3.265625 16.515625 2.695313 14.402344 2.601563 C 13.101563 2.5 7.800781 3.101563 5.898438 5.898438 C 5.199219 7 4.5 8.398438 4.199219 10.097656 C 3.898438 11.597656 3.898438 13.300781 4.398438 16.800781 C 4.699219 19.199219 5.101563 20.800781 6 24.097656 C 6.101563 24.398438 6.601563 26 8.101563 30.402344 C 8.398438 31.199219 9 32.699219 10.199219 34.097656 C 11 35.097656 11.800781 35.699219 12.800781 35.699219 C 14.101563 35.699219 15 34.800781 15.800781 33.800781 C 15.859375 33.734375 15.921875 33.660156 15.980469 33.59375 C 15.90625 33.710938 15.839844 33.839844 15.800781 34 C 15.601563 35 16.800781 35.800781 17.800781 36.199219 C 18.601563 36.597656 19.5 36.699219 20.199219 36.699219 C 21.097656 36.699219 21.800781 36.5 22.199219 36.402344 C 22.542969 36.285156 23.285156 35.964844 24.078125 35.4375 C 24.113281 37.992188 24.136719 41.007813 24.199219 41.699219 C 24.5 44.300781 25.199219 46.097656 26.5 47.097656 C 27.5 47.898438 29.300781 48 29.402344 48 C 31.199219 48 34 46.800781 35.199219 44.902344 C 35.800781 44 36 43.199219 36.199219 42.097656 C 36.398438 41.5 36.597656 38 36.699219 37.300781 C 36.835938 36.195313 36.941406 35.105469 37.046875 34.046875 C 37.707031 34.21875 38.519531 34.402344 39.402344 34.402344 C 41 34.402344 43.101563 33.300781 43.5 33.097656 C 44.300781 32.5 45.898438 31.101563 45.199219 29.902344 C 44.800781 29.199219 44.199219 29.199219 42.699219 29.402344 C 42.699219 29.402344 40.300781 29.699219 40.097656 29.597656 C 39.953125 29.542969 39.730469 29.402344 39.480469 29.21875 C 40 28.414063 40.460938 27.617188 41 26.902344 C 42.199219 24.601563 42.902344 22.800781 43.402344 21.402344 C 44.300781 18.902344 44.800781 16.898438 45.097656 15.5 C 45.800781 12.5 46 11.101563 45.597656 9.5 C 44.800781 6.699219 41.898438 4.300781 40.699219 3.601563 C 39.898438 3.199219 37.902344 2 34.902344 2 Z M 34.902344 4 C 37.402344 4 39.101563 5 40 5.398438 C 41.101563 6 43.601563 8 43.800781 9.898438 C 43.902344 11 44 12.101563 43.300781 15 C 42.902344 16.398438 42.5 18.199219 41.597656 20.699219 C 41.097656 22.097656 40.5 23.800781 39.300781 25.902344 C 39.269531 25.953125 39.234375 26.007813 39.203125 26.0625 C 39.320313 25.640625 39.402344 25.300781 39.402344 25.300781 C 39.601563 24.300781 39.601563 23.5 39.5 22.300781 C 39.398438 21.699219 39.300781 20.199219 39.300781 19.597656 C 39.300781 19.300781 39.597656 16.199219 39.699219 15.097656 C 39.800781 13.300781 38.699219 11.097656 38.402344 10.699219 C 36.902344 8.398438 36.101563 7.101563 34.5 5.800781 C 34.101563 5.460938 33.417969 4.894531 32.488281 4.324219 C 33.222656 4.144531 34.035156 4 34.902344 4 Z M 26.066406 4.410156 C 27.371094 4.441406 28.476563 4.800781 29.300781 5.101563 C 31.402344 5.800781 32.699219 6.898438 33.300781 7.398438 C 34.601563 8.5 35.300781 9.601563 36.800781 11.902344 C 36.910156 12.121094 37.195313 12.585938 37.421875 13.234375 C 35.375 13.046875 34.015625 13.765625 33.199219 14.5 C 32 15.5 32.097656 17 32.199219 18.097656 C 32.199219 18.898438 32.402344 19.902344 33.902344 23.300781 C 34.5 24.800781 35.097656 26.398438 35.699219 27.5 C 36.011719 28.121094 36.394531 28.691406 36.804688 29.199219 C 36.566406 29.320313 36.324219 29.476563 36.097656 29.699219 C 35.5 30.398438 35.398438 31.101563 35.199219 32.402344 C 35 33.402344 34.800781 35.5 34.699219 37.199219 C 34.699219 37.898438 34.402344 41.300781 34.300781 41.800781 C 34 42.800781 33.898438 43.300781 33.5 43.902344 C 32.800781 45 30.601563 45.902344 29.300781 45.800781 C 28.902344 45.800781 28.300781 45.800781 27.800781 45.402344 C 26.699219 44.601563 26.300781 42.800781 26.199219 41.402344 C 26.097656 40.402344 26.199219 33.199219 26 31.597656 C 25.898438 31.199219 25.800781 30.199219 25 29.5 C 24.664063 29.21875 23.96875 29.074219 23.3125 28.976563 C 23.320313 28.640625 23.339844 28.304688 23.402344 28 C 23.5 27.398438 23.699219 27.097656 23.902344 26.597656 C 24 26.300781 24.199219 25.902344 24.402344 25.402344 C 25.300781 22.601563 25.097656 18.898438 24.597656 16.597656 C 24.5 16.398438 24.097656 14.800781 22.699219 13.902344 C 21.199219 13 19.597656 13.5 18.699219 13.800781 C 18.328125 13.902344 17.960938 14.0625 17.59375 14.25 C 17.65625 13.832031 17.710938 13.410156 17.800781 13 C 18.199219 11 18.601563 9.300781 19.902344 7.601563 C 21.300781 5.898438 22.898438 4.800781 24.699219 4.5 C 25.175781 4.425781 25.632813 4.398438 26.066406 4.410156 Z M 13.71875 4.585938 C 13.953125 4.582031 14.152344 4.585938 14.300781 4.601563 C 15.863281 4.683594 17.359375 5.050781 18.84375 5.675781 C 18.660156 5.878906 18.476563 6.082031 18.300781 6.300781 C 16.601563 8.300781 16.199219 10.398438 15.800781 12.5 C 15.300781 15 15.199219 17.597656 15.597656 20.199219 L 15.402344 22.097656 C 15.300781 23.097656 15.097656 25 16.199219 27 C 16.585938 27.664063 17.011719 28.226563 17.480469 28.707031 C 16.464844 30.050781 15.386719 31.320313 14.300781 32.5 C 13.699219 33.199219 13.199219 33.699219 12.800781 33.699219 C 12.699219 33.699219 12.300781 33.5 11.699219 32.800781 C 10.597656 31.601563 10.199219 30.300781 10 29.800781 C 8.800781 26.199219 8.101563 23.898438 8 23.597656 C 7.199219 20.398438 6.800781 18.800781 6.398438 16.5 C 5.898438 13.300781 5.898438 11.699219 6.199219 10.402344 C 6.5 9 7 7.898438 7.5 7.101563 C 8.726563 5.175781 12.09375 4.628906 13.71875 4.585938 Z M 36.664063 15.125 C 36.984375 15.125 37.332031 15.164063 37.699219 15.242188 C 37.6875 16.175781 37.300781 19.105469 37.300781 19.5 C 37.300781 20.300781 37.5 21.898438 37.5 22.5 C 37.601563 23.601563 37.601563 24.199219 37.5 25 C 37.5 25 37.351563 25.714844 37.199219 26.222656 C 36.734375 25.171875 36.21875 23.917969 35.597656 22.5 C 34.097656 19.101563 34 18.402344 34 17.902344 C 34 17.199219 34 16.300781 34.597656 15.902344 C 35.160156 15.402344 35.84375 15.132813 36.664063 15.125 Z M 21.140625 15.417969 C 21.339844 15.441406 21.523438 15.5 21.699219 15.597656 C 22.5 16 22.699219 17 22.699219 17 C 23.199219 19.199219 23.398438 22.5 22.597656 24.699219 C 22.5 25.097656 22.300781 25.398438 22.199219 25.699219 C 22 26.199219 21.800781 26.699219 21.597656 27.597656 C 21.546875 27.96875 21.523438 28.335938 21.511719 28.703125 C 20.820313 28.558594 20.167969 28.3125 19.699219 28 C 18.898438 27.601563 18.300781 26.898438 17.902344 26.097656 C 17.199219 24.597656 17.300781 23.199219 17.402344 22.402344 L 17.597656 20.097656 C 17.457031 18.972656 17.390625 17.84375 17.40625 16.722656 C 17.867188 16.328125 18.46875 15.925781 19.300781 15.699219 C 19.902344 15.550781 20.558594 15.34375 21.140625 15.417969 Z M 35.886719 16.089844 C 35.625 16.101563 35.347656 16.148438 35.199219 16.199219 C 34.800781 16.300781 34.699219 16.300781 34.597656 16.5 C 34.5 16.699219 34.800781 17 34.902344 17.199219 C 35 17.199219 35.300781 17.5 35.699219 17.402344 C 36 17.300781 36.199219 17.101563 36.300781 17 C 36.402344 16.898438 36.800781 16.398438 36.5 16.199219 C 36.398438 16.097656 36.148438 16.074219 35.886719 16.089844 Z M 20.914063 16.816406 C 20.804688 16.824219 20.699219 16.851563 20.597656 16.902344 C 20.5 16.902344 20.300781 17 20.199219 17.199219 C 20.097656 17.398438 20.199219 17.597656 20.300781 17.699219 C 20.5 18 20.800781 18.300781 21.300781 18.300781 C 21.402344 18.300781 21.800781 18.300781 22.097656 18 C 22.097656 18 22.402344 17.699219 22.402344 17.402344 C 22.300781 17.199219 22.101563 17.101563 21.800781 17 C 21.574219 16.925781 21.238281 16.792969 20.914063 16.816406 Z M 19.074219 29.902344 C 19.6875 30.230469 20.425781 30.496094 21.234375 30.679688 C 21.019531 31.109375 20.710938 31.464844 20.402344 31.699219 C 19.699219 32.199219 18.800781 32.5 17.902344 32.699219 C 17.699219 32.699219 17.601563 32.800781 17.402344 32.800781 C 16.917969 32.9375 16.449219 33.089844 16.128906 33.421875 C 17.109375 32.332031 18.09375 31.128906 19.074219 29.902344 Z M 38.355469 30.703125 C 38.792969 31.03125 39.222656 31.273438 39.597656 31.402344 C 40.199219 31.601563 40.699219 31.601563 42.5 31.402344 C 42.199219 31.699219 41.300781 32.199219 40 32.402344 C 39.164063 32.484375 38.125 32.285156 37.28125 32.042969 C 37.359375 31.476563 37.449219 31.152344 37.597656 31 C 37.652344 30.949219 37.984375 30.847656 38.355469 30.703125 Z M 23.296875 31.003906 C 23.503906 31.039063 23.667969 31.066406 23.699219 31.097656 C 23.898438 31.300781 24 31.800781 24 32 C 24.011719 32.171875 24.019531 32.605469 24.027344 32.90625 C 23.203125 33.871094 21.878906 34.40625 21.597656 34.5 C 21.199219 34.699219 20 34.898438 18.800781 34.5 C 19.800781 34.199219 20.800781 33.902344 21.597656 33.300781 C 22.296875 32.800781 22.898438 32.003906 23.296875 31.003906 Z" />
    </svg>
  ),
  cloudwatch: (
    <svg
      width="50px"
      height="50px"
      viewBox="-1.6 -1.6 19.20 19.20"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="#000000"
      strokeWidth="0.00016"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#759C3E"
          d="M14 11.899l-.045.019-5.89 3.037c-.02.01-.04.016-.06.024v-.01-.042-2.11a1291.057 1291.057 0 002.216-.813c.361-.133.723-.264 1.085-.396l.775-.285 1.118-.408.729-.265c.015-.005.028-.016.042-.025l.03-.004v1.278z"
        />
        <path
          fill="#C6CDBD"
          d="M2.014 11.895L2 11.899V10.63h.01c0 .019.003.038.003.056v.838l.001.37z"
        />
        <path
          fill="#759C3E"
          d="M6.216 1c.014.005.029.008.042.014.101.042.202.085.304.126l.345.135c.098.04.195.083.294.122.098.04.198.075.296.115.098.04.194.082.293.122.1.04.2.076.3.116l.37.148c.093.039.186.08.28.117.087.036.176.067.264.103.11.044.217.091.326.135.098.04.198.075.297.115.098.04.195.083.293.122.103.042.208.08.311.12.094.038.186.08.28.117.1.04.201.077.302.117.062.024.124.05.19.078V8.52l-.293.01c-.074.003-.146.008-.22.012a6.5 6.5 0 00-.178.011c-.114.01-.228.02-.342.028-.078.006-.156.008-.234.013l-.164.011c-.116.01-.232.02-.347.028-.075.006-.15.008-.224.013a6.474 6.474 0 00-.154.01c-.114.01-.228.02-.343.028-.122.009-.245.016-.368.023l-.174.012-.392.029c-.065.004-.13.007-.194.012-.114.008-.228.02-.343.028-.074.005-.149.008-.224.012-.012.001-.028-.004-.031.016l-.053-.003v2.476c0 .022 0 .044-.002.067-.01 0-.02-.002-.03 0l-.27.065-.207.046V1.088 1z"
        />
        <path
          fill="#4B612C"
          d="M6.216 1v10.465c-.02-.004-.042-.007-.063-.013l-1.17-.372-.167-.054v-.28l.001-.052V3.505 1.718l.038-.022 1.32-.68c.013-.007.027-.011.04-.016h.001z"
        />
        <path
          fill="#759C3E"
          d="M12.134 8.523h.185v1.783c0 .022.003.044.004.066l-.003.252c0 .053 0 .053-.048.067l-.483.148-.644.202-.797.247-.563.175-.983.304-.673.21c-.04.013-.083.023-.124.034v-.02-3.039c.022-.003.043-.008.064-.01.086-.008.172-.014.258-.023.116-.012.231-.027.347-.038.12-.013.241-.022.362-.034.133-.012.267-.027.401-.04l.129-.013c.085-.009.171-.019.257-.027.082-.009.165-.015.248-.023.082-.01.165-.02.247-.028.086-.009.172-.015.258-.023l.396-.04.134-.014c.085-.009.171-.019.257-.027l.248-.023.277-.029.228-.022c.007-.001.013-.01.019-.014z"
        />
        <path
          fill="#4B612C"
          d="M2.014 11.895l-.002-.37v-.837l-.002-.056.04-.003c.012.007.024.017.037.021l1.542.564 2.336.855 2.04.748v2.11l-.001.042h-.021c-.014-.005-.028-.01-.04-.017L2.04 11.909l-.026-.014z"
        />
        <path
          fill="#B7CA9D"
          d="M8.005 12.816l-2.04-.748-2.336-.854-1.542-.564c-.013-.005-.025-.015-.037-.022.013-.005.025-.014.039-.017l.387-.059.374-.055.295-.045.064-.007.005.069.047.016c.248.08.495.161.743.24.07.024.143.044.214.066l.01.001h.03c.124-.023.248-.047.372-.068.062-.01.124-.016.186-.024v.28l.167.055 1.17.372c.02.006.042.009.063.013l.208-.046c.09-.02.18-.043.27-.065.01-.002.02 0 .03 0v.26l.048.017.955.296c.092.029.185.056.278.083.041-.01.083-.02.124-.033l.673-.21.983-.304.563-.176.797-.247.644-.201c.161-.05.322-.1.483-.148.048-.015.048-.015.048-.067l.003-.253c.092.013.184.024.276.038.105.014.21.031.314.047l.305.046.31.047.3.045c.037.006.075.01.112.017.01.002.02.01.03.014-.014.008-.027.019-.042.025l-.729.265-1.118.408-.775.284-1.085.396-.63.231-1.126.414-.46.168z"
        />
        <path
          fill="#4B612C"
          d="M4.218 10.837c-.071-.022-.143-.043-.214-.066l-.743-.24-.047-.017-.005-.068.003-.072V3.766c0-.045.02-.075.059-.09.3-.12.602-.24.904-.358.016-.007.035-.007.053-.01v7.519l-.01.01z"
        />
        <path
          fill="#759C3E"
          d="M4.227 10.827v-.051-7.422-.046c.046.008.092.013.137.024.136.03.272.063.408.094.014.003.03.002.044.003l.001.077V10.746c-.063.008-.126.014-.187.024-.124.021-.248.045-.372.067-.01.002-.02 0-.03 0v-.01z"
        />
        <path
          fill="#B6C99B"
          d="M12.134 8.523c-.006.005-.012.014-.019.014-.076.009-.152.015-.228.023l-.277.029c-.082.008-.165.014-.248.023-.086.008-.172.018-.257.027l-.134.013c-.132.014-.264.028-.396.04-.086.009-.172.015-.258.023-.082.009-.165.02-.247.028-.082.009-.165.015-.248.023l-.257.028-.129.013-.401.04c-.12.012-.241.021-.362.033-.116.012-.23.027-.347.039l-.258.023c-.021.002-.042.006-.063.01l-.088-.012-.256-.03-.48-.052c-.047-.005-.095-.005-.143-.01-.087-.01-.173-.023-.26-.034.003-.02.019-.016.03-.016l.225-.012c.114-.009.228-.02.342-.028l.194-.012.393-.03.174-.011c.122-.008.245-.014.368-.023.114-.008.228-.019.342-.028.051-.004.103-.008.154-.01l.224-.013.347-.028.164-.011c.078-.005.156-.007.234-.013.114-.008.228-.019.343-.028l.178-.012c.073-.004.146-.009.22-.011.097-.005.195-.007.293-.01l.329-.001h.743c.02 0 .039.004.059.005v.001z"
        />
        <path fill="#596F39" d="M7.983 14.97l.02-.001.002.01-.022-.01z" />
        <path
          fill="#4B612C"
          d="M6.778 8.814c.087.012.174.024.261.034.048.006.096.006.144.01l.478.053.256.03c.03.003.059.008.088.012v3.058c-.093-.027-.186-.054-.278-.083l-.955-.296-.049-.017v-.26l.002-.067V8.812l.053.003z"
        />
        <path
          fill="#567031"
          d="M4.228 10.827l.001.012-.01-.001.01-.01h-.001z"
        />
      </g>
    </svg>
  ),
  database: (
    <svg
      width="50px"
      height="50px"
      viewBox="-184.32 -184.32 1392.64 1392.64"
      className="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path
          d="M117 608.4v178.5c1.5 93.7 155.7 169.5 395 169.5s393.4-75.8 395-169.5V608.4H117z"
          fill="#1B9BDB"
        />
        <path
          d="M907 607.7c0 99.4-154.8 180-395 180s-395-80.6-395-180 154.8-180 395-180 395 80.5 395 180z"
          fill="#FFFFFF"
        />
        <path
          d="M117 428.4v158.5c1.5 93.7 155.7 179.5 395 179.5s393.4-85.8 395-179.5V428.4H117z"
          fill="#1B9BDB"
        />
        <path
          d="M907 427.7c0 99.4-154.8 180-395 180s-395-80.6-395-180 154.8-180 395-180 395 80.5 395 180z"
          fill="#FFFFFF"
        />
        <path
          d="M117 248.4v158.5c1.5 93.7 155.7 179.5 395 179.5s393.4-85.8 395-179.5V248.4H117z"
          fill="#1B9BDB"
        />
        <path
          d="M907 247.7c0 99.4-154.8 180-395 180s-395-80.6-395-180 154.8-180 395-180 395 80.5 395 180z"
          fill="#3ED6FF"
        />
      </g>
    </svg>
  ),
  cbrFlag: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6C3 4.34315 4.34315 3 6 3H16C16.3788 3 16.725 3.214 16.8944 3.55279C17.0638 3.89157 17.0273 4.29698 16.8 4.6L14.25 8L16.8 11.4C17.0273 11.703 17.0638 12.1084 16.8944 12.4472C16.725 12.786 16.3788 13 16 13H6C5.44772 13 5 13.4477 5 14V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V6Z"
        fill="currentColor"
      />
    </svg>
  ),
  cbrChevronDown: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9.4L0 3.4L1.4 2L6 6.6L10.6 2L12 3.4L6 9.4Z"
        fill="currentColor"
      />
    </svg>
  ),
  cbrClock: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2337 10.8337L11.0833 9.9833L8.6001 7.5001V4.0001H7.4001V8.0001L10.2337 10.8337ZM8.0001 14.4001C7.12223 14.4001 6.2945 14.2334 5.5169 13.9001C4.7393 13.5668 4.05876 13.1084 3.4753 12.5249C2.89183 11.9414 2.43343 11.2609 2.1001 10.4833C1.76676 9.7057 1.6001 8.87796 1.6001 8.0001C1.6001 7.11103 1.76676 6.2777 2.1001 5.5001C2.43343 4.7225 2.89183 4.04463 3.4753 3.4665C4.05876 2.8889 4.7393 2.43343 5.5169 2.1001C6.2945 1.76676 7.12223 1.6001 8.0001 1.6001C8.88916 1.6001 9.7225 1.76676 10.5001 2.1001C11.2777 2.43343 11.9556 2.8889 12.5337 3.4665C13.1113 4.04463 13.5668 4.7225 13.9001 5.5001C14.2334 6.2777 14.4001 7.11103 14.4001 8.0001C14.4001 8.87796 14.2334 9.7057 13.9001 10.4833C13.5668 11.2609 13.1113 11.9414 12.5337 12.5249C11.9556 13.1084 11.2777 13.5668 10.5001 13.9001C9.7225 14.2334 8.88916 14.4001 8.0001 14.4001ZM8.0001 13.2001C9.44436 13.2001 10.6721 12.6918 11.6833 11.6753C12.6945 10.6588 13.2001 9.4337 13.2001 8.0001C13.2001 6.55583 12.6945 5.3281 11.6833 4.3169C10.6721 3.3057 9.44436 2.8001 8.0001 2.8001C6.5665 2.8001 5.34143 3.3057 4.3249 4.3169C3.30836 5.3281 2.8001 6.55583 2.8001 8.0001C2.8001 9.4337 3.30836 10.6588 4.3249 11.6753C5.34143 12.6918 6.5665 13.2001 8.0001 13.2001Z"
        fill="currentColor"
      />
    </svg>
  ),
  cbrLoader: (
    <svg
      width="16"
      height="16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        r="24"
        strokeDasharray="113.09733552923255 39.69911184307752"
        transform="rotate(132 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),
  cbrInfo: (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 8.5H6.5V5.5H5.5V8.5ZM6 4.5C6.14167 4.5 6.2605 4.452 6.3565 4.356C6.45217 4.26033 6.5 4.14167 6.5 4C6.5 3.85833 6.45217 3.7395 6.3565 3.6435C6.2605 3.54783 6.14167 3.5 6 3.5C5.85833 3.5 5.73967 3.54783 5.644 3.6435C5.548 3.7395 5.5 3.85833 5.5 4C5.5 4.14167 5.548 4.26033 5.644 4.356C5.73967 4.452 5.85833 4.5 6 4.5ZM6 11C5.30833 11 4.65833 10.8687 4.05 10.606C3.44167 10.3437 2.9125 9.9875 2.4625 9.5375C2.0125 9.0875 1.65633 8.55833 1.394 7.95C1.13133 7.34167 1 6.69167 1 6C1 5.30833 1.13133 4.65833 1.394 4.05C1.65633 3.44167 2.0125 2.9125 2.4625 2.4625C2.9125 2.0125 3.44167 1.65617 4.05 1.3935C4.65833 1.13117 5.30833 1 6 1C6.69167 1 7.34167 1.13117 7.95 1.3935C8.55833 1.65617 9.0875 2.0125 9.5375 2.4625C9.9875 2.9125 10.3437 3.44167 10.606 4.05C10.8687 4.65833 11 5.30833 11 6C11 6.69167 10.8687 7.34167 10.606 7.95C10.3437 8.55833 9.9875 9.0875 9.5375 9.5375C9.0875 9.9875 8.55833 10.3437 7.95 10.606C7.34167 10.8687 6.69167 11 6 11ZM6 10C7.11667 10 8.0625 9.6125 8.8375 8.8375C9.6125 8.0625 10 7.11667 10 6C10 4.88333 9.6125 3.9375 8.8375 3.1625C8.0625 2.3875 7.11667 2 6 2C4.88333 2 3.9375 2.3875 3.1625 3.1625C2.3875 3.9375 2 4.88333 2 6C2 7.11667 2.3875 8.0625 3.1625 8.8375C3.9375 9.6125 4.88333 10 6 10Z"
        fill="currentColor"
      />
    </svg>
  ),
  cbrPreview: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99984 10.4998C8.78873 10.4998 9.45817 10.2248 10.0082 9.67484C10.5582 9.12484 10.8332 8.45539 10.8332 7.6665C10.8332 6.87761 10.5582 6.20817 10.0082 5.65817C9.45817 5.10817 8.78873 4.83317 7.99984 4.83317C7.21095 4.83317 6.5415 5.10817 5.9915 5.65817C5.4415 6.20817 5.1665 6.87761 5.1665 7.6665C5.1665 8.45539 5.4415 9.12484 5.9915 9.67484C6.5415 10.2248 7.21095 10.4998 7.99984 10.4998ZM7.99984 9.53317C7.47762 9.53317 7.03595 9.35262 6.67484 8.9915C6.31373 8.63039 6.13317 8.18873 6.13317 7.6665C6.13317 7.14428 6.31373 6.70262 6.67484 6.3415C7.03595 5.98039 7.47762 5.79984 7.99984 5.79984C8.52206 5.79984 8.96373 5.98039 9.32484 6.3415C9.68595 6.70262 9.8665 7.14428 9.8665 7.6665C9.8665 8.18873 9.68595 8.63039 9.32484 8.9915C8.96373 9.35262 8.52206 9.53317 7.99984 9.53317ZM7.99984 12.6665C6.37761 12.6665 4.91095 12.2054 3.59984 11.2832C2.28873 10.3609 1.31095 9.15539 0.666504 7.6665C1.31095 6.17762 2.28873 4.97206 3.59984 4.04984C4.91095 3.12761 6.37761 2.6665 7.99984 2.6665C9.62206 2.6665 11.0887 3.12761 12.3998 4.04984C13.7109 4.97206 14.6887 6.17762 15.3332 7.6665C14.6887 9.15539 13.7109 10.3609 12.3998 11.2832C11.0887 12.2054 9.62206 12.6665 7.99984 12.6665ZM7.99984 11.6665C9.34428 11.6665 10.5804 11.3026 11.7082 10.5748C12.8359 9.84706 13.6943 8.87762 14.2832 7.6665C13.6943 6.45539 12.8359 5.48595 11.7082 4.75817C10.5804 4.03039 9.34428 3.6665 7.99984 3.6665C6.65539 3.6665 5.41928 4.03039 4.2915 4.75817C3.16373 5.48595 2.29984 6.45539 1.69984 7.6665C2.29984 8.87762 3.16373 9.84706 4.2915 10.5748C5.41928 11.3026 6.65539 11.6665 7.99984 11.6665Z"
        fill="currentColor"
      />
    </svg>
  ),
  cbrGroup: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 18V16.425C0 15.6917 0.371 15.104 1.113 14.662C1.85433 14.2207 2.81667 14 4 14C4.21667 14 4.425 14.004 4.625 14.012C4.825 14.0207 5.01667 14.0417 5.2 14.075C4.96667 14.4083 4.79167 14.7667 4.675 15.15C4.55833 15.5333 4.5 15.9417 4.5 16.375V18H0ZM6 18V16.375C6 15.2917 6.55433 14.4167 7.663 13.75C8.771 13.0833 10.2167 12.75 12 12.75C13.8 12.75 15.25 13.0833 16.35 13.75C17.45 14.4167 18 15.2917 18 16.375V18H6ZM19.5 18V16.375C19.5 15.9417 19.4457 15.5333 19.337 15.15C19.229 14.7667 19.0667 14.4083 18.85 14.075C19.0333 14.0417 19.221 14.0207 19.413 14.012C19.6043 14.004 19.8 14 20 14C21.2 14 22.1667 14.2207 22.9 14.662C23.6333 15.104 24 15.6917 24 16.425V18H19.5ZM12 14.75C11.05 14.75 10.2 14.875 9.45 15.125C8.7 15.375 8.25833 15.6667 8.125 16H15.9C15.75 15.6667 15.304 15.375 14.562 15.125C13.8207 14.875 12.9667 14.75 12 14.75ZM4 13C3.45 13 2.97933 12.804 2.588 12.412C2.196 12.0207 2 11.55 2 11C2 10.4333 2.196 9.95833 2.588 9.575C2.97933 9.19167 3.45 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.0207 5.425 12.412C5.04167 12.804 4.56667 13 4 13ZM20 13C19.45 13 18.979 12.804 18.587 12.412C18.1957 12.0207 18 11.55 18 11C18 10.4333 18.1957 9.95833 18.587 9.575C18.979 9.19167 19.45 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.0207 21.425 12.412C21.0417 12.804 20.5667 13 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.43733 9.875 6.862C10.4583 6.28733 11.1667 6 12 6C12.85 6 13.5623 6.28733 14.137 6.862C14.7123 7.43733 15 8.15 15 9C15 9.83333 14.7123 10.5417 14.137 11.125C13.5623 11.7083 12.85 12 12 12ZM12 8C11.7167 8 11.4793 8.09567 11.288 8.287C11.096 8.479 11 8.71667 11 9C11 9.28333 11.096 9.52067 11.288 9.712C11.4793 9.904 11.7167 10 12 10C12.2833 10 12.521 9.904 12.713 9.712C12.9043 9.52067 13 9.28333 13 9C13 8.71667 12.9043 8.479 12.713 8.287C12.521 8.09567 12.2833 8 12 8Z" />
    </svg>
  ),
  checkList: (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.645996 10.9896V9.34378H8.05225V10.9896H0.645996ZM0.645996 4.40628V2.76045H8.05225V4.40628H0.645996ZM10.8502 13.4584L9.69808 12.3063L11.8377 10.1667L9.69808 8.02712L10.8502 6.87503L12.9897 9.01462L15.1293 6.87503L16.2814 8.02712L14.1418 10.1667L16.2814 12.3063L15.1293 13.4584L12.9897 11.3188L10.8502 13.4584ZM12.6194 6.05212L9.69808 3.13076L10.8502 1.97868L12.5989 3.72738L16.0963 0.22998L17.2483 1.40264L12.6194 6.05212Z"
        fill="#C81F1E"
      />
    </svg>
  ),
  pendingDots: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.66671 7.99992C3.94448 7.99992 4.1806 7.9027 4.37504 7.70825C4.56948 7.51381 4.66671 7.2777 4.66671 6.99992C4.66671 6.72214 4.56948 6.48603 4.37504 6.29158C4.1806 6.09714 3.94448 5.99992 3.66671 5.99992C3.38893 5.99992 3.15282 6.09714 2.95837 6.29158C2.76393 6.48603 2.66671 6.72214 2.66671 6.99992C2.66671 7.2777 2.76393 7.51381 2.95837 7.70825C3.15282 7.9027 3.38893 7.99992 3.66671 7.99992ZM7.00004 7.99992C7.27782 7.99992 7.51393 7.9027 7.70837 7.70825C7.90282 7.51381 8.00004 7.2777 8.00004 6.99992C8.00004 6.72214 7.90282 6.48603 7.70837 6.29158C7.51393 6.09714 7.27782 5.99992 7.00004 5.99992C6.72226 5.99992 6.48615 6.09714 6.29171 6.29158C6.09726 6.48603 6.00004 6.72214 6.00004 6.99992C6.00004 7.2777 6.09726 7.51381 6.29171 7.70825C6.48615 7.9027 6.72226 7.99992 7.00004 7.99992ZM10.3334 7.99992C10.6112 7.99992 10.8473 7.9027 11.0417 7.70825C11.2362 7.51381 11.3334 7.2777 11.3334 6.99992C11.3334 6.72214 11.2362 6.48603 11.0417 6.29158C10.8473 6.09714 10.6112 5.99992 10.3334 5.99992C10.0556 5.99992 9.81948 6.09714 9.62504 6.29158C9.4306 6.48603 9.33337 6.72214 9.33337 6.99992C9.33337 7.2777 9.4306 7.51381 9.62504 7.70825C9.81948 7.9027 10.0556 7.99992 10.3334 7.99992ZM7.00004 13.6666C6.07782 13.6666 5.21115 13.4916 4.40004 13.1416C3.58893 12.7916 2.88337 12.3166 2.28337 11.7166C1.68337 11.1166 1.20837 10.411 0.858374 9.59992C0.508374 8.78881 0.333374 7.92214 0.333374 6.99992C0.333374 6.0777 0.508374 5.21103 0.858374 4.39992C1.20837 3.58881 1.68337 2.88325 2.28337 2.28325C2.88337 1.68325 3.58893 1.20825 4.40004 0.858252C5.21115 0.508252 6.07782 0.333252 7.00004 0.333252C7.92226 0.333252 8.78893 0.508252 9.60004 0.858252C10.4112 1.20825 11.1167 1.68325 11.7167 2.28325C12.3167 2.88325 12.7917 3.58881 13.1417 4.39992C13.4917 5.21103 13.6667 6.0777 13.6667 6.99992C13.6667 7.92214 13.4917 8.78881 13.1417 9.59992C12.7917 10.411 12.3167 11.1166 11.7167 11.7166C11.1167 12.3166 10.4112 12.7916 9.60004 13.1416C8.78893 13.4916 7.92226 13.6666 7.00004 13.6666ZM7.00004 12.3333C8.48893 12.3333 9.75004 11.8166 10.7834 10.7833C11.8167 9.74992 12.3334 8.48881 12.3334 6.99992C12.3334 5.51103 11.8167 4.24992 10.7834 3.21659C9.75004 2.18325 8.48893 1.66659 7.00004 1.66659C5.51115 1.66659 4.25004 2.18325 3.21671 3.21659C2.18337 4.24992 1.66671 5.51103 1.66671 6.99992C1.66671 8.48881 2.18337 9.74992 3.21671 10.7833C4.25004 11.8166 5.51115 12.3333 7.00004 12.3333Z"
        fill="currentColor"
      />
    </svg>
  ),
  checkbox: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66683 19.3334C2.02516 19.3334 1.47586 19.1049 1.01891 18.648C0.561968 18.1911 0.333496 17.6417 0.333496 17.0001V3.00008C0.333496 2.35841 0.561968 1.80911 1.01891 1.35216C1.47586 0.89522 2.02516 0.666748 2.66683 0.666748H21.3335C21.9752 0.666748 22.5245 0.89522 22.9814 1.35216C23.4384 1.80911 23.6668 2.35841 23.6668 3.00008V17.0001C23.6668 17.6417 23.4384 18.1911 22.9814 18.648C22.5245 19.1049 21.9752 19.3334 21.3335 19.3334H2.66683ZM2.66683 17.0001H21.3335V5.33341H2.66683V17.0001ZM10.7752 15.3084L6.6335 11.1667L8.32516 9.47508L10.7752 11.9251L15.6752 7.02508L17.3668 8.71675L10.7752 15.3084Z"
        fill="#BFBFBF"
      />
    </svg>
  ),
  google: (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="22px"
      height="22px"
      viewBox="0 0 48 48"
      className="icon"
    >
      <g>
        <path
          fill="#EA4335"
          d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
        />
        <path
          fill="#4285F4"
          d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
        />
        <path
          fill="#FBBC05"
          d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
        />
        <path
          fill="#34A853"
          d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
        />
        <path fill="none" d="M0 0h48v48H0z" />
      </g>
    </svg>
  ),
  productsSwitcherDots: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3.305" cy="3.305" r="2.185" />
      <circle cx="9.925" cy="3.305" r="2.185" />
      <circle cx="16.545" cy="3.305" r="2.185" />
      <circle cx="3.305" cy="9.925" r="2.185" />
      <circle cx="9.925" cy="9.925" r="2.185" />
      <circle cx="16.545" cy="9.925" r="2.185" />
      <circle cx="3.305" cy="16.545" r="2.185" />
      <circle cx="9.925" cy="16.545" r="2.185" />
      <circle cx="16.545" cy="16.545" r="2.185" />
    </svg>
  ),
  offerPageGift: (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.625 13.5V6.75H0.5V3.375H3.375C3.32292 3.26042 3.28385 3.14094 3.25781 3.01656C3.23177 2.89229 3.21875 2.76177 3.21875 2.625C3.21875 2.10417 3.40104 1.66146 3.76562 1.29688C4.13021 0.932292 4.57292 0.75 5.09375 0.75C5.3676 0.75 5.62354 0.807292 5.86156 0.921875C6.09969 1.03646 6.3125 1.19271 6.5 1.39063C6.67708 1.19271 6.88802 1.03646 7.13281 0.921875C7.3776 0.807292 7.63542 0.75 7.90625 0.75C8.42708 0.75 8.86979 0.932292 9.23438 1.29688C9.59896 1.66146 9.78125 2.10417 9.78125 2.625C9.78125 2.75 9.76302 2.875 9.72656 3C9.6901 3.125 9.65625 3.25 9.625 3.375H12.5V6.75H11.375V13.5H1.625ZM7.90625 1.875C7.69375 1.875 7.51562 1.94687 7.37187 2.09062C7.22812 2.23438 7.15625 2.4125 7.15625 2.625C7.15625 2.8375 7.22812 3.01563 7.37187 3.15938C7.51562 3.30313 7.69375 3.375 7.90625 3.375C8.11875 3.375 8.29688 3.30313 8.44063 3.15938C8.58438 3.01563 8.65625 2.8375 8.65625 2.625C8.65625 2.4125 8.58438 2.23438 8.44063 2.09062C8.29688 1.94687 8.11875 1.875 7.90625 1.875ZM4.34375 2.625C4.34375 2.8375 4.41562 3.01563 4.55937 3.15938C4.70312 3.30313 4.88125 3.375 5.09375 3.375C5.30625 3.375 5.48438 3.30313 5.62813 3.15938C5.77188 3.01563 5.84375 2.8375 5.84375 2.625C5.84375 2.4125 5.77188 2.23438 5.62813 2.09062C5.48438 1.94687 5.30625 1.875 5.09375 1.875C4.88125 1.875 4.70312 1.94687 4.55937 2.09062C4.41562 2.23438 4.34375 2.4125 4.34375 2.625ZM1.625 4.5V5.625H5.9375V4.5H1.625ZM5.9375 12.375V6.75H2.75V12.375H5.9375ZM7.0625 12.375H10.25V6.75H7.0625V12.375ZM11.375 5.625V4.5H7.0625V5.625H11.375Z"
        fill="#012A38"
      />
    </svg>
  ),
  cancelPageCross: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.29688 9.5L6.5 7.29688L8.70312 9.5L9.5 8.70312L7.29688 6.5L9.5 4.29688L8.70312 3.5L6.5 5.70312L4.29688 3.5L3.5 4.29688L5.70312 6.5L3.5 8.70312L4.29688 9.5ZM6.5 12.5C5.67708 12.5 4.90104 12.3438 4.17188 12.0312C3.44271 11.7188 2.80469 11.2891 2.25781 10.7422C1.71094 10.1953 1.28125 9.55729 0.96875 8.82812C0.65625 8.09896 0.5 7.32292 0.5 6.5C0.5 5.66667 0.65625 4.88802 0.96875 4.16406C1.28125 3.4401 1.71094 2.80469 2.25781 2.25781C2.80469 1.71094 3.44271 1.28125 4.17188 0.96875C4.90104 0.65625 5.67708 0.5 6.5 0.5C7.33333 0.5 8.11198 0.65625 8.83594 0.96875C9.5599 1.28125 10.1953 1.71094 10.7422 2.25781C11.2891 2.80469 11.7188 3.4401 12.0312 4.16406C12.3438 4.88802 12.5 5.66667 12.5 6.5C12.5 7.32292 12.3438 8.09896 12.0312 8.82812C11.7188 9.55729 11.2891 10.1953 10.7422 10.7422C10.1953 11.2891 9.5599 11.7188 8.83594 12.0312C8.11198 12.3438 7.33333 12.5 6.5 12.5ZM6.5 11.375C7.85417 11.375 9.00521 10.901 9.95312 9.95312C10.901 9.00521 11.375 7.85417 11.375 6.5C11.375 5.14583 10.901 3.99479 9.95312 3.04688C9.00521 2.09896 7.85417 1.625 6.5 1.625C5.14583 1.625 3.99479 2.09896 3.04688 3.04688C2.09896 3.99479 1.625 5.14583 1.625 6.5C1.625 7.85417 2.09896 9.00521 3.04688 9.95312C3.99479 10.901 5.14583 11.375 6.5 11.375Z"
        fill="#012A38"
      />
    </svg>
  ),
  inAppCenter: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 15q-.619 0-1.059-.44A1.44 1.44 0 0 1 1.5 13.5v-9q0-.619.442-1.059.44-.44 1.059-.44H15q.619 0 1.059.44.443.44.442 1.059v9q0 .619-.442 1.059a1.44 1.44 0 0 1-1.059.44zm0-1.5h11.999v-9H3zm2.999-2.25H12v-4.5H6z"
        fill="currentColor"
      />
    </svg>
  ),
  fullPage: (
    <svg
      width="18"
      height="16.715"
      viewBox="0 0 18 16.715"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.429 13.928q-0.575 0 -0.983 -0.409a1.335 1.335 0 0 1 -0.41 -0.983V4.179q0 -0.575 0.41 -0.983 0.409 -0.409 0.983 -0.409h11.142q0.575 0 0.983 0.409 0.412 0.409 0.41 0.983v8.357q0 0.575 -0.41 0.983a1.335 1.335 0 0 1 -0.983 0.409zm0 -1.393h7.312v-2.438H3.429zm8.704 0h2.438V6.268h-2.438zM3.429 8.704h7.312V6.269H3.429z"
        fill="currentColor"
      />
    </svg>
  ),
};

export const CBRIcons = {
  cbrLogo: (width = 36, height = 36) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.85989 11.9889L23.7119 8.21462V0H15.4973L7.85989 11.9889Z" />
      <path d="M0 11.8574C0 12.8342 0.111009 13.7889 0.355227 14.6992L7.85939 11.9906L0.288621 9.25977C0.111008 10.1034 0 10.9693 0 11.8574Z" />
      <path d="M2.79736 4.19546L7.85934 11.9882L10.1905 0.110352C7.2377 0.532183 4.6401 2.0197 2.79736 4.19546Z" />
      <path d="M7.85986 11.9893L23.7119 15.7635V24.0004H15.4972L7.85986 11.9893Z" />
      <path d="M2.79736 19.782L7.85934 11.9893L10.1905 23.8671C7.2377 23.4675 4.6401 21.9578 2.79736 19.782Z" />
    </svg>
  ),
  cbrPencil: (width = 24, height = 24) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.475 6.69375L11.2875 3.54375L12.3375 2.49375C12.625 2.20625 12.9781 2.0625 13.3969 2.0625C13.8156 2.0625 14.1688 2.20625 14.4563 2.49375L15.5063 3.54375C15.7938 3.83125 15.9438 4.17813 15.9563 4.58438C15.9688 4.99063 15.8313 5.3375 15.5438 5.625L14.475 6.69375ZM13.3875 7.8L5.4375 15.75H2.25V12.5625L10.2 4.6125L13.3875 7.8Z"
        fill="currentColor"
      />
    </svg>
  ),
  cbrArrowRight: (width = 24, height = 24) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.99984 15.1667L8.49984 13.6833L11.5498 10.6333H4.4165V8.53333H11.5498L8.49984 5.48333L9.99984 4L15.5832 9.58333L9.99984 15.1667Z" />
    </svg>
  ),
  cbrCheckmark: (width = 16, height = 16) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.09447 14.6667L3.66113 10.2334L4.76947 9.12508L8.09447 12.4501L15.2306 5.31396L16.3389 6.4223L8.09447 14.6667Z"
        fill="currentColor"
      />
    </svg>
  ),
  cbrRocketLaunch: (width = 24, height = 24) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.99883 10.1502L7.42403 11.175C7.69083 10.625 7.98243 10.0834 8.29883 9.55024C8.61563 9.01664 8.94903 8.49984 9.29903 7.99984L7.52423 7.65004L4.99883 10.1502ZM8.74883 12.1998L11.924 15.3498C12.7908 14.9834 13.6324 14.5252 14.4488 13.9752C15.2656 13.4252 15.9656 12.8584 16.5488 12.2748C17.8324 10.9916 18.795 9.63764 19.4366 8.21284C20.0782 6.78764 20.4074 5.28344 20.4242 3.70024C18.8242 3.70024 17.3158 4.02104 15.899 4.66264C14.4822 5.30424 13.1238 6.27504 11.8238 7.57504C11.2574 8.14184 10.6992 8.83764 10.1492 9.66244C9.59923 10.4876 9.13243 11.3334 8.74883 12.1998ZM14.0492 10.05C13.6992 9.70004 13.5242 9.27084 13.5242 8.76244C13.5242 8.25404 13.6992 7.82484 14.0492 7.47484C14.3992 7.12484 14.8324 6.94984 15.3488 6.94984C15.8656 6.94984 16.299 7.12484 16.649 7.47484C16.999 7.82484 17.174 8.25404 17.174 8.76244C17.174 9.27084 16.999 9.70004 16.649 10.05C16.299 10.4 15.8656 10.575 15.3488 10.575C14.8324 10.575 14.3992 10.4 14.0492 10.05ZM13.949 19.125L16.4738 16.6002L16.124 14.8248C15.624 15.1748 15.1074 15.504 14.5742 15.8124C14.0406 16.1208 13.4906 16.4166 12.9242 16.6998L13.949 19.125ZM21.9992 2.10004C22.1992 4.28324 21.945 6.31664 21.2366 8.20024C20.5282 10.0834 19.3324 11.8666 17.6492 13.5498C17.6324 13.5498 17.6198 13.5582 17.6114 13.575C17.603 13.5918 17.5906 13.6002 17.5742 13.6002L18.1238 16.275C18.1738 16.5418 18.1572 16.8084 18.074 17.0748C17.9908 17.3416 17.8492 17.575 17.6492 17.775L13.3988 22.0248L11.2742 17.1L7.02383 12.825L2.07383 10.725L6.34883 6.47523C6.54883 6.27524 6.77803 6.13344 7.03643 6.04984C7.29483 5.96664 7.56563 5.95004 7.84883 6.00004L10.499 6.52504C10.5158 6.52504 10.5282 6.52084 10.5362 6.51244L10.574 6.47523C12.2572 4.80843 14.0364 3.61244 15.9116 2.88724C17.7864 2.16244 19.8156 1.90004 21.9992 2.10004ZM3.79883 15.9C4.38243 15.3168 5.09503 15.021 5.93663 15.0126C6.77823 15.0042 7.49063 15.2916 8.07383 15.8748C8.65743 16.4584 8.94503 17.171 8.93663 18.0126C8.92823 18.8542 8.63243 19.5666 8.04923 20.1498C7.61563 20.5834 6.93223 20.946 5.99903 21.2376C5.06583 21.5292 3.70743 21.7916 1.92383 22.0248C2.17383 20.2416 2.44063 18.8834 2.72423 17.9502C3.00743 17.0166 3.36563 16.3332 3.79883 15.9ZM4.97423 17.1C4.75743 17.3168 4.56143 17.6752 4.38623 18.1752C4.21143 18.6752 4.06563 19.2834 3.94883 19.9998C4.64883 19.8834 5.25303 19.7376 5.76143 19.5624C6.26983 19.3876 6.63243 19.1918 6.84923 18.975C7.13243 18.725 7.27823 18.4124 7.28663 18.0372C7.29503 17.6624 7.16583 17.3334 6.89903 17.0502C6.61583 16.7834 6.28663 16.6542 5.91143 16.6626C5.53663 16.671 5.22423 16.8168 4.97423 17.1Z" />
    </svg>
  ),
  cbrClose: (width = 11, height = 11) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.92963 8.69328L2.28906 8.05271L4.85134 5.49044L2.28906 2.92817L2.92963 2.2876L5.4919 4.84987L8.05418 2.2876L8.69475 2.92817L6.13247 5.49044L8.69475 8.05271L8.05418 8.69328L5.4919 6.13101L2.92963 8.69328Z" />
    </svg>
  ),
  cbrInfo: (width = 12, height = 12) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 8.5H6.5V5.5H5.5V8.5ZM6 4.5C6.14167 4.5 6.2605 4.452 6.3565 4.356C6.45217 4.26033 6.5 4.14167 6.5 4C6.5 3.85833 6.45217 3.7395 6.3565 3.6435C6.2605 3.54783 6.14167 3.5 6 3.5C5.85833 3.5 5.73967 3.54783 5.644 3.6435C5.548 3.7395 5.5 3.85833 5.5 4C5.5 4.14167 5.548 4.26033 5.644 4.356C5.73967 4.452 5.85833 4.5 6 4.5ZM6 11C5.30833 11 4.65833 10.8687 4.05 10.606C3.44167 10.3437 2.9125 9.9875 2.4625 9.5375C2.0125 9.0875 1.65633 8.55833 1.394 7.95C1.13133 7.34167 1 6.69167 1 6C1 5.30833 1.13133 4.65833 1.394 4.05C1.65633 3.44167 2.0125 2.9125 2.4625 2.4625C2.9125 2.0125 3.44167 1.65617 4.05 1.3935C4.65833 1.13117 5.30833 1 6 1C6.69167 1 7.34167 1.13117 7.95 1.3935C8.55833 1.65617 9.0875 2.0125 9.5375 2.4625C9.9875 2.9125 10.3437 3.44167 10.606 4.05C10.8687 4.65833 11 5.30833 11 6C11 6.69167 10.8687 7.34167 10.606 7.95C10.3437 8.55833 9.9875 9.0875 9.5375 9.5375C9.0875 9.9875 8.55833 10.3437 7.95 10.606C7.34167 10.8687 6.69167 11 6 11ZM6 10C7.11667 10 8.0625 9.6125 8.8375 8.8375C9.6125 8.0625 10 7.11667 10 6C10 4.88333 9.6125 3.9375 8.8375 3.1625C8.0625 2.3875 7.11667 2 6 2C4.88333 2 3.9375 2.3875 3.1625 3.1625C2.3875 3.9375 2 4.88333 2 6C2 7.11667 2.3875 8.0625 3.1625 8.8375C3.9375 9.6125 4.88333 10 6 10Z"
        fill="currentColor"
      />
    </svg>
  ),
  cbrLock: (width = 25, height = 25) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.07978 22.2922C5.52248 22.2922 5.04539 22.0938 4.64852 21.6969C4.25166 21.3 4.05322 20.8229 4.05322 20.2656V10.1328C4.05322 9.57552 4.25166 9.09844 4.64852 8.70157C5.04539 8.3047 5.52248 8.10627 6.07978 8.10627H7.09306V6.07971C7.09306 4.678 7.58704 3.48318 8.57499 2.49523C9.56293 1.50728 10.7578 1.01331 12.1595 1.01331C13.5612 1.01331 14.756 1.50728 15.7439 2.49523C16.7319 3.48318 17.2259 4.678 17.2259 6.07971V8.10627H18.2391C18.7964 8.10627 19.2735 8.3047 19.6704 8.70157C20.0673 9.09844 20.2657 9.57552 20.2657 10.1328V20.2656C20.2657 20.8229 20.0673 21.3 19.6704 21.6969C19.2735 22.0938 18.7964 22.2922 18.2391 22.2922H6.07978ZM6.07978 20.2656H18.2391V10.1328H6.07978V20.2656ZM12.1595 17.2258C12.7168 17.2258 13.1939 17.0274 13.5907 16.6305C13.9876 16.2336 14.186 15.7565 14.186 15.1992C14.186 14.6419 13.9876 14.1648 13.5907 13.768C13.1939 13.3711 12.7168 13.1727 12.1595 13.1727C11.6022 13.1727 11.1251 13.3711 10.7282 13.768C10.3313 14.1648 10.1329 14.6419 10.1329 15.1992C10.1329 15.7565 10.3313 16.2336 10.7282 16.6305C11.1251 17.0274 11.6022 17.2258 12.1595 17.2258ZM9.11962 8.10627H15.1993V6.07971C15.1993 5.23531 14.9038 4.51757 14.3127 3.92649C13.7216 3.33541 13.0039 3.03987 12.1595 3.03987C11.3151 3.03987 10.5973 3.33541 10.0062 3.92649C9.41516 4.51757 9.11962 5.23531 9.11962 6.07971V8.10627Z"
        fill="currentColor"
      />
    </svg>
  ),
  cbrLoader: (width = 16, height = 16) => (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        r="24"
        strokeDasharray="113.09733552923255 39.69911184307752"
        transform="rotate(132 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),
  cbrExternalLink: (width = 13, height = 13) => (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
      />
    </svg>
  ),
  topPointingTriangle: (
    <svg
      width="17"
      height="9"
      viewBox="0 0 17 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.292969 8.75L8.41797 0.625L16.543 8.75H0.292969Z"
        fill="currentColor"
      />
    </svg>
  ),
  downPointingTriangle: (
    <svg
      width="17"
      height="9"
      viewBox="0 0 17 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.543 0.625L8.41797 8.75L0.292969 0.624999L16.543 0.625Z"
        fill="currentColor"
      />
    </svg>
  ),
  warningShield: (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.49984 11.6654C6.72414 11.6654 6.91216 11.5895 7.0639 11.4378C7.21564 11.286 7.2915 11.098 7.2915 10.8737C7.2915 10.6494 7.21564 10.4614 7.0639 10.3096C6.91216 10.1579 6.72414 10.082 6.49984 10.082C6.27553 10.082 6.08751 10.1579 5.93577 10.3096C5.78404 10.4614 5.70817 10.6494 5.70817 10.8737C5.70817 11.098 5.78404 11.286 5.93577 11.4378C6.08751 11.5895 6.27553 11.6654 6.49984 11.6654ZM5.70817 8.4987H7.2915V4.54036H5.70817V8.4987ZM6.49984 16.4154C4.66581 15.9536 3.15175 14.9013 1.95765 13.2586C0.763553 11.6159 0.166504 9.79175 0.166504 7.7862V2.95703L6.49984 0.582031L12.8332 2.95703V7.7862C12.8332 9.79175 12.2361 11.6159 11.042 13.2586C9.84793 14.9013 8.33387 15.9536 6.49984 16.4154ZM6.49984 14.7529C7.87206 14.3174 9.00678 13.4466 9.904 12.1404C10.8012 10.8341 11.2498 9.38273 11.2498 7.7862V4.04557L6.49984 2.26432L1.74984 4.04557V7.7862C1.74984 9.38273 2.19845 10.8341 3.09567 12.1404C3.99289 13.4466 5.12761 14.3174 6.49984 14.7529Z"
        fill="#4E0E0E"
      />
    </svg>
  ),
  churnProtectiveShield: (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.31283 11.2695H7.68783V9.29036H9.66699V6.91536H7.68783V4.9362H5.31283V6.91536H3.33366V9.29036H5.31283V11.2695ZM6.50033 16.4154C4.6663 15.9536 3.15224 14.9013 1.95814 13.2586C0.764041 11.6159 0.166992 9.79175 0.166992 7.7862V2.95703L6.50033 0.582031L12.8337 2.95703V7.7862C12.8337 9.79175 12.2366 11.6159 11.0425 13.2586C9.84842 14.9013 8.33435 15.9536 6.50033 16.4154ZM6.50033 14.7529C7.87255 14.3174 9.00727 13.4466 9.90449 12.1404C10.8017 10.8341 11.2503 9.38273 11.2503 7.7862V4.04557L6.50033 2.26432L1.75033 4.04557V7.7862C1.75033 9.38273 2.19894 10.8341 3.09616 12.1404C3.99338 13.4466 5.1281 14.3174 6.50033 14.7529Z"
        fill="currentColor"
      />
    </svg>
  ),
  threepeopleGroup: (
    <svg
      width="15"
      height="9"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8.25V7.26562C0 6.81771 0.229167 6.45312 0.6875 6.17188C1.14583 5.89062 1.75 5.75 2.5 5.75C2.63542 5.75 2.76562 5.7526 2.89062 5.75781C3.01562 5.76302 3.13542 5.77604 3.25 5.79688C3.10417 6.01562 2.99479 6.24479 2.92188 6.48438C2.84896 6.72396 2.8125 6.97396 2.8125 7.23438V8.25H0ZM3.75 8.25V7.23438C3.75 6.90104 3.84115 6.59635 4.02344 6.32031C4.20573 6.04427 4.46354 5.80208 4.79688 5.59375C5.13021 5.38542 5.52865 5.22917 5.99219 5.125C6.45573 5.02083 6.95833 4.96875 7.5 4.96875C8.05208 4.96875 8.5599 5.02083 9.02344 5.125C9.48698 5.22917 9.88542 5.38542 10.2188 5.59375C10.5521 5.80208 10.8073 6.04427 10.9844 6.32031C11.1615 6.59635 11.25 6.90104 11.25 7.23438V8.25H3.75ZM12.1875 8.25V7.23438C12.1875 6.96354 12.1536 6.70833 12.0859 6.46875C12.0182 6.22917 11.9167 6.00521 11.7812 5.79688C11.8958 5.77604 12.013 5.76302 12.1328 5.75781C12.2526 5.7526 12.375 5.75 12.5 5.75C13.25 5.75 13.8542 5.88802 14.3125 6.16406C14.7708 6.4401 15 6.80729 15 7.26562V8.25H12.1875ZM2.5 5.125C2.15625 5.125 1.86198 5.0026 1.61719 4.75781C1.3724 4.51302 1.25 4.21875 1.25 3.875C1.25 3.52083 1.3724 3.22396 1.61719 2.98438C1.86198 2.74479 2.15625 2.625 2.5 2.625C2.85417 2.625 3.15104 2.74479 3.39062 2.98438C3.63021 3.22396 3.75 3.52083 3.75 3.875C3.75 4.21875 3.63021 4.51302 3.39062 4.75781C3.15104 5.0026 2.85417 5.125 2.5 5.125ZM12.5 5.125C12.1562 5.125 11.862 5.0026 11.6172 4.75781C11.3724 4.51302 11.25 4.21875 11.25 3.875C11.25 3.52083 11.3724 3.22396 11.6172 2.98438C11.862 2.74479 12.1562 2.625 12.5 2.625C12.8542 2.625 13.151 2.74479 13.3906 2.98438C13.6302 3.22396 13.75 3.52083 13.75 3.875C13.75 4.21875 13.6302 4.51302 13.3906 4.75781C13.151 5.0026 12.8542 5.125 12.5 5.125ZM7.5 4.5C6.97917 4.5 6.53646 4.31771 6.17188 3.95312C5.80729 3.58854 5.625 3.14583 5.625 2.625C5.625 2.09375 5.80729 1.64844 6.17188 1.28906C6.53646 0.929688 6.97917 0.75 7.5 0.75C8.03125 0.75 8.47656 0.929688 8.83594 1.28906C9.19531 1.64844 9.375 2.09375 9.375 2.625C9.375 3.14583 9.19531 3.58854 8.83594 3.95312C8.47656 4.31771 8.03125 4.5 7.5 4.5Z"
        fill="currentColor"
      />
    </svg>
  ),

  dollarCoin: (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.40046 14.0404H8.78587V13.0508C9.44559 12.932 10.013 12.6747 10.488 12.2789C10.963 11.8831 11.2005 11.2959 11.2005 10.5174C11.2005 9.96328 11.0421 9.45529 10.7255 8.99349C10.4088 8.53168 9.77546 8.12925 8.82546 7.7862C8.03379 7.52231 7.48622 7.29141 7.18275 7.09349C6.87928 6.89557 6.72754 6.62509 6.72754 6.28203C6.72754 5.93898 6.84959 5.66849 7.09368 5.47057C7.33778 5.27266 7.69073 5.1737 8.15254 5.1737C8.57476 5.1737 8.90462 5.27595 9.14212 5.48047C9.37962 5.68498 9.55115 5.93898 9.65671 6.24245L10.9234 5.72786C10.7782 5.26606 10.511 4.86363 10.1218 4.52057C9.73257 4.17752 9.30046 3.9862 8.82546 3.94661V2.95703H7.44004V3.94661C6.78032 4.09175 6.26573 4.38203 5.89629 4.81745C5.52684 5.25286 5.34212 5.74106 5.34212 6.28203C5.34212 6.90217 5.52355 7.40356 5.88639 7.7862C6.24924 8.16884 6.8199 8.4987 7.59837 8.77578C8.42962 9.07925 9.00688 9.34974 9.33014 9.58724C9.65341 9.82474 9.81504 10.1348 9.81504 10.5174C9.81504 10.9529 9.66 11.2728 9.34993 11.4773C9.03987 11.6819 8.66712 11.7841 8.23171 11.7841C7.79629 11.7841 7.41035 11.6489 7.07389 11.3784C6.73743 11.1079 6.49004 10.7022 6.33171 10.1612L5.02546 10.6758C5.21018 11.3091 5.49716 11.8204 5.88639 12.2096C6.27563 12.5989 6.78032 12.8661 7.40046 13.0112V14.0404ZM8.11296 16.4154C7.01782 16.4154 5.98865 16.2076 5.02546 15.7919C4.06226 15.3763 3.22441 14.8122 2.51191 14.0997C1.79941 13.3872 1.23535 12.5494 0.819727 11.5862C0.404102 10.623 0.196289 9.59384 0.196289 8.4987C0.196289 7.40356 0.404102 6.37439 0.819727 5.4112C1.23535 4.448 1.79941 3.61016 2.51191 2.89766C3.22441 2.18516 4.06226 1.62109 5.02546 1.20547C5.98865 0.789844 7.01782 0.582031 8.11296 0.582031C9.20809 0.582031 10.2373 0.789844 11.2005 1.20547C12.1637 1.62109 13.0015 2.18516 13.714 2.89766C14.4265 3.61016 14.9906 4.448 15.4062 5.4112C15.8218 6.37439 16.0296 7.40356 16.0296 8.4987C16.0296 9.59384 15.8218 10.623 15.4062 11.5862C14.9906 12.5494 14.4265 13.3872 13.714 14.0997C13.0015 14.8122 12.1637 15.3763 11.2005 15.7919C10.2373 16.2076 9.20809 16.4154 8.11296 16.4154ZM8.11296 14.832C9.88101 14.832 11.3786 14.2185 12.6057 12.9914C13.8327 11.7643 14.4463 10.2668 14.4463 8.4987C14.4463 6.73064 13.8327 5.23307 12.6057 4.00599C11.3786 2.77891 9.88101 2.16536 8.11296 2.16536C6.3449 2.16536 4.84733 2.77891 3.62025 4.00599C2.39316 5.23307 1.77962 6.73064 1.77962 8.4987C1.77962 10.2668 2.39316 11.7643 3.62025 12.9914C4.84733 14.2185 6.3449 14.832 8.11296 14.832Z"
        fill="currentColor"
      />
    </svg>
  ),
  user: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      fill="none"
      viewBox="0 0 19 19"
    >
      <path
        fill="currentColor"
        d="M4.631 13.538a8.3 8.3 0 0 1 2.257-1.218 7.7 7.7 0 0 1 2.612-.445q1.365 0 2.613.445a8.3 8.3 0 0 1 2.256 1.218 6.1 6.1 0 0 0 1.078-1.841 6.2 6.2 0 0 0 .386-2.197q0-2.632-1.85-4.483T9.5 3.167t-4.483 1.85T3.167 9.5q0 1.167.386 2.197a6.1 6.1 0 0 0 1.078 1.84M9.5 10.292q-1.167 0-1.97-.802-.8-.8-.8-1.969 0-1.167.8-1.97.803-.8 1.97-.8t1.97.8q.8.803.8 1.97t-.8 1.97q-.803.8-1.97.8m0 7.125a7.7 7.7 0 0 1-3.088-.624A8 8 0 0 1 3.9 15.101a8 8 0 0 1-1.692-2.513A7.7 7.7 0 0 1 1.583 9.5q0-1.643.624-3.087a8 8 0 0 1 1.692-2.514 8 8 0 0 1 2.513-1.692A7.7 7.7 0 0 1 9.5 1.584a7.7 7.7 0 0 1 3.088.623q1.444.624 2.513 1.692a8 8 0 0 1 1.692 2.514 7.7 7.7 0 0 1 .624 3.087 7.7 7.7 0 0 1-.624 3.088 8 8 0 0 1-1.692 2.513 8 8 0 0 1-2.514 1.692 7.7 7.7 0 0 1-3.087.624m0-1.584q1.05 0 1.98-.306a6 6 0 0 0 1.701-.881 6 6 0 0 0-1.702-.88 6.3 6.3 0 0 0-1.979-.307q-1.05 0-1.98.306a6 6 0 0 0-1.701.881 6 6 0 0 0 1.702.88 6.3 6.3 0 0 0 1.979.308m0-7.124q.515 0 .851-.337.336-.336.336-.851t-.336-.851a1.15 1.15 0 0 0-.851-.336q-.515 0-.851.336a1.15 1.15 0 0 0-.337.851q0 .515.337.851.336.336.851.337"
      />
    </svg>
  ),
  checkCircle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      fill="none"
      viewBox="0 0 19 19"
    >
      <path
        fill="currentColor"
        d="m8.391 13.141 5.582-5.58-1.109-1.11-4.473 4.474-2.256-2.257-1.108 1.109zM9.5 17.416a7.7 7.7 0 0 1-3.088-.623A8 8 0 0 1 3.9 15.1a8 8 0 0 1-1.693-2.514A7.7 7.7 0 0 1 1.583 9.5q0-1.643.623-3.088A8 8 0 0 1 3.9 3.9a8 8 0 0 1 2.513-1.693A7.7 7.7 0 0 1 9.5 1.583q1.643 0 3.087.623 1.445.624 2.514 1.693a8 8 0 0 1 1.692 2.513 7.7 7.7 0 0 1 .623 3.088 7.7 7.7 0 0 1-.623 3.087 8 8 0 0 1-1.692 2.514 8 8 0 0 1-2.514 1.692 7.7 7.7 0 0 1-3.087.623m0-1.583q2.652 0 4.492-1.84T15.833 9.5t-1.84-4.493T9.5 3.167t-4.493 1.84T3.167 9.5t1.84 4.492T9.5 15.833"
      />
    </svg>
  ),
  percent: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      fill="none"
      viewBox="0 0 19 19"
    >
      <path
        fill="currentColor"
        d="M5.938 8.709a2.67 2.67 0 0 1-1.96-.812 2.67 2.67 0 0 1-.811-1.96q0-1.147.811-1.959a2.67 2.67 0 0 1 1.96-.811q1.147 0 1.96.811a2.67 2.67 0 0 1 .81 1.96 2.67 2.67 0 0 1-.81 1.96 2.67 2.67 0 0 1-1.96.81m0-1.584q.495 0 .841-.346.345-.346.346-.841 0-.495-.346-.841a1.15 1.15 0 0 0-.841-.347q-.495 0-.841.347-.347.346-.347.84 0 .495.347.842.346.345.84.346m7.125 8.709a2.67 2.67 0 0 1-1.96-.812 2.67 2.67 0 0 1-.811-1.96q0-1.147.812-1.958a2.67 2.67 0 0 1 1.959-.812q1.147 0 1.96.812a2.67 2.67 0 0 1 .81 1.959 2.67 2.67 0 0 1-.81 1.96 2.67 2.67 0 0 1-1.96.81m0-1.584q.495 0 .841-.346t.346-.841-.346-.841a1.15 1.15 0 0 0-.841-.347q-.495 0-.841.347-.347.346-.347.84 0 .495.347.842.346.346.84.346m-8.788 1.584-1.108-1.109L14.725 3.167l1.109 1.108z"
      />
    </svg>
  ),
  dollars: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      fill="none"
      viewBox="0 0 19 19"
    >
      <path
        fill="currentColor"
        d="M11.084 10.292q-.99 0-1.683-.693a2.3 2.3 0 0 1-.692-1.682q0-.99.692-1.682a2.3 2.3 0 0 1 1.683-.693q.99 0 1.682.693a2.3 2.3 0 0 1 .693 1.682q0 .99-.693 1.682a2.3 2.3 0 0 1-1.682.693m-5.542 2.375q-.653 0-1.118-.465a1.53 1.53 0 0 1-.465-1.118V4.75q0-.653.465-1.118t1.118-.465h11.083q.653 0 1.119.465t.465 1.118v6.334q0 .653-.465 1.118t-1.119.465zm1.583-1.583h7.917q0-.654.465-1.119t1.118-.465V6.334q-.653 0-1.118-.465a1.52 1.52 0 0 1-.465-1.119H7.125q0 .653-.465 1.119t-1.118.465V9.5q.653 0 1.118.465t.465 1.119m8.709 4.75H2.375q-.653 0-1.118-.465a1.53 1.53 0 0 1-.465-1.119V5.542h1.583v8.708h13.459z"
      />
    </svg>
  ),
  chevronUp: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      fill="none"
      viewBox="0 0 19 19"
    >
      <path
        fill="currentColor"
        d="M7.066 11.4 9.5 8.966l2.434 2.434 1.129-1.108L9.5 6.729l-3.562 3.563zM9.5 17.417a7.7 7.7 0 0 1-3.087-.624 8 8 0 0 1-2.514-1.692 8 8 0 0 1-1.692-2.513A7.7 7.7 0 0 1 1.583 9.5q0-1.643.624-3.087a8 8 0 0 1 1.692-2.514 8 8 0 0 1 2.514-1.692A7.7 7.7 0 0 1 9.5 1.584q1.642 0 3.088.623 1.444.624 2.513 1.692a8 8 0 0 1 1.692 2.514 7.7 7.7 0 0 1 .624 3.087 7.7 7.7 0 0 1-.624 3.088 8 8 0 0 1-1.692 2.513 8 8 0 0 1-2.514 1.692 7.7 7.7 0 0 1-3.087.624m0-1.584q2.652 0 4.493-1.84 1.84-1.84 1.84-4.493 0-2.652-1.84-4.493-1.84-1.84-4.493-1.84-2.652 0-4.493 1.84Q3.167 6.85 3.167 9.5t1.84 4.493q1.84 1.84 4.493 1.84"
      />
    </svg>
  ),
  priority: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M8 13V5.825L5.427 8.4 4 7l5-5 5 5-1.425 1.4L10 5.825V13zm7 9-5-5 1.426-1.4L14 18.175V11h2v7.175l2.575-2.575L20 17z"
      />
    </svg>
  ),
  key: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      fill="none"
      viewBox="0 0 19 19"
    >
      <path
        fill="currentColor"
        d="M5.542 13.458q-1.643 0-2.8-1.158-1.16-1.158-1.159-2.8 0-1.643 1.158-2.8Q3.9 5.54 5.541 5.541q.99 0 1.792.435t1.375 1.148h6.334q.99 0 1.682.693a2.3 2.3 0 0 1 .693 1.682q0 .99-.693 1.682a2.3 2.3 0 0 1-1.682.693H8.708a4.5 4.5 0 0 1-1.375 1.148 3.7 3.7 0 0 1-1.791.435m3.879-3.167h5.62a.77.77 0 0 0 .565-.227.77.77 0 0 0 .227-.564.77.77 0 0 0-.227-.564.77.77 0 0 0-.564-.228H9.42q.039.178.06.396.018.217.019.396 0 .178-.02.396a3 3 0 0 1-.06.395m-3.88 1.584q.99 0 1.683-.693A2.3 2.3 0 0 0 7.917 9.5q0-.99-.693-1.682a2.3 2.3 0 0 0-1.682-.693q-.99 0-1.683.693A2.3 2.3 0 0 0 3.167 9.5q0 .99.692 1.682a2.3 2.3 0 0 0 1.683.693"
      />
    </svg>
  ),
  bag: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      fill="none"
      viewBox="0 0 19 19"
    >
      <path
        fill="currentColor"
        d="m.792 14.25.396-1.583h4.354l-.396 1.583zm1.583-3.166L2.771 9.5h5.146l-.396 1.584zm12.33 4.75.396-3.167.574-4.75.198-1.564zM4.75 17.417q-.653 0-1.118-.465a1.52 1.52 0 0 1-.465-1.119h11.538l1.168-9.48h-2.177l-.218 1.683a.72.72 0 0 1-.297.524.8.8 0 0 1-.593.149.74.74 0 0 1-.525-.287.78.78 0 0 1-.148-.584l.178-1.485H8.946l-.218 1.663a.787.787 0 0 1-.89.693.787.787 0 0 1-.693-.89l.178-1.466H4.354q.08-.673.515-1.138t1.069-.465H7.52q.158-1.485 1.02-2.325.86-.841 2.345-.841 1.266 0 2.107.94t.822 2.226h2.018q.713.02 1.188.554.475.535.376 1.247l-1.187 9.5a1.52 1.52 0 0 1-.525.98 1.54 1.54 0 0 1-1.04.386zM9.104 4.75h3.147a1.46 1.46 0 0 0-.445-1.118 1.53 1.53 0 0 0-1.118-.465q-.693 0-1.099.425-.405.426-.485 1.158"
      />
    </svg>
  ),
  info: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      fill="none"
      viewBox="0 0 15 15"
    >
      <path
        fill="info"
        d="M6.875 10.625h1.25v-3.75h-1.25zm.625-5q.266 0 .445-.18.18-.18.18-.445a.6.6 0 0 0-.18-.445.6.6 0 0 0-.445-.18.6.6 0 0 0-.445.18.6.6 0 0 0-.18.445q0 .266.18.445.18.18.445.18m0 8.125a6.1 6.1 0 0 1-2.437-.492 6.3 6.3 0 0 1-1.985-1.336 6.3 6.3 0 0 1-1.336-1.985A6.1 6.1 0 0 1 1.25 7.5q0-1.297.492-2.437a6.3 6.3 0 0 1 1.336-1.985 6.3 6.3 0 0 1 1.985-1.336A6.1 6.1 0 0 1 7.5 1.25q1.297 0 2.438.492 1.14.492 1.984 1.336a6.3 6.3 0 0 1 1.336 1.985q.492 1.14.492 2.437t-.492 2.438a6.3 6.3 0 0 1-1.336 1.984 6.3 6.3 0 0 1-1.985 1.336 6.1 6.1 0 0 1-2.437.492m0-1.25q2.094 0 3.547-1.453T12.5 7.5t-1.453-3.547T7.5 2.5 3.953 3.953 2.5 7.5t1.453 3.547T7.5 12.5"
      />
    </svg>
  ),
};

export const svgToBase64URI = (svg: React.ReactElement): string => {
  const symbols = /[\r\n%#()<>?[\\\]^`{|}]/g;

  let data = ReactDOMServer.renderToString(svg);
  data = data.replace(/"/g, `'`);
  data = data.replace(/>\s{1,}</g, `><`);
  data = data.replace(/\s{2,}/g, ` `);

  return `data:image/svg+xml,${data.replace(symbols, encodeURIComponent)}`;
};

export default icons;
